webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
	langs: [{ key: 'de', text: 'DE', textLong: 'Deutsch' }, { key: 'en', text: 'EN', textLong: 'English' }, { key: 'en_us', text: 'US', textLong: 'English (US)' }, { key: 'es', text: 'ES', textLong: 'Español' }, { key: 'fr', text: 'FR', textLong: 'Français' }, { key: 'it', text: 'IT', textLong: 'Italiano' }, { key: 'nl', text: 'NL', textLong: 'Nederlands' }],

	specifications: {
		projects: ['4', '65', '66']
	},

	max_chars: {
		'setup.objectname': 100,
		'objectdata.metaTitle': 70,
		'objectdata.metaDescription': [140, 150]
	},

	NOTPLANNEDDATE: '2030-01-01 00:00:00',
	CLEARDATE: '0000-00-00 00:00:00',

	NO_CONTENT: '[no_content]',
	DATETIMEFORMAT: 'YYYY-MM-DD HH:mm:ss',
	DATETIMEFORMATDEST: 'DD.MM.YYYY HH:mm',
	DATEFORMATDEST: 'DD.MM.YYYY'
});

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(383)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(598),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_json_hilfe_texte_json__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_json_hilfe_texte_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_json_hilfe_texte_json__);






var infoTextDatasetsCache = {};

var defaultDataset = {
	variant: 'info',
	title: 'Info'
};

var resolvePropPathAccess = function resolvePropPathAccess(propPath, obj) {
	var splitPropPath = propPath.split('.').map(function (prop) {
		return prop.trim();
	}).filter(function (prop) {
		return prop.length > 0;
	});

	if (splitPropPath.length === 0) {
		return false;
	}

	var nextProp = splitPropPath.shift();

	if (obj[nextProp]) {
		if (splitPropPath.length > 0) {
			return resolvePropPathAccess(splitPropPath.join('.'), obj[nextProp]);
		}

		return obj[nextProp];
	}

	return false;
};

var forFunc = function forFunc(key) {
	var replacements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	var cleanedKey = key.trim();
	var cacheKey = cleanedKey + '-' + (replacements && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(replacements) || '');

	if (infoTextDatasetsCache[cacheKey]) {
		return infoTextDatasetsCache[cacheKey];
	}

	var infoTextDataset = resolvePropPathAccess(cleanedKey, __WEBPACK_IMPORTED_MODULE_3__static_json_hilfe_texte_json___default.a);

	var resolvedInfoTextDataset = infoTextDataset && infoTextDataset.text ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultDataset, infoTextDataset) : null;

	infoTextDatasetsCache[cacheKey] = resolvedInfoTextDataset;

	if (infoTextDatasetsCache[cacheKey] && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(replacements).length > 0) {
		resolvedInfoTextDataset.text = resolvedInfoTextDataset.text.replace(/\{\{\s*(.*?)\s*\}\}/g, function (firstMatch, matchKey) {
			if (matchKey in replacements && replacements[matchKey]) {
				return Array.isArray(replacements[matchKey]) ? replacements[matchKey].join(' und ') : replacements[matchKey];
			}

			return firstMatch;
		});
	}

	return infoTextDatasetsCache[cacheKey];
};

/* harmony default export */ __webpack_exports__["a"] = ({
	for: forFunc,
	existsFor: function existsFor(key) {
		return !!forFunc(key);
	}
});

/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(392)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(607),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(384)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(599),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(458)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(672),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(409)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(623),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var colorstring = function colorstring(inputString) {
	var saturation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
	var lightness = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 35;

	var string = inputString;

	if (typeof string !== 'string') {
		string = '';
	}

	var hash = 0;
	for (var i = 0; i < string.length; i += 1) {
		hash = string.charCodeAt(i) + 10;
	}
	return 'hsl(' + hash % 360 + ', ' + saturation + '%, ' + lightness + '%)';
};

/* harmony default export */ __webpack_exports__["a"] = ({ colorstring: colorstring });

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_convertHelper__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_placeholder_image_svg__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_placeholder_image_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_img_placeholder_image_svg__);




var getCanvas = function getCanvas(imgNode, imgData, background) {
	var canvas = document.createElement('canvas');
	canvas.width = imgData.width;
	canvas.height = imgData.height;

	var context = canvas.getContext('2d');

	var imgRatio = imgNode.height / imgNode.width;
	var imgWidth = imgData.width * imgData.scale;
	var imgHeight = imgData.width * imgData.scale * imgRatio;
	var imgRotation = imgData.rotation * (Math.PI / 180);

	var imgLeft = imgData.width * (0.5 + imgData.left);
	var imgTop = imgData.height * (0.5 + imgData.top);

	context.fillStyle = background || imgData.background;
	context.fillRect(0, 0, imgData.width, imgData.height);
	context.translate(imgLeft, imgTop);
	context.rotate(imgRotation);
	context.drawImage(imgNode, imgWidth / -2, imgHeight / -2, imgWidth, imgHeight);
	if (imgData.border) {
		context.lineWidth = 2;
		context.strokeStyle = '#000000';
		context.strokeRect(imgWidth / -2, imgHeight / -2, imgWidth, imgHeight);
	}
	return canvas;
};

var getImage = function getImage(data, callback) {
	var placeholderImgNode = new Image();
	var con = {
		width: parseInt(data.I_Sollbreite, 10) || parseInt(data.base_width, 10) || 500,
		height: parseInt(data.I_Sollhoehe, 10) || parseInt(data.base_height, 10) || 500,
		scale: 1,
		left: 0,
		top: 0,
		rotation: 0,
		background: '#EDECEB',
		border: data.B_Rahmen === 'j'
	};
	var placeholderLoad = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
		placeholderImgNode.onload = function () {
			var placeholderData = getCanvas(placeholderImgNode, con).toDataURL();
			callback(placeholderData, true);
			resolve(placeholderData);
		};
		placeholderImgNode.src = __WEBPACK_IMPORTED_MODULE_2__assets_img_placeholder_image_svg___default.a;
	});

	placeholderLoad.then(function (placeholderData) {
		var img = new Image();
		img.crossOrigin = 'Anonymous';
		img.onerror = function () {
			callback(placeholderData, false);
		};
		img.onload = function () {
			var converted = __WEBPACK_IMPORTED_MODULE_1__helper_convertHelper__["a" /* default */].importData(data, img);
			converted.width = converted.width === 0 ? 500 : converted.width;
			converted.height = converted.height === 0 ? 500 : converted.height;
			var imgFile = getCanvas(img, converted).toDataURL();
			callback(imgFile, false);
		};
		img.src = data.value;
	});
};

/* harmony default export */ __webpack_exports__["a"] = ({ getCanvas: getCanvas, getImage: getImage });

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE1LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9InBsYWNlaG9sZGVyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiCgkgeT0iMHB4IiB3aWR0aD0iNjAwcHgiIGhlaWdodD0iNDAwcHgiIHZpZXdCb3g9IjAgMCA2MDAgNDAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA2MDAgNDAwIiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3QgeD0iMCIgZmlsbD0iI0VERUNFQiIgd2lkdGg9IjYwMCIgaGVpZ2h0PSI0MDAiLz4KPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTIzNC41MzksMTQ4LjV2MTAzaDEzMC45MjJ2LTEwM0gyMzQuNTM5eiBNMzU0LjkwOCwyNDAuMzNIMjQ1LjcwN3YtODAuNjYxaDEwOS4yMDFWMjQwLjMzTDM1NC45MDgsMjQwLjMzeiIKCS8+Cjxwb2x5Z29uIGZpbGw9IiNGRkZGRkYiIHBvaW50cz0iMjUxLjU4LDIzMS42NDMgMjc0LjA4OCwyMDcuOTg0IDI4Mi41MjEsMjExLjYzMyAzMDkuMTMsMTgzLjMwOCAzMTkuNjA0LDE5NS44MzYgMzI0LjMyOSwxOTIuOTgyIAoJMzQ5Ljg5OCwyMzEuNjQzICIvPgo8Y2lyY2xlIGZpbGw9IiNGRkZGRkYiIGN4PSIyNzcuNTgyIiBjeT0iMTgwLjE4IiByPSI5LjgzIi8+Cjwvc3ZnPgo="

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(402)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(617),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */,
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["a"] = ({
	get: function get() {
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=dashboard_overview&json=true", {}).then(function (response) {
				resolve(response.body.objekte);
			}).catch(function (response) {
				reject(response);
			});
		});
	},
	getCMSStructure: function getCMSStructure() {
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=cms_structure&json=true").then(function (response) {
				resolve(response.body);
			}).catch(function (response) {
				reject(response);
			});
		});
	},
	copyObject: function copyObject(id) {
		var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=objekt_kopieren&json=true", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ PKM_Objekt: id }, props)).then(function (response) {
				response.body.sourceId = id;
				resolve(response.body);
			}).catch(function (response) {
				reject(response);
			});
		});
	},
	batchCopyObject: function batchCopyObject(ids) {
		var _this = this;

		var promisifiedCopyObjectRequests = ids.map(function (id) {
			return _this.copyObject(id);
		});
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promisifiedCopyObjectRequests);
	},
	copyObjectEmpty: function copyObjectEmpty(id) {
		return this.copyObject(id, { modus: 'leer_kopieren' });
	},
	batchCopyObjectEmpty: function batchCopyObjectEmpty(ids) {
		var _this2 = this;

		var promisifiedCopyObjectRequests = ids.map(function (id) {
			return _this2.copyObjectEmpty(id);
		});
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promisifiedCopyObjectRequests);
	},
	createNewObject: function createNewObject(specificationId, genusId, objectname) {
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=anlegen&json=true", {
				S_de_Objekt: objectname,
				FKM_Spezifikation: specificationId,
				FKM_Gattung: genusId
			}).then(function (response) {
				resolve(response.body);
			}).catch(function (response) {
				reject(response);
			});
		});
	},
	getUserSpecifications: function getUserSpecifications() {
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=list_user_spez&json=true").then(function (response) {
				resolve(response.body.objekte);
			}).catch(function (response) {
				reject(response);
			});
		});
	}
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["a"] = ({
	get: function get(id, lang) {
		var usePublicUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			var url = usePublicUrl ? "https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=objektdaten_holen&mode=public&json=true" : "https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=objektdaten_holen&json=true";

			__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(url, { PKM_Objekt: id, sprache: lang }).then(function (response) {
				resolve(response.body);
			}).catch(function (response) {
				reject(response);
			});
		});
	},
	set: function set(id, data) {
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=objektdaten_speichern&json=true", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ PKM_Objekt: id }, data)).then(function (response) {
				resolve(response);
			}).catch(function (response) {
				reject(response);
			});
		});
	},
	batchSet: function batchSet(datasets) {
		var _this = this;

		var promisifiedSiteRequests = datasets.map(function (dataset) {
			return _this.set(dataset.id, dataset.data);
		});
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promisifiedSiteRequests);
	},
	statusSet: function statusSet(id, status, lang, additionalParams) {
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			var requestBody = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
				PKM_Objekt: id,
				FKM_Status: status
			}, additionalParams);

			if (lang) {
				requestBody.pid_sprache = lang;
			}

			__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=status_aendern&json=true", requestBody).then(function (response) {
				resolve(response.body);
			}).catch(function (response) {
				reject(response);
			});
		});
	},
	pkStatusSet: function pkStatusSet(id, status) {
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=pk_status_aendern&json=true", {
				PKM_Objekt: id,
				PKM_Status: status
			}).then(function (response) {
				resolve(response.body);
			}).catch(function (response) {
				reject(response);
			});
		});
	},
	batchStatusSet: function batchStatusSet(datasets) {
		var _this2 = this;

		var promisifiedStatusSetRequests = datasets.map(function (dataset) {
			return _this2.statusSet(dataset.PKM_Objekt, dataset.FKM_Status);
		});
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promisifiedStatusSetRequests);
	},
	setProjectToCountry: function setProjectToCountry(objId, countryId) {
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=projekte_zu_laendern&json=true", {
				PKM_Objekt: objId,
				FKM_Land: countryId,
				modus: 'update'
			}).then(function (response) {
				resolve(response.body);
			}).catch(function (response) {
				reject(response);
			});
		});
	},
	clearLightscoutCacheEntry: function clearLightscoutCacheEntry(id) {
		var url = "https://www.stage.qa.erco.com" + '/struktur/php/tapete.php?aktion=clear&oid=' + id;
		return fetch(url).then(function (response) {
			return response.text();
		});
	},
	getIdTextRTFExport: function getIdTextRTFExport(objID, lang) {
		var placeholderValues = {
			object_id: objID,
			language: lang
		};

		var url = "https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=rtf_export&PKM_Objekt={{object_id}}&sprache={{language}}".replace(/\{\{\s*(.*?)\s*\}\}/g, function (_, placeholderKey) {
			if (placeholderKey in placeholderValues) {
				return placeholderValues[placeholderKey];
			}

			return '';
		});

		return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get(url).then(function (response) {
			return response.text();
		});
	}
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
	getSuggestions: function getSuggestions(query, attribut) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=tagger&json=true", {
				S_Attribut: attribut,
				S_Type: 'tag',
				field: 'PKM_Objekt',
				query: query
			}).then(function (response) {
				if (response.body.status === 'success') {
					resolve(response.body);
				} else {
					reject(response);
				}
			}).catch(function (response) {
				reject(response);
			});
		});
	},
	setTag: function setTag(id, tag, tagvals) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=tagger&json=true", { S_Attribut: tagvals.S_Attribut,
				S_Type: tagvals.S_Type,
				field: 'PKM_Objekt',
				foreignkey: id,
				S_Value: tagvals.S_Value,
				mode: 'set' }).then(function (response) {
				resolve(response);
			}).catch(function (response) {
				reject(response);
			});
		});
	},
	deleteTag: function deleteTag(tagID) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=tagger&json=true", { PKM_Tag: tagID, mode: 'deltag' }).then(function (response) {
				resolve(response);
			}).catch(function (response) {
				reject(response);
			});
		});
	},
	getTags: function getTags(id) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=tagger&json=true", {
				field: 'PKM_Objekt',
				foreignkey: id,
				mode: 'get' }).then(function (response) {
				resolve(response.body);
			}).catch(function (response) {
				reject(response);
			});
		});
	}
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var importData = function importData(data, imgNode) {
	var r = imgNode.height / imgNode.width;

	var baseWidth = Number(data.base_width);
	var baseHeight = Number(data.base_height);

	var rotation = Number(data.I_Rotation) || 0;
	var width = Number(data.I_Sollbreite) || baseWidth || 500;
	var height = Number(data.I_Sollhoehe) || baseHeight || 500;

	var background = data.S_Background === 'transparent' && data.S_Background || data.S_Background && !isNaN(parseInt(data.S_Background, 16)) && '#' + data.S_Background || !data.S_Background && 'transparent';
	var scale = baseWidth && Number(data.I_Sollbreite) && Number(data.I_Breite) / Number(data.I_Sollbreite) || 1;
	var top = data.I_Oben && data.I_Breite && data.I_Sollhoehe && (Number(data.I_Oben) + Number(data.I_Breite) / 2 * r) / Number(data.I_Sollhoehe) - 1 / 2 || 0;
	var left = data.I_Links && data.I_Breite && data.I_Sollbreite && (Number(data.I_Links) + Number(data.I_Breite) / 2) / Number(data.I_Sollbreite) - 1 / 2 || 0;
	var border = data.B_Rahmen === 'j';

	return {
		rotation: rotation,
		width: width,
		height: height,
		background: background,
		scale: scale,
		top: top,
		left: left,
		border: border
	};
};

var exportData = function exportData(data, imgNode) {
	var r = imgNode.height / imgNode.width;

	return {
		I_Rotation: data.rotation,
		I_Sollbreite: data.width,
		I_Sollhoehe: data.height,
		S_Background: data.background && data.background.replace('#', ''),
		I_Breite: data.width && data.scale && data.width * data.scale,
		I_Oben: data.height && data.width && data.scale && data.height * (0.5 + data.top) - data.width * (data.scale / 2) * r,
		I_Links: data.width && data.width && data.scale && data.width * (0.5 + data.left) - data.width * (data.scale / 2)
	};
};

/* harmony default export */ __webpack_exports__["a"] = ({ importData: importData, exportData: exportData });

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(8);





var isProductive = function isProductive(obj, stati) {
	var currentdatetime = __WEBPACK_IMPORTED_MODULE_0_moment___default()();
	var publishdatetime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(obj.TS_online_Liveserver, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].DATETIMEFORMAT);
	var offlinedatetime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(obj.TS_offline_Liveserver, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].DATETIMEFORMAT);

	var isInTimespan = false;

	if (publishdatetime.isValid() && currentdatetime.isAfter(publishdatetime)) {
		isInTimespan = true;

		if (offlinedatetime.isValid()) {
			if (currentdatetime.isBetween(publishdatetime, offlinedatetime)) {
				isInTimespan = true;
			} else {
				isInTimespan = false;
			}
		}
	}

	return obj.FKM_Status !== stati.entwurf && isInTimespan;
};

var isOffline = function isOffline(obj) {
	var currentdatetime = __WEBPACK_IMPORTED_MODULE_0_moment___default()();
	var offlinedatetime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(obj.TS_offline_Liveserver, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].DATETIMEFORMAT);

	return offlinedatetime.isValid() && currentdatetime.isAfter(offlinedatetime);
};

var isBeforeProduction = function isBeforeProduction(obj) {
	var currentdatetime = __WEBPACK_IMPORTED_MODULE_0_moment___default()();
	var onlinedatetime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(obj.TS_online_Liveserver, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].DATETIMEFORMAT);

	return onlinedatetime.isValid() && currentdatetime.isBefore(onlinedatetime);
};

var langifyUrl = function langifyUrl(objUrl, currentLang) {
	return (objUrl || '').replace('/de/', '/' + currentLang + '/');
};

var onlineUrl = function onlineUrl(obj, currentLang) {
	var urlObject = langifyUrl(obj.S_URL_Objekt, currentLang);
	return urlObject && urlObject.length > 0 && __WEBPACK_IMPORTED_MODULE_1_url___default.a.resolve("https://www.erco.com", urlObject) || '';
};

var previewUrl = function previewUrl(obj, currentLang) {
	var urlObject = langifyUrl(obj.S_URL_Objekt, currentLang);
	return urlObject && urlObject.length > 0 && __WEBPACK_IMPORTED_MODULE_1_url___default.a.resolve("https://www.stage.qa.erco.com", urlObject) || '';
};

/* harmony default export */ __webpack_exports__["a"] = ({ isProductive: isProductive, isOffline: isOffline, isBeforeProduction: isBeforeProduction, onlineUrl: onlineUrl, previewUrl: previewUrl });

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_auth__ = __webpack_require__(207);




/* harmony default export */ __webpack_exports__["a"] = ({
	state: {
		token: null,
		username: null
	},

	mutations: {
		setToken: function setToken(state, token) {
			state.token = token;
			localStorage.setItem('token', token);
			__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.headers.common['X-Authorization'] = token;
		},
		setUsername: function setUsername(state, username) {
			state.username = username;
			localStorage.setItem('username', username);
		},
		resetToken: function resetToken(state) {
			state.token = null;
			localStorage.removeItem('token');
			delete __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.headers.common['X-Authorization'];
		}
	},

	actions: {
		updateToken: function updateToken(_ref, token) {
			var commit = _ref.commit;

			commit('setToken', token);
		},
		login: function login(_ref2, credentials) {
			var commit = _ref2.commit;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_2__api_auth__["a" /* default */].login(credentials).then(function (data) {
					commit('setToken', data.jwt);
					commit('setUsername', data.PKM_Nutzername);
					resolve();
				}).catch(function (response) {
					reject(response);
				});
			});
		},
		logout: function logout(_ref3) {
			var commit = _ref3.commit;

			commit('resetToken');
		},
		userInitialize: function userInitialize(_ref4) {
			var commit = _ref4.commit;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				var token = localStorage.getItem('token');
				var username = localStorage.getItem('username');

				if (token && username) {
					commit('setToken', token);
					commit('setUsername', username);
					resolve();
				} else {
					reject();
				}
			});
		}
	},

	getters: {
		getToken: function getToken(state) {
			return state.token;
		}
	}
});

/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cGF0aCBkPSJNMCwwbDI0LDBsMCwyNGwtMjQsMGwwLC0yNFoiIHN0eWxlPSJmaWxsOm5vbmU7Ii8+PHBhdGggZD0iTTIwLDRsLTE2LDBjLTEuMTEsMCAtMS45OSwwLjg5IC0xLjk5LDJsLTAuMDEsMTJjMCwxLjExIDAuODksMiAyLDJsMTYsMGMxLjExLDAgMiwtMC44OSAyLC0ybDAsLTEyYzAsLTEuMTEgLTAuODksLTIgLTIsLTJabS0xMS41LDExbC0xLjIsMGwtMi41NSwtMy41bDAsMy41bC0xLjI1LDBsMCwtNmwxLjI1LDBsMi41LDMuNWwwLC0zLjVsMS4yNSwwbDAsNlptNSwtNC43NGwtMi41LDBsMCwxLjEybDIuNSwwbDAsMS4yNmwtMi41LDBsMCwxLjExbDIuNSwwbDAsMS4yNWwtNCwwbDAsLTZsNCwwbDAsMS4yNlptNywzLjc0YzAsMC41NSAtMC40NSwxIC0xLDFsLTQsMGMtMC41NSwwIC0xLC0wLjQ1IC0xLC0xbDAsLTVsMS4yNSwwbDAsNC41MWwxLjEzLDBsMCwtMy41MmwxLjI1LDBsMCwzLjUxbDEuMTIsMGwwLC00LjVsMS4yNSwwbDAsNVoiIHN0eWxlPSJmaWxsLXJ1bGU6bm9uemVybzsiLz48L3N2Zz4="

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(408)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(622),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(370)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(585),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(464)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(678),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 201 */,
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_ErcoLogin__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_ErcoLogin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_pages_ErcoLogin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_ErcoLogout__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_ErcoLogout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pages_ErcoLogout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_ErcoDashboard__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_ErcoDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pages_ErcoDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_ErcoObjectView__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_ErcoObjectView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pages_ErcoObjectView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_ErcoLiveView__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_ErcoLiveView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pages_ErcoLiveView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_modules_user__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_organisms_ErcoTextEditor__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_organisms_ErcoTextEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_organisms_ErcoTextEditor__);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: [{
		path: '/login',
		component: __WEBPACK_IMPORTED_MODULE_2__components_pages_ErcoLogin___default.a,
		meta: { requiresAuth: false }
	}, {
		path: '/logout',
		component: __WEBPACK_IMPORTED_MODULE_3__components_pages_ErcoLogout___default.a,
		meta: { requiresAuth: false }
	}, {
		path: '/dashboard',
		component: __WEBPACK_IMPORTED_MODULE_4__components_pages_ErcoDashboard___default.a,
		meta: { requiresAuth: true }

	}, {
		path: '/objectview/:objectId(\\d+)/:view?',
		component: __WEBPACK_IMPORTED_MODULE_5__components_pages_ErcoObjectView___default.a,
		meta: { requiresAuth: true }
	}, {
		path: '/liveview/:objectId(\\d+)/:processview?',
		component: __WEBPACK_IMPORTED_MODULE_6__components_pages_ErcoLiveView___default.a,
		meta: { requiresAuth: false }
	}, {
		path: '/texteditor',
		component: __WEBPACK_IMPORTED_MODULE_8__components_organisms_ErcoTextEditor___default.a,
		meta: { requiresAuth: false }
	}, {
		path: '*',
		meta: { defaultRoute: true }
	}]
});

router.beforeEach(function (to, from, next) {
	if (to.matched.some(function (record) {
		return record.meta.requiresAuth;
	})) {
		if (!__WEBPACK_IMPORTED_MODULE_7__store_modules_user__["a" /* default */].state.token) {
			next({
				path: '/login',
				query: { redirect: to.fullPath }
			});
		} else {
			next();
		}
	} else if (to.matched.some(function (record) {
		return record.meta.defaultRoute;
	})) {
		next({
			path: '/dashboard'
		});
	} else {
		next();
	}
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_global__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_objectsites__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_objectsetup__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_sidebar__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_tagger__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_dashboard__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_sidebarhistory__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_objectstati__ = __webpack_require__(218);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	modules: {
		global: __WEBPACK_IMPORTED_MODULE_2__modules_global__["a" /* default */],
		user: __WEBPACK_IMPORTED_MODULE_3__modules_user__["a" /* default */],
		objectsites: __WEBPACK_IMPORTED_MODULE_4__modules_objectsites__["a" /* default */],
		objectsetup: __WEBPACK_IMPORTED_MODULE_5__modules_objectsetup__["a" /* default */],
		objectstati: __WEBPACK_IMPORTED_MODULE_10__modules_objectstati__["a" /* default */],

		sidebar: __WEBPACK_IMPORTED_MODULE_6__modules_sidebar__["a" /* default */],
		sidebarhistory: __WEBPACK_IMPORTED_MODULE_9__modules_sidebarhistory__["a" /* default */],
		tagger: __WEBPACK_IMPORTED_MODULE_7__modules_tagger__["a" /* default */],
		dashboard: __WEBPACK_IMPORTED_MODULE_8__modules_dashboard__["a" /* default */]
	}
}));

/***/ }),
/* 204 */,
/* 205 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(386)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(601),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */,
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
	login: function login(credentials) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			var body = {
				PKM_Nutzername: credentials.username,
				S_Passwort: credentials.password
			};
			__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=login&json=true", body).then(function (response) {
				resolve(response.body);
			}).catch(function (response) {
				reject(response);
			});
		});
	},
	logout: function logout() {}
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["a"] = ({
	get: function get(sites, language) {
		var promisifiedSiteRequests = sites.map(function (site) {
			var id = site.PKM_Seite;

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=seite_editieren&json=true", { FKM_Seite: id, sprache: language, layoutpart: 'body', modus: 'edit' }).then(function (response) {
					response.body.id = id;
					response.body.meta = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, site, { sprache: language, loading: false });

					resolve(response.body);
				}, function (response) {
					reject(response);
				});
			});
		});

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promisifiedSiteRequests);
	},
	save: function save(ids, language, data) {
		var promisifiedSiteRequests = ids.map(function (id) {
			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=daten_speichern&json=true", { FKM_Seite: id, sprache: language, items: data[id] }).then(function (response) {
					resolve(response.body);
				}, function (response) {
					reject(response);
				});
			});
		});

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promisifiedSiteRequests);
	},
	delete: function _delete(id, objectId) {
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=seite_loeschen&json=true", { FKM_Seite: id, FKM_Objekt: objectId }).then(function (response) {
				resolve(response.body);
			}, function (response) {
				reject(response);
			});
		});
	},
	setSiteOrder: function setSiteOrder(idStrList, topicId) {
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=seite_sortieren&json=true", { FKM_Seiten_string: idStrList, FKM_Thema: topicId }).then(function () {
				resolve();
			}).catch(function () {
				reject();
			});
		});
	},
	saveMAMImage: function saveMAMImage(data) {
		var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

		var size = {
			width: data.I_Sollbreite || 2000,
			height: data.I_Sollhoehe || 1000
		};
		var postUrl = "https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=mam_bild_einbinden&json=true" + '&sprache=' + lang + '&sollbreite=' + size.width + '&sollhoehe=' + size.height;

		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(postUrl, data).then(function (response) {
				resolve(response.body);
			}, function (response) {
				reject(response);
			});
		});
	},
	deleteImage: function deleteImage(imageId, language, objectId) {
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=bild_loeschen&json=true", { PKM_Bild: imageId, sprache: language, PKM_Objekt: objectId }).then(function (response) {
				resolve(response.body);
			}).catch(function (response) {
				reject(response);
			});
		});
	},
	getTemplates: function getTemplates(objectID, topicID) {
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=vorlage_waehlen&json=true", { FKM_Objekt: objectID, PKM_Thema: topicID }).then(function (response) {
				resolve(response.body);
			}).catch(function (response) {
				reject(response);
			});
		});
	},
	setTemplateForModule: function setTemplateForModule(objectID, moduleID, topicID, templateID) {
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=seite_anlegen&json=true", { objectID: objectID, moduleID: moduleID, templateID: templateID, topicID: topicID }).then(function (response) {
				resolve(response.body);
			}).catch(function (response) {
				reject(response);
			});
		});
	},
	insertSiteAtPosition: function insertSiteAtPosition(objectID, templateID, topicID, positionNum) {
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=seite_anlegen&json=true", {
				FKM_Template: templateID,
				PKM_Thema: topicID,
				PKM_Objekt: objectID,
				U_Seitennummer: positionNum
			}).then(function (response) {
				resolve(response.body);
			}).catch(function (response) {
				reject(response);
			});
		});
	},
	getTemplateSets: function getTemplateSets(objectID) {
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=vorlagenset_waehlen&json=true", { PKM_Objekt: objectID }).then(function (response) {
				resolve(response.body);
			}).catch(function (response) {
				reject(response);
			});
		});
	},
	createTemplateSet: function createTemplateSet(objectID, objectTemplateSetID) {
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=vorlagenset_erstellen&json=true", {
				PKM_Objekt: objectID,
				set_PKM_Objekt: objectTemplateSetID
			}).then(function (response) {
				resolve(response.body);
			}).catch(function (response) {
				reject(response);
			});
		});
	}
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
	get: function get() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post("https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=list_status_items&json=true").then(function (response) {
				resolve(response.body.objekte);
			}).catch(function (response) {
				reject(response);
			});
		});
	}
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);


var pad = function pad(num) {
	var charCnt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	var fillChar = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';

	var fillCharStr = new Array(charCnt - num.toString().length + 1).join(fillChar);
	return '' + fillCharStr + num;
};

var maskMap = {
	yyyy: function yyyy(d) {
		return d.getFullYear();
	},
	yy: function yy(d) {
		return d.getFullYear().toString().slice(-2);
	},
	mm: function mm(d) {
		return pad(d.getMonth() + 1);
	},
	m: function m(d) {
		return d.getMonth() + 1;
	},
	dd: function dd(d) {
		return pad(d.getDate());
	},
	d: function d(_d) {
		return _d.getDate();
	},
	hh: function hh(d) {
		return pad(d.getHours());
	},
	h: function h(d) {
		return d.getHours();
	},
	MM: function MM(d) {
		return pad(d.getMinutes());
	},
	M: function M(d) {
		return d.getMinutes();
	},
	ss: function ss(d) {
		return pad(d.getSeconds());
	},
	s: function s(d) {
		return d.getSeconds();
	},
	i: function i(d) {
		return d.getMilliseconds();
	},
	tt: function tt(d) {
		return pad(Math.abs(d.getTimezoneOffset() / 60));
	},
	t: function t(d) {
		return Math.abs(d.getTimezoneOffset() / 60);
	}
};

var format = function format(formatStr) {
	var dateObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();

	var formatStrReplacement = formatStr;

	__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(maskMap).forEach(function (mask) {
		var maskRegExp = new RegExp('' + mask, 'g');
		if (maskMap[mask] && formatStrReplacement.match(maskRegExp)) {
			formatStrReplacement = formatStrReplacement.replace(maskRegExp, maskMap[mask](dateObj));
		}
	});

	return formatStrReplacement;
};

/* harmony default export */ __webpack_exports__["a"] = ({ format: format });

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var format = function format(text) {
	var replacementActions = [{
		pattern: '(?:\\*)([\\s\\S]*?)(?:\\*)',
		replace: '<strong>$1</strong>'
	}, {
		pattern: '(?:\\r|\\n|\\r\\n)',
		replace: '<br>'
	}];

	return replacementActions.reduce(function (workingData, action) {
		return workingData.replace(new RegExp(action.pattern, 'gm'), action.replace);
	}, text);
};

/* harmony default export */ __webpack_exports__["a"] = ({ format: format });

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(203);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

var instance = null;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.interceptors.push(function (request, next) {

	next(function (response) {
		__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('setAccessErrorStatusCode', response.status);

		if ([401, 403].includes(response.status) && instance.$router) {
			if (instance.$route.path === '/login') return;
			instance.$router.push({
				path: '/login',
				query: { redirect: instance.$route.path }
			});
		}
	});
});

__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('globalInitialize');
__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('userInitialize').catch(function () {});

instance = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
	store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			contentGrid: {
				els: {},
				handlerAssignments: []
			}
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.contentGrid.els = {
			tabs: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.$el.querySelectorAll('.nav-tabs > .flush > [data-toggle="tab"]')),
			tabContent: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.$el.querySelectorAll('.tab-pane'))
		};

		this.contentGrid.els.tabs.forEach(function (tab) {
			var matches = tab.href.match(/.*\/#{0,1}(.*)/);
			var tabId = matches && matches[1];

			if (!tabId) {
				return;
			}

			var handler = function handler(event) {
				event.preventDefault();
				_this.contentGrid.els.tabs.forEach(function (item) {
					return item.parentElement.classList.remove('active');
				});
				_this.contentGrid.els.tabContent.forEach(function (item) {
					return item.classList.remove('active');
				});

				tab.parentElement.classList.add('active');
				var tabContentToBeActivated = _this.contentGrid.els.tabContent.find(function (item) {
					return item.id === tabId;
				});

				if (tabContentToBeActivated) {
					tabContentToBeActivated.classList.add('active');
				}
				return false;
			};
			_this.contentGrid.handlerAssignments.push({
				el: tab,
				handler: handler
			});
			tab.addEventListener('click', handler);
		});
	},
	beforeDestroy: function beforeDestroy() {
		this.contentGrid.handlerAssignments.foreach(function (assignment) {
			assignment.el.removeEventListener('click', assignment.handler);
		});
	}
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_dashboard__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_objectsetup__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helper_dateHelper__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helper_objectHelper__ = __webpack_require__(62);












var gMaxObjects = 10000;

var deepClone = function deepClone(obj) {
	return JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(obj));
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: {
		searchString: '',
		language: 'de',
		objectData: [],
		objectDataUnfrozen: [],
		loadingObjectData: false,
		activeFilters: {},
		selectedObjectIds: [],
		cmsStructure: {
			structure: {},
			loading: false
		},
		userSpecifications: [],
		lastFetchAt: null,
		actionInProcess: false
	},

	mutations: {
		setObjectData: function setObjectData(state, objectData) {
			var objects = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(objectData).map(function (key) {
				return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
					key: key
				}, objectData[key], {
					S_Status: objectData[key].S_Status || '(unknown)'
				});
			}).sort(function (a, b) {
				var aTime = new Date(a.TS_zuletzt_bearbeitet).getTime();
				var bTime = new Date(b.TS_zuletzt_bearbeitet).getTime();
				return bTime - aTime;
			});

			state.objectDataUnfrozen = objects.slice(0, gMaxObjects);
			state.objectData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()(deepClone(state.objectDataUnfrozen));

			state.lastFetchAt = new Date().getTime();
		},
		setLastFetchAt: function setLastFetchAt(state, newLastFetchAt) {
			state.lastFetchAt = newLastFetchAt;
		},
		setSearchString: function setSearchString(state, searchString) {
			state.searchString = searchString;
		},
		addDashboardFilter: function addDashboardFilter(state, filter) {
			__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].set(state.activeFilters, filter.type, filter);
		},
		removeDashboardFilter: function removeDashboardFilter(state, filterType) {
			if (state.activeFilters[filterType]) {
				__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].delete(state.activeFilters, filterType);
			}
		},
		resetDashboardFilters: function resetDashboardFilters(state) {
			state.activeFilters = {};
		},
		addObjectToSelection: function addObjectToSelection(state, id) {
			state.selectedObjectIds.push(id);
		},
		removeObjectToSelection: function removeObjectToSelection(state, id) {
			var indexOfObject = state.selectedObjectIds.indexOf(id);

			if (indexOfObject > -1) {
				state.selectedObjectIds.splice(indexOfObject, 1);
			}
		},
		emptyObjectSelection: function emptyObjectSelection(state) {
			state.selectedObjectIds = [];
		},
		updateLoadingObjectData: function updateLoadingObjectData(state, status) {
			state.loadingObjectData = status;
		},
		setCMSStructure: function setCMSStructure(state, structure) {
			state.cmsStructure.structure = structure;
		},
		setCMSStructureLoadingStatus: function setCMSStructureLoadingStatus(state, status) {
			state.cmsStructure.loading = status;
		},
		updateDashboardObjectsStatus: function updateDashboardObjectsStatus(state, datasets) {
			datasets.forEach(function (dataset) {
				var currentObject = state.objectDataUnfrozen.find(function (currObject) {
					return currObject.PKM_Objekt === dataset.PKM_Objekt.toString();
				});

				if (currentObject) {
					__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].set(currentObject, 'S_Status', dataset.S_Status);
					__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].set(currentObject, 'FKM_Status', dataset.FKM_Status);
				}
			});
			state.objectData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()(deepClone(state.objectDataUnfrozen));
		},
		copyObject: function copyObject(state, data) {
			data.relations.forEach(function (relation) {
				var oldObjectId = relation.oldObjectId;
				var newObjectId = relation.newObjectId;

				var oldObject = state.objectDataUnfrozen.find(function (obj) {
					return obj.PKM_Objekt === oldObjectId.toString();
				});

				var newObject = deepClone(oldObject);
				newObject.PKM_Objekt = newObjectId.toString();
				newObject.TS_Aenderungsdatum = __WEBPACK_IMPORTED_MODULE_8__helper_dateHelper__["a" /* default */].format('yyyy.mm.dd hh:MM:ss', new Date());
				newObject.TS_zuletzt_bearbeitet = __WEBPACK_IMPORTED_MODULE_8__helper_dateHelper__["a" /* default */].format('yyyy.mm.dd hh:MM:ss', new Date());
				newObject.isFreshlyCopied = true;

				switch (data.mode) {
					case 'full':
						newObject.S_de_Objekt = newObject.S_de_Objekt + ' Kopie';
						break;
					case 'empty':
						newObject.S_de_Objekt = newObject.S_de_Objekt + ' Leerkopie';
						newObject.S_Stellvertreterbild = null;
						break;
					default:}

				state.objectDataUnfrozen.push(newObject);
			});

			state.objectDataUnfrozen = state.objectDataUnfrozen.sort(function (a, b) {
				var aTime = new Date(a.TS_zuletzt_bearbeitet).getTime();
				var bTime = new Date(b.TS_zuletzt_bearbeitet).getTime();
				return bTime - aTime;
			});

			state.objectData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()(deepClone(state.objectDataUnfrozen));
		},
		setUserSpecifications: function setUserSpecifications(state, userSpecifications) {
			state.userSpecifications = userSpecifications;
		},
		setObjectNames: function setObjectNames(state, objectsIdNameMap) {
			objectsIdNameMap.forEach(function (objIdNamePair) {
				var objId = objIdNamePair.id.toString();
				var newName = objIdNamePair.name[state.language];
				var foundObject = state.objectDataUnfrozen.find(function (obj) {
					return obj.PKM_Objekt === objId;
				});

				if (foundObject) {
					__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].set(foundObject, 'S_' + state.language + '_Objekt', newName);
				}
			});

			state.objectData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()(deepClone(state.objectDataUnfrozen));
		},
		setActionInProcess: function setActionInProcess(state, actionInProcess) {
			state.actionInProcess = actionInProcess;
		}
	},
	actions: {
		initDashboard: function initDashboard(_ref) {
			var commit = _ref.commit,
			    state = _ref.state,
			    getters = _ref.getters;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				var remainingSeconds = (120000 - (new Date().getTime() - (state.lastFetchAt || 0))) / 1000;
				if (remainingSeconds > 0) {
					resolve({ status: -1 });
					return;
				}

				commit('updateLoadingObjectData', true);
				__WEBPACK_IMPORTED_MODULE_6__api_dashboard__["a" /* default */].get().then(function (response) {
					__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(response || {}).forEach(function (key) {
						response[key] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, response[key], {
							isProductive: __WEBPACK_IMPORTED_MODULE_9__helper_objectHelper__["a" /* default */].isProductive(response[key], getters.statiAssoc),
							isBeforeProduction: __WEBPACK_IMPORTED_MODULE_9__helper_objectHelper__["a" /* default */].isBeforeProduction(response[key]),
							onlineUrl: __WEBPACK_IMPORTED_MODULE_9__helper_objectHelper__["a" /* default */].onlineUrl(response[key], 'de'),
							previewUrl: __WEBPACK_IMPORTED_MODULE_9__helper_objectHelper__["a" /* default */].previewUrl(response[key], 'de')
						});
					});
					commit('setObjectData', response);
					commit('updateLoadingObjectData', false);
					resolve(response);
				}).catch(function (e) {
					commit('updateLoadingObjectData', false);
					reject(e);
				});
			});
		},
		updateSearchString: function updateSearchString(_ref2, params) {
			var commit = _ref2.commit;

			commit('setSearchString', params.searchString);
		},
		addDashboardFilter: function addDashboardFilter(_ref3, filter) {
			var commit = _ref3.commit;

			commit('addDashboardFilter', filter);
		},
		removeDashboardFilter: function removeDashboardFilter(_ref4, filterType) {
			var commit = _ref4.commit;

			commit('removeDashboardFilter', filterType);
		},
		resetDashboardFilters: function resetDashboardFilters(_ref5) {
			var commit = _ref5.commit;

			commit('resetDashboardFilters');
			commit('setSearchString', '');
		},
		invalidateLastFetchAt: function invalidateLastFetchAt(_ref6) {
			var commit = _ref6.commit,
			    state = _ref6.state;

			commit('setLastFetchAt', state.lastFetchAt - 120000);
		},
		handleObjectSelection: function handleObjectSelection(_ref7, action) {
			var commit = _ref7.commit;

			switch (action.type) {
				case 'add':
					commit('addObjectToSelection', action.objID);
					break;
				case 'remove':
					commit('removeObjectToSelection', action.objID);
					break;
				case 'empty':
					commit('emptyObjectSelection');
					break;
				default:}
		},
		triggerActionOnDashboardObjects: function triggerActionOnDashboardObjects(_ref8, action) {
			var commit = _ref8.commit,
			    dispatch = _ref8.dispatch,
			    rootState = _ref8.rootState;

			var selectedDashboardObjectIds = rootState.dashboard.selectedObjectIds;
			commit('setActionInProcess', true);

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				switch (action) {
					case 'clone':
						__WEBPACK_IMPORTED_MODULE_6__api_dashboard__["a" /* default */].batchCopyObject(selectedDashboardObjectIds).then(function (responses) {
							var idsRelations = responses.map(function (response) {
								return {
									oldObjectId: response.sourceId,
									newObjectId: response.PKM_Objekt
								};
							});
							commit('copyObject', {
								relations: idsRelations,
								mode: 'full'
							});
							commit('setActionInProcess', false);
							resolve(responses);
						}).catch(function (e) {
							commit('setActionInProcess', false);
							reject(e);
						});
						break;
					case 'emptyCopy':
						__WEBPACK_IMPORTED_MODULE_6__api_dashboard__["a" /* default */].batchCopyObjectEmpty(selectedDashboardObjectIds).then(function (responses) {
							var idsRelations = responses.map(function (response) {
								return {
									oldObjectId: response.sourceId,
									newObjectId: response.PKM_Objekt
								};
							});
							commit('copyObject', {
								relations: idsRelations,
								mode: 'empty'
							});
							commit('setActionInProcess', false);
							resolve(responses);
						}).catch(function (e) {
							commit('setActionInProcess', false);
							reject(e);
						});
						break;
					default:
						commit('setActionInProcess', false);
						reject('Unbekannte Aktion: ' + action);
				}
			});
		},
		changeStatusOnDashboardObjects: function changeStatusOnDashboardObjects(_ref9, statusId) {
			var commit = _ref9.commit,
			    dispatch = _ref9.dispatch,
			    state = _ref9.state,
			    rootState = _ref9.rootState,
			    getters = _ref9.getters;

			commit('setActionInProcess', true);

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				var statiName = rootState.objectstati.stati.find(function (stati) {
					return stati.PKM_Status === statusId;
				}).S_Status;

				var selectedDasboardObjects = state.selectedObjectIds.map(function (id) {
					return {
						PKM_Objekt: id,
						FKM_Status: statusId
					};
				});

				var extendedSelectedDashboardObjects = selectedDasboardObjects.map(function (currObject) {
					return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, currObject, {
						S_Status: statiName
					});
				});

				__WEBPACK_IMPORTED_MODULE_7__api_objectsetup__["a" /* default */].batchStatusSet(selectedDasboardObjects).then(function (response) {
					commit('updateDashboardObjectsStatus', extendedSelectedDashboardObjects);

					if (statusId === getters.statiAssoc.gelöscht) {
						commit('emptyObjectSelection');
					}

					commit('setActionInProcess', false);
					resolve(response);
				}).catch(function (e) {
					commit('setActionInProcess', false);
					reject(e);
				});
			});
		},
		getCMSStructure: function getCMSStructure(_ref10) {
			var commit = _ref10.commit;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				commit('setCMSStructureLoadingStatus', true);
				__WEBPACK_IMPORTED_MODULE_6__api_dashboard__["a" /* default */].getCMSStructure().then(function (response) {
					commit('setCMSStructure', response);

					__WEBPACK_IMPORTED_MODULE_6__api_dashboard__["a" /* default */].getUserSpecifications().then(function (specResponse) {
						var extendedSpecifications = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(specResponse).map(function (specIndex) {
							var specification = specResponse[specIndex];
							specification.gattungen = {};

							__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(response).forEach(function (categoryId) {
								var cmsSpecification = response[categoryId].spezifikationen[specification.PKM_Spezifikation];

								if (cmsSpecification && cmsSpecification.gattungen) {
									specification.gattungen = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(cmsSpecification.gattungen).map(function (gattungId) {
										return {
											PKM_Gattung: gattungId,
											S_Gattung: cmsSpecification.gattungen[gattungId].name
										};
									});
								}
							});

							return specification;
						});

						commit('setUserSpecifications', extendedSpecifications);

						resolve(specResponse);
					}).catch(function (specResponse) {
						reject(specResponse);
					});
				}).catch(function (e) {
					reject(e);
				});
			});
		},
		updateDashboardObjectNames: function updateDashboardObjectNames(_ref11, objectsIdNameMap) {
			var commit = _ref11.commit,
			    state = _ref11.state;

			if (state.objectData.length > 0) {
				commit('setObjectNames', objectsIdNameMap);
			}
		}
	},

	getters: {
		selectedDashboardObjects: function selectedDashboardObjects(state) {
			return state.selectedObjectIds.map(function (objId) {
				var strObjId = objId.toString();
				return state.objectData.find(function (obj) {
					return obj.PKM_Objekt === strObjId;
				});
			});
		}
	}
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);


/* harmony default export */ __webpack_exports__["a"] = ({
	state: {
		accessErrorStatusCode: -1,
		countries: []
	},

	mutations: {
		setAccessErrorStatusCode: function setAccessErrorStatusCode(state, accessErrorStatusCode) {
			state.accessErrorStatusCode = accessErrorStatusCode;
		},
		setCountries: function setCountries(state, countries) {
			state.countries = countries;
		}
	},
	actions: {
		globalInitialize: function globalInitialize(_ref) {
			var commit = _ref.commit;

			window.addEventListener('storage', function (event) {
				commit('setAccessErrorStatusCode', parseInt(event.newValue, 10));
			});
		},
		setAccessErrorStatusCode: function setAccessErrorStatusCode(_ref2, accessErrorStatusCode) {
			var commit = _ref2.commit,
			    dispatch = _ref2.dispatch;

			window.localStorage.setItem('accessErrorStatusCode', accessErrorStatusCode.toString());
			commit('setAccessErrorStatusCode', accessErrorStatusCode);
		},
		fetchCountries: function fetchCountries(_ref3) {
			var commit = _ref3.commit,
			    state = _ref3.state,
			    rootState = _ref3.rootState;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
				if (state.countries.length > 0) {
					resolve();
					return;
				}

				var countries = (rootState.objectsetup.current.land || []).sort(function (a, b) {
					var aLower = a.S_Land.toLowerCase();
					var bLower = b.S_Land.toLowerCase();
					var minLength = Math.min(aLower.length, bLower.length);

					var i = 0;
					while (i < minLength) {
						var diff = aLower.charCodeAt(i) - bLower.charCodeAt(i);
						if (diff !== 0) {
							return diff;
						}
						i += 1;
					}

					return aLower.length - bLower.length;
				}).map(function (country) {
					country.S_Land = country.S_Land.split('_').map(function (part) {
						return '' + part[0].toUpperCase() + part.substr(1);
					}).join(' ');
					return country;
				});
				commit('setCountries', countries);
				resolve();
			});
		}
	}
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_objectHelper__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_objectsetup__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_tagger__ = __webpack_require__(60);













/* harmony default export */ __webpack_exports__["a"] = ({
	state: {
		language: '',
		current: {},
		loading: true,
		statusWaiting: false
	},

	mutations: {
		setObjectLanguage: function setObjectLanguage(state, lang) {
			state.language = lang;
		},
		setObjectSetup: function setObjectSetup(state, object) {
			[1, 2, 3, 4, 5, 6].forEach(function (num) {
				var propNamePostfix = num === 1 ? '' : '' + num;
				var idPropName = 'FKM_Gattung' + propNamePostfix;
				var titlePropName = 'S_Gattung' + propNamePostfix;

				var id = object[idPropName] || '0';
				var title = object[titlePropName] || '';

				var foundGattung = object.gattungen.find(function (currGattung) {
					return currGattung.PKM_Gattung === id;
				});

				if (foundGattung) {
					title = foundGattung.S_Gattung;
				}

				object[idPropName] = id;
				object[titlePropName] = title;
			});

			state.current = object;
		},
		setObjectLoading: function setObjectLoading(state, loading) {
			state.loading = loading;
		},
		updateObjectSetupObjectname: function updateObjectSetupObjectname(state, objectname) {
			__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(objectname).forEach(function (langKey) {
				state.current['S_' + langKey + '_Objekt'] = objectname[langKey];
			});
		},
		updateObjectSetupURL: function updateObjectSetupURL(state, newURL) {
			state.current.S_URL_Objekt = newURL;
		},
		updateObjectSetupObjectAdditional: function updateObjectSetupObjectAdditional(state, objectAdditional) {
			state.current.S_Zusatz = objectAdditional;
		},
		updateObjectSetupObjectEditor: function updateObjectSetupObjectEditor(state, objectEditor) {
			state.current.FKM_Nutzername_Redakteur = objectEditor;
		},
		updateObjectSetupObjectDesigner: function updateObjectSetupObjectDesigner(state, objectDesigner) {
			state.current.FKM_Nutzername_Designer = objectDesigner;
		},
		updateObjectSetupSpecification: function updateObjectSetupSpecification(state, specification) {
			state.current.S_Spezifikation = specification;
		},
		updateObjectSetupLightscoutClassification: function updateObjectSetupLightscoutClassification(state, lang) {
			var langPropName = 'S_' + lang.code + '_Objekt';
			var currValue = state.current[langPropName];

			if (lang.value && currValue === __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* default */].NO_CONTENT) {
				state.current[langPropName] = '';
			} else {
				state.current[langPropName] = __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* default */].NO_CONTENT;
			}

			state.current.sprachen[lang.code] = lang.value;
		},
		updateObjectSetupVisibility: function updateObjectSetupVisibility(state, visibleStr) {
			state.current.B_Sichtbar = visibleStr;
		},
		updateObjectSetupSynchblock: function updateObjectSetupSynchblock(state, synchStr) {
			state.current.B_Synchblock = synchStr;
		},
		updateObjectSetupStatus: function updateObjectSetupStatus(state, status) {
			state.current.FKM_Status = status;
		},
		updateObjectSetupPkStatus: function updateObjectSetupPkStatus(state, _ref) {
			var index = _ref.index,
			    value = _ref.value;

			state.current['FKM_PK_Status_' + index] = value;
		},
		updateObjectSetupStatusWaiting: function updateObjectSetupStatusWaiting(state, waiting) {
			state.statusWaiting = waiting;
		},
		updateObjectSetupBasisGenus: function updateObjectSetupBasisGenus(state, genus) {
			__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(genus).forEach(function (genusKey) {
				var genusData = genus[genusKey];

				var propNamePostfix = genusData.type === 'basis' ? '' : genusKey;
				var idPropName = 'FKM_Gattung' + propNamePostfix;
				var titlePropName = 'S_Gattung' + propNamePostfix;

				if (genusData.id) {
					__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].set(state.current, idPropName, genusData.id);
					__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].set(state.current, titlePropName, genusData.value);
				} else {
					__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].set(state.current, idPropName, '0');
					__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].set(state.current, titlePropName, '');
				}
			});
		},
		updateObjectSetupTriad: function updateObjectSetupTriad(state, triad) {
			__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(triad).forEach(function (branchKey) {
				var branch = triad[branchKey];
				__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(branch).forEach(function (groupKey) {
					var group = branch[groupKey];
					__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(group).forEach(function (itemKey) {
						var itemValue = group[itemKey];

						state.current.dreiklang[branchKey].forEach(function (branchGroup) {
							if (branchGroup.PKM_Gattung === groupKey.toString()) {
								branchGroup.objekte.forEach(function (groupItem) {
									if (groupItem.PKM_Objekt === itemKey.toString()) {
										groupItem.selected = itemValue.toString();
									}
								});
							}
						});
					});
				});
			});
		},
		updateObjectSetupLinkedProducts: function updateObjectSetupLinkedProducts(state, linkedProducts) {
			__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(linkedProducts).forEach(function (branchKey) {
				var branch = linkedProducts[branchKey];
				__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(branch).forEach(function (groupKey) {
					var group = branch[groupKey];
					__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(group).forEach(function (itemKey) {
						var itemValue = group[itemKey];

						state.current.verwendete_produkte[branchKey].forEach(function (branchGroup) {
							if (branchGroup.PKM_Gattung.toString() === groupKey.toString()) {
								branchGroup.objekte.forEach(function (groupItem) {
									if (groupItem.PKM_Objekt.toString() === itemKey.toString()) {
										groupItem.selected = itemValue.toString();
									}
								});
							}
						});
					});
				});
			});
		},
		updateObjectSetupPublishDateTime: function updateObjectSetupPublishDateTime(state, datetime) {
			state.current.TS_online_Liveserver = datetime;
		},
		updateObjectSetupGoOfflineDateTime: function updateObjectSetupGoOfflineDateTime(state, datetime) {
			state.current.TS_offline_Liveserver = datetime;
		},
		updateObjectSetupCategories: function updateObjectSetupCategories(state, tags) {
			state.current.tags = tags;
		},
		updateObjectSetupMediaformats: function updateObjectSetupMediaformats(state, tags) {
			state.current.tags = tags;
		},
		updateObjectProjectToCountry: function updateObjectProjectToCountry(state, countryId) {
			var currentlySelectedCountryIndex = state.current.land.findIndex(function (country) {
				return country.selected === 'true';
			});

			if (currentlySelectedCountryIndex >= 0) {
				state.current.land[currentlySelectedCountryIndex].selected = 'false';
			}

			var newlySelectedCountryIndex = state.current.land.findIndex(function (country) {
				return country.PKM_Land === countryId;
			});

			if (newlySelectedCountryIndex) {
				state.current.land[newlySelectedCountryIndex].selected = 'true';
			}
		}
	},

	actions: {
		setObjectLanguage: function setObjectLanguage(_ref2, lang) {
			var commit = _ref2.commit;

			window.document.cookie = 'lang=' + encodeURIComponent(lang);
			commit('setObjectLanguage', lang);
		},
		getObjectSetup: function getObjectSetup(_ref3, requestData) {
			var commit = _ref3.commit,
			    dispatch = _ref3.dispatch;

			commit('setObjectLoading', true);

			return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_7__api_objectsetup__["a" /* default */].get(requestData.id, requestData.lang).then(function (response) {
					commit('setObjectSetup', response);
					commit('setObjectLoading', false);

					dispatch('fetchCountries');

					resolve();
				}).catch(function (e) {
					commit('setObjectLoading', false);
					reject(e);
				});
			});
		},
		getObjectSetupWithSites: function getObjectSetupWithSites(_ref4, requestData) {
			var commit = _ref4.commit,
			    state = _ref4.state,
			    dispatch = _ref4.dispatch;

			return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				var id = requestData && requestData.id || state.current && state.current.PKM_Objekt;
				var lang = requestData && requestData.lang || state.current && state.current.sprache;

				dispatch('getObjectSetup', { id: id, lang: lang }).then(function () {
					dispatch('getLayoutTemplates');

					var sites = state.current.seiten;
					dispatch('getObjectSites', { sites: sites, lang: lang });
					resolve();
				}).catch(function (e) {
					reject(e);
				});
			});
		},
		updateObjectSetup: function updateObjectSetup(_ref5, objectData) {
			var commit = _ref5.commit,
			    state = _ref5.state;

			commit('setObjectSetup', objectData);
			return __WEBPACK_IMPORTED_MODULE_7__api_objectsetup__["a" /* default */].set(state.current.PKM_Objekt, {
				objectData: objectData
			});
		},
		updateObjectSetupObjectname: function updateObjectSetupObjectname(_ref6, objectname) {
			var commit = _ref6.commit,
			    state = _ref6.state,
			    dispatch = _ref6.dispatch;

			commit('updateObjectSetupObjectname', objectname);

			var objectnameObj = {};
			__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(objectname).forEach(function (langKey) {
				objectnameObj['S_' + langKey + '_Objekt'] = objectname[langKey];
			});

			return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_7__api_objectsetup__["a" /* default */].set(state.current.PKM_Objekt, objectnameObj).then(function (resp) {
					dispatch('updateDashboardObjectNames', [{ id: state.current.PKM_Objekt, name: objectname }]);
					resolve(resp);
				}).catch(function (e) {
					reject(e);
				});
			});
		},
		updateObjectSetupObjectAdditional: function updateObjectSetupObjectAdditional(_ref7, objectAdditional) {
			var commit = _ref7.commit,
			    state = _ref7.state;

			if (typeof objectAdditional.objectadditional === 'string') {
				commit('updateObjectSetupObjectAdditional', objectAdditional.objectadditional);
				return __WEBPACK_IMPORTED_MODULE_7__api_objectsetup__["a" /* default */].set(state.current.PKM_Objekt, {
					S_Zusatz: objectAdditional.objectadditional
				});
			}
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject();
		},
		updateObjectSetupObjectEditor: function updateObjectSetupObjectEditor(_ref8, objectEditor) {
			var commit = _ref8.commit,
			    state = _ref8.state;

			if (typeof objectEditor.objecteditor === 'string') {
				commit('updateObjectSetupObjectEditor', objectEditor.objecteditor);
				return __WEBPACK_IMPORTED_MODULE_7__api_objectsetup__["a" /* default */].set(state.current.PKM_Objekt, {
					FKM_Nutzername_Redakteur: objectEditor.objecteditor
				});
			}
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject();
		},
		updateObjectSetupObjectDesigner: function updateObjectSetupObjectDesigner(_ref9, objectDesigner) {
			var commit = _ref9.commit,
			    state = _ref9.state;

			if (typeof objectDesigner.objectdesigner === 'string') {
				commit('updateObjectSetupObjectDesigner', objectDesigner.objectdesigner);
				return __WEBPACK_IMPORTED_MODULE_7__api_objectsetup__["a" /* default */].set(state.current.PKM_Objekt, {
					FKM_Nutzername_Designer: objectDesigner.objectdesigner
				});
			}
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject();
		},
		updateObjectSetupSpecification: function updateObjectSetupSpecification(_ref10, specification) {
			var commit = _ref10.commit,
			    state = _ref10.state;

			if (typeof specification.specification === 'string') {
				commit('updateObjectSetupSpecification', specification.specification);
				return __WEBPACK_IMPORTED_MODULE_7__api_objectsetup__["a" /* default */].set(state.current.PKM_Objekt, {
					S_Spezifikation: specification.specification
				});
			}
			return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				return reject();
			});
		},
		updateObjectSetupLightscoutClassification: function updateObjectSetupLightscoutClassification(_ref11, lang) {
			var commit = _ref11.commit,
			    state = _ref11.state;

			var langPropName = 'S_' + lang.code + '_Objekt';
			var currValue = state.current[langPropName];
			var data = {};

			if (lang.value && currValue === __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* default */].NO_CONTENT) {
				data[langPropName] = '';
			} else {
				data[langPropName] = __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* default */].NO_CONTENT;
			}

			return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_7__api_objectsetup__["a" /* default */].set(state.current.PKM_Objekt, data).then(function (response) {
					commit('updateObjectSetupLightscoutClassification', lang);
					resolve(response);
				}).catch(function (e) {
					reject(e);
				});
			});
		},
		updateObjectSetupVisibility: function updateObjectSetupVisibility(_ref12, visible) {
			var commit = _ref12.commit,
			    state = _ref12.state;

			var valStr = visible ? 'j' : 'n';
			var data = {
				B_Sichtbar: valStr
			};
			return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_7__api_objectsetup__["a" /* default */].set(state.current.PKM_Objekt, data).then(function (response) {
					commit('updateObjectSetupVisibility', valStr);
					resolve(response);
				}).catch(function (e) {
					reject(e);
				});
			});
		},
		updateObjectSetupSynchblock: function updateObjectSetupSynchblock(_ref13, synchblock) {
			var commit = _ref13.commit,
			    state = _ref13.state;

			var valStr = synchblock ? 'j' : 'n';
			var data = {
				B_Synchblock: valStr
			};
			return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_7__api_objectsetup__["a" /* default */].set(state.current.PKM_Objekt, data).then(function (response) {
					commit('updateObjectSetupSynchblock', valStr);
					resolve(response);
				}).catch(function (e) {
					reject(e);
				});
			});
		},
		updateObjectSetupStatus: function updateObjectSetupStatus(_ref14, data) {
			var commit = _ref14.commit,
			    state = _ref14.state,
			    getters = _ref14.getters,
			    dispatch = _ref14.dispatch;

			commit('updateObjectSetupStatusWaiting', true);

			return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				var lang = data.passLang ? state.current.sprache : null;
				var additionalParams = {};

				if (data.mode) {
					additionalParams.mode = data.mode;
				}

				__WEBPACK_IMPORTED_MODULE_7__api_objectsetup__["a" /* default */].statusSet(state.current.PKM_Objekt, data.status, lang, additionalParams).then(function (resp) {
					if (typeof data.status === 'undefined') {
						throw new Error('No status passed to "updateObjectSetupStatus"-action!');
					}

					var newStatus = parseInt(data.status, 10);

					if (data.mode !== 'preview' && newStatus !== getters.statiAssoc.synchronize) {
						commit('updateObjectSetupStatus', newStatus);
					}

					var objURL = resp.objekt_staging_url ? resp.objekt_staging_url : '';

					if (objURL === '' && newStatus === getters.statiAssoc.synchronize) {
						objURL = state.current.S_URL_Objekt;
					}

					commit('updateObjectSetupURL', objURL);
					commit('updateObjectSetupStatusWaiting', false);

					if (newStatus === getters.statiAssoc.online) {
						commit('updateObjectSetupPublishDateTime', resp.TS_online_Liveserver).then(resolve).catch(reject);
					} else {
						resolve();
					}
				}).catch(function (err) {
					commit('updateObjectSetupStatusWaiting', false);
					reject(err);
				});
			});
		},
		clearLightscoutCacheEntry: function clearLightscoutCacheEntry(_ref15) {
			var commit = _ref15.commit,
			    state = _ref15.state;

			commit('updateObjectSetupStatusWaiting', true);

			return __WEBPACK_IMPORTED_MODULE_7__api_objectsetup__["a" /* default */].clearLightscoutCacheEntry(state.current.PKM_Objekt).then(function (message) {
				alert(message.trim());
			}).catch(function (err) {
				alert('Cache konnte nicht geleert werden: ' + err);
			}).finally(function () {
				commit('updateObjectSetupStatusWaiting', false);
			});
		},
		updateObjectSetupPkStatus: function updateObjectSetupPkStatus(_ref16, data) {
			var commit = _ref16.commit,
			    state = _ref16.state;

			commit('updateObjectSetupPkStatus', { index: data.S_Modus, value: data.PKM_Status });

			return __WEBPACK_IMPORTED_MODULE_7__api_objectsetup__["a" /* default */].pkStatusSet(state.current.PKM_Objekt, data.PKM_Status);
		},
		updateObjectSetupBasisGenus: function updateObjectSetupBasisGenus(_ref17, genus) {
			var commit = _ref17.commit,
			    state = _ref17.state;

			commit('updateObjectSetupBasisGenus', genus);

			var gattung = {};
			__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(genus).forEach(function (index) {
				switch (index) {

					case '0':
						gattung.FKM_Gattung = genus[index].id || '0';
						break;

					case '2':case '3':
					case '4':case '5':
					case '6':
						gattung['FKM_Gattung' + index] = genus[index].id || '0';
						break;

					default:
				}
			});

			return __WEBPACK_IMPORTED_MODULE_7__api_objectsetup__["a" /* default */].set(state.current.PKM_Objekt, gattung);
		},
		updateObjectSetupTriad: function updateObjectSetupTriad(_ref18, triad) {
			var commit = _ref18.commit,
			    state = _ref18.state;

			var triadCopy = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(triad));
			commit('updateObjectSetupTriad', triad);

			__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(triad).forEach(function (branchKey) {
				triadCopy[branchKey] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(triad[branchKey]).map(function (groupKey) {
					var groupObj = {
						PKM_Gattung: groupKey,
						objekte: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(triad[branchKey][groupKey]).map(function (itemKey) {
							var itemObj = {
								PKM_Objekt: itemKey,
								selected: triad[branchKey][groupKey][itemKey]
							};
							return itemObj;
						})
					};
					return groupObj;
				});
			});

			return __WEBPACK_IMPORTED_MODULE_7__api_objectsetup__["a" /* default */].set(state.current.PKM_Objekt, { dreiklang: triadCopy });
		},
		updateObjectSetupLinkedProducts: function updateObjectSetupLinkedProducts(_ref19, linkedProducts) {
			var commit = _ref19.commit,
			    state = _ref19.state;

			var linkedProductsCopy = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(linkedProducts));
			commit('updateObjectSetupLinkedProducts', linkedProducts);

			__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(linkedProducts).forEach(function (branchKey) {
				linkedProductsCopy[branchKey] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(linkedProducts[branchKey]).map(function (groupKey) {
					var groupObj = {
						PKM_Gattung: groupKey.toString(),
						objekte: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(linkedProducts[branchKey][groupKey]).map(function (itemKey) {
							var itemObj = {
								PKM_Objekt: itemKey,
								selected: linkedProducts[branchKey][groupKey][itemKey]
							};
							return itemObj;
						})
					};
					return groupObj;
				});
			});

			return __WEBPACK_IMPORTED_MODULE_7__api_objectsetup__["a" /* default */].set(state.current.PKM_Objekt, {
				verwendete_produkte: linkedProductsCopy
			});
		},
		updateObjectSetupPublishDateTime: function updateObjectSetupPublishDateTime(_ref20, datetime) {
			var commit = _ref20.commit,
			    state = _ref20.state;

			return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				return __WEBPACK_IMPORTED_MODULE_7__api_objectsetup__["a" /* default */].set(state.current.PKM_Objekt, {
					TS_online_Liveserver: datetime
				}).then(function (resp) {
					commit('updateObjectSetupPublishDateTime', datetime);
					resolve(resp);
				}).catch(reject);
			});
		},
		updateObjectSetupGoOfflineDateTime: function updateObjectSetupGoOfflineDateTime(_ref21, datetime) {
			var commit = _ref21.commit,
			    state = _ref21.state;

			return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				return __WEBPACK_IMPORTED_MODULE_7__api_objectsetup__["a" /* default */].set(state.current.PKM_Objekt, {
					TS_offline_Liveserver: datetime
				}).then(function (resp) {
					commit('updateObjectSetupGoOfflineDateTime', datetime);
					resolve(resp);
				}).catch(reject);
			});
		},
		updateObjectSetupCategories: function updateObjectSetupCategories(_ref22, categories) {
			var commit = _ref22.commit,
			    state = _ref22.state;

			var initialTagIDMap = {};

			__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.current.tags.result).forEach(function (tagID) {
				var currInitTag = state.current.tags.result[tagID];
				initialTagIDMap[currInitTag.S_Value] = tagID;
			});

			__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(categories.tags).forEach(function (tag) {
				var currTag = categories.tags[tag];
				if (initialTagIDMap[tag]) {
					categories.tags[tag].id = initialTagIDMap[tag];
				}

				if (currTag.action === 'remove' && currTag.id === null) {
					delete categories.tags[tag];
				}
			});

			var tagSetPromises = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(categories.tags).map(function (tag) {
				var currTag = categories.tags[tag];

				if (currTag.action === 'add') {
					return __WEBPACK_IMPORTED_MODULE_8__api_tagger__["a" /* default */].setTag(state.current.PKM_Objekt, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(currTag.value)[0], currTag.value);
				}

				return __WEBPACK_IMPORTED_MODULE_8__api_tagger__["a" /* default */].deleteTag(currTag.id, currTag.value);
			});

			var promisifiedTagActions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(tagSetPromises);

			return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				promisifiedTagActions.then(function () {
					__WEBPACK_IMPORTED_MODULE_8__api_tagger__["a" /* default */].getTags(state.current.PKM_Objekt).then(function (response) {
						commit('updateObjectSetupCategories', response);
						resolve();
					}).catch(function () {
						reject();
					});
				}).catch(function () {});
			});
		},
		updateObjectSetupMediaformats: function updateObjectSetupMediaformats(_ref23, mediaformats) {
			var commit = _ref23.commit,
			    state = _ref23.state;

			var initialTagIDMap = {};
			__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.current.tags.result).forEach(function (tagID) {
				var currInitTag = state.current.tags.result[tagID];
				initialTagIDMap[currInitTag.S_Value] = tagID;
			});

			__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(mediaformats.tags).forEach(function (tag) {
				var currTag = mediaformats.tags[tag];
				if (initialTagIDMap[tag]) {
					mediaformats.tags[tag].id = initialTagIDMap[tag];
				}

				if (currTag.action === 'remove' && currTag.id === null) {
					delete mediaformats.tags[tag];
				}
			});

			var tagSetPromises = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(mediaformats.tags).map(function (tag) {
				var currTag = mediaformats.tags[tag];

				if (currTag.action === 'add') {
					return __WEBPACK_IMPORTED_MODULE_8__api_tagger__["a" /* default */].setTag(state.current.PKM_Objekt, currTag.value, 'medienformat');
				}

				return __WEBPACK_IMPORTED_MODULE_8__api_tagger__["a" /* default */].deleteTag(currTag.id, currTag.value);
			});

			var promisifiedTagActions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(tagSetPromises);

			return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				promisifiedTagActions.then(function () {
					__WEBPACK_IMPORTED_MODULE_8__api_tagger__["a" /* default */].getTags(state.current.PKM_Objekt).then(function (response) {
						console.log('getTags - Success!', response);
						commit('updateObjectSetupMediaformats', response);
						resolve();
					}).catch(function (response) {
						console.log('getTags - Fail!', response);
						reject();
					});
				}).catch(function () {
					console.error('Tag-Aktionen fehlgeschlagen!');
				});
			});
		},
		updateObjectProjectToCountry: function updateObjectProjectToCountry(_ref24, countryId) {
			var commit = _ref24.commit,
			    state = _ref24.state;

			return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_7__api_objectsetup__["a" /* default */].setProjectToCountry(state.current.PKM_Objekt, countryId.objectcountry).then(function () {
					commit('updateObjectProjectToCountry', countryId.objectcountry);
					resolve();
				}).catch(function (response) {
					reject(response);
				});
			});
		},
		triggerIdTextRTFExport: function triggerIdTextRTFExport(_ref25) {
			var state = _ref25.state;

			return __WEBPACK_IMPORTED_MODULE_7__api_objectsetup__["a" /* default */].getIdTextRTFExport(state.current.PKM_Objekt, state.language);
		}
	},

	getters: {
		objectname: function objectname(state) {
			return state.current && state.current['S_' + state.language + '_Objekt'] || '';
		},
		themeIdToOrder: function themeIdToOrder(state) {
			var themeIdOrderMap = {};

			(state.current.themen || []).forEach(function (theme) {
				var themeId = theme.PKM_Thema;
				var orderNum = parseInt(theme.U_Reihenfolge, 10);
				themeIdOrderMap[themeId] = orderNum;
			});

			return themeIdOrderMap;
		},
		topicIds: function topicIds(state) {
			var sites = state.current.seiten || [];
			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(sites.reduce(function (topicIds, site) {
				var topicId = parseInt(site.FKM_Thema, 10);
				topicIds[topicId] = true;
				return topicIds;
			}, {}));
		},
		objectIsProductive: function objectIsProductive(state, getters) {
			return __WEBPACK_IMPORTED_MODULE_6__helper_objectHelper__["a" /* default */].isProductive(state.current, getters.statiAssoc);
		},
		visitableObjectPreviewUrl: function visitableObjectPreviewUrl(state) {
			return __WEBPACK_IMPORTED_MODULE_6__helper_objectHelper__["a" /* default */].previewUrl(state.current, state.language);
		},
		visitableObjectOnlineUrl: function visitableObjectOnlineUrl(state) {
			return __WEBPACK_IMPORTED_MODULE_6__helper_objectHelper__["a" /* default */].onlineUrl(state.current, state.language);
		}
	}
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_url__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_objectsites__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helper_textFormatHelper__ = __webpack_require__(211);













function orderItemsByTemplate() {
	var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var template = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	var regexp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

	if (!regexp) {
		return items;
	}

	var itemOrder = template.match(regexp) || [];

	if (itemOrder) {
		itemOrder = itemOrder.filter(function (item, index, self) {
			return self.indexOf(item) === index;
		}).map(function (item) {
			return item.match(/"(.*?)"/)[1];
		});
	}

	var itemsNotInUse = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(items).reduce(function (notInUseList, itemKey) {
		var item = items[itemKey];
		if (itemOrder.indexOf(itemKey) === -1) {
			notInUseList.push(item);
		}
		return notInUseList;
	}, []);

	var itemsInUse = itemOrder.map(function (item) {
		return items[item];
	});

	return itemsInUse.concat(itemsNotInUse);
}

var defaultSiteTranslations = __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* default */].langs.reduce(function (acc, lang) {
	acc[lang.key] = null;
	return acc;
}, {});

var defaultSite = {
	id: null,
	current: {
		items: {},
		template: '',
		dirtyItems: []
	},
	translations: defaultSiteTranslations,
	uncommited: null
};

var objectSites = {
	meta: {
		ids: [],
		lang: '',
		fetched: false
	},
	sites: [],
	sitesFinishedLoading: false,
	objectdata: {
		current: {
			items: []
		}
	},
	layoutAction: {
		type: null,
		values: null
	},
	templates: {},
	templateSets: [],
	sitesArePrepared: false
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(objectSites)),

	mutations: {
		resetObjectSites: function resetObjectSites(state) {
			state.meta = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(objectSites.meta));
			state.sites = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(objectSites.sites));
			state.sitesFinishedLoading = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(objectSites.sitesFinishedLoading));
			state.objectdata = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(objectSites.objectdata));
		},
		prepareObjectSites: function prepareObjectSites(state, meta) {
			meta.sites.forEach(function (site) {
				var dummySite = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(defaultSite));
				dummySite.id = site.PKM_Seite;
				dummySite.current = {
					meta: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, site, { loading: true }),
					template: ''
				};
				dummySite.uncommited = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
				dummySite.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(defaultSiteTranslations));

				if (site.S_Kurzbezeichnung === 'objektdaten') {
					dummySite.current = site;
					dummySite.loading = true;
					state.objectdata = dummySite;
				} else {
					var alreadyExistingSite = state.sites.some(function (currSite) {
						return currSite.id === dummySite.id;
					});

					if (!alreadyExistingSite) {
						state.sites.push(dummySite);
					}
				}
			});

			state.sitesArePrepared = true;
		},
		setObjectSites: function setObjectSites(state, data) {
			data.siteObjects.forEach(function (siteObject) {
				var site = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(defaultSite));
				site.id = siteObject.id;
				site.current = siteObject;
				site.uncommited = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
				site.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(defaultSiteTranslations));

				if (site.translations[data.lang] === null) {
					site.translations[data.lang] = siteObject;
				}

				__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(site.current.items).forEach(function (itemKey) {
					if (!site.current.items[itemKey].value) {
						site.current.items[itemKey].value = '';
					}
				});

				if (siteObject.meta.S_Kurzbezeichnung === 'objektdaten') {
					state.objectdata = site;
					state.objectdata.loading = false;
				} else {
					var foundExistingSite = state.sites.find(function (currSite) {
						return currSite.id === site.id;
					});
					__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].set(foundExistingSite, 'current', site.current);
					var mergedTranslations = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(foundExistingSite.translations));

					__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(site.translations).forEach(function (transLang) {
						var trans = site.translations[transLang];

						if (trans) {
							mergedTranslations[transLang] = trans;
						}
					});

					__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].set(foundExistingSite, 'translations', mergedTranslations);
				}
			});
		},
		setObjectSiteTranslation: function setObjectSiteTranslation(state, data) {
			var site = state.sites.find(function (currSite) {
				return currSite.id === data.siteObject.id;
			});

			if (!site) {
				return;
			}

			if (site.translations[data.lang] === null) {
				__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].set(site.translations, data.lang, data.siteObject);
			}
		},
		setObjectDataTranslation: function setObjectDataTranslation(state, data) {
			if (state.objectdata.translations[data.lang] === null) {
				__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].set(state.objectdata.translations, data.lang, data.siteObject);
			}
		},
		setSitesMeta: function setSitesMeta(state, meta) {
			state.meta.ids = meta.sites.map(function (site) {
				return site.PKM_Seite;
			});
			state.meta.lang = meta.lang;
			state.meta.fetched = meta.fetched;
		},
		clearSitesUncommited: function clearSitesUncommited(state, siteId) {
			var sites = state.sites;

			if (siteId) {
				sites = state.sites.filter(function (site) {
					return site.id === siteId;
				});
			}

			sites.forEach(function (site) {
				return site.uncommited.clear();
			});
		},
		updateObjectDataItems: function updateObjectDataItems(state, data) {
			__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(data).forEach(function (itemKey) {
				state.objectdata.current.items[itemKey].value = data[itemKey];
			});
		},
		updateObjectDataItemWithTranslations: function updateObjectDataItemWithTranslations(state, data) {
			var activeLangKey = data.activeLangKey;
			__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(data.sets).forEach(function (langKey) {
				var items = data.sets[langKey];
				__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(items).forEach(function (itemKey) {
					state.objectdata.translations[langKey].items[itemKey].value = items[itemKey];

					if (activeLangKey === langKey) {
						state.objectdata.current.items[itemKey].value = items[itemKey];
					}
				});
			});
		},
		updateObjectSiteItems: function updateObjectSiteItems(state, data) {
			var siteId = data.siteId;
			var site = state.sites.find(function (currSite) {
				return currSite.id === siteId;
			});

			if (data.type === 'text' && data.items.sets) {
				var activeLangKey = data.activeLangKey;
				__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(data.items.sets).forEach(function (langKey) {
					var items = data.items.sets[langKey];
					__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(items).forEach(function (itemKey) {
						site.translations[langKey].items[itemKey].value = items[itemKey];

						if (activeLangKey === langKey) {
							site.current.items[itemKey].value = items[itemKey];
						}
					});
				});
			} else {
				__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(data.items).forEach(function (key) {
					switch (data.type) {
						case 'enum':
							site.current.items[key].value = data.items[key];
							break;

						case 'image':
							__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].set(site.current.items, key, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, site.current.items[key], data.items[key]));

							break;

						default:}

					site.uncommited.add(key);
				});
			}
		},
		updateAssetsItem: function updateAssetsItem(state, data) {
			__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(state.objectdata.current.items).forEach(function (fieldId) {
				__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(data).forEach(function (changedFieldId) {
					if (changedFieldId === fieldId) {
						var fieldData = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(state.objectdata.current.items[fieldId]));
						var updatedFieldData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, fieldData, data[changedFieldId]);
						__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].set(state.objectdata.current.items, fieldId, updatedFieldData);
					}
				});
			});
		},
		setLayoutAction: function setLayoutAction(state, action) {
			switch (action.type) {
				case 'copy':
				case 'move':
					state.layoutAction = action;
					break;

				default:
			}
		},
		resetLayoutAction: function resetLayoutAction(state) {
			state.layoutAction = {
				type: null,
				values: null
			};
		},
		moveSite: function moveSite(state, actionInfo) {
			var siteToBeMoved = state.sites.find(function (site) {
				return site.current.id === actionInfo.values.id;
			});
			var siteToBeMovedIndex = state.sites.indexOf(siteToBeMoved);
			var siteTopicId = actionInfo.values.topicId;
			state.sites.splice(siteToBeMovedIndex, 1);

			if (actionInfo.prevSiteId) {
				var prevSiteId = actionInfo.prevSiteId;
				var prevSiteItem = state.sites.find(function (site) {
					return site.current.id === prevSiteId;
				});
				var prevSiteItemIndex = state.sites.indexOf(prevSiteItem);

				state.sites.splice(prevSiteItemIndex + 1, 0, siteToBeMoved);
			} else if (actionInfo.nextSiteId) {
				var nextSiteId = actionInfo.nextSiteId;
				var nextSiteItem = state.sites.find(function (site) {
					return site.current.id === nextSiteId;
				});
				var nextSiteItemIndex = state.sites.indexOf(nextSiteItem);

				state.sites.splice(nextSiteItemIndex, 0, siteToBeMoved);
			} else {
				state.sites.splice(0, 0, siteToBeMoved);
			}

			var indexRunner = 0;
			state.sites.forEach(function (site) {
				if (parseInt(site.current.meta.FKM_Thema, 10) !== siteTopicId) {
					return;
				}
				site.current.meta.U_Seitennummer = indexRunner;
				indexRunner += 1;
			});
		},
		setLayoutTemplatesLoadingStatus: function setLayoutTemplatesLoadingStatus(state, templateInfo) {
			if (!state.templates[templateInfo.topicId]) {
				state.templates[templateInfo.topicId] = {
					items: {},
					loading: false
				};
			}
			state.templates[templateInfo.topicId].loading = templateInfo.loading;
		},
		setLayoutTemplates: function setLayoutTemplates(state, templateInfo) {
			state.templates[templateInfo.topicId].items = templateInfo.templatesData.templates;
		},
		insertLayoutSite: function insertLayoutSite(state, newSiteData) {
			state.sites.forEach(function (site) {
				if (parseInt(site.current.meta.FKM_Thema, 10) !== newSiteData.topicId) {
					return;
				}

				var currSitenumber = parseInt(site.current.meta.U_Seitennummer, 10);

				if (currSitenumber >= newSiteData.newSitenumber) {
					site.current.meta.U_Seitennummer = currSitenumber + 1;
				}
			});

			__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(newSiteData.siteData[0].items).forEach(function (itemKey) {
				if (!newSiteData.siteData[0].items[itemKey].value) {
					newSiteData.siteData[0].items[itemKey].value = '';
				}
			});

			var newSite = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(defaultSite)), {
				current: newSiteData.siteData[0],
				id: newSiteData.siteData[0].id,
				uncommited: new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a()
			});

			newSite.translations[newSiteData.lang] = newSiteData.siteData[0];

			state.sites.push(newSite);
		},
		deleteSite: function deleteSite(state, id) {
			state.sites = state.sites.filter(function (site) {
				return site.id !== id;
			});
		},
		setSitesFinishedLoading: function setSitesFinishedLoading(state, status) {
			state.sitesFinishedLoading = status;
		},
		setTemplateSets: function setTemplateSets(state, sets) {
			state.templateSets = sets;
		},
		resetSitesArePrepared: function resetSitesArePrepared(state) {
			state.sitesArePrepared = false;
		}
	},

	actions: {
		resetObjectSites: function resetObjectSites(_ref) {
			var commit = _ref.commit;

			commit('resetObjectSites');
		},
		getObjectSites: function getObjectSites(_ref2, meta) {
			var state = _ref2.state,
			    commit = _ref2.commit,
			    dispatch = _ref2.dispatch;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				if (meta.sites.length === 1 && meta.sites[0].S_Kurzbezeichnung === 'objektdaten') {
					dispatch('getTemplateSets');
				}

				if (meta.sites.length === 0) {
					reject('Action: getObjectSites => Keine Seiten!');
				}

				if (!state.sitesArePrepared || state.sites.length === 0) {
					commit('prepareObjectSites', meta);
				}

				var promisifiedRequests = meta.sites.map(function (site) {
					return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (subResolve, subReject) {
						__WEBPACK_IMPORTED_MODULE_9__api_objectsites__["a" /* default */].get([site], meta.lang).then(function (siteObjects) {
							commit('setObjectSites', { lang: meta.lang, siteObjects: siteObjects });
							subResolve();
						}).catch(function (response) {
							subReject(response);
						});
					});
				});

				__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promisifiedRequests).then(function () {
					commit('setSitesFinishedLoading', true);
					commit('setSitesMeta', {
						sites: meta.sites,
						lang: meta.lang,
						fetched: true
					});
					resolve();
				}).catch(function () {
					reject();
				});
			});
		},
		getObjectSiteTranslation: function getObjectSiteTranslation(_ref3, meta) {
			var commit = _ref3.commit;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_9__api_objectsites__["a" /* default */].get([meta.site], meta.lang).then(function (siteObjects) {
					commit('setObjectSiteTranslation', { lang: meta.lang, siteObject: siteObjects[0] });
					resolve(siteObjects[0]);
				}).catch(function (response) {
					reject(response);
				});
			});
		},
		getObjectDataTranslation: function getObjectDataTranslation(_ref4, meta) {
			var commit = _ref4.commit;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_9__api_objectsites__["a" /* default */].get([meta.site], meta.lang).then(function (siteObjects) {
					commit('setObjectDataTranslation', { lang: meta.lang, siteObject: siteObjects[0] });
					resolve(siteObjects[0]);
				}).catch(function (response) {
					reject(response);
				});
			});
		},
		clearSites: function clearSites(_ref5, siteId) {
			var commit = _ref5.commit;

			commit('clearSitesUncommited', siteId);
		},
		saveSites: function saveSites(_ref6) {
			var state = _ref6.state,
			    commit = _ref6.commit;

			var data = {};
			state.sites.forEach(function (site) {
				site.uncommited.forEach(function (key) {
					if (!data[site.id]) {
						data[site.id] = {};
					}
					data[site.id][key] = {
						U_Position: site.current.items[key].U_Position,
						value: site.current.items[key].value
					};
				});
			});

			__WEBPACK_IMPORTED_MODULE_9__api_objectsites__["a" /* default */].save(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(data), state.meta.lang, data).then(function () {
				commit('clearSitesUncommited');
			});
		},
		handleSiteAction: function handleSiteAction(_ref7, actionInfo) {
			var commit = _ref7.commit,
			    dispatch = _ref7.dispatch,
			    getters = _ref7.getters,
			    rootState = _ref7.rootState;

			var topicId = parseInt(rootState.objectsetup.current.thema_content, 10);

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				switch (actionInfo.type) {
					case 'move':
						commit('moveSite', actionInfo);

						__WEBPACK_IMPORTED_MODULE_9__api_objectsites__["a" /* default */].setSiteOrder(getters.mappedSiteData.map(function (site) {
							return site.id;
						}).join(','), topicId).then(function () {
							dispatch('resetLayoutAction');
							resolve();
						}).catch(function () {
							reject();
						});

						break;

					default:
						reject();
				}
			});
		},
		updateObjectDataItem: function updateObjectDataItem(_ref8, values) {
			var commit = _ref8.commit,
			    state = _ref8.state,
			    rootState = _ref8.rootState;

			var siteId = values.siteId;
			delete values.siteId;
			delete values.type;

			if (values.sets) {
				var activeLangKey = rootState.objectsetup.current.sprache;
				commit('updateObjectDataItemWithTranslations', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ activeLangKey: activeLangKey }, values));

				var promisifiedTranslationSiteRequests = [];

				__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(values.sets).forEach(function (langKey) {
					var dataObj = {};
					var langMappedItems = {};
					var changedItemKeys = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(values.sets[__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(values.sets)[0]]);
					changedItemKeys.forEach(function (itemKey) {
						var item = state.objectdata.translations[langKey].items[itemKey];
						langMappedItems[itemKey] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, item, {
							sprache: langKey
						});
					});

					dataObj[siteId] = langMappedItems;

					promisifiedTranslationSiteRequests.push(__WEBPACK_IMPORTED_MODULE_9__api_objectsites__["a" /* default */].save([siteId], state.meta.lang, dataObj));
				});

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promisifiedTranslationSiteRequests);
			}

			commit('updateObjectDataItems', values);
			var dataObj = {};
			dataObj[siteId] = {};

			__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(values).forEach(function (key) {
				var item = state.objectdata.current.items[key];
				dataObj[siteId][key] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, item, {
					sprache: state.meta.lang
				});
			});
			return __WEBPACK_IMPORTED_MODULE_9__api_objectsites__["a" /* default */].save([siteId], state.meta.lang, dataObj);
		},
		updateObjectSiteItems: function updateObjectSiteItems(_ref9, values) {
			var commit = _ref9.commit,
			    state = _ref9.state,
			    rootState = _ref9.rootState;

			var siteId = values.siteId;
			delete values.siteId;
			var type = values.type;
			delete values.type;

			if (!__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(values).length) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('Kein(e) Wert(e) gesetzt: ' + type);
			}

			var activeLangKey = rootState.objectsetup.current.sprache;
			commit('updateObjectSiteItems', { siteId: siteId, type: type, activeLangKey: activeLangKey, items: values });

			if (type === 'text' && values.sets) {
				var site = state.sites.find(function (currSite) {
					return currSite.id === siteId;
				});

				var promisifiedTranslationSiteRequests = [];

				__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(values.sets).forEach(function (langKey) {
					var dataObj = {};
					var langMappedItems = {};
					var changedItemKeys = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(values.sets[__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(values.sets)[0]]);
					changedItemKeys.forEach(function (itemKey) {
						var item = site.translations[langKey].items[itemKey];
						langMappedItems[itemKey] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, item, {
							sprache: langKey
						});
					});

					dataObj[siteId] = langMappedItems;

					promisifiedTranslationSiteRequests.push(__WEBPACK_IMPORTED_MODULE_9__api_objectsites__["a" /* default */].save([siteId], state.meta.lang, dataObj));
				});

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promisifiedTranslationSiteRequests);
			} else if (type === 'enum') {
				var _site = state.sites.find(function (currSite) {
					return currSite.id === siteId;
				});
				var itemKey = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(values)[0];
				var item = _site.current.items[itemKey];

				var dataObj = {};

				dataObj[siteId] = {};
				dataObj[siteId][itemKey] = {
					U_Position: item.U_Position,
					value: values[itemKey],
					sprache: state.meta.lang
				};

				return __WEBPACK_IMPORTED_MODULE_9__api_objectsites__["a" /* default */].save([siteId], state.meta.lang, dataObj);
			} else if (type === 'image') {
				var promisifiedRequests = [];
				var _dataObj = {};
				_dataObj[siteId] = values;

				promisifiedRequests.push(__WEBPACK_IMPORTED_MODULE_9__api_objectsites__["a" /* default */].save([siteId], state.meta.lang, _dataObj));

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promisifiedRequests);
			}

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('Unbekannter Typ: ' + type);
		},
		updateObjectSiteItemsAndSave: function updateObjectSiteItemsAndSave(_ref10, values) {
			var dispatch = _ref10.dispatch,
			    commit = _ref10.commit;

			dispatch('updateObjectSiteItems', values).then(function () {
				return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
					commit('clearSitesUncommited');
					resolve();
				});
			}).catch(function () {});
		},
		updateAssetsItem: function updateAssetsItem(_ref11, values) {
			var commit = _ref11.commit,
			    state = _ref11.state,
			    rootState = _ref11.rootState;

			commit('updateAssetsItem', values);

			var siteId = state.objectdata.id;

			var promisifiedRequests = [];
			var dataObj = {};
			dataObj[siteId] = values;

			promisifiedRequests.push(__WEBPACK_IMPORTED_MODULE_9__api_objectsites__["a" /* default */].save([siteId], state.meta.lang, dataObj));

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promisifiedRequests);
		},
		deleteImageById: function deleteImageById(_ref12, imageId) {
			var state = _ref12.state,
			    rootState = _ref12.rootState;

			var objId = rootState.objectsetup.current.PKM_Objekt;
			return __WEBPACK_IMPORTED_MODULE_9__api_objectsites__["a" /* default */].deleteImage(imageId, state.meta.lang, objId);
		},
		updateAssetsItemFromMAM: function updateAssetsItemFromMAM(_ref13, data) {
			var commit = _ref13.commit,
			    dispatch = _ref13.dispatch,
			    state = _ref13.state,
			    rootState = _ref13.rootState;

			var currentSelectedLang = rootState.objectsetup.language;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_9__api_objectsites__["a" /* default */].saveMAMImage(data, currentSelectedLang).then(function (response) {
					if (response.success === 'true') {
						if (state.objectdata.id !== data.PKM_Seite) {
							var commitData = {};
							commitData.siteId = data.PKM_Seite;
							commitData.type = 'image';
							commitData.items = {};
							commitData.items['bildfeld_' + data.U_Position] = {
								value: '' + "https://cms-backend.stage.qa.erco.com" + response.url
							};
							commit('updateObjectSiteItems', commitData);
						} else {
							var _commitData = {};
							_commitData['bildfeld_' + data.U_Position] = {
								value: '' + "https://cms-backend.stage.qa.erco.com" + response.url
							};
							commit('updateAssetsItem', _commitData);
						}

						dispatch('updateImageInHistory', { key: 'bildfeld_' + data.U_Position, value: '' + "https://cms-backend.stage.qa.erco.com" + response.url });
						resolve();
					} else {
						reject();
					}
				}).catch(function (err) {
					reject(err);
				});
			});
		},
		setLayoutAction: function setLayoutAction(_ref14, action) {
			var commit = _ref14.commit;

			commit('setLayoutAction', action);
		},
		resetLayoutAction: function resetLayoutAction(_ref15) {
			var commit = _ref15.commit;

			commit('resetLayoutAction');
		},
		getLayoutTemplatesForTopicId: function getLayoutTemplatesForTopicId(_ref16, topicId) {
			var commit = _ref16.commit,
			    rootState = _ref16.rootState;

			var objectId = parseInt(rootState.objectsetup.current.PKM_Objekt, 10);

			commit('setLayoutTemplatesLoadingStatus', { topicId: topicId, loading: true });

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_9__api_objectsites__["a" /* default */].getTemplates(objectId, topicId).then(function (templatesData) {
					commit('setLayoutTemplates', { topicId: topicId, templatesData: templatesData });
					commit('setLayoutTemplatesLoadingStatus', { topicId: topicId, loading: false });
					resolve();
				}).catch(function (e) {
					commit('setLayoutTemplatesLoadingStatus', { topicId: topicId, loading: false });
					reject(e);
				});
			});
		},
		getLayoutTemplates: function getLayoutTemplates(_ref17) {
			var dispatch = _ref17.dispatch,
			    getters = _ref17.getters;

			getters.topicIds.forEach(function (topicId) {
				return dispatch('getLayoutTemplatesForTopicId', topicId);
			});
		},
		insertLayoutSite: function insertLayoutSite(_ref18, data) {
			var commit = _ref18.commit,
			    state = _ref18.state,
			    rootState = _ref18.rootState;

			var objectId = parseInt(rootState.objectsetup.current.PKM_Objekt, 10);
			var selectedTemplateId = data.selectedTemplateId;
			var topicId = data.topicId;
			var newSitenumber = data.sitenumber;
			var lang = state.meta.lang;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_9__api_objectsites__["a" /* default */].insertSiteAtPosition(objectId, selectedTemplateId, topicId, newSitenumber).then(function (responseData) {
					if (!responseData.neue_FKM_Seite) {
						reject({
							error: 'Neue FKM_Seite ist null!'
						});
					}

					var newSite = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data.selectedTemplateData, {
						FKM_Template: data.selectedTemplateData.PKM_Template,
						FKM_Thema: topicId,
						PKM_Seite: responseData.neue_FKM_Seite,
						U_Seitennummer: newSitenumber
					});

					__WEBPACK_IMPORTED_MODULE_9__api_objectsites__["a" /* default */].get([newSite], lang).then(function (siteData) {
						commit('insertLayoutSite', { siteData: siteData, newSitenumber: newSitenumber, topicId: topicId, lang: lang });
						resolve();
					}).catch(function (e) {
						reject(e);
					});
				}).catch(function (e) {
					reject(e);
				});
			});
		},
		deleteSite: function deleteSite(_ref19, id) {
			var commit = _ref19.commit,
			    state = _ref19.state,
			    dispatch = _ref19.dispatch,
			    rootState = _ref19.rootState;

			var objectId = parseInt(rootState.objectsetup.current.PKM_Objekt, 10);
			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_9__api_objectsites__["a" /* default */].delete(id, objectId).then(function () {
					commit('deleteSite', id);

					if (state.sites.length === 0) {
						dispatch('getLayoutTemplates');
					}
					resolve();
				}).catch(function () {
					reject();
				});
			});
		},
		getTemplateSets: function getTemplateSets(_ref20) {
			var commit = _ref20.commit,
			    rootState = _ref20.rootState;

			var objectId = parseInt(rootState.objectsetup.current.PKM_Objekt, 10);

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_9__api_objectsites__["a" /* default */].getTemplateSets(objectId).then(function (response) {
					commit('setTemplateSets', response.sets);
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		},
		createTemplateSet: function createTemplateSet(_ref21, objectTemplateSetId) {
			var commit = _ref21.commit,
			    rootState = _ref21.rootState;

			var objectId = parseInt(rootState.objectsetup.current.PKM_Objekt, 10);

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_9__api_objectsites__["a" /* default */].createTemplateSet(objectId, objectTemplateSetId).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		},
		resetSitesArePrepared: function resetSitesArePrepared(_ref22) {
			var commit = _ref22.commit;

			commit('resetSitesArePrepared');
		}
	},

	getters: {
		mappedSiteData: function mappedSiteData(state, getters, rootState) {
			var sites = {};

			var lang = rootState.objectsetup.current && rootState.objectsetup.current.sprache || rootState.objectsetup.language;

			state.sites.forEach(function (site) {
				var templateId = parseInt(site.current.meta.FKM_Template, 10);
				var template = site.current.template.replace(/ src="(.+?)"/, function (match, path) {
					var resolvedUrl = __WEBPACK_IMPORTED_MODULE_6_url___default.a.resolve("https://cms-backend.stage.qa.erco.com", path);
					return ' src="' + resolvedUrl + '"';
				});

				var topicId = parseInt(site.current.meta.FKM_Thema, 10) || 0;

				var templateTitle = state.templates[topicId] && state.templates[topicId].items && state.templates[topicId].items[templateId] && state.templates[topicId].items[templateId].S_Titel || '';

				sites[site.id] = {
					id: site.id,
					key: site.id,
					topicId: topicId,
					topicOrderNum: getters.themeIdToOrder[topicId] || 0,
					sitenumber: parseInt(site.current.meta.U_Seitennummer, 10),
					template: template,
					templateId: templateId,
					templateTitle: templateTitle,
					templatePath: site.current.meta.S_Templatepfad,
					loading: site.current.meta.loading,
					data: {},
					lang: lang,
					translations: site.translations,
					items: __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].util.extend({}, site.current.items),
					bodytagAttrs: site.current.bodytag_attributes || ''
				};

				__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(site.current.items || []).forEach(function (key) {
					if (site.current.items[key].enum) {
						sites[site.id].data[key] = site.current.items[key].enum.reduce(function (value, item) {
							return item.value.trim() === site.current.items[key].value.trim() ? item.label : value;
						}, '');
					} else if (site.current.items[key].typ === 'text') {
						sites[site.id].data[key] = __WEBPACK_IMPORTED_MODULE_10__helper_textFormatHelper__["a" /* default */].format(site.current.items[key].value);
					} else {
						sites[site.id].data[key] = site.current.items[key].value;
					}
				});
			});

			var sitesArray = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(sites).map(function (siteId) {
				return sites[siteId];
			});
			var sortedSites = sitesArray.sort(function (a, b) {
				var sortRes = a.topicOrderNum - b.topicOrderNum;

				if (sortRes === 0) {
					return a.sitenumber - b.sitenumber;
				}

				return sortRes;
			});

			return sortedSites;
		},
		mappedObjectDataItems: function mappedObjectDataItems(state) {
			var result = {
				template: '',
				textItems: {},
				imageItems: {},
				seoItems: {},
				textItemsTranslations: state.objectdata.translations
			};

			if (state.objectdata.current.template) {
				result.template = state.objectdata.current.template;
			}

			__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(state.objectdata.current.items || []).forEach(function (itemKey) {
				var item = state.objectdata.current.items[itemKey];
				var labelKey = (item.label || '').trim().toLowerCase().replace(/[:$&?!.,()/]*/mg, '').replace(/([\s-][a-z])/mg, function (match) {
					return match[1].toUpperCase();
				}).replace(/[\s-]/, '');
				var mappedItem = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
					key: itemKey,
					labelKey: labelKey
				}, item, {
					charlength: item.charlength && parseInt(item.charlength, 10) || false
				});

				if (item.typ === 'bild') {
					result.imageItems[itemKey] = mappedItem;
				} else {
					result.textItems[itemKey] = mappedItem;
				}
			});

			result.imageItems = orderItemsByTemplate(result.imageItems, result.template, /v-bind:src="(.*?)"/mg);

			var orderedTextItems = orderItemsByTemplate(result.textItems, result.template, /v-html="(.*?)"/mg);

			var _orderedTextItems$red = orderedTextItems.reduce(function (acc, item) {
				if (item.cardtab === 'seo') {
					acc.orderedSeoTextItems.push(item);
				} else {
					acc.orderedObjectDataTextItems.push(item);
				}

				return acc;
			}, { orderedObjectDataTextItems: [], orderedSeoTextItems: [] }),
			    orderedObjectDataTextItems = _orderedTextItems$red.orderedObjectDataTextItems,
			    orderedSeoTextItems = _orderedTextItems$red.orderedSeoTextItems;

			result.textItems = orderedObjectDataTextItems;
			result.seoItems = orderedSeoTextItems;

			return result;
		},
		maxSitesPerTopicStatus: function maxSitesPerTopicStatus(state, getters, rootState) {
			var sitesPerTopicStatus = {};

			state.sites.forEach(function (site) {
				var topicId = parseInt(site.current.meta.FKM_Thema, 10);
				var topic = (rootState.objectsetup.current.themen || []).find(function (currTopic) {
					return parseInt(currTopic.PKM_Thema, 10) === topicId;
				});

				if (!sitesPerTopicStatus[topicId]) {
					sitesPerTopicStatus[topicId] = {
						cnt: 0,
						max: topic && parseInt(topic.U_Max_Seitenzahl, 10) || 0
					};
				}

				sitesPerTopicStatus[topicId].cnt += 1;
			});

			__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(sitesPerTopicStatus).forEach(function (topicId) {
				sitesPerTopicStatus[topicId] = sitesPerTopicStatus[topicId].cnt >= sitesPerTopicStatus[topicId].max;
			});

			return sitesPerTopicStatus;
		},
		isMandatoryFilledOut: function isMandatoryFilledOut(state) {
			if (!state.objectdata.current.items) return false;
			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(state.objectdata.current.items).every(function (key) {
				var isMandatory = Object.prototype.hasOwnProperty.call(state.objectdata.current.items[key], 'mandatory') && state.objectdata.current.items[key].mandatory === 'true';

				if (!isMandatory) {
					return true;
				}
				if (!state.objectdata.current.items[key].value) {
					return false;
				}
				return true;
			});
		}
	}
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_objectstati__ = __webpack_require__(209);




/* harmony default export */ __webpack_exports__["a"] = ({
	state: {
		stati: [],
		loading: false,
		fetched: false
	},

	mutations: {
		setStatiList: function setStatiList(state, stati) {
			state.stati = stati;
			state.loading = false;
			state.fetched = true;
		},
		setStatiLoadingState: function setStatiLoadingState(state, loading) {
			state.loading = loading;
		}
	},
	actions: {
		getStatiList: function getStatiList(_ref) {
			var commit = _ref.commit,
			    state = _ref.state;

			if (state.fetched) {
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(state.stati);
			}

			var pkmUNameMap = {
				1: 'entwurf',
				2: 'online',
				3: 'kopiert',
				4: 'gelöscht',
				5: 'archiv',
				6: 'synchronize',
				8: 'unknown',
				9: 'templateset'
			};

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				commit('setStatiLoadingState', true);

				__WEBPACK_IMPORTED_MODULE_2__api_objectstati__["a" /* default */].get().then(function (response) {
					var sortedStatis = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response).map(function (statiKey) {
						var status = response[statiKey];

						status.S_Status_Uppercase = '' + status.S_Status.substr(0, 1).toUpperCase() + status.S_Status.substr(1);

						status.S_Key = pkmUNameMap[status.PKM_Status] ? pkmUNameMap[status.PKM_Status] : status.S_Status;

						status.PKM_Status = parseInt(status.PKM_Status, 10);
						return status;
					}).sort(function (a, b) {
						return parseInt(a.U_Reihenfolge, 10) - parseInt(b.U_Reihenfolge, 10);
					});
					commit('setStatiList', sortedStatis);
					resolve(response);
				}).catch(function (e) {
					commit('setStatiLoadingState', false);
					reject(e);
				});
			});
		}
	},
	getters: {
		mappedStati: function mappedStati(state) {
			return state.stati.map(function (status) {
				return {
					id: status.PKM_Status,
					name: status.S_Status_Uppercase
				};
			}).sort(function (a, b) {
				return parseInt(a.id, 10) - parseInt(b.id, 10);
			});
		},
		statiAssoc: function statiAssoc(state) {
			return state.stati.reduce(function (carry, status) {
				carry[status.S_Key] = status.PKM_Status;
				return carry;
			}, {});
		},
		statiKey: function statiKey(state) {
			return state.stati.reduce(function (carry, status) {
				carry[status.PKM_Status] = status;
				return carry;
			}, {});
		},
		dashboardStati: function dashboardStati(state) {
			return (state.stati || []).filter(function (status) {
				return status.B_Dashboard_Dropdown === 'j';
			});
		},
		setupStati: function setupStati(state) {
			return (state.stati || []).filter(function (status) {
				return status.B_Setup_Dropdown === 'j';
			});
		}
	}
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);




var sidebarDefault = {
	visible: false,
	view: '',
	fixed: false,
	styles: {},
	outputData: [],
	context: {
		actionName: '',
		value: ''
	},
	initialContext: null,
	resetButton: null,
	title: '',
	titleInfo: '',
	info: null,
	applied: false,
	closeOnSave: true,
	revert: false,
	doTrack: false
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, sidebarDefault),

	mutations: {
		updateSidebar: function updateSidebar(state, sidebarData) {
			var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(sidebarData);
			keys.forEach(function (key) {
				if (key === 'context') {
					state.applied = false;
				}

				state[key] = sidebarData[key];

				if (key === 'visible' && sidebarData[key]) {
					sidebarData.context = sidebarData.context ? sidebarData.context : {};
					state.initialContext = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sidebarData.context));
				}

				if (state.applied) {
					state.context = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.initialContext));
				}
			});
		},
		resetSidebar: function resetSidebar(state) {
			var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(sidebarDefault);
			keys.forEach(function (key) {
				state[key] = sidebarDefault[key];
			});
		},
		resetSidebarContext: function resetSidebarContext(state) {
			state.context = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, sidebarDefault.context);
		}
	},

	actions: {
		updateSidebar: function updateSidebar(_ref, sidebarData) {
			var commit = _ref.commit,
			    state = _ref.state;

			if (sidebarData.doTrack) {
				sidebarData.doTrack = false;
				commit('pushToSidebarHistory', state);
			}
			commit('updateSidebar', sidebarData);
		},
		revertSidebar: function revertSidebar(_ref2) {
			var commit = _ref2.commit,
			    getters = _ref2.getters;

			commit('updateSidebar', getters.peekFromSidebarHistory);
			commit('popFromSidebarHistory');
		},
		resetSidebar: function resetSidebar(_ref3, initialData) {
			var commit = _ref3.commit;

			commit('resetSidebar', initialData);
		},
		resetSidebarContext: function resetSidebarContext(_ref4) {
			var commit = _ref4.commit;

			commit('resetSidebarContext');
		}
	}
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["a"] = ({
	state: {
		history: []
	},

	mutations: {
		pushToSidebarHistory: function pushToSidebarHistory(state, sidebarData) {
			state.history.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(sidebarData));
		},
		popFromSidebarHistory: function popFromSidebarHistory(state) {
			state.history.pop();
		},
		updateImageInHistory: function updateImageInHistory(state, data) {
			state.history = state.history.map(function (item) {
				var sidebar = JSON.parse(item);

				if (sidebar.outputData.key === data.key) {
					sidebar.outputData.value = data.value;
				}
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(sidebar);
			});
		}
	},

	actions: {
		pushToSidebarHistory: function pushToSidebarHistory(_ref, sidebarData) {
			var commit = _ref.commit;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
				commit('pushToSidebarHistory', sidebarData);
				resolve();
			});
		},
		popFromSidebarHistory: function popFromSidebarHistory(_ref2) {
			var commit = _ref2.commit;

			commit('popFromSidebarHistory');
		},
		updateImageInHistory: function updateImageInHistory(_ref3, data) {
			var commit = _ref3.commit;

			commit('updateImageInHistory', data);
		}
	},

	getters: {
		peekFromSidebarHistory: function peekFromSidebarHistory(state) {
			var length = state.history.length;
			if (length > 0) return JSON.parse(state.history[length - 1]);
			return null;
		}
	}
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_tagger__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_colorHelper__ = __webpack_require__(39);







var suggestionsDefault = {
	query: '',
	suggestions: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, suggestionsDefault),

	mutations: {
		updateSuggestions: function updateSuggestions(state, data) {
			data.suggestions.suggestions = data.suggestions.suggestions.map(function (currentValue) {
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, currentValue, { color: __WEBPACK_IMPORTED_MODULE_4__helper_colorHelper__["a" /* default */].colorstring(currentValue.S_Type) });
			});
			state.query = data.query;
			state.suggestions = data.suggestions;
		},
		resetSuggestions: function resetSuggestions(state) {
			state.query = '';
			state.suggestions = [];
		}
	},

	actions: {
		getCategorySuggestions: function getCategorySuggestions(_ref, query) {
			var commit = _ref.commit;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_3__api_tagger__["a" /* default */].getSuggestions(query, 'ATTRIBUT').then(function (responseData) {
					commit('updateSuggestions', {
						query: query,
						suggestions: responseData
					});
					resolve();
				}).catch(function (e) {
					reject(e);
				});
			});
		},
		resetSuggestions: function resetSuggestions(_ref2) {
			var commit = _ref2.commit;

			commit('resetSuggestions');
		}
	}
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 100 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    color: {
      default: '#35495e'
    },
    stroke: {
      default: '5px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size,
        border: this.stroke + ' solid ' + this.background,
        borderTopColor: this.color
      };
    }
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    dotSize: {
      default: function _default() {
        var size = parseInt(this.size);
        return size / 3 + 1;
      }
    }
  },
  computed: {
    styles: function styles() {
      var size = parseInt(this.size);
      var halfSize = size / 3;
      return {
        width: this.size,
        height: this.size,
        border: '0px solid ' + this.background,
        boxShadow: '0 -' + halfSize + 'px 0 ' + this.dotSize + 'px ' + this.background + ' inset'
      };
    }
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      var size = parseInt(this.size);
      return {
        width: this.size,
        height: this.size,
        transform: 'scale(' + size / 75 + ')'
      };
    }
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 44 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 120 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.8s'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size,
        backgroundColor: this.background,
        animationDuration: this.duration
      };
    }
  }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    diamondStyle: function diamondStyle() {
      var size = parseInt(this.size);
      return {
        width: size / 4 + 'px',
        height: size / 4 + 'px'
      };
    },
    styles: function styles() {
      var size = parseInt(this.size);
      return {
        width: this.size,
        height: size / 4 + 'px'
      };
    }
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '2.0s'
    }
  },
  computed: {
    bounceStyle: function bounceStyle() {
      return {
        backgroundColor: this.background,
        animationDuration: this.duration
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 60 + ')'
      };
    },
    styles: function styles() {
      var size = parseInt(this.size);
      return {
        width: this.size,
        height: size / 2 + 'px'
      };
    }
  }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 164 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 64 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 70 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size) / 2;
      return {
        transform: 'scale(' + size / 75 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 31 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 60 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: 'auto',
        fill: this.color
      };
    }
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 250 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        width: size + 'px',
        height: this.size,
        transform: 'scale(' + size / 70 + ')'
      };
    },
    styles: function styles() {
      var size = parseInt(this.size);
      return {
        width: size + 'px',
        height: this.size
      };
    }
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.2s'
    }
  },
  computed: {
    styles: function styles() {
      return {
        backgroundColor: this.background,
        width: this.size,
        height: this.size,
        animationDuration: this.duration
      };
    }
  }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 80 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.0s'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size,
        backgroundColor: this.background,
        animationDuration: this.duration
      };
    }
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 220 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    },
    stroke: {
      default: '5px'
    }
  },
  computed: {
    lineStyles: function lineStyles() {
      return {
        width: this.size,
        height: this.stroke,
        background: this.color,
        borderRadius: this.stroke
      };
    },
    styles: function styles() {
      var size = parseInt(this.size);
      return {
        width: this.size,
        height: this.size,
        transform: 'scale(' + size / 75 + ')'
      };
    }
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.3s'
    }
  },
  computed: {
    cubeStyles: function cubeStyles() {
      return {
        backgroundColor: this.background,
        animationDuration: this.duration
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.2s'
    }
  },
  computed: {
    rectStyles: function rectStyles() {
      return {
        backgroundColor: this.background,
        animationDuration: this.duration
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    blobStyles: function blobStyles() {
      return {
        borderColor: this.color
      };
    },
    moveBlobStyles: function moveBlobStyles() {
      return {
        borderColor: this.color,
        background: this.color
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.8s'
    }
  },
  computed: {
    cubeStyles: function cubeStyles() {
      return {
        backgroundColor: this.background,
        animationName: 'sk-cubemove',
        animationDuration: this.duration
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',
	mounted: function mounted() {}
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoBackToTopButton',

	props: {
		visibilityThreshold: {
			type: Number,
			default: 0.1
		},

		thresholdType: {
			type: String,
			default: 'percentual',
			validator: function validator(val) {
				return ['percentual', 'windowHeight'].includes(val);
			}
		}
	},

	data: function data() {
		return {
			ticking: false,
			mainElements: [],
			buttonIsVisible: false
		};
	},


	computed: {},

	methods: {
		handleScroll: function handleScroll() {
			var _this = this;

			if (!this.ticking) {
				window.requestAnimationFrame(function () {
					_this.evaluateScrollPosition(window.scrollY, document.body.scrollHeight, window.innerHeight);
					_this.ticking = false;
				});
			}
			this.ticking = true;
		},
		goBackToTop: function goBackToTop() {
			if (window.scrollTo) {
				window.scrollTo({ top: 0, behavior: 'smooth' });
				return;
			}

			this.mainElements.forEach(function (el) {
				el.scrollTop = 0;
			});
		},
		evaluateScrollPosition: function evaluateScrollPosition(currentYScrollPosition, currentScrollHeight, windowInnerHeight) {
			switch (this.thresholdType) {
				case 'windowHeight':
					this.buttonIsVisible = windowInnerHeight <= currentYScrollPosition;
					break;

				case 'percentual':
				default:
					this.buttonIsVisible = currentScrollHeight * this.visibilityThreshold < currentYScrollPosition;
			}
		},
		handleBackToTopClick: function handleBackToTopClick() {
			this.goBackToTop();
		}
	},

	mounted: function mounted() {
		this.mainElements = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(document.querySelectorAll('html, body'));
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeDestroy: function beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
	}
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoCmsStructureDropdownAtom',

	props: {
		dataset: {
			type: Object,
			required: true
		}
	},

	data: function data() {
		return {
			visible: false
		};
	},


	computed: {
		lightscoutURL: function lightscoutURL() {
			return "https://www.stage.qa.erco.com";
		},
		selectionInfo: function selectionInfo() {
			if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.currentSelection).length === 0) {
				return '';
			}
			return this.currentSelection.category + '\n\t\t\t        <span class="divider">-</span> ' + this.currentSelection.specification + '\n\t\t\t        <span class="divider">-</span> ' + this.currentSelection.genus;
		},
		currentSelection: function currentSelection() {
			return this.$store.state.dashboard.activeFilters.cmsStructure && this.$store.state.dashboard.activeFilters.cmsStructure.value || {};
		}
	},

	methods: {
		itemIsActive: function itemIsActive(pairs) {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(pairs).reduce(function (acc, key) {
				var value = pairs[key];
				return acc && _this.currentSelection[key] === value;
			}, true) && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(pairs).length > 0;
		},
		handleButtonClick: function handleButtonClick() {
			this.visible = !this.visible;
		},
		handleBlur: function handleBlur(event) {
			if (event.relatedTarget && event.relatedTarget.classList.contains('dropdown-item')) {
				this.$refs.mainDropdownButton.focus();
				return;
			}

			if (this.visible) {
				this.visible = !this.visible;
			}
		},
		handleSubmenuItemClick: function handleSubmenuItemClick() {
			return false;
		},
		handleGenusClick: function handleGenusClick(category, specification, genus) {
			this.$emit('click', {
				category: category,
				specification: specification,
				genus: genus
			});
			this.visible = false;
			return false;
		},
		handleResetClick: function handleResetClick() {
			this.$emit('click', null);
			this.visible = false;
		}
	}
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_infoTextHelper__ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoLayoutDividerActionBarAtom',
	data: function data() {
		return {};
	},

	props: {
		prevSiteDataset: {
			type: [Object, Boolean],
			default: false
		},
		nextSiteDataset: {
			type: [Object, Boolean],
			default: false
		}
	},
	computed: {
		objectsites: function objectsites() {
			return this.$store.state.objectsites;
		},
		insertNewActionActive: function insertNewActionActive() {
			if (this.prevSiteDataset) {
				var sitesPerTopicOverMax = this.$store.getters.maxSitesPerTopicStatus[this.prevSiteDataset.topicId];
				return !sitesPerTopicOverMax;
			}

			return true;
		},
		currentActionDataObject: function currentActionDataObject() {
			return this.$store.state.objectsites.layoutAction.values;
		},
		pasteActionActive: function pasteActionActive() {
			if (this.objectsites.layoutAction.type !== 'move') {
				return false;
			}

			var previousOfSameTopic = this.prevSiteDataset && this.prevSiteDataset.topicId === this.currentActionDataObject.topicId;
			var nextOfSameTopic = this.nextSiteDataset && this.nextSiteDataset.topicId === this.currentActionDataObject.topicId;

			if (!previousOfSameTopic && !nextOfSameTopic) {
				return false;
			}

			var actionValues = this.objectsites.layoutAction.values;

			var matchingPrevSiteId = this.prevSiteDataset && this.prevSiteDataset.id === actionValues.id;
			var matchingNextSiteId = this.nextSiteDataset && this.nextSiteDataset.id === actionValues.id;

			if (matchingPrevSiteId || matchingNextSiteId) {
				return false;
			}

			return true;
		},
		nextSiteNum: function nextSiteNum() {
			var nextSiteNum = 0;
			if (this.prevSiteDataset) {
				nextSiteNum = this.prevSiteDataset.sitenumber + 1;
			} else if (this.nextSiteDataset) {
				nextSiteNum = this.nextSiteDataset.sitenumber;
			}

			return nextSiteNum;
		}
	},
	methods: {
		handleCreateClick: function handleCreateClick() {
			var _this = this;

			var prevDatasetTopicId = this.prevSiteDataset.topicId;

			var outputData = this.$store.state.objectsites.templates[prevDatasetTopicId];

			if (outputData) {
				this.openSidebarForClickAction(prevDatasetTopicId, outputData);
			} else {
				var contentTopicId = this.$store.state.objectsetup.current.thema_content;
				var contentTopicOutputData = this.$store.state.objectsites.templates[contentTopicId];

				if (contentTopicOutputData) {
					this.openSidebarForClickAction(contentTopicId, contentTopicOutputData);
					return;
				}

				this.$store.dispatch('getLayoutTemplatesForTopicId', contentTopicId).then(function () {
					var freshContentTopicOutputData = _this.$store.state.objectsites.templates[contentTopicId];
					_this.openSidebarForClickAction(contentTopicId, freshContentTopicOutputData);
				}).catch(function () {});
			}
		},
		openSidebarForClickAction: function openSidebarForClickAction(topicId, outputData) {
			var sidebarData = {
				visible: true,
				key: 'layout-template-selection',
				view: 'erco-sidebar-template-selection',
				fixed: true,
				outputData: outputData,
				context: {
					dispatchActionName: 'insertLayoutSite',
					value: {
						sitenumber: this.nextSiteNum,
						topicId: topicId
					}
				},
				styles: {
					width: '70%'
				},
				title: 'Modulauswahl',
				titleAdditional: '',
				info: __WEBPACK_IMPORTED_MODULE_0__helper_infoTextHelper__["a" /* default */].for('layout.createNewSite')
			};

			this.$store.dispatch('updateSidebar', sidebarData);
		},
		handlePasteClick: function handlePasteClick() {
			var actionInfo = {
				type: this.objectsites.layoutAction.type,
				prevSiteId: this.prevSiteDataset && this.prevSiteDataset.id,
				nextSiteId: this.nextSiteDataset && this.nextSiteDataset.id,
				values: this.objectsites.layoutAction.values
			};
			this.$store.dispatch('handleSiteAction', actionInfo);
		}
	}
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helper_infoTextHelper__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helper_renderHelper__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_molecules_ErcoCloak__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_molecules_ErcoCloak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_molecules_ErcoCloak__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_preview_ContentGrid__ = __webpack_require__(213);

















var siteMixins = {
	'career_content_grid.htm': __WEBPACK_IMPORTED_MODULE_10__mixins_preview_ContentGrid__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoLayoutPreviewItemAtom',

	props: {
		dataset: {
			type: Object,
			required: true
		},
		objecttype: {
			type: String,
			default: '-1'
		},
		objectname: {
			type: String,
			default: ''
		}
	},

	data: function data() {
		return {
			$previewItem: null,
			componentIsAlreadyInjected: false,
			siteType: '',
			siteTitle: ''
		};
	},


	components: {
		ErcoCloak: __WEBPACK_IMPORTED_MODULE_9__components_molecules_ErcoCloak___default.a
	},

	watch: {
		dataset: function dataset() {
			this.updatePreview();
		},
		objectname: function objectname(newObjectname) {
			this.$set(this.$previewItem.$data, 'objectname', newObjectname);
		}
	},

	mounted: function mounted() {
		this.updatePreview();
	},


	computed: {
		previewItemWrapperAttrs: function previewItemWrapperAttrs() {
			var attrs = {
				class: ['wrapper']
			};

			this.dataset.bodytagAttrs.replace(/(.*?)="(.*?)"/g, function (whole, attrName, attrValue) {
				var lcAttrName = attrName.trim().toLowerCase();

				if (!attrs[lcAttrName]) {
					attrs[lcAttrName] = [];
				}

				attrs[lcAttrName].push(attrValue.trim());
			});

			return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(attrs).map(function (attrKey) {
				var attrValue = Array.isArray(attrs[attrKey]) ? attrs[attrKey].join(' ') : attrs[attrKey];
				return attrKey + '="' + attrValue + '"';
			}).join(' ');
		},
		imgFieldCount: function imgFieldCount() {
			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(this.dataset.items).reduce(function (acc, item) {
				var newAcc = acc;
				if (item.typ === 'bild' && item.value) {
					newAcc += 1;
				}
				return newAcc;
			}, 0);
		},
		textFieldCount: function textFieldCount() {
			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(this.dataset.items).reduce(function (acc, item) {
				var newAcc = acc;
				if (item.typ === 'text' && item.value) {
					newAcc += 1;
				}
				return newAcc;
			}, 0);
		},
		template: function template() {
			return {
				title: this.dataset.templateTitle || '',
				id: this.dataset.templateId || '',
				path: this.dataset.templatePath || ''
			};
		}
	},

	methods: {
		updatePreview: function updatePreview() {
			if (!this.dataset.loading) {
				this.injectPreviewComponent();
			}

			this.updateRenderPreviewData(this.dataset);
		},
		injectPreviewComponent: function injectPreviewComponent() {
			var _this = this;

			if (this.componentIsAlreadyInjected) {
				return;
			}

			this.componentIsAlreadyInjected = true;

			var previewItemContainer = this.$refs['preview-item'];
			var cssStyles = [];
			var imgKeys = [];

			this.specification = this.dataset.specification;
			this.category = this.dataset.category;
			this.idArea = this.dataset.idArea;
			this.idObject = this.dataset.idObject;
			this.isGenus = this.dataset.isGenus;

			var sanitizedTemplate = this.dataset.template && this.dataset.template.replace(/style\s*=\s*"(.*?)"/g, function (match, group) {
				var cleanedGroup = group.replace(/(min-){0,1}height.*?(;|$)/g, '');
				return 'style="' + cleanedGroup + '"';
			}).replace(/<\s*style\s*>([\s\S.]*?)<\s*\/\s*style\s*>/mg, function (match, firstGroup) {
				if (firstGroup) {
					cssStyles.push(firstGroup);
				}
				return '';
			}).replace(/<\s*km(\s[\s\S]*?){0,1}\s*>([\s\S]*?)(<\s*\/\s*km\s*>){0,1}/mg, function (match, groupOne, groupTwo) {
				return '<div' + (groupOne || '') + '>' + (groupTwo || '') + '</div>';
			}).replace(/<\s*?script[\s\S]*?>[\s\S]*?<\s*?\/\s*?script\s*?>/mg, '').replace(/v-html="(\s*.+?\s*)"/mg, function (match, key) {
				var subtype = _this.dataset.items[key].typ;
				if (subtype === 'text' && _this.dataset.items[key].enum) {
					subtype = 'enum';
				}
				var editableSubAttr = subtype === 'enum' ? 'data-list-select' : 'data-text-edit';
				var editableAttr = 'data-editable ' + editableSubAttr;
				var position = _this.dataset.items[key].U_Position;
				var modifiedAttrs = match + ' @click="handleItemClick(\'' + key + '\', $event)" ' + editableAttr + ' data-dev-info="{ type: \'item\', id: \'' + key + '\', subtype: \'' + subtype + '\', position: ' + position + ' }"';
				return modifiedAttrs;
			}).replace(/v-bind:src="(\s*.+?\s*)"/mg, function (match, key) {
				var subtype = _this.dataset.items[key].typ;
				var position = _this.dataset.items[key].U_Position;
				var sUrbild = _this.dataset.items[key].S_Urbild;
				var modifiedAttrs = match + ' @click="handleItemClick(\'' + key + '\', $event)" data-editable data-dev-info="{ type: \'item\', id: \'' + key + '\', subtype: \'' + subtype + '\', position: ' + position + ', image: \'' + sUrbild + '\' }" v-bind:class="{ loading: ' + key + '_loading }"';
				imgKeys.push(key);
				return modifiedAttrs;
			}).replace(new RegExp('(>[\\w\\d]*?)(' + this.objectname + ')', 'g'), function (match, prefix) {
				return prefix + '{{objectname}}';
			});

			var cssRules = this.parseCSSStyles(cssStyles);

			var loadingData = imgKeys.reduce(function (fields, imgKey) {
				fields[imgKey + '_loading'] = false;
				return fields;
			}, {});
			var extendedData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.dataset.data, loadingData, {
				objectname: this.objectname,
				bgColorGrayscaleThreshold: 127.5,
				invertEdit: 'false'
			});

			var specificMixins = [];

			if (siteMixins[this.dataset.templatePath]) {
				specificMixins.push(siteMixins[this.dataset.templatePath]);
			}

			this.$refs['preview-item-cloak'].$destroy();
			previewItemContainer.innerHTML = '';

			var wrappedSanitizedTemplate = '<div class="preview-item 96a5e0e1b988103acd3676a3bfca66930fb87db">\n\t\t\t\t\t<div :data-invert-edit="invertEdit" ' + this.previewItemWrapperAttrs + '>\n\t\t\t\t\t\t' + sanitizedTemplate + '\n\t\t\t\t\t</div>\n\t\t\t\t</div>';

			this.$previewItem = new __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */]({
				name: 'ErcoLayoutPreviewDynItem',
				mixins: specificMixins,

				template: wrappedSanitizedTemplate,

				parent: this,

				data: extendedData,
				mounted: function mounted() {
					var _this2 = this;

					cssRules.forEach(function (rule) {
						var selectedEls = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(_this2.$el.querySelectorAll(rule.selector));
						selectedEls.forEach(function (el) {
							return el.setAttribute('style', rule.props);
						});
					});

					var wrapperEl = this.$el.querySelector('.wrapper');
					if (!wrapperEl) {
						return;
					}

					var color = window.getComputedStyle(wrapperEl).backgroundColor;

					if (color && this.hasDarkBackgroundColor(color)) {
						this.invertEdit = 'true';
					}
				},

				methods: {
					handleItemClick: function handleItemClick(key, $event) {
						this.$parent.handleItemClick(key, $event);
					},
					hasDarkBackgroundColor: function hasDarkBackgroundColor(foundColor) {
						var matches = foundColor.match(/\((\d{1,3}), (\d{1,3}), (\d{1,3}).*?\)/);

						if (!matches) {
							return false;
						}

						matches.shift();

						var erg = (parseInt(matches[0], 10) + parseInt(matches[1], 10) + parseInt(matches[2], 10)) / 3;

						var opacityMatch = foundColor.match(/\(\d{1,3}, \d{1,3}, \d{1,3}, (\d\.\d*|\d).*?\)/);

						var opacity = opacityMatch ? parseInt(opacityMatch[1], 10) : 1;

						if (erg < this.bgColorGrayscaleThreshold && opacity !== 0) {
							return true;
						}

						return false;
					}
				}
			}).$mount(previewItemContainer);
		},
		parseCSSStyles: function parseCSSStyles(cssStyles) {
			var cssRules = [];
			cssStyles.forEach(function (style) {
				style.replace(/(\s*[\s\S]*?)\s*\{\s*([\s\S]*?)\s*\}/mg, function (match, firstGroup, secondGroup) {
					cssRules.push({
						selector: firstGroup.trim(),
						props: secondGroup.split(';').map(function (item) {
							return item.trim();
						}).filter(function (item) {
							return item.trim().length > 0;
						}).join('; ') + ';'
					});
				});
			});
			return cssRules;
		},
		updateRenderPreviewData: function updateRenderPreviewData(dataset) {
			var _this3 = this;

			if (!this.$previewItem || !this.$previewItem.$data || !dataset) {
				return;
			}

			__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(dataset.data).forEach(function (key) {
				var item = dataset.items[key];
				if (item && item.typ === 'bild') {
					__WEBPACK_IMPORTED_MODULE_8__helper_renderHelper__["a" /* default */].getImage(item, function (img, loading) {
						_this3.$set(_this3.$previewItem.$data, key, img);
						_this3.$set(_this3.$previewItem.$data, key + '_loading', loading);
					});
				} else {
					_this3.$set(_this3.$previewItem.$data, key, dataset.data[key]);
				}
			});
		},
		handleItemClick: function handleItemClick(key, event) {
			var _this4 = this;

			var type = '';
			var view = '';
			var title = 'Position ' + this.dataset.items[key].nummer;
			var titleAdditional = '';
			var outputData = null;
			var resetButton = null;

			if (event.target) {
				var labelEl = event.target.previousElementSibling;

				if (labelEl && labelEl.classList.contains('label')) {
					titleAdditional = title;
					title = labelEl.innerHTML;
				}
			}

			if (this.dataset.items[key].enum) {
				type = 'enum';
				view = 'erco-sidebar-dropdown';
				outputData = [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ key: key }, this.dataset.items[key])];
			} else if (this.dataset.items[key].typ === 'bild') {
				type = 'image';
				view = 'erco-sidebar-image-editor';
				title = this.dataset.items[key].S_Urbild;
				outputData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ key: key }, this.dataset.items[key]);
				resetButton = { visible: true };
			} else {
				type = 'text';
				view = 'erco-sidebar-tabbed-text-input';

				var tabs = __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].langs.map(function (lang) {
					var text = _this4.dataset.translations[lang.key] && _this4.dataset.translations[lang.key].items[key] && _this4.dataset.translations[lang.key].items[key].value || '';
					return {
						key: key,
						tabKey: lang.key,
						label: lang.text,
						text: text,
						toBeFetched: _this4.dataset.translations[lang.key] === null
					};
				});

				var charlength = parseInt(this.dataset.items[key].charlength, 10) || -1;

				outputData = {
					tabChangeAction: 'getObjectSiteTranslation',
					selectedTabKey: this.$store.state.objectsetup.current.sprache,
					tabs: tabs,
					charlength: charlength
				};

				if (charlength > -1) {
					titleAdditional = '(max. ' + charlength + ' Zeichen)';
				}
			}

			var sidebarData = {
				visible: true,
				key: 'layout-preview-item',
				view: view,
				fixed: true,
				outputData: outputData,
				context: {
					dispatchActionName: 'updateObjectSiteItemsAndSave',
					value: {
						siteId: this.dataset.id,
						type: type
					}
				},
				resetButton: resetButton,
				title: title,
				titleAdditional: titleAdditional,
				info: __WEBPACK_IMPORTED_MODULE_7__helper_infoTextHelper__["a" /* default */].for('layout.itemEdit')
			};

			this.$store.dispatch('updateSidebar', sidebarData);
		},
		handleMoveClick: function handleMoveClick() {
			this.$store.dispatch('setLayoutAction', {
				type: 'move',
				values: this.dataset
			});
		},
		handleDeleteClick: function handleDeleteClick() {
			this.$refs.deleteConfirmation.show();
		},
		handleDeleteConfirmationModalClick: function handleDeleteConfirmationModalClick() {
			this.$store.dispatch('deleteSite', this.dataset.id);
		}
	}
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoListAtom',

	data: function data() {
		return {};
	},


	props: {
		items: {
			type: Array,
			required: true
		},

		ordered: {
			type: Boolean,
			default: false
		},

		draggable: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		handleDragStart: function handleDragStart(index, e) {
			e.dataTransfer.effectAllowed = 'copy';
			e.dataTransfer.setData('text/plain', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.items[index]));
		}
	}
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoDropdown__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoDropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoDropdown__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoMenuAtom',

	props: {
		items: {
			type: Array,
			required: true
		},

		jumpTo: {
			type: Function,
			required: true
		},
		lang: {
			type: String,
			default: 'de'
		}
	},

	data: function data() {
		return {
			langs: function () {
				return __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].langs.slice().map(function (lang) {
					return {
						value: lang.key,
						text: lang.textLong
					};
				});
			}()
		};
	},


	computed: {
		languageSelectorIsVisible: function languageSelectorIsVisible() {
			var activeItem = this.items.find(function (item) {
				return item.active && ['assets', 'layout'].includes(item.name);
			});
			return !!activeItem;
		},
		selectedLangIndex: function selectedLangIndex() {
			var _this = this;

			var index = this.langs.findIndex(function (lang) {
				return lang.value === _this.lang;
			});
			return Math.max(0, index);
		}
	},

	methods: {
		handleLanguageChange: function handleLanguageChange(item) {
			var lang = item.currentValue;
			this.$store.dispatch('setObjectLanguage', lang);
		}
	},

	components: {
		ErcoDropdown: __WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoDropdown___default.a
	}
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoNumberStepperAtom',

	data: function data() {
		return {
			currentValue: null
		};
	},


	props: {
		value: {
			type: Number
		},

		min: {
			type: Number,
			default: null
		},

		max: {
			type: Number,
			default: null
		},

		step: {
			type: Number,
			default: 1
		},

		leftPadLength: {
			type: Number,
			default: null
		},

		stepDown: {
			type: Function,
			default: null
		},

		stepUp: {
			type: Function,
			default: null
		},

		validator: {
			type: Function,
			default: function _default(value) {
				return !!value.match(/\d*/);
			}
		}
	},

	computed: {
		leftPaddedValue: function leftPaddedValue() {
			var retVal = this.computedValue.toString();

			if (this.leftPadLength !== null && retVal !== '') {
				retVal = retVal.padStart(this.leftPadLength, '0');
				retVal = retVal.substr(retVal.length - this.leftPadLength);
			}

			return retVal;
		},


		computedValue: {
			set: function set(value) {
				this.currentValue = value;
			},
			get: function get() {
				return this.currentValue !== null ? this.currentValue : this.value;
			}
		},

		inputClasses: function inputClasses() {
			var inputClasses = {};

			if (!this.validator(this.computedValue.toString())) {
				inputClasses['-invalid'] = true;
			}

			return inputClasses;
		}
	},

	methods: {
		handleInputValue: function handleInputValue(newValue) {
			this.computedValue = this.keepInBound(newValue);
			this.handleValueChange();
		},
		handleValueChange: function handleValueChange() {
			if (this.validator(this.computedValue.toString())) {
				this.$emit('change', parseInt(this.computedValue, 10));
			}
		},
		innerStepDown: function innerStepDown() {
			var value = this.stepDown && this.stepDown(this.computedValue) || parseInt(this.computedValue, 10) - this.step;

			this.computedValue = this.keepInBound(value);
			this.handleValueChange();
		},
		innerStepUp: function innerStepUp() {
			var value = this.stepUp && this.stepUp(this.computedValue) || parseInt(this.computedValue, 10) + this.step;

			this.computedValue = this.keepInBound(value);
			this.handleValueChange();
		},
		keepInBound: function keepInBound(val) {
			var min = this.min;
			var max = this.max;

			var retVal = parseInt(val, 10) || 0;

			if (max !== null && retVal > max) {
				retVal = min !== null ? min : max;
			}

			if (min !== null && retVal < min) {
				retVal = max !== null ? max : min;
			}

			return retVal;
		}
	}
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_spinner__ = __webpack_require__(57);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoSpinnerAtom',

	props: {
		isFixedColor: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: '60px'
		}
	},

	computed: {
		computedStyle: function computedStyle() {
			return 'background-color: ' + this.backgroundColor + ';';
		}
	},

	components: {
		'circle-spinner': __WEBPACK_IMPORTED_MODULE_0_vue_loading_spinner__["a" /* Circle */]
	}
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoStatusBadgeAtom',

	data: function data() {
		return {};
	},


	props: {
		status: {
			type: String,
			required: true
		}
	},
	computed: {
		uppercasedStatus: function uppercasedStatus() {
			var status = this.status;

			if (!status) {
				return status;
			}

			return '' + status[0].toUpperCase() + status.substr(1);
		},
		badgeVariant: function badgeVariant() {
			switch (this.status) {
				case 'online':
					return 'success';
				case 'entwurf':
					return 'primary';
				case 'preview':
					return 'primary';
				default:
					return 'info';
			}
		}
	}
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoTextAreaAtom',

	data: function data() {
		return {};
	},


	props: {
		label: {
			type: String,
			default: ''
		},
		text: {
			type: String,
			required: true
		}
	},
	methods: {
		handleTextChange: function handleTextChange(value) {
			this.$emit('change', value.target.value);
		}
	}
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoTooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoTooltip__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoCheckboxGroupMolecule',

	props: {
		label: {
			type: String,
			default: ''
		},
		options: {
			type: Array,
			default: []
		},
		direction: {
			type: String,
			default: 'horizontal',
			validator: function validator(dir) {
				return ['vertical', 'horizontal'].includes(dir.toLowerCase());
			}
		},
		tooltip: {
			type: Object,
			required: false,
			default: function _default() {
				return { variant: '', title: '', text: '' };
			}
		}
	},

	components: {
		ErcoTooltip: __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoTooltip___default.a
	},

	computed: {
		containerClasses: function containerClasses() {
			var containerClasses = {};
			containerClasses['-' + this.direction.toLowerCase()] = true;
			return containerClasses;
		},
		prepValue: function prepValue() {
			return this.options.map(function (option) {
				return option.checked ? option.value : '';
			});
		},
		selectedValues: function selectedValues() {
			var _this = this;

			var selectedValues = {};

			this.value.forEach(function (value, index) {
				var lang = _this.options[index].value;
				selectedValues[lang] = value === '' ? 0 : 1;
			});

			return selectedValues;
		}
	},

	methods: {
		handleChange: function handleChange(index, value, checked) {
			this.$emit('change', index, value, checked !== '');
		}
	}
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_atoms_ErcoSpinner__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_atoms_ErcoSpinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_atoms_ErcoSpinner__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoCloakMolecule',

	props: {
		backgroundColor: {
			type: String,
			default: 'rgba(0, 0, 0, 0.4)'
		},
		vCenter: {
			type: Boolean,
			default: true
		}
	},

	computed: {
		computedStyle: function computedStyle() {
			return 'background-color: ' + this.backgroundColor + ';';
		}
	},

	components: {
		ErcoSpinner: __WEBPACK_IMPORTED_MODULE_0__components_atoms_ErcoSpinner___default.a
	}
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoNumberStepper__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoNumberStepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoNumberStepper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ErcoDropdown__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ErcoDropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ErcoDropdown__);







__WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale('de');

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoDateTimePickerMolecule',
	data: function data() {
		return {
			currentDay: null,
			currentMonth: null,
			currentYear: null,
			currentHours: null,
			currentMinutes: null,

			visibleYear: null,
			visibleMonth: null,

			manuallySelectedDate: __WEBPACK_IMPORTED_MODULE_1_moment___default()(),
			selectedDatetime: null
		};
	},

	props: {
		datetime: {
			type: Date,
			required: false
		},
		fallbackDatetime: {
			type: Date,
			required: false,
			default: new Date()
		}
	},
	methods: {
		changeYear: function changeYear(rel) {
			this.visibleYear = parseInt(this.currentVisibleYear, 10) + rel;
		},
		handleInputYear: function handleInputYear(value) {
			this.visibleYear = value;
		},
		inputYearValidator: function inputYearValidator(value) {
			return !!value.match(/\d{4}/);
		},
		handleChangeMonth: function handleChangeMonth(data) {
			this.visibleMonth = parseInt(data.currentIndex, 10);
		},
		handleChangeHour: function handleChangeHour(value) {
			this.currentHours = value;
			this.emitChange();
		},
		handleChangeMinute: function handleChangeMinute(value) {
			this.currentMinutes = value;
			this.emitChange();
		},
		handleClickDay: function handleClickDay(day) {
			if (day === undefined) {
				return;
			}
			this.currentDay = parseInt(day, 10);
			this.currentYear = this.visibleYear !== null ? this.visibleYear : this.currentDateTime.currentYear;
			this.currentMonth = this.visibleMonth !== null ? this.visibleMonth : this.currentDateTime.currentMonth;
			this.emitChange();
		},
		emitChange: function emitChange() {
			var newManuallySelectedDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
			newManuallySelectedDate.year(this.currentDateTime.currentYear);
			newManuallySelectedDate.month(this.currentDateTime.currentMonth);
			newManuallySelectedDate.date(this.currentDateTime.currentDay);
			newManuallySelectedDate.hours(this.currentDateTime.currentHours);
			newManuallySelectedDate.minutes(this.currentDateTime.currentMinutes);
			newManuallySelectedDate.seconds(0);

			this.manuallySelectedDate = newManuallySelectedDate;

			this.$emit('change', this.manuallySelectedDate.toDate());
		},
		isSelectedDay: function isSelectedDay(day) {
			if (this.currentDateTime.currentYear === this.currentVisibleYear && this.currentDateTime.currentMonth === this.currentVisibleMonth && day === this.currentDay) {
				return true;
			}

			return false;
		}
	},
	components: {
		ErcoNumberStepper: __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoNumberStepper___default.a,
		ErcoDropdown: __WEBPACK_IMPORTED_MODULE_3__ErcoDropdown___default.a
	},
	computed: {
		currentDateTime: function currentDateTime() {
			var _this = this;

			if (!this.datetime) {
				this.selectedDatetime = this.fallbackDatetime;
			} else {
				this.selectedDatetime = this.datetime;
				this.manuallySelectedDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.datetime);
			}

			this.selectedDatetime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.selectedDatetime);

			var currentDateTime = {
				currentDay: this.currentDay !== null ? this.currentDay : this.selectedDatetime.date(),
				currentMonth: this.currentMonth !== null ? this.currentMonth : this.selectedDatetime.month(),
				currentYear: this.currentYear !== null ? this.currentYear : this.selectedDatetime.year(),
				currentHours: this.currentHours !== null ? this.currentHours : this.selectedDatetime.hours(),
				currentMinutes: this.currentMinutes !== null ? this.currentMinutes : this.selectedDatetime.minutes()
			};

			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(currentDateTime).forEach(function (key) {
				return _this[key] = currentDateTime[key];
			});

			return currentDateTime;
		},
		currentVisibleYear: function currentVisibleYear() {
			return this.visibleYear !== null ? this.visibleYear : this.currentDateTime.currentYear;
		},
		currentVisibleMonth: function currentVisibleMonth() {
			return this.visibleMonth !== null ? this.visibleMonth : this.currentDateTime.currentMonth;
		},
		weeks: function weeks() {
			var weeks = [];
			var days = [];
			var i = 0;
			var day = 0;
			for (i = 0; i < this.beginWeekDay - 1; i += 1) {
				days.push('');
			}
			var weeksInMonth = Math.ceil((this.beginWeekDay - 1 + this.daysInMonth) / 7);
			for (var j = 1; j <= weeksInMonth; j += 1) {
				for (; i < 7 * j && day < this.daysInMonth; i += 1) {
					var currDay = day + 1;
					day += 1;

					days.push({
						num: currDay,
						text: currDay.toString().padStart(2, '0'),
						isSelected: this.isSelectedDay(currDay)
					});
				}
				weeks.push(days);
				days = [];
			}
			return weeks;
		},
		weekdays: function weekdays() {
			var weekdays = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.weekdaysMin();
			weekdays.push(weekdays.splice(0, 1)[0]);
			return weekdays;
		},
		months: function months() {
			var months = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.months();
			var items = [];
			months.forEach(function (item) {
				items.push({
					text: item
				});
			});
			return items;
		},
		currentMonthIndex: function currentMonthIndex() {
			return this.currentDateTime.currentMonth;
		},
		years: function years() {
			var currentYear = __WEBPACK_IMPORTED_MODULE_1_moment___default()().year();
			var items = [];
			for (var i = currentYear; i < currentYear + 10; i += 1) {
				items.push({
					text: i.toString()
				});
			}
			return items;
		},
		beginWeekDay: function beginWeekDay() {
			return __WEBPACK_IMPORTED_MODULE_1_moment___default()().year(this.currentVisibleYear).month(this.currentVisibleMonth).date(1).isoWeekday();
		},
		daysInMonth: function daysInMonth() {
			return __WEBPACK_IMPORTED_MODULE_1_moment___default()().year(this.currentVisibleYear).month(this.currentVisibleMonth).date(1).daysInMonth();
		},
		hours: function hours() {
			return this.currentDateTime.currentHours;
		},
		minutes: function minutes() {
			return this.currentDateTime.currentMinutes;
		}
	}
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoDropdownMolecule',
	data: function data() {
		return {
			internalCurrentItemIndex: null
		};
	},
	mounted: function mounted() {
		var _this = this;

		var dropdownComponentElem = this.$refs.dropdown.$el.querySelector('.dropdown-toggle');

		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.styleInfo || {}).forEach(function (key) {
			dropdownComponentElem.style[key] = _this.styleInfo[key];
		});
	},

	props: {
		label: {
			type: String,
			required: false,
			default: ''
		},
		currentItemIndex: {
			type: Number,
			default: 0
		},
		items: {
			type: Array,
			required: true,
			default: []
		},
		right: {
			type: Boolean,
			required: false,
			default: false
		},
		size: {
			type: String,
			required: false,
			default: ''
		},
		styleInfo: {
			type: Object,
			default: null
		},
		useLabelInline: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		selectedItemText: function selectedItemText() {
			if (this.useLabelInline) {
				return this.label;
			}

			return this.items[this.selectedCurrentItemIndex] ? this.items[this.selectedCurrentItemIndex].text : '';
		},
		selectedCurrentItemIndex: function selectedCurrentItemIndex() {
			var currentItemIndex = typeof this.internalCurrentItemIndex === 'number' ? this.internalCurrentItemIndex : this.currentItemIndex;

			currentItemIndex = Math.max(Math.min(currentItemIndex, this.items.length - 1), 0);

			return currentItemIndex;
		}
	},
	methods: {
		handleClick: function handleClick(event, index, rightclick) {
			if (rightclick) {
				event.preventDefault();
			}

			this.internalCurrentItemIndex = index;
			this.$emit('change', {
				currentIndex: this.internalCurrentItemIndex,
				currentText: this.items[this.internalCurrentItemIndex].text,
				currentValue: this.items[this.internalCurrentItemIndex].value,
				rightclick: rightclick
			});
		},
		resetSelection: function resetSelection() {
			this.internalCurrentItemIndex = null;
		}
	}
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_infoTextHelper__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoTooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_atoms_ErcoStatusBadge__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_atoms_ErcoStatusBadge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_atoms_ErcoStatusBadge__);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoHeaderMolecule',

	props: {
		name: {
			type: String,
			default: ''
		},
		id: {
			type: String,
			default: ''
		},
		breadcrumb: {
			type: Array,
			default: []
		},
		previewUrl: {
			type: String,
			default: ''
		},
		status: {
			type: Number,
			required: true
		},
		stati: {
			type: Object,
			required: true
		},
		isProductive: {
			type: Boolean,
			default: false
		}
	},

	data: function data() {
		return {
			renewOnlineButtonTooltip: __WEBPACK_IMPORTED_MODULE_1__helper_infoTextHelper__["a" /* default */].for('header.renewOnlineButton'),
			renewPreviewButtonTooltip: __WEBPACK_IMPORTED_MODULE_1__helper_infoTextHelper__["a" /* default */].for('header.renewPreviewButton'),
			createPreviewButtonTooltip: __WEBPACK_IMPORTED_MODULE_1__helper_infoTextHelper__["a" /* default */].for('header.createPreviewButton'),
			clearCacheButtonTooltip: __WEBPACK_IMPORTED_MODULE_1__helper_infoTextHelper__["a" /* default */].for('header.clearCacheButton')
		};
	},


	components: {
		ErcoTooltip: __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoTooltip___default.a,
		ErcoStatusBadge: __WEBPACK_IMPORTED_MODULE_3__components_atoms_ErcoStatusBadge___default.a
	},

	computed: {
		isVisitable: function isVisitable() {
			return !!this.previewUrl;
		},
		statusname: function statusname() {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.stati).reduce(function (acc, statusKey) {
				return _this.stati[statusKey] === _this.status ? statusKey : acc;
			}, '');
		},
		actionConfirmationModalState: function actionConfirmationModalState() {
			var entries = {
				onlineRenew: {
					title: 'Online erneuern',

					text: 'Soll das Objekt wirklich online erneuert werden? Die Veröffentlichung kann bis zu 10 Minuten dauern.',
					okfunc: this.handleRenewProductiveClick
				},
				default: {
					title: '',
					text: '',
					func: function func() {}
				}
			};

			return entries.onlineRenew;
		}
	},

	methods: {
		openSiteUrl: function openSiteUrl() {
			window.open(this.previewUrl, '_blank');
		},
		handleRenewPreviewClick: function handleRenewPreviewClick() {
			this.$store.dispatch('updateObjectSetupStatus', {
				status: this.stati.online,
				passLang: true,
				mode: 'preview'
			});
		},
		handleClearCacheClick: function handleClearCacheClick() {
			this.$store.dispatch('clearLightscoutCacheEntry');
		},
		handleRenewProductiveClickWithPreCheck: function handleRenewProductiveClickWithPreCheck() {
			this.$refs.actionConfirmation.show();
		},
		handleRenewProductiveClick: function handleRenewProductiveClick() {
			this.$store.dispatch('updateObjectSetupStatus', {
				status: this.stati.synchronize,
				passLang: true
			});
		}
	}
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_sign__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_tween__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_tween___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_es6_tween__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_renderHelper__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_convertHelper__ = __webpack_require__(61);








var mappingHelper = function mappingHelper() {
	var minp = 1;
	var maxp = 100;

	var minv = Math.log(1);
	var maxv = Math.log(100);

	var scale = (maxv - minv) / (maxp - minp);

	function log(value) {
		return (Math.log(value) - minv) / scale + minp;
	}

	function exp(value) {
		return Math.exp(minv + scale * (value - minp));
	}

	return { log: log, exp: exp };
}();

var animateHelper = function animateHelper(from, to, callback, namespace, instantly, completeCallback) {
	var animationFrame = void 0;

	if (namespace) {
		__WEBPACK_IMPORTED_MODULE_2_es6_tween__["getAll"]().filter(function (x) {
			return x.namespace === namespace;
		}).forEach(function (x) {
			return __WEBPACK_IMPORTED_MODULE_2_es6_tween__["remove"](x);
		});
	}

	if (instantly) {
		callback(to);
		if (completeCallback) {
			completeCallback();
		}
	} else {
		var animate = function animate(time) {
			__WEBPACK_IMPORTED_MODULE_2_es6_tween__["update"](time);
			animationFrame = requestAnimationFrame(animate);
		};

		new __WEBPACK_IMPORTED_MODULE_2_es6_tween__["Tween"](from).to(to, 300).easing(__WEBPACK_IMPORTED_MODULE_2_es6_tween__["Easing"].Quadratic.Out).on('update', callback).on('complete', function () {
			if (completeCallback) {
				completeCallback();
			}
			cancelAnimationFrame(animationFrame);
		}).start().namespace = namespace;

		animationFrame = requestAnimationFrame(animate);
	}
};

var HTMLColorOrElse = function HTMLColorOrElse(colorValue, elseValue) {
	if (colorValue.trim().match(/^#[0-9a-f]{6}$/i)) {
		return {
			r: parseInt(colorValue.substr(1, 2), 16),
			g: parseInt(colorValue.substr(3, 2), 16),
			b: parseInt(colorValue.substr(5, 2), 16),
			a: 1
		};
	} else if (colorValue.trim().match(/^#[0-9-a-f]{3}/i)) {
		var redHex = '' + colorValue.substr(1, 1) + colorValue.substr(1, 1);
		var greenHex = '' + colorValue.substr(2, 1) + colorValue.substr(2, 1);
		var blueHex = '' + colorValue.substr(3, 1) + colorValue.substr(3, 1);

		return {
			r: parseInt(redHex, 16),
			g: parseInt(greenHex, 16),
			b: parseInt(blueHex, 16),
			a: 1
		};
	}

	return elseValue;
};

var RGBAToHTMLColor = function RGBAToHTMLColor(color) {
	if (typeof color !== 'string') {
		return false;
	}

	var parsedColor = {
		r: 0,
		g: 0,
		b: 0,
		a: 0
	};

	var match = color.trim().replace(/\s/g, '').match(/^rgba\((\d+),(\d+),(\d+),(.+)\)$/);

	if (match) {
		parsedColor.r = parseInt(match[1], 10);
		parsedColor.g = parseInt(match[2], 10);
		parsedColor.b = parseInt(match[3], 10);
		parsedColor.a = parseInt(match[4], 10);
	}

	var rr = ('0' + parseInt(parsedColor.r, 10).toString(16)).slice(-2);
	var gg = ('0' + parseInt(parsedColor.g, 10).toString(16)).slice(-2);
	var bb = ('0' + parseInt(parsedColor.b, 10).toString(16)).slice(-2);

	if (parsedColor.a === 0) {
		return 'transparent';
	}

	return '#' + (rr + gg + bb);
};

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoImageEditorMolecule',
	props: {
		data: {
			type: Object
		},
		backgrounds: {
			type: Array,
			default: function _default() {
				return [{
					name: 'Weiß',
					value: '#ffffff'
				}, {
					name: 'Grau',
					value: '#aaaaaa'
				}, {
					name: 'Schwarz',
					value: '#000000'
				}, {
					name: 'Spezifisch',
					value: undefined
				}];
			}
		}
	},
	computed: {
		sliderScale: {
			get: function get() {
				return mappingHelper.log(this.img.scale * 10);
			},
			set: function set(value) {
				this.setScale(mappingHelper.exp(value) / 10);
				this.handleChange();
			}
		},
		sliderrotation: {
			get: function get() {
				return this.img.rotation * 100;
			},
			set: function set(value) {
				this.setRotation(value / 100);
				this.handleChange();
			}
		},
		selectedSize: {
			get: function get() {
				var _this = this;

				var size = this.sizes.find(function (x) {
					return x.width === _this.img.width && x.height === _this.img.height;
				});
				return size && size.name;
			},
			set: function set(value) {
				var size = this.sizes.find(function (x) {
					return x.name === value;
				});
				this.setSize(size.width, size.height);
				this.handleChange();
			}
		},
		selectedBackground: {
			get: function get() {
				var _this2 = this;

				var background = this.backgrounds.find(function (x) {
					return x.value === _this2.img.background;
				});
				return background && background.name;
			},
			set: function set(value) {
				var background = value === this.enteredBackground.name ? this.enteredBackground : this.backgrounds.find(function (x) {
					return x.name === value;
				});
				this.setBackground(background.value);
				this.handleChange();
			}
		},

		ratio: function ratio() {
			return this.img.height / (this.img.width || 1);
		},
		initialScale: function initialScale() {
			return this.ratio < this.imgRatio ? 1 : this.ratio / (this.imgRatio || 1);
		},
		imgRatio: function imgRatio() {
			return this.imgNode.height / (this.imgNode.width || 1);
		}
	},
	data: function data() {
		return {
			border: 'n',

			img: {
				left: undefined,
				top: undefined,
				scale: undefined,
				rotation: undefined,
				width: undefined,
				height: undefined,
				background: undefined
			},

			imgNode: undefined,

			drag: {
				prev: { x: 0, y: 0 },
				dragging: false
			},

			misc: {
				background: undefined,
				slideDown: false,
				sliding: false,
				color: undefined,
				picking: false
			},

			sizes: [{
				name: '1:1',
				width: 550,
				height: 550
			}, {
				name: '2:1',
				width: 1100,
				height: 550
			}, {
				name: '4:3',
				width: 1100,
				height: 825
			}],

			enteredBackground: {
				name: 'entered',
				value: '#FF00FF'
			}
		};
	},

	methods: {
		drawObject: function drawObject() {
			this.img.border = this.border === 'j';
			return __WEBPACK_IMPORTED_MODULE_3__helper_renderHelper__["a" /* default */].getCanvas(this.imgNode, this.img, this.misc.background);
		},
		setId: function setId(value) {
			var _this3 = this;

			if (!value || this.imgNode && this.imgNode.src === value) {
				if (!value) {
					this.imgNode = undefined;
				}
				return;
			}

			var img = new Image();
			img.crossOrigin = 'Anonymous';
			img.src = value;
			img.onerror = function () {
				_this3.imgNode = undefined;
			};
			img.onload = function () {
				_this3.imgNode = img;

				var converted = __WEBPACK_IMPORTED_MODULE_4__helper_convertHelper__["a" /* default */].importData(_this3.data, _this3.imgNode);

				_this3.setBackground(converted.background);
				_this3.setRotation(converted.rotation);
				_this3.setSize(converted.width, converted.height);
				_this3.setScale(converted.scale);
				_this3.setPosition(converted.left, converted.top);
				_this3.setBorder(_this3.data.B_Rahmen);
			};
		},
		setBorder: function setBorder(border) {
			this.border = border;
		},
		setPosition: function setPosition() {
			var _this4 = this;

			var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
			var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

			var instantly = typeof this.img.left === 'undefined' || this.drag.dragging || this.img.left === left && this.img.top === top;
			var maxLeft = 0.5 + this.img.scale / 2;
			var maxTop = 0.5 + this.img.scale * (this.imgRatio / this.ratio) / 2;

			animateHelper({
				l: this.img.left,
				t: this.img.top
			}, {
				l: Math.min(Math.abs(left), maxLeft) * __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_sign___default()(left),
				t: Math.min(Math.abs(top), maxTop) * __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_sign___default()(top)
			}, function (_ref) {
				var l = _ref.l,
				    t = _ref.t;

				_this4.img.left = l;
				_this4.img.top = t;
			}, 'position', instantly);
		},
		setScale: function setScale() {
			var _this5 = this;

			var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.initialScale;

			var instantly = typeof this.img.scale === 'undefined' || this.misc.sliding || this.img.scale === scale;

			animateHelper({
				s: this.img.scale
			}, {
				s: scale
			}, function (_ref2) {
				var s = _ref2.s;

				_this5.img.scale = s;
			}, 'scale', instantly);
		},
		setSize: function setSize(width, height) {
			var _this6 = this;

			var instantly = !this.img.width && !this.img.height || width === this.img.width && height === this.img.height;
			var size = this.sizes.find(function (x) {
				return x.width === width && x.height === height;
			}) || this.sizes[0];

			if (this.img.scale) {
				var diff = !width && !height ? 1 : this.img.scale / this.initialScale;
				this.setScale(this.getInitialScaleFor(size.width, size.height) * diff);
			}

			animateHelper({
				w: this.img.width,
				h: this.img.height
			}, {
				w: size.width,
				h: size.height
			}, function (_ref3) {
				var w = _ref3.w,
				    h = _ref3.h;

				_this6.img.width = w;
				_this6.img.height = h;
			}, 'size', instantly);
		},
		setBackground: function setBackground(value) {
			var _this7 = this;

			var val = value || this.backgrounds[0].value;
			var instantly = !this.img.background || this.img.background === val;

			if (this.enteredBackground.value !== val && !this.backgrounds.find(function (x) {
				return x.value === val;
			})) {
				if (!this.backgrounds.find(function (x) {
					return x.name === 'custom';
				})) {
					this.backgrounds.push({ name: 'custom' });
				}

				this.backgrounds.find(function (x) {
					return x.name === 'custom';
				}).value = val;
			}

			var initBackground = this.img.background || val;
			var background = this.enteredBackground.value === val ? this.enteredBackground : this.backgrounds.find(function (x) {
				return x.value === val;
			});

			var from = HTMLColorOrElse(initBackground, { r: 0, g: 0, b: 0, a: 0 });
			var to = HTMLColorOrElse(background.value, { r: 0, g: 0, b: 0, a: 0 });

			animateHelper(from, to, function (_ref4) {
				var r = _ref4.r,
				    g = _ref4.g,
				    b = _ref4.b,
				    a = _ref4.a;

				_this7.img.background = 'rgba(' + r.toFixed() + ', ' + g.toFixed() + ', ' + b.toFixed() + ', ' + a.toFixed(2) + ')';
			}, 'background', instantly, function () {
				_this7.img.background = RGBAToHTMLColor(_this7.img.background);
			});
		},
		setSpecialBackground: function setSpecialBackground() {
			var _this8 = this;

			var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.img.background;

			var start = this.misc.background || this.img.background;
			var stop = value;

			var from = HTMLColorOrElse(start, { r: 0, g: 0, b: 0, a: 0 });
			var to = HTMLColorOrElse(stop, { r: 0, g: 0, b: 0, a: 0 });

			animateHelper(from, to, function (_ref5) {
				var r = _ref5.r,
				    g = _ref5.g,
				    b = _ref5.b,
				    a = _ref5.a;

				var color = 'rgba(' + r.toFixed() + ', ' + g.toFixed() + ', ' + b.toFixed() + ', ' + a.toFixed(2) + ')';
				_this8.misc.background = color !== _this8.img.background && color;
			}, 'specialbackground', false, function () {
				if (value === _this8.img.background) {
					_this8.misc.background = false;
				} else {
					_this8.misc.background = RGBAToHTMLColor(_this8.misc.background);
				}
			});
		},
		setEnteredBackground: function setEnteredBackground() {
			var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.misc.color;

			this.enteredBackground.value = value;
			this.handleBackgroundColorClick(this.enteredBackground.name);
			this.selectedBackground = 'entered';
		},
		setRotation: function setRotation() {
			var _this9 = this;

			var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

			var instantly = this.misc.sliding || typeof this.img.rotation === 'undefined' || this.img.rotation === value;

			animateHelper({
				rotation: this.img.rotation || 0
			}, {
				rotation: (value + 180) % 360 - 180
			}, function (_ref6) {
				var rotation = _ref6.rotation;

				_this9.img.rotation = rotation;
			}, 'rotation', instantly);
		},
		setSizes: function setSizes() {
			var w = parseInt(this.data.base_width, 10);
			var h = parseInt(this.data.base_height, 10);
			var ratios = this.data.ratios && JSON.parse(this.data.ratios);
			var dimension = this.data.dimension;

			if (!w && !h) return;

			var newSizes = [{
				name: 'Original',
				width: w,
				height: h
			}];

			if (ratios) {
				ratios.forEach(function (x) {
					if (dimension === 'height') {
						newSizes.push({
							name: '' + x,
							width: h * x,
							height: h,
							ratio: x
						});
					} else {
						newSizes.push({
							name: '' + x,
							width: w,
							height: w / x,
							ratio: x
						});
					}
				});
			}
			this.sizes = newSizes;
		},
		getInitialScaleFor: function getInitialScaleFor(width, height) {
			var ratio = height / width;

			return ratio < this.imgRatio ? 1 : ratio / this.imgRatio;
		},
		resetData: function resetData() {
			this.setBackground();
			this.setRotation();
			this.setSize();
			this.setPosition();

			this.handleChange();
		},
		colorPicker: function colorPicker() {
			this.misc.picking = true;
		},
		startDrag: function startDrag(e) {
			var ev = e.changedTouches ? e.changedTouches[0] : e;

			if (this.misc.picking && this.misc.color) {
				this.setBackground(this.misc.color);
				this.setEnteredBackground(this.misc.color);
				this.misc.color = undefined;
				this.misc.picking = false;
			} else {
				this.drag.dragging = true;
				this.setSpecialBackground('#ff00ff');

				this.drag.prev.x = ev.pageX;
				this.drag.prev.y = ev.pageY;
			}
		},
		onDrag: function onDrag(e) {
			var ev = e.changedTouches ? e.changedTouches[0] : e;

			if (this.misc.picking) {
				var el = ev.target;
				var b = el.getBoundingClientRect();
				var x = ev.pageX - (b.left + window.scrollX);
				var y = ev.pageY - (b.top + window.scrollY);

				var dx = parseInt(x / b.width * el.width, 10);
				var dy = parseInt(y / b.height * el.height, 10);

				var p = el.getContext('2d').getImageData(dx, dy, 1, 1).data;

				var rr = ('0' + parseInt(p[0], 10).toString(16)).slice(-2);
				var gg = ('0' + parseInt(p[1], 10).toString(16)).slice(-2);
				var bb = ('0' + parseInt(p[2], 10).toString(16)).slice(-2);

				this.misc.color = '#' + (rr + gg + bb);
				this.setEnteredBackground(this.misc.color);
			}

			if (this.drag.dragging) {
				var width = ev.target.offsetWidth;
				var height = ev.target.offsetHeight;
				var left = (ev.pageX - this.drag.prev.x) / width;
				var top = (ev.pageY - this.drag.prev.y) / height;

				this.setPosition(this.img.left + left, this.img.top + top);

				this.drag.prev.x = ev.pageX;
				this.drag.prev.y = ev.pageY;
			}
		},
		stopDrag: function stopDrag() {
			if (this.drag.dragging) {
				this.drag.dragging = false;
				this.setSpecialBackground();
				this.drag.prev = { x: 0, y: 0 };

				this.handleChange();
			}
		},
		startSlide: function startSlide() {
			var _this10 = this;

			this.misc.slideDown = true;
			setTimeout(function () {
				if (_this10.misc.slideDown) {
					_this10.setSpecialBackground('#ff00ff');
				}
			}, 100);
		},
		onSlide: function onSlide() {
			if (this.misc.slideDown) {
				this.misc.sliding = true;
			}
		},
		stopSlide: function stopSlide() {
			if (this.misc.slideDown) {
				this.misc.sliding = false;
				this.misc.slideDown = false;
				this.setSpecialBackground();
			}
		},
		handleSizeClick: function handleSizeClick(sizeName) {
			this.selectedSize = sizeName;
		},
		handleBackgroundColorClick: function handleBackgroundColorClick(bgColorName) {
			this.selectedBackground = bgColorName;
		},
		getRatioBlockStyle: function getRatioBlockStyle(size) {
			var baseRem = 1.2;
			var height = size.height;
			var width = size.width;
			var blockHeight = baseRem;
			var blockWidth = parseFloat((baseRem * (width / height)).toFixed(3));
			return 'height: ' + blockHeight + 'rem; width: ' + blockWidth + 'rem;';
		},
		handleSave: function handleSave() {
			if (!this.imgNode) {
				return;
			}
			var newSidebarValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$store.state.sidebar.context);

			if (newSidebarValue.value && newSidebarValue.value[this.data.key]) {
				delete newSidebarValue.value[this.data.key].value;
			}

			newSidebarValue.value[this.data.key] = __WEBPACK_IMPORTED_MODULE_4__helper_convertHelper__["a" /* default */].exportData(this.img, this.imgNode);
			newSidebarValue.value[this.data.key].U_Position = this.data.U_Position;
			newSidebarValue.value[this.data.key].sprache = this.data.S_Sprachkuerzel;
			newSidebarValue.value[this.data.key].B_Rahmen = this.border;

			var newSidebarOutputData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.data, newSidebarValue.value[this.data.key]);
			this.$store.dispatch('updateSidebar', {
				context: newSidebarValue,
				outputData: newSidebarOutputData
			});
		},
		handleChange: function handleChange() {
			this.$store.dispatch('updateSidebar', {
				applied: false
			});
		},
		handleApply: function handleApply() {
			this.handleSave();
		},
		triggerReset: function triggerReset() {
			this.resetData();
		},
		changeScaleLevel: function changeScaleLevel(val) {
			this.sliderScale = Math.min(100, Math.max(1, this.sliderScale + val));
		}
	},
	mounted: function mounted() {
		this.setSizes();

		this.setId(this.data.value);
	},

	watch: {
		data: function data() {
			this.setSizes();

			this.setId(this.data.value);
		}
	},
	directives: {
		draw: function draw(el, binding) {
			var getDrawing = binding.value;
			if (!getDrawing.width) return;

			window.requestAnimationFrame(function () {
				el.width = getDrawing.width;
				el.height = getDrawing.height;
				el.getContext('2d').drawImage(getDrawing, 0, 0);
			});
		}
	}
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_atoms_ErcoLayout_PreviewItem__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_atoms_ErcoLayout_PreviewItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_atoms_ErcoLayout_PreviewItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_atoms_ErcoLayout_DividerActionBar__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_atoms_ErcoLayout_DividerActionBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_atoms_ErcoLayout_DividerActionBar__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoLayoutPreviewBlockMolecule',

	props: {
		datasets: {
			type: Array,
			required: true
		}
	},

	computed: {
		objecttype: function objecttype() {
			return this.$store.state.objectsetup.current.FKM_Bereich;
		},
		objectname: function objectname() {
			return this.$store.getters.objectname;
		},
		specification: function specification() {
			return this.$store.state.objectsetup.current.spezifikation_S_Platzhalter || '';
		},
		category: function category() {
			return this.$store.state.objectsetup.current.S_Kurzbezeichnung_gattung || '';
		},
		idArea: function idArea() {
			return parseInt(this.$store.state.objectsetup.current.FKM_Bereich, 10) || 0;
		},
		idObject: function idObject() {
			return parseInt(this.$store.state.objectsetup.current.PKM_Objekt, 10) || 0;
		},
		isGenus: function isGenus() {
			return this.$store.state.objectsetup.current.B_Gattungsobjekt || '';
		}
	},

	methods: {
		getNextSiteDatasetAfter: function getNextSiteDatasetAfter(dataset) {
			var currentSiteDatasetIndex = this.datasets.indexOf(dataset);

			if (currentSiteDatasetIndex > -1) {
				return currentSiteDatasetIndex < this.datasets.length - 1 ? this.datasets[currentSiteDatasetIndex + 1] : false;
			}

			return null;
		}
	},

	components: {
		ErcoLayoutPreviewItem: __WEBPACK_IMPORTED_MODULE_0__components_atoms_ErcoLayout_PreviewItem___default.a,
		ErcoLayoutDividerActionBar: __WEBPACK_IMPORTED_MODULE_1__components_atoms_ErcoLayout_DividerActionBar___default.a
	}
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_placeholder_image_svg__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_placeholder_image_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_img_placeholder_image_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_infoTextHelper__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoTooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoTooltip__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoLayoutTemplateSelectionMolecule',

	props: {
		sets: {
			type: Array,
			required: true,
			default: function _default() {
				return [];
			}
		}
	},

	methods: {
		handleSetClick: function handleSetClick(set) {
			var _this = this;

			this.$store.dispatch('createTemplateSet', set.PKM_Objekt).then(function () {
				_this.$store.dispatch('resetSitesArePrepared');

				_this.$store.dispatch('getObjectSetupWithSites').catch(function () {});
			});
		},
		getAbsolutePathForImage: function getAbsolutePathForImage(urlPath) {
			return __WEBPACK_IMPORTED_MODULE_0_url___default.a.resolve("https://cms-backend.stage.qa.erco.com", urlPath);
		},
		handleImageError: function handleImageError(event) {
			event.target.src = __WEBPACK_IMPORTED_MODULE_1__assets_img_placeholder_image_svg___default.a;
		},
		fixUpperCase: function fixUpperCase(text) {
			return text.split('-').map(function (part) {
				return '' + part[0].toUpperCase() + part.slice(1).toLowerCase();
			}).join('-');
		},
		infoTextKeyForSet: function infoTextKeyForSet(set) {
			var key = (set.S_de_Objekt || set.PKM_Objekt || '').toLowerCase();
			return 'layout.presets.' + key;
		},
		infoTextForSet: function infoTextForSet(set) {
			var key = this.infoTextKeyForSet(set);
			return __WEBPACK_IMPORTED_MODULE_2__helper_infoTextHelper__["a" /* default */].for(key);
		}
	},

	components: {
		ErcoTooltip: __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoTooltip___default.a
	}
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoDropdown__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoDropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoDropdown__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoLiveSelectionHeaderMolecule',

	props: {
		name: {
			type: String,
			default: ''
		},
		id: {
			type: String,
			default: ''
		},
		processstate: {
			type: Object,
			default: function _default() {
				return {
					id: '',
					name: '',
					items: [],
					currentProcessStatusItem: null
				};
			}
		}
	},

	data: function data() {
		return {};
	},


	computed: {
		headerStyle: function headerStyle() {
			var bgColor = this.processstate.id === '' ? 'rgba(2, 117, 216, 1)' : 'rgba(68, 157, 68, 1)';

			return {
				'background-color': bgColor
			};
		},
		dropdownLabel: function dropdownLabel() {
			if (this.processstate.currentProcessStatusItem === null) {
				return 'Aktion';
			}

			return this.processstate.currentProcessStatusItem.S_Status;
		}
	},

	methods: {
		handleStateChange: function handleStateChange(item) {
			this.$emit('change', item.currentValue);
		}
	},

	components: {
		ErcoDropdown: __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoDropdown___default.a
	}
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoStatusBadge__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoStatusBadge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoStatusBadge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoDropdown__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoDropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoDropdown__);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoObjectCardMolecule',
	data: function data() {
		return {
			innerIsChecked: null,
			innerStatus: null
		};
	},

	props: {
		title: {
			type: String,
			default: 'Kein Titel',
			required: true
		},
		type: {
			type: String,
			default: 'Unbekannter Typ',
			required: true
		},
		imageSrc: {
			default: 'http://placehold.it/320x180',
			required: false
		},
		publishdate: {
			type: String,
			default: '01.01.1970'
		},
		offlinedate: {
			type: String,
			defaukt: '01.01.1970'
		},
		date: {
			type: String,
			default: '01.01.1970',
			required: true
		},
		objectId: {
			type: String,
			default: '0',
			required: true
		},
		status: {
			type: String,
			default: 'unknown',
			required: true
		},
		onlineUrl: {
			type: String,
			default: ''
		},
		previewUrl: {
			type: String,
			default: ''
		},
		isProductive: {
			type: Boolean,
			default: false
		},
		checked: {
			type: Boolean,
			default: false
		},
		category: {
			type: String,
			default: ''
		},
		specification: {
			type: String,
			default: ''
		},
		genus: {
			type: String,
			default: ''
		}
	},
	components: {
		ErcoStatusBadge: __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoStatusBadge___default.a,
		ErcoDropdown: __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoDropdown___default.a
	},
	computed: {
		computedStatus: function computedStatus() {
			var status = this.innerStatus || this.status;

			return status === 'online' && !this.isProductive ? 'preview' : status;
		},
		publishDateTime: function publishDateTime() {
			return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.publishdate, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].DATETIMEFORMAT);
		},
		offlineDateTime: function offlineDateTime() {
			return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.offlinedate, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].DATETIMEFORMAT);
		},
		dateTime: function dateTime() {
			return this.date && __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.publishdate, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].DATETIMEFORMAT).toDate();
		},
		clearDateTime: function clearDateTime() {
			return this.dateTime && __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.dateTime).format(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].DATETIMEFORMATDEST);
		},
		numDateTime: function numDateTime() {
			return this.dateTime && __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.dateTime).format('YYYYMMDD');
		},
		clearPublishDateTime: function clearPublishDateTime() {
			if (!this.publishDateTime.isValid()) {
				return '';
			}
			var notPlanedMomentDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].NOTPLANNEDDATE, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].DATETIMEFORMAT);
			if (this.publishDateTime.isValid() && this.publishDateTime.format(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].DATEFORMATDEST) === notPlanedMomentDate.format(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].DATEFORMATDEST)) {
				return 'Nicht geplant';
			}
			return this.publishDateTime.format(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].DATETIMEFORMATDEST);
		},
		clearOfflineDateTime: function clearOfflineDateTime() {
			if (!this.offlineDateTime.isValid()) {
				return '';
			}
			var notPlanedMomentDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].NOTPLANNEDDATE, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].DATETIMEFORMAT);
			if (this.offlineDateTime.isValid() && this.offlineDateTime.format(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].DATEFORMATDEST) === notPlanedMomentDate.format(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].DATEFORMATDEST)) {
				return 'Nicht geplant';
			}
			return this.offlineDateTime.format(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].DATETIMEFORMATDEST);
		},
		imagePath: function imagePath() {
			if (this.imageSrc !== null) {
				return "https://cms-backend.stage.qa.erco.com" + '/system/images/web/' + this.imageSrc;
			}
			return "@/../static/svg/placeholder-image.svg";
		},

		isChecked: {
			get: function get() {
				return typeof this.innerIsChecked === 'boolean' ? this.innerIsChecked : this.checked;
			},
			set: function set(checked) {
				this.innerIsChecked = checked;
			}
		},
		markedForDeletion: function markedForDeletion() {
			return this.computedStatus === 'löschmarkiert';
		},
		objectViewUrlForObject: function objectViewUrlForObject() {
			return '/#/objectview/' + this.objectId;
		},
		objectviewUrl: function objectviewUrl() {
			var host = window.location.protocol + '//' + window.location.host;
			return '' + host + this.objectViewUrlForObject;
		},
		actionSelectionItems: function actionSelectionItems() {
			var selectionItems = [];

			if (this.isVisitable) {
				selectionItems.push({ text: 'Preview ansehen', value: 'preview' });
			}

			if (this.isVisitable && this.isProductive) {
				selectionItems.push({ text: 'Online ansehen', value: 'online' });
			}

			return selectionItems;
		},
		isVisitable: function isVisitable() {
			return !!this.previewUrl;
		}
	},

	methods: {
		formatDateTime: function formatDateTime(value) {
			return ('0' + value).slice(-2);
		},
		handleActionSelectionChange: function handleActionSelectionChange(selectionInfo) {
			switch (selectionInfo.currentValue) {
				case 'preview':
					window.open(this.previewUrl);
					break;
				case 'online':
					window.open(this.onlineUrl);
					break;
				default:
			}
		},
		handleCheckClick: function handleCheckClick(objID, checked) {
			var action = {
				type: '',
				objID: parseInt(objID, 10)
			};

			action.type = checked ? 'add' : 'remove';
			this.$store.dispatch('handleObjectSelection', action);
		}
	},

	watch: {
		checked: function checked(newChecked) {
			this.innerIsChecked = newChecked;
		},
		status: function status(newStatus) {
			this.innerStatus = newStatus;
		}
	}
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoOptionsGroupMolecule',

	props: {
		label: {
			type: String,
			default: ''
		},
		size: {
			type: String,
			default: ''
		},
		options: {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	},

	methods: {
		handleOptionClick: function handleOptionClick(option) {
			this.options.forEach(function (propOption) {
				return propOption.active = propOption.value === option.value;
			});
			this.$emit('click', option);
		}
	}
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoTooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoTooltip__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoRadioGroupMolecule',

	props: {
		label: {
			type: String,
			default: ''
		},
		options: {
			type: Array,
			default: []
		},
		change: {
			type: Function,
			default: function _default() {}
		},
		chained: {
			type: Boolean,
			default: true
		},
		freezed: {
			type: Boolean,
			default: false
		},
		tooltip: {
			type: Object,
			required: false,
			default: function _default() {
				return { variant: '', title: '', text: '' };
			}
		}
	},

	components: {
		ErcoTooltip: __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoTooltip___default.a
	},

	computed: {
		valueChained: function valueChained() {
			return this.options.reduce(function (val, option) {
				return option.selected ? option.value : val;
			}, '');
		},
		value: function value() {
			return this.options.map(function (option) {
				return option.selected ? option.value : '';
			});
		}
	},

	methods: {
		handleChange: function handleChange(value) {
			if (this.freezed) {
				return;
			}

			this.$emit('change', value);
		},
		handleWrapClick: function handleWrapClick(event) {
			if (this.freezed) {
				event.preventDefault();
			}
		}
	}
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_atoms_ErcoList__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_atoms_ErcoList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_atoms_ErcoList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoTextInput__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoTextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoTextInput__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoSidebarBasisgenusMolecule',

	props: {
		data: {
			type: Object,
			default: function dataDefault() {
				return {
					draggable: [],
					destinations: []
				};
			}()
		}
	},

	data: function data() {
		return {
			enabled: {}
		};
	},


	methods: {
		handleDragOver: function handleDragOver($event) {
			$event.dataTransfer.effectAllowed = 'copy';
			$event.preventDefault();
		},
		handleDrop: function handleDrop(index, e) {
			var destinationData = this.data.destinations[index];
			var itemData = e.dataTransfer.getData('text/plain');

			if (!itemData) {
				return false;
			}

			var parsedItemData = JSON.parse(itemData);
			var newSidebarValue = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.state.sidebar.context));

			newSidebarValue.value[destinationData.key] = {
				id: parsedItemData.id,
				value: parsedItemData.value,
				type: destinationData.type
			};

			var newSidebarOutputData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data));
			this.$set(newSidebarOutputData.destinations[index], 'id', parsedItemData.id);
			this.$set(newSidebarOutputData.destinations[index], 'text', parsedItemData.value);

			this.$store.dispatch('updateSidebar', {
				context: newSidebarValue,
				outputData: newSidebarOutputData
			});

			e.preventDefault();
			return false;
		},
		handleReset: function handleReset(index) {
			var destinationData = this.data.destinations[index];
			var newSidebarOutputData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data));
			var newSidebarValue = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.state.sidebar.context));

			this.$set(newSidebarValue.value, destinationData.key, {
				id: null,
				value: null,
				type: destinationData.type
			});

			this.$set(newSidebarOutputData.destinations[index], 'id', '0');
			this.$set(newSidebarOutputData.destinations[index], 'text', '');

			this.$store.dispatch('updateSidebar', {
				context: newSidebarValue,
				outputData: newSidebarOutputData
			});
		}
	},

	components: {
		ErcoList: __WEBPACK_IMPORTED_MODULE_1__components_atoms_ErcoList___default.a,
		ErcoTextInput: __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoTextInput___default.a
	}
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoDateTimePicker__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoDateTimePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoDateTimePicker__);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoSidebarDateTimePickerMolecule',

	props: {
		data: {
			type: Object,
			default: function dataDefault() {
				return {
					datetime: new Date()
				};
			}()
		}
	},

	data: function data() {
		return {
			now: new Date()
		};
	},


	methods: {
		handleDateTimePickerChange: function handleDateTimePickerChange(dateTime) {
			var dateTimeFormat = __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].DATETIMEFORMAT;
			var momDateTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(dateTime, dateTimeFormat);
			var newSidebarContext = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$store.state.sidebar.context);
			newSidebarContext.value = momDateTime.format(dateTimeFormat);

			this.$store.dispatch('updateSidebar', { context: newSidebarContext });
		}
	},

	components: {
		ErcoDateTimePicker: __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoDateTimePicker___default.a
	}
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoDropdown__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoDropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoDropdown__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoSidebarDropdownMolecule',

	props: {
		data: {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	},

	methods: {
		handleSelect: function handleSelect(index, newValue) {
			var key = this.data[index].key;

			var newSidebarContext = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$store.state.sidebar.context);
			newSidebarContext.value[key] = newValue.currentValue;

			this.$store.dispatch('updateSidebar', { context: newSidebarContext });
		},
		mapItems: function mapItems(items) {
			return items.map(function (item) {
				return {
					text: item.label,
					value: item.value
				};
			});
		},
		getCurrentItemIndexFor: function getCurrentItemIndexFor(entry) {
			return entry.enum.reduce(function (fIdx, item, idx) {
				return item.value.toString().trim() === entry.value.toString().trim() ? idx : fIdx;
			}, 0);
		}
	},

	components: {
		ErcoDropdown: __WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoDropdown___default.a
	}
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_infoTextHelper__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoImageEditor__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoImageEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoImageEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoSidebar_ImageLoader__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoSidebar_ImageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoSidebar_ImageLoader__);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoSidebarImageEditorMolecule',
	props: {
		data: {
			type: Object
		}
	},
	data: function data() {
		return {
			currentData: null
		};
	},

	computed: {
		imageData: function imageData() {
			return this.currentData || this.data;
		}
	},
	methods: {
		handleApply: function handleApply() {
			if (this.$refs['image-editor'] && this.$refs['image-editor'].handleApply) {
				this.$refs['image-editor'].handleApply();
			}
		},
		triggerReset: function triggerReset() {
			if (this.$refs['image-editor'] && this.$refs['image-editor'].triggerReset) {
				this.$refs['image-editor'].triggerReset();
			}
		},
		openSidebarFor: function openSidebarFor(item) {
			var sidebarData = {
				visible: true,
				key: 'assets',
				view: 'erco-sidebar-image-loader',
				outputData: item,
				context: {
					dispatchActionName: 'updateAssetsItemFromMAM',
					value: {
						I_Sollbreite: item.I_Sollbreite,
						I_Sollhoehe: item.I_Sollhoehe
					}
				},
				title: 'Bild aus MAM laden - Position ' + item.nummer,
				titleAdditional: '',
				info: __WEBPACK_IMPORTED_MODULE_1__helper_infoTextHelper__["a" /* default */].for('misc.imageEditor'),
				revert: true,
				doTrack: true,
				closeOnSave: false
			};
			this.$store.dispatch('updateSidebar', sidebarData);
		},
		prepareImageDeletion: function prepareImageDeletion() {
			var updatedSidebarContext = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$store.state.sidebar.context);
			updatedSidebarContext.value[this.data.key] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, updatedSidebarContext.value[this.data.key], { value: '' });

			var newSidebarOutputData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.data, updatedSidebarContext.value[this.data.key]);

			this.$set(this, 'currentData', newSidebarOutputData);

			if (this.imageData.PKM_Bild) {
				this.$store.dispatch('deleteImageById', this.imageData.PKM_Bild);
			}

			this.$store.dispatch('updateSidebar', {
				context: updatedSidebarContext,
				outputData: newSidebarOutputData
			});
		}
	},
	components: {
		ErcoImageEditor: __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoImageEditor___default.a,
		'erco-image-loader': __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoSidebar_ImageLoader___default.a
	}
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoSidebarImageLoaderMolecule',

	props: {
		data: {
			type: Object
		}
	},

	computed: {
		src: function src() {
			var src = "https://cms-backend.stage.qa.erco.com/usercgi/kunden/ls2014/k3.pl?aktion=mam_bild_suchen";
			src += '&jwt=' + this.token;
			return src;
		},
		token: function token() {
			return this.$store.state.user.token;
		},
		context: function context() {
			return this.$store.state.sidebar.context;
		}
	},

	mounted: function mounted() {
		window.addEventListener('message', this.onReceive, false);

		this.$refs.search.onload = function onload() {
			this.contentWindow.postMessage('init', "https://cms-backend.stage.qa.erco.com");
			this.onload = null;
		};
	},
	destroyed: function destroyed() {
		window.removeEventListener('message', this.onReceive);
	},


	methods: {
		onReceive: function onReceive(event) {
			if (event.origin === "https://cms-backend.stage.qa.erco.com") {
				var context = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$store.state.sidebar.context);
				context.value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, context.value, {
					PKM_Seite: this.data.FKM_Seite,
					U_Position: this.data.U_Position,
					sprache: this.data.S_Sprachkuerzel
				}, event.data);
				this.$store.dispatch('updateSidebar', { doTrack: false, context: context });
			}
		}
	}
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoSidebarLastChangesMolecule',

	props: {
		data: {
			type: String
		}
	},

	data: function data() {
		return {
			fields: {
				type: {
					label: ''
				},
				date: {
					label: 'Datum'
				},
				time: {
					label: 'Uhrzeit',
					class: 'text-center'
				},
				user: {
					label: 'User'
				},
				action: {
					label: 'Aktion',
					formatter: 'actionFormatter'
				}
			}
		};
	},


	computed: {
		items: function items() {
			var _this = this;

			var dateFormat = 'DD.MM.YYYY';
			var timeFormat = 'HH:mm:ss';

			var items = this.data.split(/\n\n|<br \/>|\s(?=\d{4}-\d{2}-\d{2})/).filter(function (item) {
				return item.trim().length > 0;
			}).reverse().map(function (item) {
				var cleanedItem = item.trim();
				var actionObj = {
					type: 'default',
					date: null,
					time: null,
					user: '',
					action: '',
					_cellVariants: {}
				};

				var datedActionRegexp = /^(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})\s*-\s*(.*?):([\s\S]*){0,1}$/;
				var datedAltActionrRegexp = /^(\d{1,2}).(\d{1,2}).(\d{4})\s*(\d{1,2}:\d{1,2}:\d{1,2}){0,1}\s*-\s*(.*?):([\s\S]*){0,1}$/;
				var createdRegexp = /Angelegt am (\d{2}\. \w+ \d{4}) von (.*)/i;
				var emptyCopyRegexp = /Leerkopie durch (.*?) /i;
				var dateOnlyRegexp = /^(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})\s*$/;

				var datedActionMatch = cleanedItem.match(datedActionRegexp);
				var datedAltActionMatch = cleanedItem.match(datedAltActionrRegexp);
				var createdMatch = cleanedItem.match(createdRegexp);
				var emptyCopyMatch = cleanedItem.match(emptyCopyRegexp);
				var dateOnlyMatch = cleanedItem.match(dateOnlyRegexp);

				if (datedActionMatch) {
					var mDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(datedActionMatch[1]);
					actionObj.date = mDate.format(dateFormat);
					actionObj.time = mDate.format(timeFormat);
					actionObj.user = (datedActionMatch[2] || '-').trim();
					actionObj.action = (datedActionMatch[3] || '').trim().split(',').join(', ').replace(/(.*[\s(?!-)]\d{4,} )/, '');
				} else if (datedAltActionMatch) {
					var daam = datedAltActionMatch;
					var _mDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(daam[3] + '-' + daam[2] + '-' + daam[1] + ' ' + (daam[4] ? daam[4] : ''));
					actionObj.date = _mDate.format(dateFormat);
					actionObj.time = daam[4] ? _mDate.format(timeFormat) : '-';
					actionObj.user = (datedAltActionMatch[5] || '-').trim();
					actionObj.action = (datedAltActionMatch[6] || '').trim().split(',').join(', ').replace(/(.*[\s(?!-)]\d{4,} )/, '');
				} else if (createdMatch) {
					actionObj.type = 'creation';
					var _mDate2 = __WEBPACK_IMPORTED_MODULE_1_moment___default()(createdMatch[1]);
					actionObj.date = _mDate2.format(dateFormat);
					actionObj.time = '-';
					actionObj.user = (createdMatch[2] || '').trim();
					actionObj.action = 'Objekt angelegt';
				} else if (emptyCopyMatch) {
					actionObj.user = (emptyCopyMatch[1] || '').trim();
					actionObj.action = cleanedItem;
				} else if (dateOnlyMatch) {
					var _mDate3 = __WEBPACK_IMPORTED_MODULE_1_moment___default()(dateOnlyMatch[1]);
					actionObj.date = _mDate3.format(dateFormat);
					actionObj.time = _mDate3.format(timeFormat);
					actionObj.user = '-';
					actionObj.action = '-';
					actionObj.type = 'unknown';
				} else {}

				if (actionObj.user === _this.$store.state.user.username) {
					actionObj._cellVariants = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, actionObj._cellVariants, { user: 'info' });
				}

				if (actionObj.action.indexOf('Seiten anlegen aus Vorlagenset') > -1) {
					actionObj.type = 'creation_template_set';
				} else if (actionObj.action.indexOf('Status') > -1 || actionObj.action.indexOf('Objekdaten geändert:') > -1) {
					actionObj.type = 'status_change';
				} else if (actionObj.action.indexOf('Bild gelöscht') > -1) {
					actionObj.type = 'image_delete';
				} else if (actionObj.action.indexOf('Bild hochgeladen') > -1) {
					actionObj.type = 'image_upload';
				} else if (actionObj.action.indexOf('Bild geändert') > -1) {
					actionObj.type = 'image_change';
				} else if (actionObj.action.indexOf('Text geändert') > -1) {
					actionObj.type = 'text_change';
				} else if (actionObj.action.indexOf('Seite loeschen') > -1) {
					actionObj.type = 'site_delete';
				} else if (actionObj.action.indexOf('Seite anlegen') > -1) {
					actionObj.type = 'site_add';
				} else if (actionObj.action.indexOf('Seite sortieren') > -1) {
					actionObj.type = 'site_sort';
				} else if (actionObj.action.indexOf('Tag hinzugefügt') > -1) {
					actionObj.type = 'label_add';
				} else if (actionObj.action.indexOf('Weitergegeben') > -1) {
					actionObj.type = 'assign_to_person';
				} else if (actionObj.action.indexOf('Übersetzung angefordert') > -1) {
					actionObj.type = 'translation_request';
				} else if (actionObj.action.indexOf('Übersetzung wurde abgeschlossen') > -1) {
					actionObj.type = 'translation_finished';
				} else if (actionObj.action.indexOf('angefordert') > -1) {
					actionObj.type = 'assignment_request';
				} else if (actionObj.action.indexOf('eedback') > -1) {
					actionObj.type = 'assignment_feedback';
				} else if (actionObj.action.indexOf('erteilt') > -1) {
					actionObj.type = 'assignment_finished';
				} else if (actionObj.action.indexOf('Synchronisierung veranlasst') > -1) {
					actionObj.type = 'synchronization_request';
				} else if (actionObj.action.indexOf('Objekt synchronisiert') > -1) {
					actionObj.type = 'synchronization';
				} else if (actionObj.action.indexOf('Leerkopie') > -1) {
					actionObj.type = 'empty_copy';
				} else if (actionObj.action.indexOf('Stammdaten geändert:') > -1) {
					actionObj.type = 'basedata_change';
				}

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, actionObj);
			});

			return items;
		}
	},

	methods: {
		actionFormatter: function actionFormatter(value) {
			var subItems = value.split('\n');

			if (subItems.length > 0) {
				var headItem = subItems.shift();
				var tailItems = subItems.map(function (currItem) {
					return '<li>' + currItem + '</li>';
				});

				return headItem + '<ul>' + tailItems.join() + '</ul>';
			}

			return value;
		}
	}
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoSidebarLinkedProductsMolecule',

	props: {
		data: {
			type: Object,
			default: function _default() {
				return {
					tabs: []
				};
			}
		}
	},

	data: function data() {
		return {
			tabIndex: 0
		};
	},


	computed: {
		firstTab: function firstTab() {
			return this.data.tabs[0];
		},
		itemValues: function itemValues() {
			return this.data.tabs.reduce(function (values, tab) {
				return tab.groups.reduce(function (gValues, group) {
					return group.items.reduce(function (iValues, item) {
						iValues[tab.key + '-' + item.id] = item.selected;
						return iValues;
					}, gValues);
				}, values);
			}, {});
		}
	},

	methods: {
		tabTitle: function tabTitle(index) {
			var title = this.data.tabs[index].title;

			var contextlinks = this.data.tabs[index].groups.reduce(function (count, group) {
				return count + group.items.reduce(function (groupitemCount, item) {
					return groupitemCount + (item.selected ? 1 : 0);
				}, 0);
			}, 0);

			if (contextlinks > 0) {
				title = title + ' (' + contextlinks + ')';
			}

			return title;
		},
		handleItemChange: function handleItemChange(tabKey, groupKey, item, value) {
			var checked = value.length > 0;
			var newSidebarValue = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].util.extend({}, this.$store.state.sidebar.context);

			if (!newSidebarValue.value[tabKey]) {
				newSidebarValue.value[tabKey] = {};
			}

			if (!newSidebarValue.value[tabKey][groupKey]) {
				newSidebarValue.value[tabKey][groupKey] = {};
			}

			if (newSidebarValue.value[tabKey][groupKey][item.id]) {
				delete newSidebarValue.value[tabKey][groupKey][item.id];
			} else {
				newSidebarValue.value[tabKey][groupKey][item.id] = checked;
			}

			var newSidebarOutputData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.data);
			newSidebarOutputData.tabs.forEach(function (branch) {
				if (branch.key === tabKey) {
					branch.groups.forEach(function (group) {
						if (group.key === groupKey) {
							group.items.forEach(function (groupItem) {
								if (groupItem.id === item.id) {
									groupItem.selected = checked;
									return false;
								}
								return true;
							});
							return false;
						}
						return true;
					});
					return false;
				}
				return true;
			});

			this.$store.dispatch('updateSidebar', {
				context: newSidebarValue,
				outputData: newSidebarOutputData
			});
		}
	}
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoOptionsGroup__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoOptionsGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoOptionsGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoDropdown__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoDropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoDropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_molecules_ErcoTextInput__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_molecules_ErcoTextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_molecules_ErcoTextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_atoms_ErcoTextArea__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_atoms_ErcoTextArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_atoms_ErcoTextArea__);










/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoSidebarSideEditorMolecule',

	props: {
		data: {
			type: Object,
			default: function _default() {}
		}
	},

	data: function data() {
		return {
			langs: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].langs.map(function (lang, index) {
				lang.active = index === 0;
				return lang;
			})
		};
	},


	computed: {
		pagination: function pagination() {
			return {
				items: [{ text: 'ja', value: true }, { text: 'nein', value: false }],
				selectedIndex: 1
			};
		},
		distanceBelow: function distanceBelow() {
			return {
				items: [{ text: 'mittel', value: 'middle' }],
				selectedIndex: 0
			};
		},
		backgroundType: function backgroundType() {
			return {
				items: [{ text: 'Story', value: 'story' }],
				selectedIndex: 0
			};
		},
		title: function title() {
			return '';
		},
		imageSubtitle: function imageSubtitle() {
			return '';
		},
		subtitle: function subtitle() {
			return '';
		},
		text: function text() {
			return '';
		},
		multiformItems: function multiformItems() {
			var _this = this;

			var Types = {
				text: 'text',
				bild: 'image'
			};

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.data.items).map(function (itemKey) {
				var item = _this.data.items[itemKey];
				var type = Types[item.typ] || item.typ;

				var restrictions = {};

				var values = {
					value: item.value && item.value.trim(),
					height: item.height && parseInt(item.height, 10),
					width: item.width && parseInt(item.width, 10)
				};

				switch (type) {
					case 'text':
						restrictions.charlength = item.charlength ? parseInt(item.charlength, 10) : null;

						values.tag = item.tag || null;
						break;

					case 'image':
						values.ratios = item.ratios;

						if (typeof values.ratios === 'string') {
							var matches = values.ratios.match(/\[(.*)\]/);
							if (matches) {
								values.ratios = matches[1].split(',').map(function (ratio) {
									return parseInt(ratio, 10);
								});
							}
						} else {
							values.ratios = null;
						}

						values.dimension = item.dimension || null;
						break;

					default:
				}

				return {
					id: itemKey,
					number: item.nummer,
					type: Types[item.typ] || item.typ,
					label: 'Position ' + item.U_Position,
					restrictions: restrictions,
					values: values
				};
			});
		}
	},

	methods: {
		handleLangClick: function handleLangClick(option) {
			throw new Error('SiteEditor > Lang ' + option);
		},
		handlePaginationChange: function handlePaginationChange(item) {
			throw new Error('SiteEditor > Pagination ' + item);
		},
		handleDistanceBelowChange: function handleDistanceBelowChange(item) {
			throw new Error('SiteEditor > DistanceBelow ' + item);
		},
		handleBackgroundTypeChange: function handleBackgroundTypeChange(item) {
			throw new Error('SiteEditor > BackgroundType ' + item);
		},
		handleTitleChange: function handleTitleChange(value) {
			throw new Error('SiteEditor > Title ' + value);
		},
		handleImageSubtitleChange: function handleImageSubtitleChange(value) {
			throw new Error('SiteEditor > ImageSubtitle ' + value);
		},
		handleSubtitleChange: function handleSubtitleChange(value) {
			throw new Error('SiteEditor > Subtitle ' + value);
		},
		handleTextChange: function handleTextChange(value) {
			throw new Error('SiteEditor > Text ' + value);
		},
		handleMultiformInputChange: function handleMultiformInputChange(item, value) {
			throw new Error('SiteEditor > MultiformItem ' + item.id + ' ' + value);
		}
	},

	components: {
		ErcoOptionsGroup: __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoOptionsGroup___default.a,
		ErcoDropdown: __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoDropdown___default.a,
		ErcoTextInput: __WEBPACK_IMPORTED_MODULE_4__components_molecules_ErcoTextInput___default.a,
		ErcoTextArea: __WEBPACK_IMPORTED_MODULE_5__components_atoms_ErcoTextArea___default.a
	}
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoSpinner__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoSpinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoSpinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoTextInput__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoTextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoTextInput__);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoSidebarTabbedTextInputMolecule',

	props: {
		data: {
			type: Object,
			default: function _default() {
				return {};
			}
		}
	},

	data: function data() {
		return {
			innerTabIndex: null,
			tabsBeingLoaded: {},
			finishedTabFetching: {},
			changes: []
		};
	},
	mounted: function mounted() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
			var visibleInputEl = _this.$refs['input' + _this.tabIndex] && _this.$refs['input' + _this.tabIndex][0];

			if (visibleInputEl) {
				visibleInputEl.focus();
			}
		});
	},


	computed: {
		tabIndex: {
			get: function get() {
				var _this2 = this;

				return this.innerTabIndex || this.data.tabs.reduce(function (val, tab, index) {
					return tab.tabKey === _this2.data.selectedTabKey ? index : val;
				}, 0);
			},
			set: function set(val) {
				this.innerTabIndex = val;
			}
		},
		computedCharLength: function computedCharLength() {
			return this.data.charlength && this.data.charlength > -1 ? this.data.charlength : false;
		}
	},

	methods: {
		handleInput: function handleInput(index, newValue) {
			var key = this.data.tabs[index].key;
			var langKey = this.data.tabs[index].tabKey;

			var newSidebarContext = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$store.state.sidebar.context);
			if (!newSidebarContext.value.sets) {
				this.$set(newSidebarContext.value, 'sets', {});
			}
			if (!newSidebarContext.value.sets[langKey]) {
				this.$set(newSidebarContext.value.sets, langKey, {});
			}
			this.$set(newSidebarContext.value.sets[langKey], key, newValue);

			this.$store.dispatch('updateSidebar', {
				context: newSidebarContext
			});

			var currentLabel = this.data.tabs[index].tabLabel || this.data.tabs[index].label;
			if (!this.changes.includes(currentLabel)) {
				this.changes.push(currentLabel);
			}
		},
		handleReset: function handleReset(index) {
			this.handleInput(index, '');
		},
		tabIsBeingLoaded: function tabIsBeingLoaded(index) {
			return index in this.tabsBeingLoaded;
		},
		handleApply: function handleApply() {
			this.changes = [];
		},
		buildChangesStrList: function buildChangesStrList(changes) {
			if (changes.length === 1) {
				return changes[0];
			}

			return changes.reduce(function (str, val, i) {
				if (i === 0) {
					return val;
				}

				return i < changes.length - 1 ? [str, val].join(', ') : [str, val].join(' und ');
			});
		},
		handleTabChange: function handleTabChange() {
			this.focusCurrentTabInput();
		},
		updateTextInputHeight: function updateTextInputHeight() {
			var inputEl = this.$refs['input' + this.tabIndex] && this.$refs['input' + this.tabIndex][0];

			if (inputEl && inputEl.handleInputHeight) {
				__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
					inputEl.handleInputHeight(true);
				});
			}

			this.focusCurrentTabInput();
		},
		focusCurrentTabInput: function focusCurrentTabInput() {
			if (this.data.tabs[this.tabIndex].toBeFetched && !this.finishedTabFetching[this.tabIndex]) {
				return;
			}

			var inputEl = this.$refs['input' + this.tabIndex] && this.$refs['input' + this.tabIndex][0];

			if (inputEl && inputEl.focus) {
				__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
					inputEl.focus();
				});
			}
		}
	},

	watch: {
		tabIndex: function tabIndex(newIndex) {
			var _this3 = this;

			if (this.data.tabs[newIndex].toBeFetched && !this.finishedTabFetching[newIndex]) {
				this.$set(this.tabsBeingLoaded, newIndex, true);

				var siteId = this.$store.state.sidebar.context.value.siteId;
				this.$store.dispatch(this.data.tabChangeAction, {
					lang: this.data.tabs[newIndex].tabKey,
					site: {
						PKM_Seite: siteId
					}
				}).then(function (siteObject) {
					_this3.$delete(_this3.tabsBeingLoaded, newIndex);
					_this3.$set(_this3.finishedTabFetching, newIndex, true);

					var newSidebarOutputData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this3.data);
					newSidebarOutputData.tabs[newIndex].text = siteObject.items[_this3.data.tabs[newIndex].key].value || '';

					_this3.$store.dispatch('updateSidebar', {
						outputData: newSidebarOutputData
					});
				}).catch(function () {});
			} else {
				this.updateTextInputHeight();
			}
		},
		finishedTabFetching: function finishedTabFetching() {
			this.updateTextInputHeight();
		}
	},

	components: {
		ErcoSpinner: __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoSpinner___default.a,
		ErcoTextInput: __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoTextInput___default.a
	}
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoSpinner__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoSpinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoSpinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoTextInput__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoTextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoTextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_colorHelper__ = __webpack_require__(39);








function focusFirstElement() {
	var containerNode = this.$refs.inputField.$el;
	var firstInputNode = containerNode.querySelector('input');

	if (firstInputNode) {
		firstInputNode.focus();
	}
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoSidebarTextInputMolecule',

	props: {
		data: {
			type: Object,
			default: { tags: [] }
		}
	},

	data: function data() {
		return {
			tagInputText: '',
			timeoutHandler: null,
			suggestions: null,
			loading: false
		};
	},


	computed: {
		atomarTags: function atomarTags() {
			var atomarTags = {};
			this.data.tags.forEach(function (tag) {
				atomarTags[tag.text] = tag.s_attribut;
			});
			return atomarTags;
		}
	},

	mounted: focusFirstElement,
	updated: focusFirstElement,

	methods: {
		handleChange: function handleChange(value) {
			var _this = this;

			clearTimeout(this.timeoutHandler);
			this.tagInputText = value;

			this.timeoutHandler = setTimeout(function () {
				var trimmedValue = _this.tagInputText;

				_this.suggestions = null;

				if (trimmedValue.length === 0) {
					return;
				}

				_this.loading = true;

				_this.$store.dispatch(_this.data.suggestionAction, trimmedValue).then(function () {
					_this.suggestions = _this.removeSelectedTagsFromSuggestions(_this.$store.state.tagger.suggestions.suggestions);
					_this.loading = false;
				}).catch(function () {
					_this.loading = false;
				});
			}, 500);
		},
		handleTagRemove: function handleTagRemove(index) {
			var tag = this.data.tags[index];

			var newSidebarContext = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$store.state.sidebar.context);
			newSidebarContext.value.tags[tag.text] = {
				id: tag.id,
				value: tag.text,
				action: 'remove'
			};

			var newOutputData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$store.state.sidebar.outputData);
			newOutputData.tags.splice(index, 1);

			this.$store.dispatch('updateSidebar', {
				context: newSidebarContext,
				outputData: newOutputData
			});
		},
		handleSuggestionClick: function handleSuggestionClick(event) {
			var index = parseInt(event.target.getAttribute('data-index'), 10);
			this.addNewTag(this.suggestions[index]);
		},
		addNewTag: function addNewTag(value) {
			var newSidebarOutputData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.data);
			var newSidebarValue = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$store.state.sidebar.context);

			newSidebarOutputData.tags.push({
				id: null,
				text: value.S_Value,
				s_attribut: value.S_Attribut,
				s_type: value.S_Type,
				color: __WEBPACK_IMPORTED_MODULE_4__helper_colorHelper__["a" /* default */].colorstring(value.S_Type)
			});

			newSidebarValue.value.tags = newSidebarValue.value.tags || {};
			newSidebarValue.value.tags[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(value)[0]] = {
				value: value,
				action: 'add'
			};

			this.$store.dispatch('updateSidebar', {
				context: newSidebarValue,
				outputData: newSidebarOutputData
			});

			this.tagInputText = '';
			this.suggestions = null;
			this.$refs.inputField.$el.focus();
		},
		removeSelectedTagsFromSuggestions: function removeSelectedTagsFromSuggestions(suggestions) {
			var _this2 = this;

			return suggestions.filter(function (suggestion) {
				return !(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(suggestion)[0] in _this2.atomarTags);
			});
		}
	},

	components: {
		ErcoSpinner: __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoSpinner___default.a,
		ErcoTextInput: __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoTextInput___default.a
	}
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoCloak__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoCloak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoCloak__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_url__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_url__);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoSidebarTemplateSelectionMolecule',
	props: {
		data: {
			type: Object
		}
	},
	data: function data() {
		return {
			tabIndex: 0,
			selectedTemplateId: -1
		};
	},

	computed: {
		templates: function templates() {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.data.items).map(function (key) {
				return _this.data.items[key];
			});
		},
		tagGroups: function tagGroups() {
			var tagGroups = {};
			var templates = this.templates;

			templates.forEach(function (template) {
				var templateTagsResult = template.tags.result;

				if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(templateTagsResult).length === 0) {
					return;
				}

				__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(templateTagsResult).forEach(function (key) {
					var templateTag = templateTagsResult[key];
					var tagName = templateTag.S_Value;
					var tagId = tagName.trim().toLowerCase();

					if (!tagGroups[tagId]) {
						tagGroups[tagId] = {
							id: tagId,
							name: tagName,
							templates: []
						};
					}

					tagGroups[tagId].templates.push(template);
				});
			});

			var tagGroupsArr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(tagGroups).map(function (key) {
				return tagGroups[key];
			});

			tagGroupsArr.unshift({
				id: 'all',
				name: 'All',
				templates: this.templates
			});

			return tagGroupsArr;
		},
		loading: function loading() {
			return this.data.loading;
		}
	},
	methods: {
		cardClasses: function cardClasses(dataset) {
			var templateId = parseInt(dataset.PKM_Template, 10);
			return ['_entry', { '-active': templateId === this.selectedTemplateId }];
		},
		getAbsolutePathForImage: function getAbsolutePathForImage(imgPath) {
			return __WEBPACK_IMPORTED_MODULE_3_url___default.a.resolve("https://cms-backend.stage.qa.erco.com", imgPath);
		},
		handleTemplateClick: function handleTemplateClick(templateData) {
			this.selectedTemplateId = parseInt(templateData.PKM_Template, 10);

			var newSidebarValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$store.state.sidebar.context);

			newSidebarValue.value.selectedTemplateId = this.selectedTemplateId;
			newSidebarValue.value.selectedTemplateData = templateData;

			this.$store.dispatch('updateSidebar', {
				context: newSidebarValue
			});
		},
		hyph: function hyph(str) {
			return str.replace(/([/-_])/g, '<wbr>$1');
		}
	},
	components: {
		ErcoCloak: __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoCloak___default.a
	}
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoTextInput__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoTextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoTextInput__);





function focusFirstElement() {
	var containerNode = this.$refs.sidebarTextInput;

	if (!containerNode) {
		return;
	}

	var firstInputNode = containerNode.querySelector('input');

	if (firstInputNode) {
		firstInputNode.focus();
	}
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoSidebarTextInputMolecule',

	props: {
		data: {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	},

	mounted: focusFirstElement,
	updated: focusFirstElement,

	methods: {
		handleInput: function handleInput(index, newValue) {
			var key = this.data[index].key;

			var newSidebarContext = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$store.state.sidebar.context);
			newSidebarContext.value[key] = newValue;

			this.$store.dispatch('updateSidebar', {
				context: newSidebarContext
			});
		},
		handleReset: function handleReset(index) {
			this.handleInput(index, '');
		}
	},

	components: {
		ErcoTextInput: __WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoTextInput___default.a
	}
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoList__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoTextInput__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoTextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoTextInput__);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoSidebarTriadMolecule',

	props: {
		data: {
			type: Object,
			default: function dataDefault() {
				return {
					draggable: [],
					destinations: []
				};
			}()
		}
	},

	data: function data() {
		return {
			tabIndex: 0
		};
	},


	computed: {
		itemValues: function itemValues() {
			return this.data.tabs.reduce(function (values, tab) {
				return tab.groups.reduce(function (gValues, group) {
					return group.items.reduce(function (iValues, item) {
						iValues[tab.key + '-' + item.id] = item.selected;
						return iValues;
					}, gValues);
				}, values);
			}, {});
		}
	},

	methods: {
		tabTitle: function tabTitle(index) {
			var title = this.data.tabs[index].title;

			var contextlinks = this.data.tabs[index].groups.reduce(function (count, group) {
				return count + group.items.reduce(function (groupitemCount, item) {
					return groupitemCount + (item.selected ? 1 : 0);
				}, 0);
			}, 0);

			if (contextlinks > 0) {
				title = title + ' (' + contextlinks + ')';
			}

			return title;
		},
		handleItemChange: function handleItemChange(tabKey, groupKey, item, value) {
			var checked = value.length > 0;
			var newSidebarValue = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].util.extend({}, this.$store.state.sidebar.context);

			if (!newSidebarValue.value[tabKey]) {
				newSidebarValue.value[tabKey] = {};
			}

			if (!newSidebarValue.value[tabKey][groupKey]) {
				newSidebarValue.value[tabKey][groupKey] = {};
			}

			if (newSidebarValue.value[tabKey][groupKey][item.id]) {
				delete newSidebarValue.value[tabKey][groupKey][item.id];
			} else {
				newSidebarValue.value[tabKey][groupKey][item.id] = checked;
			}

			var newSidebarOutputData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.data);
			newSidebarOutputData.tabs.forEach(function (branch) {
				if (branch.key === tabKey) {
					branch.groups.forEach(function (group) {
						if (group.key === groupKey) {
							group.items.forEach(function (groupItem) {
								if (groupItem.id === item.id) {
									groupItem.selected = checked;
									return false;
								}
								return true;
							});
							return false;
						}
						return true;
					});
					return false;
				}
				return true;
			});

			this.$store.dispatch('updateSidebar', {
				context: newSidebarValue,
				outputData: newSidebarOutputData
			});
		}
	},

	components: {
		ErcoList: __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoList___default.a,
		ErcoTextInput: __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoTextInput___default.a
	}
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoDropdown__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoDropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoDropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoCmsStructureDropdown__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoCmsStructureDropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoCmsStructureDropdown__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoStatusbarMolecule',
	data: function data() {
		return {
			lastEditChange: ''
		};
	},

	methods: {
		handleStatiFilterChange: function handleStatiFilterChange(changeData) {
			var value = changeData.currentValue.trim().toLowerCase();
			var label = 'Status';

			this.handleFilter('stati', label, value, function (itemValue) {
				var isFiltered = false;
				var currentItemValue = itemValue.S_Status.trim().toLowerCase();

				switch (value) {
					case 'preview':
						isFiltered = currentItemValue === 'online' && itemValue.isBeforeProduction;
						break;

					case 'online':
						isFiltered = itemValue.isProductive;
						break;

					default:
						isFiltered = currentItemValue === value;
				}

				return isFiltered;
			});
		},
		handleLastEditFilterChange: function handleLastEditFilterChange(changeData) {
			var value = changeData.currentValue.trim().toLowerCase();
			var label = 'letzte Änderung';

			this.lastEditChange = value;
			this.handleFilter('lastEdit', label, value, function (itemValue) {
				var currentItemValue = itemValue.S_NutzerAenderung;

				if (typeof currentItemValue === 'string') {
					currentItemValue = currentItemValue.trim().toLowerCase();
				}
				return currentItemValue === value;
			});
		},
		handleCategoryFilterChange: function handleCategoryFilterChange(changeData) {
			var value = changeData.currentValue.trim().toLowerCase();
			var label = 'Rubrik';

			this.handleFilter('category', label, value, function (itemValue) {
				var currentItemValue = itemValue.Tags;

				if (value === 'nicht zugeordnet' && !currentItemValue) {
					return true;
				}

				if (typeof currentItemValue === 'string') {
					currentItemValue = currentItemValue.split(',').map(function (val) {
						return val.trim().toLowerCase();
					});
				}

				return currentItemValue && currentItemValue.includes(value);
			});
		},
		handleCmsStructureClick: function handleCmsStructureClick(data) {
			var label = 'Gattung';

			this.handleFilter('cmsStructure', label, data, function (itemValue) {
				var itemCategory = itemValue.S_Bereich && itemValue.S_Bereich.trim();
				var itemSpecification = itemValue.S_Spezifikation && itemValue.S_Spezifikation.trim();
				var itemGenus = itemValue.S_Gattung && itemValue.S_Gattung.trim();

				var matched = itemCategory === data.category && itemSpecification === data.specification && itemGenus === data.genus;

				return matched;
			});
		},
		handleFilter: function handleFilter(type, label, value, filterFunc) {
			if (value === null || value === 'alle') {
				this.$store.dispatch('removeDashboardFilter', type);
			} else {
				this.$store.dispatch('addDashboardFilter', {
					type: type,
					value: value,
					label: label,
					filterFunc: filterFunc
				});
			}
		},
		getIndexOf: function getIndexOf(value, dropDownItems) {
			return dropDownItems.findIndex(function (item) {
				return item.value === value;
			});
		}
	},
	components: {
		ErcoDropdown: __WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoDropdown___default.a,
		ErcoCmsStructureDropdown: __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoCmsStructureDropdown___default.a
	},
	computed: {
		currentStatus: function currentStatus() {
			return this.$store.state.dashboard.activeFilters.stati && this.$store.state.dashboard.activeFilters.stati.value || '';
		},
		stati: function stati() {
			var states = {
				alle: { text: 'Alle', value: 'alle' },
				preview: { text: 'Preview', value: 'preview' }
			};

			if (!this.$store.state.dashboard.objectData) {
				return [];
			}

			this.$store.state.dashboard.objectData.forEach(function (item) {
				if (!item.S_Status) {
					return;
				}

				var text = item.S_Status === '(unknown)' ? 'Unbekannt' : item.S_Status;

				var ucText = '' + text.substr(0, 1).toUpperCase() + text.substr(1);
				states[item.S_Status] = { text: ucText,
					value: item.S_Status };
			});
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(states).map(function (key) {
				return states[key];
			});
		},
		currentEditor: function currentEditor() {
			return this.$store.state.dashboard.activeFilters.lastEdit && this.$store.state.dashboard.activeFilters.lastEdit.value || '';
		},
		editors: function editors() {
			var editors = {};

			if (!this.$store.state.dashboard.objectData) {
				return [];
			}
			this.$store.state.dashboard.objectData.forEach(function (item) {
				if (item.S_NutzerAenderung) {
					editors[item.S_NutzerAenderung] = { text: item.S_NutzerAenderung,
						value: item.S_NutzerAenderung };
				}
			});
			var sortedEditors = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(editors).map(function (key) {
				return editors[key];
			}).sort(function (a, b) {
				if (a.text < b.text) {
					return -1;
				}
				if (a.text > b.text) {
					return 1;
				}
				return 0;
			});

			return [{ text: 'Alle', value: 'alle' }].concat(sortedEditors);
		},
		currentCategory: function currentCategory() {
			return this.$store.state.dashboard.activeFilters.category && this.$store.state.dashboard.activeFilters.category.value || '';
		},
		categories: function categories() {
			var categories = {};

			if (!this.$store.state.dashboard.objectData) {
				return [];
			}
			this.$store.state.dashboard.objectData.forEach(function (item) {
				if (item.Tags) {
					item.Tags.split(',').forEach(function (tag) {
						categories[tag] = { text: tag,
							value: tag };
					});
				}
			});

			var sortedCategories = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(categories).map(function (key) {
				return categories[key];
			}).sort(function (a, b) {
				if (a.text < b.text) {
					return -1;
				}
				if (a.text > b.text) {
					return 1;
				}
				return 0;
			});

			return [{ text: 'Alle', value: 'alle' }, { text: 'Nicht zugeordnet', value: 'nicht zugeordnet' }].concat(sortedCategories);
		},
		cmsStructure: function cmsStructure() {
			return this.$store.state.dashboard.cmsStructure.structure;
		}
	}
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoTooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoTooltip__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoTextInputMolecule',
	props: {
		label: {
			type: String,
			default: ''
		},
		text: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		},
		keepUnfocused: {
			type: Boolean,
			default: false
		},
		resetable: {
			type: Boolean,
			default: false
		},
		droppable: {
			type: Boolean,
			default: false
		},
		forcePointerCursor: {
			type: Boolean,
			default: false
		},
		forceFocusOutline: {
			type: Boolean,
			default: false
		},
		inputType: {
			type: String,
			default: 'input',
			validator: function validator(value) {
				return ['input', 'textarea', 'auto'].indexOf(value.toLowerCase()) > -1;
			}
		},
		charlength: {
			type: [Number, Boolean],
			default: false
		},
		showMandatory: {
			type: Boolean,
			default: false
		},
		error: {
			type: Boolean,
			default: false
		},
		tooltip: {
			type: Object,
			required: false,
			default: function _default() {
				return { variant: '', title: '', text: '' };
			}
		}
	},

	components: {
		ErcoTooltip: __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoTooltip___default.a
	},

	data: function data() {
		return {
			dataText: null,
			hadFocus: false
		};
	},
	mounted: function mounted() {
		this.handleInputHeight();
	},


	methods: {
		handleFocus: function handleFocus() {
			if (this.keepUnfocused) {
				this.$refs.input.$el.blur();
				return;
			}

			this.hadFocus = true;
			this.$emit('focus');
		},
		handleBlur: function handleBlur() {
			if (this.keepUnfocused) {
				return;
			}

			this.hadFocus = false;
		},
		handleChange: function handleChange(value) {
			var valueAfterCheck = this.checkCharlengthRestriction(value);
			this.$emit('change', valueAfterCheck);
		},
		handleInput: function handleInput(value) {
			var valueAfterCheck = this.checkCharlengthRestriction(value);
			this.$emit('input', valueAfterCheck);
			this.handleInputHeight();
		},
		handleReset: function handleReset($event) {
			this.dataText = '';
			this.$emit('reset', $event);
		},
		handleInputHeight: function handleInputHeight() {
			if (this.isLongOrComplexText) {
				var el = this.$refs.input.$el;
				el.style.height = 'auto';
				el.style.overflowY = 'hidden';
				el.style.height = el.scrollHeight + 'px';
			}
		},
		handleLabelClick: function handleLabelClick($event) {
			if ($event.target.classList.contains('_reset')) {
				$event.preventDefault();
				return;
			}
			this.$emit('click', $event);
		},
		resetInput: function resetInput() {
			this.dataText = '';
		},
		checkCharlengthRestriction: function checkCharlengthRestriction(value) {
			var workingValue = value;

			if (this.charlength !== false && this.charlength < workingValue.length) {
				workingValue = workingValue.slice(0, this.charlength);
				this.textvalue = workingValue;
				this.$refs.input.$el.value = workingValue;
			}

			return workingValue;
		},
		focus: function focus() {
			this.$refs.input.focus();
		}
	},

	computed: {
		isLongOrComplexText: function isLongOrComplexText() {
			var charCountThreshold = 50;
			var val = this.textvalue;
			var hasLineBreaks = !!val.match(/<\s*br\s*\/{0,1}\s*>/) || !!val.match(/\n/gm);

			switch (this.inputType.toLowerCase()) {
				case 'input':
					return false;
				case 'textarea':
					return true;
				default:
					return this.textvalue.length > charCountThreshold || hasLineBreaks;
			}
		},
		inputStyle: function inputStyle() {
			var style = '';

			if (this.keepUnfocused) {
				style = 'cursor: default;';
			}
			if (this.forcePointerCursor) {
				style = 'cursor: pointer;';
			}

			return style;
		},


		textvalue: {
			get: function get() {
				return typeof this.dataText === 'string' ? this.dataText : this.text;
			},
			set: function set(value) {
				this.dataText = value;
			}
		},

		isResetable: function isResetable() {
			return this.resetable && this.textvalue;
		}
	},

	watch: {
		text: function text(newText) {
			this.dataText = newText;
		},
		isLongOrComplexText: function isLongOrComplexText() {
			this.focus();
			this.handleInputHeight();
		}
	}

});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoTooltipMolecules',

	data: function data() {
		return {
			outerMargin: 15,
			tooltipBoxWidth: 420,
			currentlyHovering: false,
			addXOffset: 0
		};
	},


	props: {
		variant: {
			type: String,
			required: false,
			default: ''
		},
		title: {
			type: String,
			required: false,
			default: ''
		},
		text: {
			type: String,
			required: true
		},
		invertIcon: {
			type: Boolean,
			default: false
		},
		offsetX: {
			type: String,
			default: '0'
		},
		offsetY: {
			type: String,
			default: '0'
		}
	},
	methods: {
		handleMouseHover: function handleMouseHover(isHovering) {
			this.currentlyHovering = isHovering;
		}
	},
	computed: {
		tooltipVisible: function tooltipVisible() {
			return this.currentlyHovering;
		},
		tooltipBoxStyle: function tooltipBoxStyle() {
			return {
				width: this.tooltipBoxWidth + 'px',
				left: this.addXOffset + 'px',
				marginTop: this.offsetY
			};
		}
	},
	watch: {
		currentlyHovering: function currentlyHovering(isHovering) {
			if (!isHovering) {
				return;
			}

			var tb = this.$refs.tooltipBox;

			tb.classList.add('hollow');
			tb.classList.add('visible');

			var totalOffsetLeft = tb.getBoundingClientRect().x - this.addXOffset;

			var offsetXDiff = document.body.offsetWidth - (totalOffsetLeft + this.tooltipBoxWidth);

			if (offsetXDiff < 0) {
				this.addXOffset = offsetXDiff + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign___default()(offsetXDiff) * this.outerMargin;
			} else {
				this.addXOffset = 0;
			}

			tb.classList.remove('visible');
			tb.classList.remove('hollow');
		}
	}
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoDropdown__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoDropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoDropdown__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoDashboardHeaderbarOrganism',
	data: function data() {
		var _this = this;

		return {
			searchString: function () {
				return _this.$store.state.dashboard.searchString;
			}(),
			timeoutHandler: null
		};
	},

	props: {},
	computed: {
		username: function username() {
			return this.$store.state.user.username;
		}
	},
	watch: {
		searchString: function searchString() {
			var _this2 = this;

			clearTimeout(this.timeoutHandler);
			this.timeoutHandler = setTimeout(function () {
				_this2.$store.dispatch('updateSearchString', { searchString: _this2.searchString });
			}, 500);
		}
	},
	methods: {
		handleSignoutClick: function handleSignoutClick() {
			this.$router.push({ path: '/logout', query: {} });
		}
	},
	components: {
		ErcoDropdown: __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoDropdown___default.a
	}
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_dashboard__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoStatusBadge__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoStatusBadge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoStatusBadge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoTextInput__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoTextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoTextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_molecules_ErcoDropdown__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_molecules_ErcoDropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_molecules_ErcoDropdown__);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoEditbarOrganism',
	data: function data() {
		return {
			actions: [{
				value: 'clone',
				text: 'klonen'
			}, {
				value: 'emptyCopy',
				text: 'leer kopieren'
			}],
			newObjectData: {
				specificationId: '',
				genusId: '',
				objectname: ''
			},
			alertTextList: [],
			selectedActionStatus: {}
		};
	},

	props: {},
	computed: {
		statiList: function statiList() {
			return this.$store.getters.dashboardStati.map(function (status) {
				return {
					value: status.PKM_Status,
					text: status.S_Status_Uppercase
				};
			});
		},
		userSpecifications: function userSpecifications() {
			var userSpecifications = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.state.dashboard.userSpecifications));

			var sortedUserSpecifications = userSpecifications.sort(function (a, b) {
				var lcASpec = a.S_Spezifikation.toLowerCase();
				var lcBSpec = b.S_Spezifikation.toLowerCase();
				return lcASpec.localeCompare(lcBSpec);
			});

			return sortedUserSpecifications;
		},
		userSpecificationsDropdown: function userSpecificationsDropdown() {
			var userSpecifications = this.userSpecifications.map(function (specification) {
				return {
					text: specification.S_Spezifikation,
					value: specification.PKM_Spezifikation
				};
			});

			userSpecifications.unshift({
				text: 'Bitte auswählen...',
				value: ''
			});

			return userSpecifications;
		},
		selectedUserSpecificationGenus: function selectedUserSpecificationGenus() {
			var _this = this;

			var foundSpecification = this.userSpecifications.find(function (spec) {
				return spec.PKM_Spezifikation === _this.newObjectData.specificationId;
			});

			var gattungen = foundSpecification ? JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(foundSpecification.gattungen)) : [];

			var sortedGattungen = gattungen.sort(function (a, b) {
				var lcAGattung = a.S_Gattung.toLowerCase();
				var lcBGattung = b.S_Gattung.toLowerCase();
				return lcAGattung.localeCompare(lcBGattung);
			});

			return sortedGattungen;
		},
		selectedUserSpecificationGenusDropdown: function selectedUserSpecificationGenusDropdown() {
			var selectedUserSpecificationGenus = this.selectedUserSpecificationGenus.map(function (genus) {
				return {
					text: genus.S_Gattung,
					value: genus.PKM_Gattung
				};
			});

			selectedUserSpecificationGenus.unshift({
				text: 'Bitte auswählen...',
				value: ''
			});

			return selectedUserSpecificationGenus;
		},
		activeObjectSelection: function activeObjectSelection() {
			return this.$store.getters.selectedDashboardObjects;
		},
		activeObjectsSelected: function activeObjectsSelected() {
			return this.activeObjectSelection.length > 0;
		}
	},
	methods: {
		handleNewClick: function handleNewClick(e) {
			var _this2 = this;

			var valid = true;
			this.alertTextList = [];

			if (this.newObjectData.objectname.length === 0) {
				valid = false;
				this.alertTextList.push('Keinen Objektnamen eingegeben');
			}
			if (this.newObjectData.specificationId.trim().length === 0) {
				valid = false;
				this.alertTextList.push('Keine Spezifikation ausgewählt');
			}
			if (this.newObjectData.genusId.length === 0) {
				valid = false;
				this.alertTextList.push('Keine Gattung ausgewählt');
			}

			if (!valid) {
				e.cancel();
				return;
			}

			__WEBPACK_IMPORTED_MODULE_1__api_dashboard__["a" /* default */].createNewObject(this.newObjectData.specificationId.trim(), this.newObjectData.genusId, this.newObjectData.objectname).then(function (response) {
				var objectId = response.PKM_Objekt;

				_this2.$store.dispatch('invalidateLastFetchAt');
				_this2.$router.push({ path: '/objectview/' + objectId });
			}).catch(function () {
				e.cancel();
			});
		},
		handleActionClick: function handleActionClick(value) {
			this.$store.dispatch('triggerActionOnDashboardObjects', value.currentValue);
		},
		handleStatiClick: function handleStatiClick(value) {
			this.$refs.actionConfirmation.show();
			this.selectedActionStatus = value;
		},
		handleStatiModalClick: function handleStatiModalClick() {
			this.$store.dispatch('changeStatusOnDashboardObjects', this.selectedActionStatus.currentValue);
		},
		resetSelectedActionStatus: function resetSelectedActionStatus() {
			this.selectedActionStatus = {};
		},
		handleObjectnameChange: function handleObjectnameChange(value) {
			this.newObjectData.objectname = value;
		},
		clearNewObjectDataset: function clearNewObjectDataset() {
			this.newObjectData.specificationId = '';
			this.$refs.modalObjectSpecificationDropdown.resetSelection();

			this.newObjectData.genusId = '';
			this.$refs.modalObjectGenusDropdown.resetSelection();

			this.newObjectData.objectname = '';
			this.$refs.modalObjectnameInput.resetInput();
		},
		handleSpecificationClick: function handleSpecificationClick(data) {
			this.newObjectData.specificationId = data.currentValue;
		},
		handleGenusClick: function handleGenusClick(data) {
			this.newObjectData.genusId = data.currentValue;
		},
		handleObjectSelectionReset: function handleObjectSelectionReset() {
			this.$store.dispatch('handleObjectSelection', { type: 'empty' });
		},
		getImageSrcForObject: function getImageSrcForObject(obj) {
			if (obj.S_Stellvertreterbild) {
				return "https://cms-backend.stage.qa.erco.com" + '/system/images/web/' + obj.S_Stellvertreterbild;
			}
			return "@/../static/svg/placeholder-image.svg";
		}
	},
	components: {
		ErcoStatusBadge: __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoStatusBadge___default.a,
		ErcoTextInput: __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoTextInput___default.a,
		ErcoDropdown: __WEBPACK_IMPORTED_MODULE_4__components_molecules_ErcoDropdown___default.a
	}
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoMainOrganism'
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoObjectCard__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoObjectCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoObjectCard__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoObjectCardOverviewOrganism',
	data: function data() {
		return {
			currentContentIndex: 0,
			innerVisibleItemsNum: 0
		};
	},

	props: {
		items: {
			type: Array,
			required: true,
			default: function _default() {
				return [];
			}
		},
		headline: {
			type: String,
			required: false,
			default: 'headline'
		},
		ismultiline: {
			type: Boolean,
			default: false
		},
		visibleItemsNum: {
			type: Number,
			default: 12
		},
		disabledItemRestriction: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		visibleItems: function visibleItems() {
			if (this.disabledItemRestriction) {
				return this.items;
			}

			return this.items.slice(0, this.innerVisibleItemsNum || this.visibleItemsNum);
		},
		selectedObjectIds: function selectedObjectIds() {
			return this.$store.state.dashboard.selectedObjectIds;
		}
	},
	methods: {
		belongsToSelection: function belongsToSelection(objID) {
			var parsedObjID = parseInt(objID, 10);
			return this.selectedObjectIds.includes(parsedObjID);
		}
	},
	watch: {
		visibleItemsNum: function visibleItemsNum(newVisibleItemsNum) {
			this.$set(this, 'innerVisibleItemsNum', newVisibleItemsNum);
		}
	},
	components: {
		ErcoObjectCard: __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoObjectCard___default.a
	}
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_infoTextHelper__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_renderHelper__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_molecules_ErcoTooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_molecules_ErcoTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_molecules_ErcoTooltip__);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoObjectViewAssetsOrganism',

	data: function data() {
		return {
			imgSrcs: {}
		};
	},


	props: {
		dataset: {
			type: Object,
			required: true
		}
	},

	computed: {
		objectdataImageItems: function objectdataImageItems() {
			return this.$store.getters.mappedObjectDataItems.imageItems;
		},
		siteId: function siteId() {
			return this.$store.state.objectsites.objectdata.id;
		}
	},

	mounted: function mounted() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.mappedObjectDataItems.imageItems).forEach(function (index) {
			var data = _this.$store.getters.mappedObjectDataItems.imageItems[index];
			__WEBPACK_IMPORTED_MODULE_3__helper_renderHelper__["a" /* default */].getImage(data, function (img) {
				__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(_this.imgSrcs, index, img);
			});
		});
	},


	methods: {
		openSidebarFor: function openSidebarFor(item) {
			var outputData = item;

			var sidebarData = {
				visible: true,
				key: this.getItemKey(item),
				view: 'erco-sidebar-image-editor',
				outputData: outputData,
				context: {
					dispatchActionName: 'updateAssetsItem',
					value: {}
				},
				title: item.S_Urbild,
				titleAdditional: item.label,
				info: __WEBPACK_IMPORTED_MODULE_2__helper_infoTextHelper__["a" /* default */].for('assets.editAsset')
			};

			this.$store.dispatch('updateSidebar', sidebarData);
		},
		getImgSrc: function getImgSrc(key) {
			return this.imgSrcs[key];
		},
		getItemKey: function getItemKey(item) {
			var key = item.label.toLowerCase().replace(/\s*\(.*?\)\s*/g, '').replace(/\s/, '_').replace(/[*:]|\s+/g, '').trim();
			return key;
		},
		infoTextKeyForItem: function infoTextKeyForItem(item) {
			return 'assets.' + this.getItemKey(item);
		},
		infoTextForItem: function infoTextForItem(item) {
			var key = this.infoTextKeyForItem(item);
			return __WEBPACK_IMPORTED_MODULE_2__helper_infoTextHelper__["a" /* default */].for(key);
		},
		isSidebarFocused: function isSidebarFocused(item) {
			var key = this.getItemKey(item);
			var sidebarStore = this.$store.state.sidebar;
			return sidebarStore.visible && sidebarStore.key === key;
		}
	},

	watch: {
		objectdataImageItems: function objectdataImageItems() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.mappedObjectDataItems.imageItems).forEach(function (index) {
				var data = _this2.$store.getters.mappedObjectDataItems.imageItems[index];
				__WEBPACK_IMPORTED_MODULE_3__helper_renderHelper__["a" /* default */].getImage(data, function (img) {
					__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(_this2.imgSrcs, index, img);
				});
			});
		}
	},

	components: {
		ErcoTooltip: __WEBPACK_IMPORTED_MODULE_4__components_molecules_ErcoTooltip___default.a
	}
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoLayout_TemplateSelection__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoLayout_TemplateSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoLayout_TemplateSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoLayout_PreviewBlock__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoLayout_PreviewBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoLayout_PreviewBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoBackToTopButton__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoBackToTopButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoBackToTopButton__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoObjectViewLayoutOrganism',

	data: function data() {
		return {
			$preview: null
		};
	},


	props: {
		dataset: {
			type: Object,
			required: true
		}
	},

	computed: {
		sites: function sites() {
			return this.$store.getters.mappedSiteData || {};
		},
		sitesFinishedLoading: function sitesFinishedLoading() {
			return this.$store.state.objectsites.sitesFinishedLoading;
		},
		templateSets: function templateSets() {
			return this.$store.state.objectsites.templateSets;
		}
	},

	components: {
		ErcoLayoutTemplateSelection: __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoLayout_TemplateSelection___default.a,
		ErcoLayoutPreviewBlock: __WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoLayout_PreviewBlock___default.a,

		ErcoBackToTopButton: __WEBPACK_IMPORTED_MODULE_2__components_atoms_ErcoBackToTopButton___default.a
	}
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_infoTextHelper__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoTextInput__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoTextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoTextInput__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoObjectViewObjectDataOrganism',

	data: function data() {
		return {};
	},


	props: {
		dataset: {
			type: Object,
			required: true
		}
	},

	computed: {
		objectdataTextItems: function objectdataTextItems() {
			return this.$store.getters.mappedObjectDataItems.textItems;
		},
		objectdataTextTranslations: function objectdataTextTranslations() {
			return this.$store.getters.mappedObjectDataItems.textItemsTranslations;
		},
		mandatoryMissing: function mandatoryMissing() {
			return this.$store.getters.getMissingMandatoryFields;
		}
	},

	methods: {
		openSidebarFor: function openSidebarFor(item) {
			var _this = this;

			var tabs = __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].langs.map(function (lang) {
				var text = _this.objectdataTextTranslations[lang.key] && _this.objectdataTextTranslations[lang.key].items[item.key] && _this.objectdataTextTranslations[lang.key].items[item.key].value || '';
				return {
					key: item.key,
					tabKey: lang.key,
					label: lang.text,
					text: text,
					toBeFetched: _this.objectdataTextTranslations[lang.key] === null
				};
			});

			var outputData = {
				tabChangeAction: 'getObjectDataTranslation',
				selectedTabKey: this.$store.state.objectsetup.current.sprache,
				tabs: tabs,
				charlength: item.charlength && parseInt(item.charlength, 10) || false
			};

			var titleAdditional = outputData.charlength ? '(max. ' + outputData.charlength + ' Zeichen)' : '';

			var sidebarData = {
				visible: true,
				key: item.labelKey,
				view: 'erco-sidebar-tabbed-text-input',
				fixed: true,
				outputData: outputData,
				context: {
					dispatchActionName: 'updateObjectDataItem',
					value: {
						siteId: this.$store.state.objectsites.objectdata.id
					}
				},
				title: item.label,
				titleAdditional: titleAdditional,
				info: __WEBPACK_IMPORTED_MODULE_1__helper_infoTextHelper__["a" /* default */].for('objectdata.' + item.labelKey)
			};

			this.$store.dispatch('updateSidebar', sidebarData);
		},
		tooltipFor: function tooltipFor(item) {
			var infoKey = 'objectdata.' + item.labelKey;
			var replacements = {};

			if (item.charlength) {
				replacements.maxChars = parseInt(item.charlength, 10);
			}
			return __WEBPACK_IMPORTED_MODULE_1__helper_infoTextHelper__["a" /* default */].for(infoKey, replacements) || { variant: '', title: '', text: '' };
		},
		isSidebarFocused: function isSidebarFocused(key) {
			var sidebarStore = this.$store.state.sidebar;
			return sidebarStore.visible && sidebarStore.key === key;
		}
	},

	components: {
		ErcoTextInput: __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoTextInput___default.a
	}
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_infoTextHelper__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoTextInput__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoTextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoTextInput__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoObjectViewSeoOrganism',

	data: function data() {
		return {};
	},


	props: {
		dataset: {
			type: Object,
			required: true
		}
	},

	computed: {
		objectdataSeoTextItems: function objectdataSeoTextItems() {
			return this.$store.getters.mappedObjectDataItems.seoItems;
		},
		objectdataSeoTextTranslations: function objectdataSeoTextTranslations() {
			return this.$store.getters.mappedObjectDataItems.textItemsTranslations;
		},
		mandatoryMissing: function mandatoryMissing() {
			return this.$store.getters.getMissingMandatoryFields;
		}
	},

	methods: {
		openSidebarFor: function openSidebarFor(item) {
			var _this = this;

			var type = '';
			var view = '';
			var outputData = {};
			var titleAdditional = '';

			if (item.enum) {
				type = 'enum';
				view = 'erco-sidebar-dropdown';
				outputData = [item];
			} else {
				type = 'text';
				view = 'erco-sidebar-tabbed-text-input';

				var tabs = __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].langs.map(function (lang) {
					var text = _this.objectdataSeoTextTranslations[lang.key] && _this.objectdataSeoTextTranslations[lang.key].items[item.key] && _this.objectdataSeoTextTranslations[lang.key].items[item.key].value || '';

					return {
						key: item.key,
						tabKey: lang.key,
						label: lang.text,
						text: text,
						toBeFetched: _this.objectdataSeoTextTranslations[lang.key] === null
					};
				});

				outputData = {
					tabChangeAction: 'getObjectDataTranslation',
					selectedTabKey: this.$store.state.objectsetup.current.sprache,
					tabs: tabs,
					charlength: item.charlength && parseInt(item.charlength, 10) || false
				};

				if (outputData.charlength) {
					titleAdditional = '(max. ' + outputData.charlength + ' Zeichen)';
				}
			}

			var sidebarData = {
				visible: true,
				key: item.labelKey,
				view: view,
				fixed: true,
				outputData: outputData,
				context: {
					dispatchActionName: 'updateObjectDataItem',
					value: {
						siteId: this.$store.state.objectsites.objectdata.id,
						type: type
					}
				},
				title: item.label,
				titleAdditional: titleAdditional,
				info: this.tooltipFor(item)
			};

			this.$store.dispatch('updateSidebar', sidebarData);
		},
		tooltipFor: function tooltipFor(item) {
			var infoKey = 'objectdata.' + item.labelKey;
			var replacements = {};

			if (item.charlength) {
				replacements.maxChars = parseInt(item.charlength, 10);
			}

			return __WEBPACK_IMPORTED_MODULE_1__helper_infoTextHelper__["a" /* default */].for(infoKey, replacements) || { variant: '', title: '', text: '' };
		},
		isSidebarFocused: function isSidebarFocused(key) {
			var sidebarStore = this.$store.state.sidebar;
			return sidebarStore.visible && sidebarStore.key === key;
		},
		getInputTextFor: function getInputTextFor(item) {
			if (item.enum) {
				var matchingEnumItem = item.enum.find(function (currItem) {
					return currItem.value === item.value;
				});

				if (matchingEnumItem) {
					return matchingEnumItem.label;
				}
			}

			return item.value;
		}
	},

	components: {
		ErcoTextInput: __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoTextInput___default.a
	}
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_infoTextHelper__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_colorHelper__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_molecules_ErcoTooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_molecules_ErcoTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_molecules_ErcoTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_atoms_ErcoStatusBadge__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_atoms_ErcoStatusBadge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_atoms_ErcoStatusBadge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_molecules_ErcoTextInput__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_molecules_ErcoTextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_molecules_ErcoTextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_molecules_ErcoRadioGroup__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_molecules_ErcoRadioGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_molecules_ErcoRadioGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_molecules_ErcoCheckboxGroup__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_molecules_ErcoCheckboxGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_molecules_ErcoCheckboxGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);


















var FileSaver = __webpack_require__(466);

var sidebarInputActions = {
	lastchanges: function lastchanges() {
		var sidebarData = {
			visible: true,
			applied: true,
			key: 'lastchanges',
			view: 'erco-sidebar-last-changes',
			outputData: [],
			title: 'Letzte Änderungen',
			titleAdditional: '',
			info: __WEBPACK_IMPORTED_MODULE_5__helper_infoTextHelper__["a" /* default */].for('setup.lastchanges')
		};

		sidebarData.outputData = this.dataset.S_Historie;

		return sidebarData;
	},
	objectname: function objectname() {
		var _this = this;

		var maxChars = __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].max_chars['setup.objectname'];
		var titleAdditional = '(max. ' + maxChars + ' Zeichen)';

		var sidebarData = {
			visible: true,
			key: 'objectname',
			view: 'erco-sidebar-text-input',
			outputData: [],
			context: {
				dispatchActionName: 'updateObjectSetupObjectname',
				value: {}
			},
			title: 'Objektname',
			titleAdditional: titleAdditional,
			info: __WEBPACK_IMPORTED_MODULE_5__helper_infoTextHelper__["a" /* default */].for('setup.objectname', { maxChars: maxChars }),
			applied: false
		};

		__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].langs.forEach(function (lang) {
			if (_this.dataset['S_' + lang.key + '_Objekt'] === __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].NO_CONTENT) return;

			var objectText = _this.dataset['S_' + lang.key + '_Objekt'] || '';

			var entry = {
				key: lang.key,
				label: lang.text,
				text: objectText,
				charlength: maxChars
			};

			sidebarData.outputData.push(entry);
		});

		return sidebarData;
	},
	pdbKey: function pdbKey() {
		var sidebarData = {
			visible: true,
			key: 'pdbKey',
			view: 'erco-sidebar-text-input',
			outputData: [],
			context: {
				dispatchActionName: 'updateObjectSetupPDBKey',
				value: {}
			},
			title: 'PDB-Key',
			titleAdditional: '',
			info: __WEBPACK_IMPORTED_MODULE_5__helper_infoTextHelper__["a" /* default */].for('setup.pdbKey')
		};

		sidebarData.outputData.push({
			key: 'pdbKey',
			label: '',
			text: this.pdbKey
		});

		return sidebarData;
	},
	objectadditional: function objectadditional() {
		var sidebarData = {
			visible: true,
			key: 'objectadditional',
			view: 'erco-sidebar-text-input',
			outputData: [],
			context: {
				dispatchActionName: 'updateObjectSetupObjectAdditional',
				value: {}
			},
			title: 'Objektzusatz',
			titleAdditional: '',
			info: __WEBPACK_IMPORTED_MODULE_5__helper_infoTextHelper__["a" /* default */].for('setup.objectadditional')
		};

		sidebarData.outputData.push({
			key: 'objectadditional',
			label: '',
			text: this.objectadditional
		});

		return sidebarData;
	},
	objecteditor: function objecteditor() {
		var sidebarData = {
			visible: true,
			key: 'objecteditor',
			view: 'erco-sidebar-dropdown',
			outputData: [],
			context: {
				dispatchActionName: 'updateObjectSetupObjectEditor',
				value: {}
			},
			title: 'Redakteur',
			titleAdditional: '',
			info: __WEBPACK_IMPORTED_MODULE_5__helper_infoTextHelper__["a" /* default */].for('setup.objecteditor')
		};

		var enums = this.objectusers.map(function (user) {
			return {
				label: user.PKM_Nutzername,
				value: user.PKM_Nutzername
			};
		});

		sidebarData.outputData.push({
			key: 'objecteditor',
			label: '',
			enum: [{ label: 'Bitte auswählen', value: '' }].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(enums)),
			value: this.objecteditor
		});

		return sidebarData;
	},
	objectdesigner: function objectdesigner() {
		var sidebarData = {
			visible: true,
			key: 'objectdesigner',
			view: 'erco-sidebar-dropdown',
			outputData: [],
			context: {
				dispatchActionName: 'updateObjectSetupObjectDesigner',
				value: {}
			},
			title: 'Designer',
			titleAdditional: '',
			info: __WEBPACK_IMPORTED_MODULE_5__helper_infoTextHelper__["a" /* default */].for('setup.objectdesigner')
		};

		var enums = this.objectusers.map(function (user) {
			return {
				label: user.PKM_Nutzername,
				value: user.PKM_Nutzername
			};
		});

		sidebarData.outputData.push({
			key: 'objectdesigner',
			label: '',
			enum: [{ label: 'Bitte auswählen', value: '' }].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(enums)),
			value: this.objectdesigner
		});

		return sidebarData;
	},
	objectcountry: function objectcountry() {
		var sidebarData = {
			visible: true,
			key: 'objectcountry',
			view: 'erco-sidebar-dropdown',
			outputData: [],
			context: {
				dispatchActionName: 'updateObjectProjectToCountry',
				value: {}
			},
			title: 'Land',
			titleAdditional: '',
			info: __WEBPACK_IMPORTED_MODULE_5__helper_infoTextHelper__["a" /* default */].for('setup.objectcountry')
		};

		var enums = this.countries.map(function (country) {
			return {
				label: country.S_Land,
				value: country.PKM_Land
			};
		});

		sidebarData.outputData.push({
			key: 'objectcountry',
			label: '',
			enum: [{ label: 'Bitte auswählen', value: '' }].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(enums)),
			value: this.objectcountrykey
		});

		return sidebarData;
	},
	basisgenus: function basisgenus() {
		var _this2 = this;

		var sidebarData = {
			visible: true,
			key: 'basisgenus',
			view: 'erco-sidebar-basisgenus',
			outputData: {
				draggable: [],
				destinations: []
			},
			context: {
				dispatchActionName: 'updateObjectSetupBasisGenus',
				value: {}
			},
			title: 'Stammgattung',
			titleAdditional: 'Gattungen auf die Felder ziehen',
			info: __WEBPACK_IMPORTED_MODULE_5__helper_infoTextHelper__["a" /* default */].for('setup.basisgenus'),
			applied: false
		};

		this.dataset.gattungen.forEach(function (gattung) {
			var id = gattung.PKM_Gattung;
			var value = gattung.S_Gattung;
			var text = value + ' (' + id + ')';
			var short = gattung.S_Kurzbezeichnung;

			sidebarData.outputData.draggable.push({
				id: id,
				value: value,
				text: text,
				short: short
			});
		});

		var destinations = [];

		destinations.push({
			key: 0,
			type: 'basis',
			data: {
				PKM_Gattung: this.dataset.FKM_Gattung,
				S_Gattung: this.dataset.S_Gattung || ''
			}
		});

		[2, 3, 4, 5, 6].forEach(function (traitNum) {
			destinations.push({
				key: traitNum,
				type: 'trait',
				data: {
					PKM_Gattung: _this2.dataset['FKM_Gattung' + traitNum],
					S_Gattung: _this2.dataset['S_Gattung' + traitNum] || ''
				}
			});
		});

		destinations = destinations.map(function (entry) {
			var key = entry.key;
			var type = entry.type;
			var label = entry.type === 'basis' ? 'Stammgattung' : 'Merkmal';
			var id = '0';
			var text = '';

			if (entry.data) {
				id = entry.data.PKM_Gattung;
				text = entry.data.S_Gattung;
			}

			return {
				id: id,
				key: key,
				label: label,
				text: text,
				type: type
			};
		});

		sidebarData.outputData.destinations = destinations;

		return sidebarData;
	},
	categories: function categories() {
		var sidebarData = {
			visible: true,
			key: 'categories',
			view: 'erco-sidebar-tags',
			outputData: {
				tags: [],
				suggestionAction: 'getCategorySuggestions'
			},
			context: {
				dispatchActionName: 'updateObjectSetupCategories',
				value: {
					tags: {}
				}
			},
			title: 'Tags',
			titleAdditional: 'Tags verwalten',
			info: __WEBPACK_IMPORTED_MODULE_5__helper_infoTextHelper__["a" /* default */].for('setup.categories'),
			applied: false
		};

		if (this.dataset.tags) {
			var tags = this.dataset.tags;

			if (tags.result) {
				tags = tags.result;
				var tagKeys = [];

				__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(tags).forEach(function (entry) {
					tagKeys.push(entry[0]);
				});

				sidebarData.outputData.tags = tagKeys.map(function (tagKey) {
					var tag = tags[tagKey];

					return {
						id: tag.PKM_Tag,
						text: tag.S_Value,
						s_attribut: tag.S_Attribut,
						s_type: tag.S_Type,
						color: __WEBPACK_IMPORTED_MODULE_6__helper_colorHelper__["a" /* default */].colorstring(tag.S_Type)
					};
				});
			}
		}

		return sidebarData;
	},
	triad: function triad() {
		var _this3 = this;

		var sidebarData = {
			visible: true,
			key: 'triad',
			view: 'erco-sidebar-triad',
			outputData: {
				tabs: []
			},
			context: {
				dispatchActionName: 'updateObjectSetupTriad',
				value: {}
			},
			title: 'Dreiklang',
			titleAdditional: 'Kontextlinks verwalten',
			info: __WEBPACK_IMPORTED_MODULE_5__helper_infoTextHelper__["a" /* default */].for('setup.triad'),
			applied: false
		};

		[{ key: 'produkte_objekte', title: 'Produkte' }, { key: 'projekte_objekte', title: 'Projekte' }].forEach(function (branch) {
			var branchData = _this3.dataset.dreiklang[branch.key];

			var tab = {
				title: branch.title,
				key: branch.key,
				groups: []
			};

			(branchData || []).forEach(function (genus) {
				var group = {
					title: genus.S_Gattung,
					key: genus.PKM_Gattung,
					items: []
				};

				(genus.objekte || []).forEach(function (item) {
					group.items.push({
						id: item.PKM_Objekt,
						text: item.S_Objekt,
						additional: item.S_Zusatz,
						selected: item.selected === 'true'
					});
				});

				tab.groups.push(group);
			});

			sidebarData.outputData.tabs.push(tab);
		});

		return sidebarData;
	},
	linkedProducts: function linkedProducts() {
		var sidebarData = {
			visible: true,
			key: 'linkedProducts',
			view: 'erco-sidebar-linked-products',
			outputData: {
				tabs: []
			},
			context: {
				dispatchActionName: 'updateObjectSetupLinkedProducts',
				value: {}
			},
			title: 'Verwendete Produkte',
			titleAdditional: 'Produktverknüpfungen verwalten',
			info: __WEBPACK_IMPORTED_MODULE_5__helper_infoTextHelper__["a" /* default */].for('setup.linkedProducts'),
			applied: false
		};

		var branch = {
			key: 'verwendete_produkte_objekte',
			title: 'Verwendete Produkte'
		};
		var data = this.dataset.verwendete_produkte[branch.key];

		var tab = {
			title: branch.title,
			key: branch.key,
			groups: []
		};

		(data || []).forEach(function (genus) {
			var group = {
				title: genus.S_Gattung,
				key: genus.PKM_Gattung,
				items: []
			};

			(genus.objekte || []).forEach(function (item) {
				group.items.push({
					id: item.PKM_Objekt,
					text: item.S_Objekt,
					additional: item.S_Zusatz,
					selected: item.selected === 'true'
				});
			});

			tab.groups.push(group);
		});

		sidebarData.outputData.tabs.push(tab);

		return sidebarData;
	},
	publishdatetime: function publishdatetime() {
		var sidebarData = {
			visible: true,
			key: 'publishdatetime',
			view: 'erco-sidebar-date-time-picker',
			outputData: {
				datetime: null
			},
			context: {
				dispatchActionName: 'updateObjectSetupPublishDateTime',
				value: {}
			},
			title: 'Veröffentlichung',
			titleAdditional: 'Zeitpunkt der Veröffentlichung setzen',
			info: __WEBPACK_IMPORTED_MODULE_5__helper_infoTextHelper__["a" /* default */].for('setup.publishdatetime'),
			applied: false
		};

		var publishDateTime = __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.publishDateTime, __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].DATETIMEFORMAT);

		if (publishDateTime.isValid()) {
			sidebarData.outputData.datetime = publishDateTime.toDate();
		}

		return sidebarData;
	},
	gooffdatetime: function gooffdatetime() {
		var sidebarData = {
			visible: true,
			key: 'gooffdatetime',
			view: 'erco-sidebar-date-time-picker',
			outputData: {
				datetime: null
			},
			context: {
				dispatchActionName: 'updateObjectSetupGoOfflineDateTime',
				value: {}
			},
			title: 'Offlinesetzung',
			titleAdditional: 'Zeitpunkt der Offlinesetzung',
			info: __WEBPACK_IMPORTED_MODULE_5__helper_infoTextHelper__["a" /* default */].for('setup.gooffdatetime'),
			applied: false
		};

		var goOfflineDateTime = __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.goOfflineDateTime, __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].DATETIMEFORMAT);

		if (goOfflineDateTime.isValid()) {
			sidebarData.outputData.datetime = goOfflineDateTime.toDate();
		}

		return sidebarData;
	}
};

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoObjectViewSetupOrganism',

	props: {
		dataset: {
			type: Object,
			required: true
		}
	},

	data: function data() {
		return {
			dirtySelectedStatusNum: null,
			change: null,
			approval: {
				redaktionellefreigabe: 'Red. Freigabe',
				uebersetzung: 'Übersetzung',
				technischefreigabe: 'Techn. Freigabe',
				endfreigabe: 'End-Freigabe',
				linkspruefen: 'Links prüfen',
				fremdsprachenpruefen: 'Fremdsprachen prüfen'
			},
			statusTooltip: __WEBPACK_IMPORTED_MODULE_5__helper_infoTextHelper__["a" /* default */].for('setup.status'),
			processTooltip: __WEBPACK_IMPORTED_MODULE_5__helper_infoTextHelper__["a" /* default */].for('setup.process')
		};
	},


	computed: {
		username: function username() {
			return this.$store.state.user.username;
		},
		mandatoryFieldsStatus: function mandatoryFieldsStatus() {
			return this.$store.getters.isMandatoryFilledOut;
		},
		mandatoryFieldsText: function mandatoryFieldsText() {
			return this.$store.getters.isMandatoryFilledOut ? 'Pflichtfelder vollständig' : 'Pflichtfelder unvollständig';
		},
		belongsToProductAreaOne: function belongsToProductAreaOne() {
			return this.$store.state.objectsetup.current.FKM_Bereich === '1';
		},
		isProject: function isProject() {
			return __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].specifications.projects.indexOf(this.dataset.FKM_Spezifikation) !== -1;
		},
		objectname: function objectname() {
			var lang = this.dataset.sprache;
			var name = this.dataset['S_' + lang + '_Objekt'];

			return name || '';
		},
		objectid: function objectid() {
			return this.dataset.PKM_Objekt;
		},
		objectstatus: function objectstatus() {
			return this.dataset.FKM_Status && this.$store.getters.statiKey[this.dataset.FKM_Status] && this.$store.getters.statiKey[this.dataset.FKM_Status].S_Status || '';
		},
		isProductive: function isProductive() {
			return this.$store.getters.objectIsProductive;
		},
		pdbKey: function pdbKey() {
			return this.dataset.FKM_PKM_PDB.toString() || '';
		},
		objectadditional: function objectadditional() {
			return this.dataset.S_Zusatz || '';
		},
		objectusers: function objectusers() {
			return this.dataset.nutzer || [];
		},
		objecteditor: function objecteditor() {
			return this.dataset.FKM_Nutzername_Redakteur || '';
		},
		objectdesigner: function objectdesigner() {
			return this.dataset.FKM_Nutzername_Designer || '';
		},
		objectcountry: function objectcountry() {
			if (!this.dataset.land) {
				return '';
			}
			var selectedCountry = this.dataset.land.find(function (country) {
				return country.selected === 'true';
			});
			return selectedCountry && selectedCountry.S_Land || '';
		},
		objectcountrykey: function objectcountrykey() {
			if (!this.dataset.land) {
				return '';
			}
			var selectedCountry = this.dataset.land.find(function (country) {
				return country.selected === 'true';
			});
			return selectedCountry && selectedCountry.PKM_Land || '';
		},
		countries: function countries() {
			return this.$store.state.global.countries;
		},
		specification: function specification() {
			return this.dataset.S_Spezifikation || '';
		},
		basisgenus: function basisgenus() {
			var _this4 = this;

			var basisgenusList = [];

			if (this.dataset.S_Gattung) {
				basisgenusList.push(this.dataset.S_Gattung);
			}

			[2, 3, 4, 5, 6].forEach(function (key) {
				if (_this4.dataset['S_Gattung' + key]) {
					basisgenusList.push(_this4.dataset['S_Gattung' + key]);
				}
			});

			return basisgenusList.join(', ');
		},
		basisgenusArr: function basisgenusArr() {
			var _this5 = this;

			return [1, 2, 3, 4, 5, 6].map(function (num) {
				var propNamePostfix = num === 1 ? '' : '' + num;
				var type = num === 1 ? 'basis' : 'trait';
				var idPropName = 'FKM_Gattung' + propNamePostfix;
				var titlePropName = 'S_Gattung' + propNamePostfix;

				return {
					id: _this5.dataset[idPropName] || '0',
					title: _this5.dataset[titlePropName] || '',
					type: type
				};
			});
		},
		basisgenusDestinationsAreFull: function basisgenusDestinationsAreFull() {
			return !this.basisgenusArr.some(function (currGenus) {
				return currGenus.id === '0';
			});
		},
		categories: function categories() {
			var categories = [];

			if (this.dataset.tags) {
				var tags = this.dataset.tags;

				if (tags.result) {
					tags = tags.result;
					var tagKeys = [];
					__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(tags).forEach(function (entry) {
						if (entry[1].S_Attribut) {
							tagKeys.push(entry[0]);
						}
					});
					categories = tagKeys.map(function (tagKey) {
						return tags[tagKey].S_Value;
					});
				}
			}

			return categories.join(', ');
		},
		mediaformats: function mediaformats() {
			var mediaformats = [];

			if (this.dataset.tags) {
				var tags = this.dataset.tags;

				if (tags.result) {
					tags = tags.result;
					var tagKeys = [];
					__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(tags).forEach(function (entry) {
						if (entry[1].S_Attribut === 'medienformat') {
							tagKeys.push(entry[0]);
						}
					});
					mediaformats = tagKeys.map(function (tagKey) {
						return tags[tagKey].S_Value;
					});
				}
			}

			return mediaformats.join(', ');
		},
		triad: function triad() {
			var _this6 = this;

			var dreiklangEntries = [];

			['produkte_objekte', 'projekte_objekte'].forEach(function (key) {
				if (!(_this6.dataset.dreiklang || {})[key]) {
					return;
				}
				var subDreiklang = _this6.dataset.dreiklang[key];
				subDreiklang.forEach(function (entry) {
					entry.objekte.forEach(function (subEntry) {
						if (subEntry.selected === 'true') {
							dreiklangEntries.push(subEntry.S_Objekt);
						}
					});
				});
			});

			return dreiklangEntries.join(', ');
		},
		linkedProducts: function linkedProducts() {
			var linkedProductsEntries = [];
			var branchKey = 'verwendete_produkte_objekte';

			if ((this.dataset.verwendete_produkte || {})[branchKey]) {
				var subLinkedProducts = this.dataset.verwendete_produkte[branchKey];
				subLinkedProducts.forEach(function (entry) {
					entry.objekte.forEach(function (subEntry) {
						if (subEntry.selected === 'true') {
							linkedProductsEntries.push(subEntry.S_Objekt);
						}
					});
				});
			}

			return linkedProductsEntries.join(', ');
		},
		sliderItems: function sliderItems() {
			var keyTextMap = {
				homeheadslide: {
					text: 'Heroslider',
					order: 1
				},
				homeheadslide_us: {
					text: 'Heroslider US',
					order: 2
				},
				homeprojectslide: {
					text: 'Projektslider',
					order: 3
				}
			};
			var keyTextMapKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(keyTextMap);

			var sliderItems = (this.dataset.gattungen || []).filter(function (gattung) {
				return keyTextMapKeys.includes(gattung.S_Kurzbezeichnung);
			});

			return sliderItems.map(function (option) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
					value: option.PKM_Gattung
				}, keyTextMap[option.S_Kurzbezeichnung]);
			}).sort(function (a, b) {
				return a.order - b.order;
			});
		},
		startpageOptions: function startpageOptions() {
			var _this7 = this;

			var items = this.sliderItems;

			var enrichedItems = items.map(function (item) {
				var genusIsSelected = _this7.basisgenusArr.some(function (currGenus) {
					return currGenus.id === item.value.toString();
				});

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
					checked: genusIsSelected,
					disabled: !genusIsSelected && _this7.basisgenusDestinationsAreFull
				});
			});

			return enrichedItems;
		},
		lightscoutClassificationOptions: function lightscoutClassificationOptions() {
			var _this8 = this;

			return __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].langs.map(function (lang) {
				var langEntry = {
					value: lang.key,
					text: lang.text
				};

				if (_this8.dataset && _this8.dataset.sprachen) {
					langEntry.checked = _this8.dataset.sprachen[lang.key] === 1;
				}
				return langEntry;
			});
		},
		visibilityOptions: function visibilityOptions() {
			return [{
				value: 'visibility',
				text: 'sichtbar',
				checked: this.dataset && this.dataset.B_Sichtbar === 'j'
			}];
		},
		synchblockOptions: function synchblockOptions() {
			return [{
				value: 'synchblock',
				text: 'gesperrt',
				checked: this.dataset && this.dataset.B_Synchblock === 'j'
			}];
		},
		dirtySelectedStatus: function dirtySelectedStatus() {
			var statiItem = this.$store.getters.statiKey[this.dirtySelectedStatusNum];
			return statiItem && statiItem.S_Status || '';
		},
		actionConfirmationModalState: function actionConfirmationModalState() {
			var entries = {
				gelöscht: {
					title: 'Objekt löschen',
					text: 'Soll das Objekt wirklich gelöscht werden?'
				},
				online: {
					title: 'Objekt online setzen',
					text: 'Soll das Objekt wirklich online gestellt werden? Die Veröffentlichung kann bis zu 10 Minuten dauern.'
				},
				default: {
					title: '',
					text: ''
				}
			};

			return entries[this.dirtySelectedStatus] || entries.default;
		},
		initialStatusNum: function initialStatusNum() {
			return parseInt(this.dataset.FKM_Status || 1, 10);
		},
		statusItems: function statusItems() {
			var statusItems = this.$store.getters.setupStati.map(function (status) {
				var variantsMap = {
					1: 'primary',
					2: 'success',
					4: 'danger' };

				var statusEntry = {
					value: parseInt(status.PKM_Status, 10),
					text: status.S_Status_Uppercase,
					variant: variantsMap[status.PKM_Status] || 'danger',
					changeInfo: __WEBPACK_IMPORTED_MODULE_5__helper_infoTextHelper__["a" /* default */].for('status.' + status.S_Status)
				};

				return statusEntry;
			});
			return statusItems;
		},
		status: function status() {
			return {
				selectedItemValue: this.dirtySelectedStatusNum || this.initialStatusNum,
				items: this.statusItems
			};
		},
		currentSelectedStatusItem: function currentSelectedStatusItem() {
			var selectedItemValue = this.status.selectedItemValue;
			var selectedItem = this.status.items.find(function (item) {
				return item.value === selectedItemValue;
			}) || {
				title: '',
				variant: ''
			};

			return selectedItem;
		},
		publishDateTime: function publishDateTime() {
			return this.dataset.TS_online_Liveserver;
		},
		isValidPublishDateTime: function isValidPublishDateTime() {
			var momentDate = __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.publishDateTime, __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].DATETIMEFORMAT);
			var notPlanedMomentDate = __WEBPACK_IMPORTED_MODULE_12_moment___default()(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].NOTPLANNEDDATE, __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].DATETIMEFORMAT);
			return momentDate.isValid() && momentDate.format(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].DATEFORMATDEST) !== notPlanedMomentDate.format(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].DATEFORMATDEST);
		},
		goOfflineDateTime: function goOfflineDateTime() {
			return this.dataset.TS_offline_Liveserver;
		},
		isValidGoOfflineDateTime: function isValidGoOfflineDateTime() {
			var momentDate = __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.goOfflineDateTime, __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].DATETIMEFORMAT);
			var notPlanedMomentDate = __WEBPACK_IMPORTED_MODULE_12_moment___default()(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].NOTPLANNEDDATE, __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].DATETIMEFORMAT);
			return momentDate.isValid() && momentDate.format(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].DATEFORMATDEST) !== notPlanedMomentDate.format(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].DATEFORMATDEST);
		},
		pkStatus: function pkStatus() {
			if (!this.dataset.pk_status) return [];
			var pkStatus = this.dataset.pk_status.reduce(function (data, item) {
				if (!data[item.S_Modus]) {
					data[item.S_Modus] = {
						items: [],
						order: parseInt(item.U_Reihenfolge, 10)
					};
				}

				data[item.S_Modus].items.push(item);
				return data;
			}, {});
			var tmp = [];
			__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(pkStatus).forEach(function (key) {
				var item = pkStatus[key];
				item.items = item.items.sort(function (a, b) {
					return parseInt(a.U_Reihenfolge, 10) - parseInt(b.U_Reihenfolge, 10);
				});
				tmp.push([key, item.items, item.order]);
			});
			tmp.sort(function (a, b) {
				return a[2] - b[2];
			});
			return tmp;
		}
	},

	methods: {
		infoTextFor: function infoTextFor(infoKey) {
			var replacements = infoKey in __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].max_chars && {
				maxChars: __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].max_chars[infoKey]
			} || {};

			return __WEBPACK_IMPORTED_MODULE_5__helper_infoTextHelper__["a" /* default */].for(infoKey, replacements);
		},
		getPkStatus: function getPkStatus(category) {
			return this.dataset['FKM_PK_Status_' + category];
		},
		getPkLabel: function getPkLabel(id) {
			var item = false;
			this.dataset.pk_status.forEach(function (value) {
				if (parseInt(value.PKM_Status, 10) === parseInt(id, 10)) {
					item = value;
				}
			});
			return item.S_Status;
		},
		formatTimestamp: function formatTimestamp(timestamp) {
			var mDate = __WEBPACK_IMPORTED_MODULE_12_moment___default()(timestamp, __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].DATETIMEFORMAT);

			var notPlanedMomentDate = __WEBPACK_IMPORTED_MODULE_12_moment___default()(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].NOTPLANNEDDATE, __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].DATETIMEFORMAT);

			if (mDate.isValid() && mDate.format(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].DATEFORMATDEST) === notPlanedMomentDate.format(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].DATEFORMATDEST)) {
				return 'Nicht geplant';
			}
			if (!mDate.isValid()) {
				return 'Bitte einen Zeitpunkt angeben...';
			}
			return mDate.format('lll');
		},
		handleStartpageChange: function handleStartpageChange(i, id, checked) {
			var genusChange = {};
			var strId = id.toString();

			if (checked) {
				var freeGenusDestinationIndex = this.basisgenusArr.findIndex(function (currGenus) {
					return currGenus.id === '0';
				});

				if (freeGenusDestinationIndex < 0) {
					return;
				}
				var index = freeGenusDestinationIndex > 0 ? freeGenusDestinationIndex + 1 : 0;
				var type = index === 0 ? 'basis' : 'trait';
				var foundGenus = this.dataset.gattungen.find(function (currGenus) {
					return currGenus.PKM_Gattung === id;
				});
				var value = foundGenus ? foundGenus.S_Gattung : '';

				genusChange[index] = {
					id: strId,
					type: type,
					value: value
				};
			} else {
				var foundDestinationIndex = this.basisgenusArr.findIndex(function (currGenus) {
					return currGenus.id === strId;
				});

				if (foundDestinationIndex < 0) {
					return;
				}
				var _index = foundDestinationIndex > 0 ? foundDestinationIndex + 1 : 0;
				var _type = _index === 0 ? 'basis' : 'trait';

				genusChange[_index] = {
					id: null,
					type: _type,
					value: null
				};
			}

			this.$store.dispatch('updateObjectSetupBasisGenus', genusChange);
		},
		handleLightscoutClassificationChange: function handleLightscoutClassificationChange(index, lang, checked) {
			var langData = {
				code: lang,
				value: checked ? 1 : 0
			};
			this.$store.dispatch('updateObjectSetupLightscoutClassification', langData);
		},
		handleVisibilityChange: function handleVisibilityChange(index, value, checked) {
			this.$store.dispatch('updateObjectSetupVisibility', checked);
		},
		handleSynchblockChange: function handleSynchblockChange(index, value, checked) {
			this.$store.dispatch('updateObjectSetupSynchblock', checked);
		},
		handleStatusClick: function handleStatusClick(item) {
			var _this9 = this;

			this.dirtySelectedStatusNum = item.value;

			if (item.value === this.initialStatusNum) {
				this.change = null;
				return;
			}

			var selectedItem = this.statusItems.find(function (statusItem) {
				return statusItem.value === _this9.dirtySelectedStatusNum;
			});

			if (selectedItem) {
				this.change = {
					info: selectedItem.changeInfo
				};
			} else {
				this.change = null;
			}
		},
		handlePkStatusClick: function handlePkStatusClick(item) {
			this.$store.dispatch('updateObjectSetupPkStatus', item).then(function (data) {
				if (item.B_Mailclient === 'j') {
					var body = encodeURIComponent(data.body.replace(/\\r\\n/g, '\r\n'));
					var subject = encodeURIComponent(data.subject);
					location.href = 'mailto:' + (data.empfaengeradresse || '') + '?subject=' + subject + '&body=' + body;
				}
			});
		},
		handlePublishDateTimeReset: function handlePublishDateTimeReset() {
			this.$store.dispatch('updateObjectSetupPublishDateTime', __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].CLEARDATE);
		},
		handleGoOfflineDateTimeReset: function handleGoOfflineDateTimeReset() {
			this.$store.dispatch('updateObjectSetupGoOfflineDateTime', __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].CLEARDATE);
		},
		handleAsideChangeWithPreCheck: function handleAsideChangeWithPreCheck() {
			var statusNum = this.dirtySelectedStatusNum.toString();

			var statiCheckNums = [this.$store.getters.statiAssoc.gelöscht, this.$store.getters.statiAssoc.online];

			if (statiCheckNums.includes(statusNum)) {
				this.$refs.actionConfirmation.show();
			} else {
				this.handleAsideChange();
			}
		},
		handleAsideChange: function handleAsideChange() {
			var _this10 = this;

			var statusNum = this.dirtySelectedStatusNum.toString();

			if (statusNum !== this.initialStatusNum) {
				this.$store.dispatch('updateObjectSetupStatus', { status: statusNum }).then(function () {
					_this10.change = null;

					if (statusNum === _this10.$store.getters.statiAssoc.gelöscht) {
						_this10.$router.push({ path: '/dashboard' });
					}

					if (_this10.initialStatusNum === _this10.$store.getters.statiAssoc.online && statusNum === _this10.$store.getters.statiAssoc.entwurf) {
						_this10.$store.dispatch('updateObjectSetupPublishDateTime', __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].CLEARDATE);
					}
				}).catch(function () {});
			}
		},
		handleAsideCancel: function handleAsideCancel() {
			this.dirtySelectedStatusNum = null;
			this.change = null;
		},
		openSidebarFor: function openSidebarFor(view) {
			var actionFunction = sidebarInputActions[view];

			if (!actionFunction) {
				return;
			}

			var sidebarData = actionFunction.call(this);

			this.$store.dispatch('updateSidebar', sidebarData);
		},
		isSidebarFocused: function isSidebarFocused(key) {
			var sidebarStore = this.$store.state.sidebar;
			return sidebarStore.visible && sidebarStore.key === key;
		},
		triggerIDTextRTFExport: function triggerIDTextRTFExport() {
			var _this11 = this;

			this.$store.dispatch('triggerIdTextRTFExport').then(function (data) {
				var blob = new Blob([data], { type: 'application/rtf;charset=utf-8' });
				FileSaver.saveAs(blob, 'ID-Text-Translation-' + _this11.objectid + '.rtf');
			}).catch(function () {});
		}
	},

	components: {
		ErcoTooltip: __WEBPACK_IMPORTED_MODULE_7__components_molecules_ErcoTooltip___default.a,
		ErcoStatusBadge: __WEBPACK_IMPORTED_MODULE_8__components_atoms_ErcoStatusBadge___default.a,
		ErcoTextInput: __WEBPACK_IMPORTED_MODULE_9__components_molecules_ErcoTextInput___default.a,
		ErcoRadioGroup: __WEBPACK_IMPORTED_MODULE_10__components_molecules_ErcoRadioGroup___default.a,
		ErcoCheckboxGroup: __WEBPACK_IMPORTED_MODULE_11__components_molecules_ErcoCheckboxGroup___default.a
	}
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_throttle__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_spinner__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_molecules_ErcoSidebar_Basisgenus__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_molecules_ErcoSidebar_Basisgenus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_molecules_ErcoSidebar_Basisgenus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_molecules_ErcoSidebar_DateTimePicker__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_molecules_ErcoSidebar_DateTimePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_molecules_ErcoSidebar_DateTimePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_molecules_ErcoSidebar_TextInput__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_molecules_ErcoSidebar_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_molecules_ErcoSidebar_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_molecules_ErcoSidebar_TabbedTextInput__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_molecules_ErcoSidebar_TabbedTextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_molecules_ErcoSidebar_TabbedTextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_molecules_ErcoSidebar_Triad__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_molecules_ErcoSidebar_Triad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_molecules_ErcoSidebar_Triad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_molecules_ErcoSidebar_LinkedProducts__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_molecules_ErcoSidebar_LinkedProducts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_molecules_ErcoSidebar_LinkedProducts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_molecules_ErcoSidebar_Tags__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_molecules_ErcoSidebar_Tags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_molecules_ErcoSidebar_Tags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_molecules_ErcoSidebar_ImageLoader__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_molecules_ErcoSidebar_ImageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_molecules_ErcoSidebar_ImageLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_molecules_ErcoSidebar_Dropdown__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_molecules_ErcoSidebar_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_molecules_ErcoSidebar_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_molecules_ErcoSidebar_ImageEditor__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_molecules_ErcoSidebar_ImageEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_molecules_ErcoSidebar_ImageEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_molecules_ErcoSidebar_SiteEditor__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_molecules_ErcoSidebar_SiteEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_molecules_ErcoSidebar_SiteEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_molecules_ErcoSidebar_TemplateSelection__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_molecules_ErcoSidebar_TemplateSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_molecules_ErcoSidebar_TemplateSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_molecules_ErcoSidebar_LastChanges__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_molecules_ErcoSidebar_LastChanges___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_molecules_ErcoSidebar_LastChanges__);






















var headerMenuHeight = 113;

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoSidebarOrganism',

	props: {
		sidebar: {
			type: Object,
			required: true
		}
	},

	data: function data() {
		return {
			applying: false,
			applyError: false,
			throttledScrollListener: null
		};
	},


	computed: {
		sidebarClasses: function sidebarClasses() {
			var classes = {
				'container-fluid': true,
				'sidebar-wrapper': true,
				'-fixed': this.sidebar.fixed
			};

			classes[this.sidebar.view] = true;
			return classes;
		},
		sidebarStyle: function sidebarStyle() {
			var _this = this;

			var styleAttrValue = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.sidebar.styles).filter(function (cssProp) {
				return _this.sidebar.styles[cssProp];
			}).map(function (cssProp) {
				var fixedCssProp = cssProp;
				var cssPropParts = cssProp.match(/([A-Za-z][a-z]*)/g);
				if (cssPropParts) {
					fixedCssProp = cssPropParts.map(function (part) {
						return part.toLowerCase();
					}).join('-');
				}
				var cssPropValue = _this.sidebar.styles[cssProp];
				return fixedCssProp + ': ' + cssPropValue + ';';
			});

			return styleAttrValue.join(' ');
		},
		applyButton: function applyButton() {
			var buttonData = {
				variant: 'success',
				text: 'Bestätigen',
				applied: false
			};

			if (this.applyError) {
				buttonData = {
					variant: 'primary',
					text: 'Wiederholen',
					applied: false
				};
			} else if (this.$store.state.sidebar.applied) {
				buttonData = {
					variant: '',
					text: 'Schließen',
					applied: true
				};
			}

			return buttonData;
		},
		resetButton: function resetButton() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$store.state.sidebar.resetButton);
		}
	},

	created: function created() {
		window.removeEventListener('scroll', this.throttledScrollListener);
		this.throttledScrollListener = __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default()(this.handleScroll.bind(this), 15);
		window.addEventListener('scroll', this.throttledScrollListener);
	},
	mounted: function mounted() {
		this.$el.style.transform = null;
		this.repositionSidebar();
	},
	beforeDestroy: function beforeDestroy() {
		window.removeEventListener('scroll', this.throttledScrollListener);
	},


	methods: {
		applyChanges: function applyChanges() {
			var _this2 = this;

			if (this.$store.state.sidebar.applied) {
				this.closeSidebar();
				return;
			}

			if (this.$refs.component && this.$refs.component.handleApply) {
				this.$refs.component.handleApply();
			}

			var actionName = this.$store.state.sidebar.context.dispatchActionName;
			var value = this.$store.state.sidebar.context.value;

			this.applying = true;

			this.$store.dispatch(actionName, value).then(function () {
				if (_this2.sidebar.closeOnSave) {
					_this2.closeSidebar();
				}

				if (_this2.$store.state.sidebar.revert === true) _this2.$store.dispatch('revertSidebar');else _this2.$store.dispatch('updateSidebar', { applied: true });

				_this2.applying = false;
				_this2.applyError = false;
			}).catch(function () {
				_this2.applying = false;
				_this2.applyError = true;
			});
		},
		closeSidebar: function closeSidebar() {
			this.$store.dispatch('resetSidebar');
		},
		triggerReset: function triggerReset() {
			if (this.$refs.component && this.$refs.component.triggerReset) {
				this.$refs.component.triggerReset();
			}
		},
		handleScroll: function handleScroll() {
			this.repositionSidebar();
		},
		repositionSidebar: function repositionSidebar() {
			if (!this.sidebar.fixed) {
				return;
			}

			var el = document.body.parentElement.scrollTop ? document.body.parentElement : document.body;
			if (el.scrollTop < headerMenuHeight) {
				var diff = headerMenuHeight - el.scrollTop;
				this.$el.style.height = 'calc(100% - ' + diff + 'px)';
				this.$el.style.transform = 'translateY(' + diff + 'px)';
			} else {
				this.$el.style.height = null;
				this.$el.style.transform = null;
			}
		}
	},

	components: {
		Stretch: __WEBPACK_IMPORTED_MODULE_3_vue_loading_spinner__["b" /* Stretch */],

		ErcoSidebarBasisgenus: __WEBPACK_IMPORTED_MODULE_4__components_molecules_ErcoSidebar_Basisgenus___default.a,
		ErcoSidebarDateTimePicker: __WEBPACK_IMPORTED_MODULE_5__components_molecules_ErcoSidebar_DateTimePicker___default.a,
		ErcoSidebarTextInput: __WEBPACK_IMPORTED_MODULE_6__components_molecules_ErcoSidebar_TextInput___default.a,
		ErcoSidebarTabbedTextInput: __WEBPACK_IMPORTED_MODULE_7__components_molecules_ErcoSidebar_TabbedTextInput___default.a,
		ErcoSidebarTriad: __WEBPACK_IMPORTED_MODULE_8__components_molecules_ErcoSidebar_Triad___default.a,
		ErcoSidebarLinkedProducts: __WEBPACK_IMPORTED_MODULE_9__components_molecules_ErcoSidebar_LinkedProducts___default.a,
		ErcoSidebarTags: __WEBPACK_IMPORTED_MODULE_10__components_molecules_ErcoSidebar_Tags___default.a,
		ErcoSidebarImageLoader: __WEBPACK_IMPORTED_MODULE_11__components_molecules_ErcoSidebar_ImageLoader___default.a,
		ErcoSidebarDropdown: __WEBPACK_IMPORTED_MODULE_12__components_molecules_ErcoSidebar_Dropdown___default.a,
		ErcoSidebarImageEditor: __WEBPACK_IMPORTED_MODULE_13__components_molecules_ErcoSidebar_ImageEditor___default.a,
		ErcoSidebarSiteEditor: __WEBPACK_IMPORTED_MODULE_14__components_molecules_ErcoSidebar_SiteEditor___default.a,
		ErcoSidebarTemplateSelection: __WEBPACK_IMPORTED_MODULE_15__components_molecules_ErcoSidebar_TemplateSelection___default.a,
		ErcoSidebarLastChanges: __WEBPACK_IMPORTED_MODULE_16__components_molecules_ErcoSidebar_LastChanges___default.a
	}
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_atoms_ErcoTextArea__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_atoms_ErcoTextArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_atoms_ErcoTextArea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoTextInput__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoTextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoTextInput__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoTextEditorOrganism',
	data: function data() {
		return {
			currentContentIndex: 0
		};
	},

	props: {
		contents: {
			type: Object,
			required: true,
			default: function _default() {
				return [{ language: 'DE', text: 'Das ist ein Text' }];
			}
		},
		headline: {
			type: String,
			required: true,
			default: 'headline'
		},
		ismultiline: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		changeContent: function changeContent() {
			var element = event.currentTarget;
			this.currentContentIndex = parseInt(element.getAttribute('data-item-index'), 10);
		},
		getClassObject: function getClassObject(index) {
			return {
				active: index === this.currentContentIndex
			};
		}
	},
	components: {
		ErcoTextArea: __WEBPACK_IMPORTED_MODULE_0__components_atoms_ErcoTextArea___default.a,
		ErcoTextInput: __WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoTextInput___default.a
	}
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_organisms_ErcoDashboardHeadbar__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_organisms_ErcoDashboardHeadbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_organisms_ErcoDashboardHeadbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_organisms_ErcoEditbar__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_organisms_ErcoEditbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_organisms_ErcoEditbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoStatusbar__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoStatusbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoStatusbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_organisms_ErcoObjectCardOverview__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_organisms_ErcoObjectCardOverview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_organisms_ErcoObjectCardOverview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_molecules_ErcoCloak__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_molecules_ErcoCloak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_molecules_ErcoCloak__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fuse_js__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fuse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_fuse_js__);










var searchOptions = {
	shouldSort: true,
	threshold: 0,
	location: 0,
	distance: 0,
	minMatchCharLength: 1,
	tokenize: true,
	matchAllTokens: true,
	keys: ['S_de_Objekt', 'S_Bereich', 'S_Gattung', 'S_Spezifikation', 'PKM_Objekt', 'S_Zusatz', 'PKM_PDB', 'FKM_PKM_PDB']
};

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoDashboardPage',
	data: function data() {
		return {
			visibleItemsNum: 12,
			visibleItemsNumStep: 12
		};
	},
	created: function created() {
		var _this = this;

		[this.$store.dispatch('initDashboard'), this.$store.dispatch('getCMSStructure'), this.$store.dispatch('getStatiList')].forEach(function (dispatchAction) {
			dispatchAction.then(function () {
				_this.resetAccessErrorStatusCode();
			}).catch(function () {});
		});
	},
	mounted: function mounted() {
		document.title = 'Dashboard - Light Scout Publisher';
	},


	computed: {
		token: function token() {
			return this.$store.state.user.token;
		},
		loading: function loading() {
			return this.$store.state.dashboard.loadingObjectData;
		},
		inProcess: function inProcess() {
			var actionInProcess = this.$store.state.dashboard.actionInProcess;

			return this.loading || actionInProcess;
		},
		itemFilters: function itemFilters() {
			return this.$store.state.dashboard.activeFilters;
		},
		itemFiltersActive: function itemFiltersActive() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.itemFilters).length > 0;
		},
		searchString: function searchString() {
			return this.$store.state.dashboard.searchString.trim();
		},
		filteredItems: function filteredItems() {
			var _this2 = this;

			var filteredItems = this.items;

			if (!filteredItems) {
				return [];
			}

			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.itemFilters).forEach(function (key) {
				var filter = _this2.itemFilters[key];
				filteredItems = filteredItems.filter(filter.filterFunc);
			});

			filteredItems = filteredItems.filter(function (item) {
				return item.FKM_Status !== _this2.$store.getters.statiAssoc.gelöscht;
			});

			if (this.searchString === '') {
				return filteredItems;
			}

			var fuse = new __WEBPACK_IMPORTED_MODULE_6_fuse_js___default.a(filteredItems, searchOptions);
			return fuse.search(this.searchString);
		},
		notFreshlyCopiedItems: function notFreshlyCopiedItems() {
			return this.filteredItems.filter(function (item) {
				return !item.isFreshlyCopied;
			});
		},
		freshlyCopiedItems: function freshlyCopiedItems() {
			return this.filteredItems.filter(function (item) {
				return item.isFreshlyCopied;
			});
		},
		items: function items() {
			return this.$store.state.dashboard.objectData;
		},
		disabledItemRestriction: function disabledItemRestriction() {
			var searchString = this.$store.state.dashboard.searchString.trim();
			return !(searchString === '');
		},
		moreItemsAvailable: function moreItemsAvailable() {
			return this.filteredItems.length > this.visibleItemsNum;
		}
	},
	methods: {
		handleItemFetch: function handleItemFetch() {
			this.visibleItemsNum += this.visibleItemsNumStep;
		},
		resetAccessErrorStatusCode: function resetAccessErrorStatusCode() {
			this.$store.dispatch('setAccessErrorStatusCode', -1);
		}
	},
	watch: {},
	components: {
		ErcoDashboardHeadbar: __WEBPACK_IMPORTED_MODULE_1__components_organisms_ErcoDashboardHeadbar___default.a,
		ErcoEditbar: __WEBPACK_IMPORTED_MODULE_2__components_organisms_ErcoEditbar___default.a,
		ErcoStatusbar: __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoStatusbar___default.a,
		ErcoObjectCardOverview: __WEBPACK_IMPORTED_MODULE_4__components_organisms_ErcoObjectCardOverview___default.a,
		ErcoCloak: __WEBPACK_IMPORTED_MODULE_5__components_molecules_ErcoCloak___default.a
	}
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoCloak__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoCloak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoCloak__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoLiveViewHeader__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoLiveViewHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoLiveViewHeader__);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoLiveViewPage',

	created: function created() {
		var _this = this;

		var objectId = parseInt(this.$route.params.objectId, 10);
		this.processView = this.$route.params.processview || this.processView;

		this.$store.dispatch('getObjectSetup', { id: objectId, lang: this.lang }).then(function () {
			_this.$store.dispatch('setAccessErrorStatusCode', -1);
			var title = _this.objectDataset['S_' + _this.lang + '_Objekt'];
			document.title = objectId + ' - ' + title;
		}).catch(function () {});
	},
	data: function data() {
		return {
			lang: 'de',
			processView: '',
			isUpdatingStatus: false
		};
	},


	computed: {
		objectDataset: function objectDataset() {
			return this.$store.state.objectsetup.current;
		},
		objectIsLoading: function objectIsLoading() {
			return this.$store.state.objectsetup.loading;
		},
		objectName: function objectName() {
			if (!this.objectDataset) {
				return '';
			}

			var lang = this.objectDataset.sprache || this.lang;
			var name = this.objectDataset['S_' + lang + '_Objekt'];

			return name;
		},
		objectId: function objectId() {
			return this.objectDataset.PKM_Objekt || '';
		},
		processState: function processState() {
			var processViews = {
				unknown: {
					name: '(unbekannter Modus)'
				},
				redaktionellefreigabe: {
					name: 'Red. Freigabe'
				},
				uebersetzung: {
					name: 'Übersetzung'
				},
				endfreigabe: {
					name: 'End-Freigabe'
				},
				technischefreigabe: {
					name: 'Techn. Freigabe'
				},
				linkspruefen: {
					name: 'Links geprüft'
				},
				fremdsprachenpruefen: {
					name: 'Fremdsprachen geprüft'
				}
			};

			var selectedProcessView = processViews[this.processView] && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ id: this.processView
			}, processViews[this.processView], {
				items: this.pkStatusProcessItemsDropdownItems,
				currentProcessStatusItem: this.currentProcessStatusItem }) || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ id: '' }, processViews.unknown, { items: [], currentProcessStatusItem: null });

			return selectedProcessView;
		},
		objectUrl: function objectUrl() {
			var serverUrl = "https://www.stage.qa.erco.com";
			return this.objectDataset.S_URL_Objekt ? __WEBPACK_IMPORTED_MODULE_1_url___default.a.resolve(serverUrl, this.objectDataset.S_URL_Objekt) : '';
		},
		currentProcessStatusItem: function currentProcessStatusItem() {
			var currentProcessStatusId = this.objectDataset['FKM_PK_Status_' + this.processView];
			var currentProcessStatusItem = this.pkStatusProcessItems.find(function (item) {
				return item.PKM_Status === currentProcessStatusId;
			});

			return currentProcessStatusItem;
		},
		pkStatusProcessItems: function pkStatusProcessItems() {
			if (!this.objectDataset.pk_status) {
				return [];
			}

			var pkStatusProcessItemGroups = this.objectDataset.pk_status.reduce(function (data, item) {
				if (!data[item.S_Modus]) {
					data[item.S_Modus] = [];
				}

				data[item.S_Modus].push(item);
				return data;
			}, {});

			return pkStatusProcessItemGroups[this.processView];
		},
		pkStatusProcessItemsDropdownItems: function pkStatusProcessItemsDropdownItems() {
			var ret = this.pkStatusProcessItems.map(function (item) {
				return {
					value: item.PKM_Status,
					text: item.S_Status_Aktion
				};
			});

			return ret;
		}
	},

	methods: {
		handleActionChange: function handleActionChange(key) {
			var _this2 = this;

			var item = this.pkStatusProcessItems.find(function (currItem) {
				return currItem.PKM_Status === key;
			});

			if (!item) {
				return;
			}

			this.isUpdatingStatus = true;

			this.$store.dispatch('updateObjectSetupPkStatus', item).then(function (data) {
				_this2.isUpdatingStatus = false;

				if (item.B_Mailclient === 'j') {
					var body = encodeURIComponent(data.body.replace(/\\r\\n/g, '\r\n'));
					var subject = encodeURIComponent(data.subject);
					location.href = 'mailto:' + (data.empfaengeradresse || '') + '?subject=' + subject + '&body=' + body;
				}
			});
		}
	},

	components: {
		ErcoCloak: __WEBPACK_IMPORTED_MODULE_2__components_molecules_ErcoCloak___default.a,
		'erco-header': __WEBPACK_IMPORTED_MODULE_3__components_molecules_ErcoLiveViewHeader___default.a
	}
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_spinner__ = __webpack_require__(57);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoLoginPage',
	data: function data() {
		return {
			credentials: {
				username: '',
				password: ''
			},
			loggingIn: false,
			error: ''
		};
	},

	computed: {
		token: function token() {
			return this.$store.state.user.token;
		},
		accessErrorStatusCode: function accessErrorStatusCode() {
			return this.$store.state.global.accessErrorStatusCode;
		}
	},
	methods: {
		submit: function submit() {
			var _this = this;

			this.loggingIn = true;

			var credentialsMissing = [];
			var credentialsSet = {
				username: 'Benutzer',
				password: 'Passwort'
			};

			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(credentialsSet).forEach(function (credKey) {
				if (_this.credentials[credKey].trim().length === 0) {
					credentialsMissing.push(credentialsSet[credKey]);
				}
			});

			if (credentialsMissing.length > 0) {
				this.error = 'Es ' + (credentialsMissing.length > 1 ? 'müssen' : 'muss') + ' ein ' + credentialsMissing.join(' und ') + ' angegeben werden!';
				this.loggingIn = false;
			}

			this.$store.dispatch('login', this.credentials).catch(function (response) {
				_this.$store.dispatch('setAccessErrorStatusCode', response.status);
				_this.loggingIn = false;
			});
		},
		getErrorMsg: function getErrorMsg(statusCode) {
			switch (statusCode) {
				case 200:
				case -1:
					return '';
				case 0:
					return 'Server ist nicht erreichbar';
				case 401:
					return 'Nicht autorisiert';
				case 403:
					return 'Unbekannter Benutzer / Passwort';
				default:
					return 'Unbekanntes Problem';
			}
		}
	},
	mounted: function mounted() {
		document.title = 'Login - Light Scout Publisher';
		this.$refs.username.focus();
		this.error = this.getErrorMsg(this.accessErrorStatusCode);
	},

	watch: {
		token: function token() {
			if (!this.$route.query.redirect) {
				this.$router.push('dashboard');
			} else {
				this.$router.push(this.$route.query.redirect);
			}
		},
		accessErrorStatusCode: function accessErrorStatusCode(newAccessErrorStatusCode) {
			this.error = this.getErrorMsg(newAccessErrorStatusCode);
		}
	},
	components: {
		Stretch: __WEBPACK_IMPORTED_MODULE_1_vue_loading_spinner__["b" /* Stretch */]
	}
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	mounted: function mounted() {
		this.$store.dispatch('logout');
		this.$router.push('login');
	}
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoCloak__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoCloak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoCloak__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoHeader__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_organisms_ErcoMain__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_organisms_ErcoMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_organisms_ErcoMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_atoms_ErcoMenu__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_atoms_ErcoMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_atoms_ErcoMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_organisms_ErcoObjectView_Setup__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_organisms_ErcoObjectView_Setup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_organisms_ErcoObjectView_Setup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_organisms_ErcoObjectView_ObjectData__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_organisms_ErcoObjectView_ObjectData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_organisms_ErcoObjectView_ObjectData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_organisms_ErcoObjectView_Seo__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_organisms_ErcoObjectView_Seo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_organisms_ErcoObjectView_Seo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_organisms_ErcoObjectView_Assets__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_organisms_ErcoObjectView_Assets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_organisms_ErcoObjectView_Assets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_organisms_ErcoObjectView_Layout__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_organisms_ErcoObjectView_Layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_organisms_ErcoObjectView_Layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_organisms_ErcoSidebar__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_organisms_ErcoSidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_organisms_ErcoSidebar__);
















/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ErcoObjectViewPage',

	created: function created() {
		var cookie = window.document.cookie.split(';').reduce(function (acc, pair) {
			var splitPair = pair.trim().split('=');
			acc[splitPair[0]] = splitPair[1];
			return acc;
		}, {});

		var defaultLang = 'de';
		var paramLang = this.$route.query.lang;
		var cookieLang = cookie.lang;
		var userLang = this.objectLanguage || paramLang || cookieLang || defaultLang;

		this.$store.dispatch('setObjectLanguage', userLang);
		this.$store.dispatch('resetObjectSites');
		this.$store.dispatch('getStatiList');
		this.init();
	},
	data: function data() {
		return {
			subviews: [{
				name: 'setup',
				title: 'Setup',
				active: false
			}, {
				name: 'object-data',
				title: 'Objektdaten',
				active: false
			}, {
				name: 'seo',
				title: 'Seo',
				active: false
			}, {
				name: 'assets',
				title: 'Assets',
				active: false
			}, {
				name: 'layout',
				title: 'Layout',
				active: false
			}],

			view: 'setup'
		};
	},


	computed: {
		objectDataset: function objectDataset() {
			return this.$store.state.objectsetup.current;
		},
		objectId: function objectId() {
			return this.objectDataset.PKM_Objekt;
		},
		objectLanguage: function objectLanguage() {
			return this.$store.state.objectsetup.language;
		},
		objectLoading: function objectLoading() {
			return this.$store.state.objectsetup.loading;
		},
		objectName: function objectName() {
			return this.objectDataset['S_' + this.objectLanguage + '_Objekt'] || '';
		},
		breadcrumb: function breadcrumb() {
			var category = this.objectDataset.S_Bereich;
			var genus = this.objectDataset.S_Gattung;

			return typeof category === 'string' && typeof genus === 'string' ? [category, genus] : [];
		},
		objectPreviewUrl: function objectPreviewUrl() {
			return this.$store.getters.visitableObjectPreviewUrl;
		},
		objectStatus: function objectStatus() {
			return this.objectDataset.FKM_Status || -1;
		},
		objectStatusWaiting: function objectStatusWaiting() {
			return this.$store.state.objectsetup.statusWaiting;
		},
		objectIsProductive: function objectIsProductive() {
			return this.$store.getters.objectIsProductive;
		},
		stati: function stati() {
			return this.$store.getters.statiAssoc;
		},
		loading: function loading() {
			return this.objectLoading || this.objectStatusWaiting || ['object-data', 'seo', 'assets'].includes(this.view) && this.$store.state.objectsites.objectdata.loading || this.view === 'layout' && this.$store.state.objectsites.sites.length === 0 && !this.$store.state.objectsites.sitesFinishedLoading;
		},
		sidebar: function sidebar() {
			return this.$store.state.sidebar;
		}
	},

	methods: {
		init: function init() {
			var _this = this;

			var objectId = parseInt(this.$route.params.objectId, 10);

			var lang = this.objectLanguage;

			this.$store.dispatch('getObjectSetupWithSites', { id: objectId, lang: lang }).then(function () {
				_this.$store.dispatch('setAccessErrorStatusCode', -1);
				var title = _this.objectDataset['S_' + lang + '_Objekt'];
				document.title = objectId + ' - ' + title;
			}).catch(function () {});

			if (this.$route.params.view) {
				var view = this.$route.params.view;
				var viewExists = this.subviews.filter(function (subview) {
					return subview.name === view;
				}).length > 0;

				if (viewExists) {
					this.view = view;
				}
			} else {
				var path = this.$route.path.replace(/\/$/, '');

				var defaultRoutePath = path + '/' + this.view;
				this.$router.replace(defaultRoutePath);
			}

			this.jumpTo(this.view);
		},
		jumpTo: function jumpTo(view) {
			this.closeSidebar();

			this.view = view;
			this.$router.replace(view);

			this.subviews.forEach(function (subview) {
				subview.active = subview.name === view;
			});
		},
		closeSidebar: function closeSidebar() {
			this.$store.dispatch('resetSidebar');
		}
	},

	watch: {
		objectLanguage: function objectLanguage(newLang, oldLang) {
			if (oldLang === '') {
				return;
			}
			this.init();
		}
	},

	beforeRouteEnter: function beforeRouteEnter(to, from, next) {
		if (from.path === '/dashboard') {
			var scrollEl = document.scrollingElement;
			scrollEl.scrollTop = 0;
		}

		next();
	},


	components: {
		ErcoCloak: __WEBPACK_IMPORTED_MODULE_0__components_molecules_ErcoCloak___default.a,

		ErcoHeader: __WEBPACK_IMPORTED_MODULE_1__components_molecules_ErcoHeader___default.a,
		ErcoMenu: __WEBPACK_IMPORTED_MODULE_3__components_atoms_ErcoMenu___default.a,
		ErcoMain: __WEBPACK_IMPORTED_MODULE_2__components_organisms_ErcoMain___default.a,

		Setup: __WEBPACK_IMPORTED_MODULE_4__components_organisms_ErcoObjectView_Setup___default.a,
		ObjectData: __WEBPACK_IMPORTED_MODULE_5__components_organisms_ErcoObjectView_ObjectData___default.a,
		Seo: __WEBPACK_IMPORTED_MODULE_6__components_organisms_ErcoObjectView_Seo___default.a,
		Assets: __WEBPACK_IMPORTED_MODULE_7__components_organisms_ErcoObjectView_Assets___default.a,
		Layout: __WEBPACK_IMPORTED_MODULE_8__components_organisms_ErcoObjectView_Layout___default.a,

		ErcoSidebar: __WEBPACK_IMPORTED_MODULE_9__components_organisms_ErcoSidebar___default.a
	}
});

/***/ }),
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 436 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 82,
	"./af.js": 82,
	"./ar": 89,
	"./ar-dz": 83,
	"./ar-dz.js": 83,
	"./ar-kw": 84,
	"./ar-kw.js": 84,
	"./ar-ly": 85,
	"./ar-ly.js": 85,
	"./ar-ma": 86,
	"./ar-ma.js": 86,
	"./ar-sa": 87,
	"./ar-sa.js": 87,
	"./ar-tn": 88,
	"./ar-tn.js": 88,
	"./ar.js": 89,
	"./az": 90,
	"./az.js": 90,
	"./be": 91,
	"./be.js": 91,
	"./bg": 92,
	"./bg.js": 92,
	"./bn": 93,
	"./bn.js": 93,
	"./bo": 94,
	"./bo.js": 94,
	"./br": 95,
	"./br.js": 95,
	"./bs": 96,
	"./bs.js": 96,
	"./ca": 97,
	"./ca.js": 97,
	"./cs": 98,
	"./cs.js": 98,
	"./cv": 99,
	"./cv.js": 99,
	"./cy": 100,
	"./cy.js": 100,
	"./da": 101,
	"./da.js": 101,
	"./de": 104,
	"./de-at": 102,
	"./de-at.js": 102,
	"./de-ch": 103,
	"./de-ch.js": 103,
	"./de.js": 104,
	"./dv": 105,
	"./dv.js": 105,
	"./el": 106,
	"./el.js": 106,
	"./en-au": 107,
	"./en-au.js": 107,
	"./en-ca": 108,
	"./en-ca.js": 108,
	"./en-gb": 109,
	"./en-gb.js": 109,
	"./en-ie": 110,
	"./en-ie.js": 110,
	"./en-nz": 111,
	"./en-nz.js": 111,
	"./eo": 112,
	"./eo.js": 112,
	"./es": 114,
	"./es-do": 113,
	"./es-do.js": 113,
	"./es.js": 114,
	"./et": 115,
	"./et.js": 115,
	"./eu": 116,
	"./eu.js": 116,
	"./fa": 117,
	"./fa.js": 117,
	"./fi": 118,
	"./fi.js": 118,
	"./fo": 119,
	"./fo.js": 119,
	"./fr": 122,
	"./fr-ca": 120,
	"./fr-ca.js": 120,
	"./fr-ch": 121,
	"./fr-ch.js": 121,
	"./fr.js": 122,
	"./fy": 123,
	"./fy.js": 123,
	"./gd": 124,
	"./gd.js": 124,
	"./gl": 125,
	"./gl.js": 125,
	"./gom-latn": 126,
	"./gom-latn.js": 126,
	"./he": 127,
	"./he.js": 127,
	"./hi": 128,
	"./hi.js": 128,
	"./hr": 129,
	"./hr.js": 129,
	"./hu": 130,
	"./hu.js": 130,
	"./hy-am": 131,
	"./hy-am.js": 131,
	"./id": 132,
	"./id.js": 132,
	"./is": 133,
	"./is.js": 133,
	"./it": 134,
	"./it.js": 134,
	"./ja": 135,
	"./ja.js": 135,
	"./jv": 136,
	"./jv.js": 136,
	"./ka": 137,
	"./ka.js": 137,
	"./kk": 138,
	"./kk.js": 138,
	"./km": 139,
	"./km.js": 139,
	"./kn": 140,
	"./kn.js": 140,
	"./ko": 141,
	"./ko.js": 141,
	"./ky": 142,
	"./ky.js": 142,
	"./lb": 143,
	"./lb.js": 143,
	"./lo": 144,
	"./lo.js": 144,
	"./lt": 145,
	"./lt.js": 145,
	"./lv": 146,
	"./lv.js": 146,
	"./me": 147,
	"./me.js": 147,
	"./mi": 148,
	"./mi.js": 148,
	"./mk": 149,
	"./mk.js": 149,
	"./ml": 150,
	"./ml.js": 150,
	"./mr": 151,
	"./mr.js": 151,
	"./ms": 153,
	"./ms-my": 152,
	"./ms-my.js": 152,
	"./ms.js": 153,
	"./my": 154,
	"./my.js": 154,
	"./nb": 155,
	"./nb.js": 155,
	"./ne": 156,
	"./ne.js": 156,
	"./nl": 158,
	"./nl-be": 157,
	"./nl-be.js": 157,
	"./nl.js": 158,
	"./nn": 159,
	"./nn.js": 159,
	"./pa-in": 160,
	"./pa-in.js": 160,
	"./pl": 161,
	"./pl.js": 161,
	"./pt": 163,
	"./pt-br": 162,
	"./pt-br.js": 162,
	"./pt.js": 163,
	"./ro": 164,
	"./ro.js": 164,
	"./ru": 165,
	"./ru.js": 165,
	"./sd": 166,
	"./sd.js": 166,
	"./se": 167,
	"./se.js": 167,
	"./si": 168,
	"./si.js": 168,
	"./sk": 169,
	"./sk.js": 169,
	"./sl": 170,
	"./sl.js": 170,
	"./sq": 171,
	"./sq.js": 171,
	"./sr": 173,
	"./sr-cyrl": 172,
	"./sr-cyrl.js": 172,
	"./sr.js": 173,
	"./ss": 174,
	"./ss.js": 174,
	"./sv": 175,
	"./sv.js": 175,
	"./sw": 176,
	"./sw.js": 176,
	"./ta": 177,
	"./ta.js": 177,
	"./te": 178,
	"./te.js": 178,
	"./tet": 179,
	"./tet.js": 179,
	"./th": 180,
	"./th.js": 180,
	"./tl-ph": 181,
	"./tl-ph.js": 181,
	"./tlh": 182,
	"./tlh.js": 182,
	"./tr": 183,
	"./tr.js": 183,
	"./tzl": 184,
	"./tzl.js": 184,
	"./tzm": 186,
	"./tzm-latn": 185,
	"./tzm-latn.js": 185,
	"./tzm.js": 186,
	"./uk": 187,
	"./uk.js": 187,
	"./ur": 188,
	"./ur.js": 188,
	"./uz": 190,
	"./uz-latn": 189,
	"./uz-latn.js": 189,
	"./uz.js": 190,
	"./vi": 191,
	"./vi.js": 191,
	"./x-pseudo": 192,
	"./x-pseudo.js": 192,
	"./yo": 193,
	"./yo.js": 193,
	"./zh-cn": 194,
	"./zh-cn.js": 194,
	"./zh-hk": 195,
	"./zh-hk.js": 195,
	"./zh-tw": 196,
	"./zh-tw.js": 196
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 469;

/***/ }),
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHN0eWxlPSJmaWxsOm5vbmU7Ii8+PHBhdGggZD0iTTE5LDNsLTQuMTgsMGMtMC40MiwtMS4xNiAtMS41MiwtMiAtMi44MiwtMmMtMS4zLDAgLTIuNCwwLjg0IC0yLjgyLDJsLTQuMTgsMGMtMS4xLDAgLTIsMC45IC0yLDJsMCwxNGMwLDEuMSAwLjksMiAyLDJsMTQsMGMxLjEsMCAyLC0wLjkgMiwtMmwwLC0xNGMwLC0xLjEgLTAuOSwtMiAtMiwtMlptLTcsMGMwLjU1LDAgMSwwLjQ1IDEsMWMwLDAuNTUgLTAuNDUsMSAtMSwxYy0wLjU1LDAgLTEsLTAuNDUgLTEsLTFjMCwtMC41NSAwLjQ1LC0xIDEsLTFabTAsNGMxLjY2LDAgMywxLjM0IDMsM2MwLDEuNjYgLTEuMzQsMyAtMywzYy0xLjY2LDAgLTMsLTEuMzQgLTMsLTNjMCwtMS42NiAxLjM0LC0zIDMsLTNabTYsMTJsLTEyLDBsMCwtMS40YzAsLTIgNCwtMy4xIDYsLTMuMWMyLDAgNiwxLjEgNiwzLjFsMCwxLjRaIiBzdHlsZT0iZmlsbC1ydWxlOm5vbnplcm87Ii8+PC9zdmc+"

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cGF0aCBkPSJNMCwwbDI0LDBsMCwyNGwtMjQsMGwwLC0yNFoiIHN0eWxlPSJmaWxsOm5vbmU7Ii8+PHBhdGggZD0iTTkuMTgsM2MwLjQyLC0xLjE2IDEuNTIsLTIgMi44MiwtMmMxLjMsMCAyLjQsMC44NCAyLjgyLDJsNC4xOCwwYzEuMSwwIDIsMC45IDIsMmwwLDE0YzAsMS4xIC0wLjksMiAtMiwybC0xNCwwYy0xLjEsMCAtMiwtMC45IC0yLC0ybDAsLTE0YzAsLTEuMSAwLjksLTIgMiwtMmw0LjE4LDBabTMuOTYzLDE0LjU4N2wwLC0yLjI4NmwtMi4yODYsMGwwLDIuMjg2bDIuMjg2LDBabTAsLTQuNTcxbDAsLTQuNTcxbC0yLjI4NiwwbDAsNC41NzFsMi4yODYsMFptLTEuMTQzLC0xMC4wMTZjMC41NSwwIDEsMC40NSAxLDFjMCwwLjU1IC0wLjQ1LDEgLTEsMWMtMC41NSwwIC0xLC0wLjQ1IC0xLC0xYzAsLTAuNTUgMC40NSwtMSAxLC0xWiIvPjwvc3ZnPg=="

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHN0eWxlPSJmaWxsOm5vbmU7Ii8+PHBhdGggZD0iTTE5LDNsLTQuMTgsMGMtMC40MiwtMS4xNiAtMS41MiwtMiAtMi44MiwtMmMtMS4zLDAgLTIuNCwwLjg0IC0yLjgyLDJsLTQuMTgsMGMtMS4xLDAgLTIsMC45IC0yLDJsMCwxNGMwLDEuMSAwLjksMiAyLDJsMTQsMGMxLjEsMCAyLC0wLjkgMiwtMmwwLC0xNGMwLC0xLjEgLTAuOSwtMiAtMiwtMlptLTcsMGMwLjU1LDAgMSwwLjQ1IDEsMWMwLDAuNTUgLTAuNDUsMSAtMSwxYy0wLjU1LDAgLTEsLTAuNDUgLTEsLTFjMCwtMC41NSAwLjQ1LC0xIDEsLTFabS0yLDE0bC00LC00bDEuNDEsLTEuNDFsMi41OSwyLjU4bDYuNTksLTYuNTlsMS40MSwxLjQybC04LDhaIiBzdHlsZT0iZmlsbDojMjhhNzQ1O2ZpbGwtcnVsZTpub256ZXJvOyIvPjwvc3ZnPg=="

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cGF0aCBkPSJNMCwwbDI0LDBsMCwyNGwtMjQsMGwwLC0yNFoiIHN0eWxlPSJmaWxsOm5vbmU7Ii8+PHBhdGggZD0iTTE5LDNsLTQuMTgsMGMtMC40MiwtMS4xNiAtMS41MiwtMiAtMi44MiwtMmMtMS4zLDAgLTIuNCwwLjg0IC0yLjgyLDJsLTQuMTgsMGMtMS4xLDAgLTIsMC45IC0yLDJsMCwxNGMwLDEuMSAwLjksMiAyLDJsMTQsMGMxLjEsMCAyLC0wLjkgMiwtMmwwLC0xNGMwLC0xLjEgLTAuOSwtMiAtMiwtMlptLTcsMGMwLjU1LDAgMSwwLjQ1IDEsMWMwLDAuNTUgLTAuNDUsMSAtMSwxYy0wLjU1LDAgLTEsLTAuNDUgLTEsLTFjMCwtMC41NSAwLjQ1LC0xIDEsLTFabTIsMTRsLTcsMGwwLC0ybDcsMGwwLDJabTMsLTRsLTEwLDBsMCwtMmwxMCwwbDAsMlptMCwtNGwtMTAsMGwwLC0ybDEwLDBsMCwyWiIgc3R5bGU9ImZpbGw6I2ZmYzEwNztmaWxsLXJ1bGU6bm9uemVybzsiLz48L3N2Zz4="

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxuczpzZXJpZj0iaHR0cDovL3d3dy5zZXJpZi5jb20vIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cGF0aCBkPSJNMTIsNy43N2w2LjM5LDEwLjIzbC0xMi43OCwwbDYuMzksLTEwLjIzbTAsLTMuNzdsLTEwLDE2bDIwLDBsLTEwLC0xNloiIHN0eWxlPSJmaWxsOiMyOGE3NDU7ZmlsbC1ydWxlOm5vbnplcm87Ii8+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBzdHlsZT0iZmlsbDpub25lOyIvPjwvc3ZnPg=="

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHN0eWxlPSJmaWxsOm5vbmU7Ii8+PGc+PHBhdGggZD0iTTE2LDFsLTEyLDBjLTEuMSwwIC0yLDAuOSAtMiwybDAsMTRsMiwwbDAsLTE0bDEyLDBsMCwtMlptMyw0bC0xMSwwYy0xLjEsMCAtMiwwLjkgLTIsMmwwLDE0YzAsMS4xIDAuOSwyIDIsMmwxMSwwYzEuMSwwIDIsLTAuOSAyLC0ybDAsLTE0YzAsLTEuMSAtMC45LC0yIC0yLC0yWm0wLDE2bC0xMSwwbDAsLTE0bDExLDBsMCwxNFoiIHN0eWxlPSJmaWxsOiMyOGE3NDU7ZmlsbC1ydWxlOm5vbnplcm87Ii8+PHBhdGggZD0iTTE3LjcwNiwxNC40NjlsLTMuNTA3LDBsMCwzLjUwN2wtMS4xNjksMGwwLC0zLjUwN2wtMy41MDgsMGwwLC0xLjE2OWwzLjUwOCwwbDAsLTMuNTA4bDEuMTY5LDBsMCwzLjUwOGwzLjUwNywwbDAsMS4xNjlaIiBzdHlsZT0iZmlsbDojMjhhNzQ1O2ZpbGwtcnVsZTpub256ZXJvOyIvPjwvZz48L3N2Zz4="

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MS40MTQyMTsiPjxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiBzdHlsZT0iZmlsbDpub25lOyIvPjxwYXRoIGQ9Ik00NS44MzMsNjIuNWw4LjMzNCwwbDAsOC4zMzNsLTguMzM0LDBsMCwtOC4zMzNabTAsLTMzLjMzM2w4LjMzNCwwbDAsMjVsLTguMzM0LDBsMCwtMjVabTQuMTI1LC0yMC44MzRjLTIzLDAgLTQxLjYyNSwxOC42NjcgLTQxLjYyNSw0MS42NjdjMCwyMyAxOC42MjUsNDEuNjY3IDQxLjYyNSw0MS42NjdjMjMuMDQyLDAgNDEuNzA5LC0xOC42NjcgNDEuNzA5LC00MS42NjdjMCwtMjMgLTE4LjY2NywtNDEuNjY3IC00MS43MDksLTQxLjY2N1ptMC4wNDIsNzVjLTE4LjQxNywwIC0zMy4zMzMsLTE0LjkxNiAtMzMuMzMzLC0zMy4zMzNjMCwtMTguNDE3IDE0LjkxNiwtMzMuMzMzIDMzLjMzMywtMzMuMzMzYzE4LjQxNywwIDMzLjMzMywxNC45MTYgMzMuMzMzLDMzLjMzM2MwLDE4LjQxNyAtMTQuOTE2LDMzLjMzMyAtMzMuMzMzLDMzLjMzM1oiIHN0eWxlPSJmaWxsLXJ1bGU6bm9uemVybzsiLz48L3N2Zz4="

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHN0eWxlPSJmaWxsOm5vbmU7Ii8+PHBhdGggZD0iTTIxLDE3LjVsMCwtMTFjMCwtMS4xIC0wLjksLTIgLTIsLTJsLTE0LDBjLTEuMSwwIC0yLDAuOSAtMiwybDAsMTFjMCwxLjEgMC45LDIgMiwybDE0LDBjMS4xLDAgMiwtMC45IDIsLTJabS0xNiwwbDAsLTExbDE0LDBsMCwxMWwtMTQsMFoiIHN0eWxlPSJmaWxsOiMyOGE3NDU7ZmlsbC1ydWxlOm5vbnplcm87Ii8+PHBhdGggZD0iTTcuMTMyLDEwLjUwN2wwLDIuOTg2bDQuNDk0LDBsMCwxLjk5bDUuMjQyLC0zLjQ4M2wtNS4yNDIsLTMuNDgzbDAsMS45OWwtNC40OTQsMFoiIHN0eWxlPSJmaWxsOiMyOGE3NDU7ZmlsbC1ydWxlOm5vbnplcm87Ii8+PC9zdmc+"

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHN0eWxlPSJmaWxsOm5vbmU7Ii8+PHBhdGggZD0iTTIxLDE3LjVsMCwtMTFjMCwtMS4xIC0wLjksLTIgLTIsLTJsLTE0LDBjLTEuMSwwIC0yLDAuOSAtMiwybDAsMTFjMCwxLjEgMC45LDIgMiwybDE0LDBjMS4xLDAgMiwtMC45IDIsLTJabS0xNiwwbDAsLTExbDE0LDBsMCwxMWwtMTQsMFoiIHN0eWxlPSJmaWxsOiNkYzM1NDU7ZmlsbC1ydWxlOm5vbnplcm87Ii8+PHBhdGggZD0iTTguNSwxNC42MjRsMi42MjUsLTIuNjI0bC0yLjYyNSwtMi42MjRsMC44NzUsLTAuODc1bDIuNjI1LDIuNjI0bDIuNjI1LC0yLjYyNWwwLjg3NSwwLjg3NWwtMi42MjYsMi42MjVsMi42MjYsMi42MjVsLTAuODc1LDAuODc1bC0yLjYyNSwtMi42MjVsLTIuNjI1LDIuNjI0bC0wLjg3NSwtMC44NzVaIiBzdHlsZT0iZmlsbDojZGMzNTQ1O2ZpbGwtcnVsZTpub256ZXJvOyIvPjwvc3ZnPg=="

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHN0eWxlPSJmaWxsOm5vbmU7Ii8+PHBhdGggZD0iTTIxLDE3LjVsMCwtMTFjMCwtMS4xIC0wLjksLTIgLTIsLTJsLTE0LDBjLTEuMSwwIC0yLDAuOSAtMiwybDAsMTFjMCwxLjEgMC45LDIgMiwybDE0LDBjMS4xLDAgMiwtMC45IDIsLTJabS0xNiwwbDAsLTExbDE0LDBsMCwxMWwtMTQsMFoiIHN0eWxlPSJmaWxsOiMyOGE3NDU7ZmlsbC1ydWxlOm5vbnplcm87Ii8+PHBhdGggZD0iTTEwLjYzNSwxNS42NjZsMi43MywwbDAsLTMuMzg0bDEuODIxLDBsLTMuMTg2LC0zLjk0OGwtMy4xODYsMy45NDhsMS44MjEsMGwwLDMuMzg0WiIgc3R5bGU9ImZpbGw6IzI4YTc0NTtmaWxsLXJ1bGU6bm9uemVybzsiLz48L3N2Zz4="

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cGF0aCBkPSJNMCwwbDI0LDBsMCwyNGwtMjQsMGwwLC0yNFoiIHN0eWxlPSJmaWxsOm5vbmU7Ii8+PHBhdGggZD0iTTE3LjYzLDUuODRjLTAuMzYsLTAuNTEgLTAuOTYsLTAuODQgLTEuNjMsLTAuODRsLTExLDAuMDFjLTEuMSwwIC0yLDAuODkgLTIsMS45OWwwLDEwYzAsMS4xIDAuOSwxLjk5IDIsMS45OWwxMSwwLjAxYzAuNjcsMCAxLjI3LC0wLjMzIDEuNjMsLTAuODRsNC4zNywtNi4xNmwtNC4zNywtNi4xNlptLTEuNjMsMTEuMTZsLTExLDBsMCwtMTBsMTEsMGwzLjU1LDVsLTMuNTUsNVoiIHN0eWxlPSJmaWxsLXJ1bGU6bm9uemVybzsiLz48L3N2Zz4="

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHN0eWxlPSJmaWxsOm5vbmU7Ii8+PGc+PGc+PHBhdGggZD0iTTE3LjUsM2wtMTEsMGMtMS4xLDAgLTIsMC45IC0yLDJsMCwxNGMwLDEuMSAwLjksMiAyLDJsMTEsMGMxLjEsMCAyLC0wLjkgMiwtMmwwLC0xNGMwLC0xLjEgLTAuOSwtMiAtMiwtMlptMCwxNmwtMTEsMGwwLC0xNGwxMSwwbDAsMTRaIiBzdHlsZT0iZmlsbDojMjhhNzQ1O2ZpbGwtcnVsZTpub256ZXJvOyIvPjxwYXRoIGQ9Ik0xNS41MDksMTIuNTAybC0zLjAwNywwbDAsMy4wMDdsLTEuMDAzLDBsMCwtMy4wMDdsLTMuMDA4LDBsMCwtMS4wMDNsMy4wMDgsMGwwLC0zLjAwOGwxLjAwMywwbDAsMy4wMDhsMy4wMDcsMGwwLDEuMDAzWiIgc3R5bGU9ImZpbGw6IzI4YTc0NTtmaWxsLXJ1bGU6bm9uemVybzsiLz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHN0eWxlPSJmaWxsOm5vbmU7Ii8+PGc+PGc+PHBhdGggZD0iTTE3LjUsM2wtMTEsMGMtMS4xLDAgLTIsMC45IC0yLDJsMCwxNGMwLDEuMSAwLjksMiAyLDJsMTEsMGMxLjEsMCAyLC0wLjkgMiwtMmwwLC0xNGMwLC0xLjEgLTAuOSwtMiAtMiwtMlptMCwxNmwtMTEsMGwwLC0xNGwxMSwwbDAsMTRaIiBzdHlsZT0iZmlsbDojZGMzNTQ1O2ZpbGwtcnVsZTpub256ZXJvOyIvPjxwYXRoIGQ9Ik0xNC42MjQsMTUuNWwtMi42MjQsLTIuNjI1bC0yLjYyNCwyLjYyNWwtMC44NzUsLTAuODc1bDIuNjI0LC0yLjYyNWwtMi42MjUsLTIuNjI1bDAuODc1LC0wLjg3NWwyLjYyNSwyLjYyNmwyLjYyNSwtMi42MjZsMC44NzUsMC44NzVsLTIuNjI1LDIuNjI1bDIuNjI0LDIuNjI1bC0wLjg3NSwwLjg3NVoiIHN0eWxlPSJmaWxsOiNkYzM1NDU7ZmlsbC1ydWxlOm5vbnplcm87Ii8+PC9nPjwvZz48L3N2Zz4="

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHN0eWxlPSJmaWxsOm5vbmU7Ii8+PGc+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBzdHlsZT0iZmlsbDpub25lOyIvPjxnPjxwYXRoIGQ9Ik0xNS40NTEsMi40MDlsLTEwLjUzNSwwYy0wLjk2NiwwIC0xLjc1NiwwLjc4NSAtMS43NTYsMS43NDRsMCwxMi4yMDdsMS43NTYsMGwwLC0xMi4yMDdsMTAuNTM1LDBsMCwtMS43NDRabTIuNjMzLDMuNDg4bC05LjY1NywwYy0wLjk2NSwwIC0xLjc1NiwwLjc4NCAtMS43NTYsMS43NDNsMCwxMi4yMDdjMCwwLjk1OSAwLjc5MSwxLjc0NCAxLjc1NiwxLjc0NGw5LjY1NywwYzAuOTY2LDAgMS43NTYsLTAuNzg1IDEuNzU2LC0xLjc0NGwwLC0xMi4yMDdjMCwtMC45NTkgLTAuNzksLTEuNzQzIC0xLjc1NiwtMS43NDNabTAsMTMuOTVsLTkuNjU3LDBsMCwtMTIuMjA3bDkuNjU3LDBsMCwxMi4yMDdaIiBzdHlsZT0iZmlsbC1ydWxlOm5vbnplcm87Ii8+PHBhdGggZD0iTTkuNzkyLDE3LjM1OGwzLjA4NCwwbDAsLTEuMTUzbC0zLjA4NCwwbDAsMS4xNTNabTAsLTcuMDQ4bDAsMS4xNTRsNi45MjgsMGwwLC0xLjE1NGwtNi45MjgsMGwwLDBabTAsNC4xMjdsNC45MDgsMGwwLC0xLjE1M2wtNC45MDgsMGwwLDEuMTUzWiIgc3R5bGU9ImZpbGwtcnVsZTpub256ZXJvOyIvPjwvZz48L2c+PC9zdmc+"

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHN0eWxlPSJmaWxsOm5vbmU7Ii8+PHBhdGggZD0iTTE5LDIxbC0xNCwwYy0xLjExLDAgLTIsLTAuOSAtMiwtMmwwLC0xNGMwLC0xLjEgMC44OSwtMiAyLC0ybDE0LDBjMS4xLDAgMiwwLjkgMiwybDAsMTRjMCwxLjEgLTAuOSwyIC0yLDJabS0xLjUyNywtMS45NjRjMC44NiwwIDEuNTYzLC0wLjcwMyAxLjU2MywtMS41NjNsMCwtMTAuOTQ2YzAsLTAuODYgLTAuNzAzLC0xLjU2MyAtMS41NjMsLTEuNTYzbC0xMC45NDYsMGMtMC44NjcsMCAtMS41NjMsMC43MDMgLTEuNTYzLDEuNTYzbDAsMTAuOTQ2YzAsMC44NiAwLjY5NiwxLjU2MyAxLjU2MywxLjU2M2wxMC45NDYsMFoiLz48cGF0aCBkPSJNMTIsMTMuNTY0bC0zLjEyNywtMy4xMjhsNi4yNTQsMGwtMy4xMjcsMy4xMjhaIi8+PC9zdmc+"

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHN0eWxlPSJmaWxsOm5vbmU7Ii8+PHBhdGggZD0iTTEyLDRsMCwtM2wtNCw0bDQsNGwwLC0zYzMuMzEsMCA2LDIuNjkgNiw2YzAsMS4wMSAtMC4yNSwxLjk3IC0wLjcsMi44bDEuNDYsMS40NmMwLjc4LC0xLjIzIDEuMjQsLTIuNjkgMS4yNCwtNC4yNmMwLC00LjQyIC0zLjU4LC04IC04LC04Wm0wLDE0Yy0zLjMxLDAgLTYsLTIuNjkgLTYsLTZjMCwtMS4wMSAwLjI1LC0xLjk3IDAuNywtMi44bC0xLjQ2LC0xLjQ2Yy0wLjc4LDEuMjMgLTEuMjQsMi42OSAtMS4yNCw0LjI2YzAsNC40MiAzLjU4LDggOCw4bDAsM2w0LC00bC00LC00bDAsM1oiIHN0eWxlPSJmaWxsOiMyOGE3NDU7ZmlsbC1ydWxlOm5vbnplcm87Ii8+PC9zdmc+"

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHN0eWxlPSJmaWxsOm5vbmU7Ii8+PHBhdGggZD0iTTEyLDRsMCwtM2wtNCw0bDQsNGwwLC0zYzMuMzEsMCA2LDIuNjkgNiw2YzAsMS4wMSAtMC4yNSwxLjk3IC0wLjcsMi44bDEuNDYsMS40NmMwLjc4LC0xLjIzIDEuMjQsLTIuNjkgMS4yNCwtNC4yNmMwLC00LjQyIC0zLjU4LC04IC04LC04bDAsMFptMCwxNGMtMy4zMSwwIC02LC0yLjY5IC02LC02YzAsLTEuMDEgMC4yNSwtMS45NyAwLjcsLTIuOGwtMS40NiwtMS40NmMtMC43OCwxLjIzIC0xLjI0LDIuNjkgLTEuMjQsNC4yNmMwLDQuNDIgMy41OCw4IDgsOGwwLDNsNCwtNGwtNCwtNGwwLDNaIiBzdHlsZT0iZmlsbDojZmZjMTA3O2ZpbGwtcnVsZTpub256ZXJvOyIvPjwvc3ZnPg=="

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHN0eWxlPSJmaWxsOm5vbmU7Ii8+PHBhdGggZD0iTTIuNSw0bDAsM2w1LDBsMCwxMmwzLDBsMCwtMTJsNSwwbDAsLTNsLTEzLDBabTE5LDVsLTksMGwwLDNsMywwbDAsN2wzLDBsMCwtN2wzLDBsMCwtM1oiIHN0eWxlPSJmaWxsOiMyOGE3NDU7ZmlsbC1ydWxlOm5vbnplcm87Ii8+PC9zdmc+"

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAA8klEQVR4Ae3UP0rHQBBH8Yd7DqPxUjERS0GrQM4i9tEtvIitN4h/DmEjyy9ChAyyhNXsDFjsd/rPIxCWf7GysppnPrnDYbIz3pmX8zgzXivh8DQxr5VwPDITaGJeJ+EX4DshfHy37FxDWBOD8NF9QGYicU9kbEjyE8eZP2WCryg8I9ccdPn6B38EXHGw5IkSvTYPcCMBAueavLxMcoE2j7/f5CXR/ZV/S/NM9IT1Gw34CmgJ8lDr8wAd417+IcHv2Omv+JfCe30eax5rXgKXm/wJaAQCrTIvAUno8hKQxIXwvCrwEpDT5bHmsebR4PVXVvYFEVLJV0ZEiSEAAAAASUVORK5CYII="

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTVweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTUgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ1LjEgKDQzNTA0KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5QYXRoIDI8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cG9seWdvbiBpZD0iUGF0aC0yIiBmaWxsPSIjRkZGRkZGIiBwb2ludHM9IjAgNy42Mzc3NzgyMyA3LjQxMzQ4ODQ5IDAgMTUuMDA0NTA4IDcuNjM3Nzc4MjMgMTMuMzc5Mjg4MSA3LjYzNzc3ODIzIDEzLjM3OTI4ODEgMTUuNzkgOS4yMTA3MjU3NCAxNS43OSA5LjIxMDcyNTc0IDEwLjIyNDk2NDYgNS43Nzc3NzU0NCAxMC4yMjQ5NjQ2IDUuNzc3Nzc1NDQgMTUuNzkgMS43NjI0MDQ0IDE1Ljc5IDEuNzYyNDA0NCA3LjYzNzc3ODIzIj48L3BvbHlnb24+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyMSAyMSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxuczpzZXJpZj0iaHR0cDovL3d3dy5zZXJpZi5jb20vIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cGF0aCBkPSJNMTAuNDE3LDAuMDMzYzUuNzMsMCAxMC4zODMsNC42NTMgMTAuMzgzLDEwLjM4NGMwLDUuNzMgLTQuNjUzLDEwLjM4MyAtMTAuMzgzLDEwLjM4M2MtNS43MzEsMCAtMTAuMzg0LC00LjY1MyAtMTAuMzg0LC0xMC4zODNjMCwtNS43MzEgNC42NTMsLTEwLjM4NCAxMC4zODQsLTEwLjM4NFptMi44MDgsMTcuMzkybDAsLTAuNDU4Yy0wLjY0NCwwIC0xLjA2NiwtMC4xMyAtMS4yNjYsLTAuMzkxYy0wLjIsLTAuMjYyIC0wLjMwMSwtMC43MzUgLTAuMzAxLC0xLjQxOWwwLC03LjUyOGwtMy42NjIsMC41MDhsMCwwLjQ1OGMwLjU4NCwwIDAuOTg5LDAuMTMxIDEuMjE2LDAuMzkyYzAuMjI3LDAuMjYxIDAuMzQxLDAuNjgzIDAuMzQxLDEuMjY2bDAsNC45MDRjMCwwLjY4NCAtMC4xLDEuMTU3IC0wLjMsMS40MTljLTAuMiwwLjI2MSAtMC42MTksMC4zOTEgLTEuMjU3LDAuMzkxbDAsMC40NThsNS4yMjksMFptLTEuNjU4LC0xMy43MDJjMC4yNTgsMC4yNDQgMC4zODYsMC41NDcgMC4zODYsMC45MWMwLDAuMzYzIC0wLjEyOCwwLjY3MyAtMC4zODYsMC45MzFjLTAuMjU4LDAuMjU4IC0wLjU3LDAuMzg2IC0wLjkzNiwwLjM4NmMtMC4zNjYsMCAtMC42NzEsLTAuMTI4IC0wLjkxNSwtMC4zODZjLTAuMjQ1LC0wLjI1OCAtMC4zNjcsLTAuNTY4IC0wLjM2NywtMC45MzFjMCwtMC4zNjMgMC4xMjQsLTAuNjY4IDAuMzcyLC0wLjkxNWMwLjI0NywtMC4yNDggMC41NTIsLTAuMzcyIDAuOTE1LC0wLjM3MmMwLjM2MywwIDAuNjczLDAuMTI2IDAuOTMxLDAuMzc3WiIgc3R5bGU9ImZpbGw6I2ZmZjsiLz48L3N2Zz4="

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCA1IDUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxLjQxNDIxOyI+PGNpcmNsZSBjeD0iMi41IiBjeT0iMi41IiByPSIyLjQ5MiIgc3R5bGU9ImZpbGw6IzQ0NDsiLz48dGV4dCB4PSIxLjc1OHB4IiB5PSI0LjE4MnB4IiBzdHlsZT0iZm9udC1mYW1pbHk6J1JvdGlzU2VyaWZXMDEtQm9sZCcsIHNlcmlmO2ZvbnQtc2l6ZTo1cHg7ZmlsbDojZmZmOyI+aTwvdGV4dD48L3N2Zz4="

/***/ }),
/* 499 */,
/* 500 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(400)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(615),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(371)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(586),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(455)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(669),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(433)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(647),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(411)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(625),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(403)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(618),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(460)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(674),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(413)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(627),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(376)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(591),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(418)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(632),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(404)
__webpack_require__(405)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(619),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(380)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(595),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(372)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(587),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(391)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(606),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(398)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(613),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(410)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(624),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(412)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(626),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(421)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(635),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(389)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(604),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(387)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(602),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(396)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(611),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(431)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(645),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(429)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(643),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(375)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(590),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(424)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(638),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(373)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(588),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(401)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(616),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(430)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(644),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(459)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(673),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(448)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(662),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(456)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(670),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(449)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(663),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(414)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(628),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(434)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(648),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(406)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(620),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(378)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(593),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(420)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(634),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(381)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(596),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(463)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(677),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(415)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(629),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(462)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(676),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(419)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(633),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(447)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(661),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(461)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(675),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(417)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(631),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(399)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(614),
  /* scopeId */
  "data-v-37546dc6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(436)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(650),
  /* scopeId */
  "data-v-95d78e36",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(435)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(649),
  /* scopeId */
  "data-v-95bb5f34",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(444)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(658),
  /* scopeId */
  "data-v-995e1748",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(443)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(657),
  /* scopeId */
  "data-v-9941e846",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(442)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(656),
  /* scopeId */
  "data-v-9925b944",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(441)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(655),
  /* scopeId */
  "data-v-99098a42",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(440)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(654),
  /* scopeId */
  "data-v-98ed5b40",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(439)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(653),
  /* scopeId */
  "data-v-98d12c3e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(438)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(652),
  /* scopeId */
  "data-v-98b4fd3c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(437)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(651),
  /* scopeId */
  "data-v-9898ce3a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(393)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(608),
  /* scopeId */
  "data-v-2733c52b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(395)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(610),
  /* scopeId */
  "data-v-2f44ef4e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(450)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(664),
  /* scopeId */
  "data-v-c00e58a2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(397)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(612),
  /* scopeId */
  "data-v-34bbb4f3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(388)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(603),
  /* scopeId */
  "data-v-1e0a32af",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(465)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(679),
  /* scopeId */
  "data-v-ff4c83cc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(457)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(671),
  /* scopeId */
  "data-v-c4d1891c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(428)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(642),
  /* scopeId */
  "data-v-7da72878",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(422)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(636),
  /* scopeId */
  "data-v-759c20d1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(445)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(659),
  /* scopeId */
  "data-v-a978441e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(382)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(597),
  /* scopeId */
  "data-v-15a96257",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(425)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(639),
  /* scopeId */
  "data-v-788461d6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(446)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(660),
  /* scopeId */
  "data-v-ac8650fa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(432)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(646),
  /* scopeId */
  "data-v-8efcae00",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(416)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(630),
  /* scopeId */
  "data-v-68745654",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(394)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(609),
  /* scopeId */
  "data-v-2e7060ce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(454)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(668),
  /* scopeId */
  "data-v-c0993b58",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(453)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(667),
  /* scopeId */
  "data-v-c07d0c56",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(452)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(666),
  /* scopeId */
  "data-v-c060dd54",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(451)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(665),
  /* scopeId */
  "data-v-c044ae52",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(423)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(637),
  /* scopeId */
  "data-v-759f8dcc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(427)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(641),
  /* scopeId */
  "data-v-7b67c6e9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(407)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(621),
  /* scopeId */
  "data-v-4d4109cc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(390)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(605),
  /* scopeId */
  "data-v-23affb0e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(377)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(592),
  /* scopeId */
  "data-v-11711702",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(385)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(600),
  /* scopeId */
  "data-v-19ff6795",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(426)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(640),
  /* scopeId */
  "data-v-7a994282",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(379)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(594),
  /* scopeId */
  "data-v-135a541b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(374)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(589),
  /* scopeId */
  "data-v-056806ef",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "erco-text-area"
  }, [_c('label', {
    staticClass: "label_"
  }, [_c('span', {
    staticClass: "_text text-muted"
  }, [_vm._v(_vm._s(_vm.label || ' '))]), _vm._v(" "), _c('textarea', {
    staticClass: "textarea form-control",
    on: {
      "change": _vm.handleTextChange
    }
  }, [_vm._v(_vm._s(_vm.text))])])])
},staticRenderFns: []}

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "erco-cms-structure-dropdown d-inline-block"
  }, [_c('div', {
    staticClass: "dropdown-label-box d-inline-block my-2 my-lg-0"
  }, [_c('div', {
    class: ['dropdown', 'btn-group', {
      'show': _vm.visible
    }]
  }, [_c('button', {
    ref: "mainDropdownButton",
    staticClass: "btn btn-secondary dropdown-toggle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleButtonClick,
      "blur": _vm.handleBlur
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": _vm.lightscoutURL,
      "role": "menuitem"
    }
  }, [_vm._v("\n\t\t\t\t   Live-Auswahl\n\t\t\t\t")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "javascript: void(0);",
      "role": "menuitem"
    },
    on: {
      "click": _vm.handleSubmenuItemClick,
      "blur": _vm.handleBlur
    }
  }, [_vm._v("\n\t\t\t\t   CMS-Struktur\n\t\t\t\t\t"), _c('div', {
    staticClass: "dropdown dropdown-sub btn-group"
  }, [_c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('a', {
    staticClass: "dropdown-item -muted text-muted",
    attrs: {
      "href": "javascript: void(0);",
      "role": "menuitem"
    },
    on: {
      "click": _vm.handleSubmenuItemClick,
      "blur": _vm.handleBlur
    }
  }, [_c('strong', [_vm._v("Bereich")])]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item dropdown-static-item",
    attrs: {
      "href": "javascript: void(0);",
      "role": "menuitem"
    },
    on: {
      "click": _vm.handleResetClick
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t   Auswahl zurücksetzen\n\t\t\t\t\t\t\t")]), _vm._v(" "), _vm._l((_vm.dataset), function(category, cIndex) {
    return _c('a', {
      key: cIndex,
      class: ['dropdown-item', 'dropdown-multilevel-item', {
        '-active': _vm.itemIsActive({
          category: category.name
        })
      }],
      attrs: {
        "href": "javascript: void(0);",
        "role": "menuitem"
      },
      on: {
        "click": _vm.handleSubmenuItemClick,
        "blur": _vm.handleBlur
      }
    }, [_c('div', {
      staticClass: "dropdown dropdown-sub"
    }, [_c('a', {
      staticClass: "dropdown-item",
      attrs: {
        "aria-disabled": "false",
        "role": "menuitem"
      },
      on: {
        "click": _vm.handleSubmenuItemClick,
        "blur": _vm.handleBlur
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(category.name) + "\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu",
      attrs: {
        "role": "menu"
      }
    }, [_c('a', {
      staticClass: "dropdown-item -muted text-muted",
      attrs: {
        "href": "javascript: void(0);",
        "role": "menuitem"
      },
      on: {
        "click": _vm.handleSubmenuItemClick,
        "blur": _vm.handleBlur
      }
    }, [_c('strong', [_vm._v("Spezifikation")])]), _vm._v(" "), _vm._l((category.spezifikationen), function(specification, sIndex) {
      return _c('a', {
        key: sIndex,
        class: ['dropdown-item', 'dropdown-multilevel-item', {
          '-active': _vm.itemIsActive({
            category: category.name,
            specification: specification.name
          })
        }],
        attrs: {
          "role": "menuitem"
        },
        on: {
          "click": _vm.handleSubmenuItemClick,
          "blur": _vm.handleBlur
        }
      }, [_c('div', {
        staticClass: "dropdown dropdown-sub"
      }, [_c('a', {
        staticClass: "dropdown-item",
        attrs: {
          "href": "javascript: void(0);",
          "role": "menuitem"
        },
        on: {
          "click": _vm.handleSubmenuItemClick,
          "blur": _vm.handleBlur
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(specification.name) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
        staticClass: "dropdown-menu -last",
        attrs: {
          "role": "menu"
        }
      }, [_c('a', {
        staticClass: "dropdown-item -muted text-muted",
        attrs: {
          "href": "javascript: void(0);",
          "role": "menuitem"
        },
        on: {
          "click": _vm.handleSubmenuItemClick,
          "blur": _vm.handleBlur
        }
      }, [_c('strong', [_vm._v("Gattung")])]), _vm._v(" "), _vm._l((specification.gattungen), function(genus, gIndex) {
        return _c('a', {
          key: gIndex,
          class: ['dropdown-item', 'dropdown-last-item', {
            '-active': _vm.itemIsActive({
              category: category.name,
              specification: specification.name,
              genus: genus.name
            })
          }],
          attrs: {
            "href": "javascript: void(0);",
            "role": "menuitem"
          },
          on: {
            "mousedown": function($event) {
              _vm.handleGenusClick(category.name, specification.name, genus.name, $event)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(genus.name) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])
      })], 2)])])
    })], 2)])])
  })], 2)])])])])])])
},staticRenderFns: []}

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "live-view-header container-fluid",
    style: (_vm.headerStyle)
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-auto"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), (_vm.name) ? _c('span', [_vm._v("–")]) : _vm._e(), _vm._v(" "), (_vm.name) ? _c('span', {
    staticClass: "state-name"
  }, [_vm._v(_vm._s(_vm.processstate.name))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "id"
  }, [_vm._v(_vm._s(_vm.id))])]), _vm._v(" "), _c('div', {
    staticClass: "col text-right"
  }, [(_vm.processstate.items.length) ? _c('erco-dropdown', {
    attrs: {
      "size": "sm",
      "label": _vm.dropdownLabel,
      "right": true,
      "items": _vm.processstate.items,
      "useLabelInline": true
    },
    on: {
      "change": _vm.handleStateChange
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon glyphicon glyphicon-home"
  }, [_c('a', {
    attrs: {
      "href": "/#/dashboard"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(496)
    }
  })])])
}]}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-template-selection"
  }, [(!_vm.loading) ? _c('b-tabs', {
    attrs: {
      "small": ""
    },
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, _vm._l((_vm.tagGroups), function(tagGroup) {
    return _c('b-tab', {
      key: tagGroup.id,
      attrs: {
        "title": tagGroup.name
      }
    }, [_c('div', {
      staticClass: "template-list"
    }, _vm._l((tagGroup.templates), function(template) {
      return _c('div', {
        key: template.PKM_Template,
        staticClass: "_entry-wrap_",
        on: {
          "click": function($event) {
            _vm.handleTemplateClick(template)
          }
        }
      }, [_c('b-card', {
        class: _vm.cardClasses(template),
        attrs: {
          "show-footer": ""
        }
      }, [_c('img', {
        staticClass: "image",
        attrs: {
          "src": _vm.getAbsolutePathForImage(template.S_Vorschaubild_url),
          "alt": template.S_Titel
        }
      }), _vm._v(" "), _c('small', {
        staticClass: "text-muted",
        attrs: {
          "title": template.S_Template
        },
        slot: "footer"
      }, [_c('span', {
        staticClass: "_tmpl-id"
      }, [_vm._v(_vm._s(template.PKM_Template))]), _vm._v(" "), _c('span', {
        staticClass: "_tmpl-name"
      }, [_vm._v(_vm._s(template.S_Titel))]), _vm._v(" "), _c('div', {
        staticClass: "_tmpl-tags"
      }, _vm._l((template.tags.result), function(tag) {
        return _c('b-badge', {
          key: tag.PKM_Tag,
          staticClass: "badge"
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(tag.S_Value) + "\n\t\t\t\t\t\t\t\t")])
      }))])])], 1)
    }))])
  })) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('erco-cloak') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--wave",
    style: (_vm.styles)
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
},staticRenderFns: []}

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "sidebarTextInput",
    staticClass: "sidebar-tabbed-text-input"
  }, [_c('b-tabs', {
    on: {
      "input": _vm.handleTabChange
    },
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, _vm._l((_vm.data.tabs), function(input, index) {
    return _c('b-tab', {
      key: input.key,
      staticClass: "tab",
      attrs: {
        "title": input.tabLabel || input.label
      }
    }, [_c('div', {
      staticClass: "col-12 container"
    }, [(_vm.tabIsBeingLoaded(index)) ? _c('div', {
      staticClass: "spinner-container"
    }, [_c('erco-spinner', {
      staticClass: "spinner",
      attrs: {
        "size": "30px",
        "isFixedColor": true
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('erco-text-input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.tabIsBeingLoaded(index)),
        expression: "!tabIsBeingLoaded(index)"
      }],
      ref: ("input" + index),
      refInFor: true,
      staticClass: "_input",
      attrs: {
        "label": "",
        "text": input.text,
        "inputType": "textarea",
        "resetable": true,
        "charlength": index === 0 && _vm.computedCharLength
      },
      on: {
        "input": function($event) {
          _vm.handleInput(index, $event)
        },
        "reset": function($event) {
          _vm.handleReset(index)
        }
      }
    })], 1)])
  })), _vm._v(" "), (_vm.changes.length > 0 && !_vm.tabIsBeingLoaded(_vm.tabIndex)) ? _c('b-alert', {
    staticClass: "alert",
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [(_vm.changes.length === 1) ? _c('span', [_vm._v("\n\t\t\tEs liegt noch eine unbestätigte Änderung im Reiter " + _vm._s(_vm.buildChangesStrList(_vm.changes)) + " vor\n\t    ")]) : _c('span', [_vm._v("\n\t\t\tEs liegen noch mehrere unbestätigte Änderungen in den Reitern " + _vm._s(_vm.buildChangesStrList(_vm.changes)) + " vor\n\t    ")])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid erco-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-auto"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('a', {
    staticClass: "go-back",
    attrs: {
      "href": "/#/dashboard"
    }
  }, [_c('b-button', {
    staticClass: "_btn",
    attrs: {
      "size": "sm"
    }
  }, [_vm._v("\n\t\t\t\t\t\t×\n\t\t\t\t\t\t")])], 1)]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', {
    staticClass: "id"
  }, [_vm._v(_vm._s(_vm.id))]), _vm._v(" "), _c('span', {
    staticClass: "bc"
  }, _vm._l((_vm.breadcrumb.concat(_vm.name)), function(entry) {
    return _c('span', {
      staticClass: "entry"
    }, [_vm._v(_vm._s(entry))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col text-right"
  }, [(_vm.isVisitable) ? _c('b-button', {
    staticClass: "action-btn",
    attrs: {
      "size": "sm",
      "href": "#",
      "variant": "info"
    },
    on: {
      "click": _vm.handleClearCacheClick
    }
  }, [_vm._v("\n\t\t\t\tCache leeren\n\t\t\t\t"), (_vm.clearCacheButtonTooltip && _vm.clearCacheButtonTooltip.text) ? _c('erco-tooltip', {
    attrs: {
      "variant": _vm.clearCacheButtonTooltip.variant,
      "title": _vm.clearCacheButtonTooltip.title,
      "text": _vm.clearCacheButtonTooltip.text,
      "invertIcon": true,
      "offsetY": "1rem"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-button-group', {
    staticClass: "preview-block"
  }, [_c('b-button', {
    staticClass: "action-btn",
    attrs: {
      "size": "sm",
      "href": "#"
    },
    on: {
      "click": _vm.handleRenewPreviewClick
    }
  }, [(_vm.isVisitable) ? _c('span', [_vm._v("\n\t\t\t\t\t\tPreview erneuern\n\t\t\t\t\t\t"), (_vm.renewPreviewButtonTooltip && _vm.renewPreviewButtonTooltip.text) ? _c('erco-tooltip', {
    attrs: {
      "variant": _vm.renewPreviewButtonTooltip.variant,
      "title": _vm.renewPreviewButtonTooltip.title,
      "text": _vm.renewPreviewButtonTooltip.text,
      "invertIcon": true,
      "offsetY": "1rem"
    }
  }) : _vm._e()], 1) : _c('span', [_vm._v("\n\t\t\t\t\t\tPreview erstellen\n\t\t\t\t\t\t"), (_vm.createPreviewButtonTooltip && _vm.createPreviewButtonTooltip.text) ? _c('erco-tooltip', {
    attrs: {
      "variant": _vm.createPreviewButtonTooltip.variant,
      "title": _vm.createPreviewButtonTooltip.title,
      "text": _vm.createPreviewButtonTooltip.text,
      "invertIcon": true,
      "offsetY": "1rem"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.isVisitable) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "href": "#"
    },
    on: {
      "click": _vm.openSiteUrl
    }
  }, [_vm._v("\n\t\t\t\t\tAnsehen\n\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), (_vm.isProductive && _vm.isVisitable) ? _c('b-button', {
    staticClass: "action-btn mr-4",
    attrs: {
      "size": "sm",
      "href": "#",
      "variant": "success"
    },
    on: {
      "click": _vm.handleRenewProductiveClickWithPreCheck
    }
  }, [_vm._v("\n\t\t\t\tOnline erneuern\n\t\t\t\t"), (_vm.renewOnlineButtonTooltip && _vm.renewOnlineButtonTooltip.text) ? _c('erco-tooltip', {
    attrs: {
      "variant": _vm.renewOnlineButtonTooltip.variant,
      "title": _vm.renewOnlineButtonTooltip.title,
      "text": _vm.renewOnlineButtonTooltip.text,
      "invertIcon": true,
      "offsetY": "1rem"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "actionConfirmation",
    staticClass: "action-confirmation-modal",
    attrs: {
      "id": "action-confirmation",
      "title": _vm.actionConfirmationModalState.title,
      "closeTitle": "Abbrechen"
    },
    on: {
      "ok": _vm.actionConfirmationModalState.okfunc
    }
  }, [_c('p', {
    staticClass: "_infotext"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.actionConfirmationModalState.text)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "selected-obj-list-container"
  }, [_c('b-list-group', {
    staticClass: "selected-obj-list"
  }, [_c('b-list-group-item', {
    staticClass: "_entry_"
  }, [_c('span', {
    staticClass: "_title font-weight-bold"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', {
    staticClass: "_id float-left text-muted"
  }, [_vm._v(_vm._s(_vm.id))]), _vm._v(" "), _c('span', {
    staticClass: "_badge"
  }, [_c('erco-status-badge', {
    attrs: {
      "status": _vm.statusname
    }
  })], 1)])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--stretch",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "rect rect-1",
    style: (_vm.rectStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect-2",
    style: (_vm.rectStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect-3",
    style: (_vm.rectStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect-4",
    style: (_vm.rectStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect-5",
    style: (_vm.rectStyles)
  })])
},staticRenderFns: []}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "objectdata-view container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8 main"
  }, _vm._l((_vm.objectdataTextItems), function(item) {
    return _c('div', {
      staticClass: "row"
    }, [_c('erco-text-input', {
      staticClass: "col-12",
      attrs: {
        "data-infotextkey": ("objectdata." + (item.labelKey)),
        "label": item.label,
        "text": item.value,
        "inputType": "input",
        "keepUnfocused": true,
        "forcePointerCursor": true,
        "forceFocusOutline": _vm.isSidebarFocused(item.labelKey),
        "error": item.mandatory === 'true' && item.value === '',
        "tooltip": _vm.tooltipFor(item),
        "charlength": item.charlength,
        "showMandatory": item.mandatory === 'true'
      },
      on: {
        "click": function($event) {
          _vm.openSidebarFor(item)
        }
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "col-4 aside"
  })])])
},staticRenderFns: []}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--two-cube",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "cube1",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "cube2",
    style: (_vm.cubeStyles)
  })])
},staticRenderFns: []}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "erco-layout-template-selection"
  }, [(_vm.sets.length > 0) ? _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.sets), function(set) {
    return _c('div', {
      key: set.PKM_Objekt,
      staticClass: "_item",
      on: {
        "click": function($event) {
          _vm.handleSetClick(set)
        }
      }
    }, [_c('b-card', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "text-muted",
      slot: "header"
    }, [_c('span', {
      attrs: {
        "data-infotextkey": _vm.infoTextKeyForSet(set)
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.fixUpperCase(set.S_de_Objekt)) + "\n\t\t\t\t\t\t"), (_vm.infoTextForSet(set)) ? _c('erco-tooltip', {
      attrs: {
        "variant": _vm.infoTextForSet(set).variant,
        "title": _vm.infoTextForSet(set).title,
        "text": _vm.infoTextForSet(set).text
      }
    }) : _vm._e()], 1)]), _vm._v(" "), _c('img', {
      staticClass: "image",
      attrs: {
        "src": _vm.getAbsolutePathForImage(set.S_Vorschaubild_url),
        "alt": ("Vorschaubild für " + (set.S_de_Objekt))
      },
      on: {
        "error": _vm.handleImageError
      }
    })])], 1)
  })) : _c('div', {
    staticClass: "_empty"
  }, [_vm._v("\n\t\tKeine Sets gefunden!\n\t")])])
},staticRenderFns: []}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setup-view container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8 main"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "Objektname",
      "text": _vm.objectname,
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "forceFocusOutline": _vm.isSidebarFocused('objectname'),
      "tooltip": _vm.infoTextFor('setup.objectname')
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor('objectname')
      }
    }
  })], 1), _vm._v(" "), (_vm.belongsToProductAreaOne) ? _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "PDB-Key",
      "text": _vm.pdbKey,
      "disabled": true,
      "keepUnfocused": true,
      "tooltip": _vm.infoTextFor('setup.pdbKey')
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "Objektzusatz",
      "text": _vm.objectadditional,
      "placeholder": "z. B.: Version 1.0",
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "forceFocusOutline": _vm.isSidebarFocused('objectadditional'),
      "tooltip": _vm.infoTextFor('setup.objectadditional')
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor('objectadditional')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "Redakteur (Ansprechpartner Gruppe Content)",
      "text": _vm.objecteditor,
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "forceFocusOutline": _vm.isSidebarFocused('objecteditor'),
      "mandatory": true,
      "tooltip": _vm.infoTextFor('setup.objecteditor')
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor('objecteditor')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "Designer (Ansprechpartner Gruppe Media)",
      "text": _vm.objectdesigner,
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "forceFocusOutline": _vm.isSidebarFocused('objectdesigner'),
      "mandatory": true,
      "tooltip": _vm.infoTextFor('setup.objectdesigner')
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor('objectdesigner')
      }
    }
  })], 1), _vm._v(" "), (_vm.isProject) ? _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "Land",
      "text": _vm.objectcountry,
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "forceFocusOutline": _vm.isSidebarFocused('objectcountry'),
      "mandatory": true,
      "tooltip": _vm.infoTextFor('setup.objectcountry')
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor('objectcountry')
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "Spezifikation",
      "text": _vm.specification,
      "keepUnfocused": true,
      "tooltip": _vm.infoTextFor('setup.specification'),
      "disabled": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "Stammgattung",
      "text": _vm.basisgenus,
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "forceFocusOutline": _vm.isSidebarFocused('basisgenus'),
      "tooltip": _vm.infoTextFor('setup.basisgenus')
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor('basisgenus')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "Tags",
      "text": _vm.categories,
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "forceFocusOutline": _vm.isSidebarFocused('categories'),
      "tooltip": _vm.infoTextFor('setup.categories')
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor('categories')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "label": "Medienformate",
      "text": _vm.mediaformats,
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "forceFocusOutline": _vm.isSidebarFocused('mediaformats'),
      "tooltip": _vm.infoTextFor('setup.mediaformats')
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor('mediaformats')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "Dreiklang",
      "text": _vm.triad,
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "forceFocusOutline": _vm.isSidebarFocused('triad'),
      "tooltip": _vm.infoTextFor('setup.triad')
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor('triad')
      }
    }
  })], 1), _vm._v(" "), (_vm.isProject) ? _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "Verwendete Produkte",
      "text": _vm.linkedProducts,
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "forceFocusOutline": _vm.isSidebarFocused('linkedProducts'),
      "tooltip": _vm.infoTextFor('setup.linkedProducts')
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor('linkedProducts')
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4",
    staticStyle: {
      "display": "none"
    }
  }, [_c('erco-checkbox-group', {
    attrs: {
      "label": "Auf der Startseite",
      "options": _vm.startpageOptions,
      "direction": "vertical",
      "tooltip": _vm.infoTextFor('setup.startpage')
    },
    on: {
      "change": _vm.handleStartpageChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('erco-checkbox-group', {
    attrs: {
      "label": "Einordnung im Light Scout",
      "options": _vm.lightscoutClassificationOptions,
      "tooltip": _vm.infoTextFor('setup.lightscoutClassification')
    },
    on: {
      "change": _vm.handleLightscoutClassificationChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('erco-checkbox-group', {
    attrs: {
      "label": "Sichtbarkeit",
      "options": _vm.visibilityOptions,
      "tooltip": _vm.infoTextFor('setup.visibility')
    },
    on: {
      "change": _vm.handleVisibilityChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('erco-checkbox-group', {
    attrs: {
      "label": "Synchsperre",
      "options": _vm.synchblockOptions,
      "tooltip": _vm.infoTextFor('setup.synchblock')
    },
    on: {
      "change": _vm.handleSynchblockChange
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 aside"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), (_vm.statusTooltip && _vm.statusTooltip.text) ? _c('erco-tooltip', {
    attrs: {
      "variant": _vm.statusTooltip.variant,
      "title": _vm.statusTooltip.title,
      "text": _vm.statusTooltip.text
    }
  }) : _vm._e(), _vm._v(" "), _c('b-dropdown', {
    staticClass: "status-dropdown",
    attrs: {
      "text": _vm.currentSelectedStatusItem.text,
      "variant": _vm.currentSelectedStatusItem.variant
    }
  }, _vm._l((_vm.status.items), function(item, index) {
    return _c('b-dropdown-item', {
      key: index,
      attrs: {
        "active": _vm.currentSelectedStatusItem.value === item.value
      },
      on: {
        "click": function($event) {
          _vm.handleStatusClick(item)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(item.text) + "\n\t\t\t\t\t\t\t\t")])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 last-changes-link"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openSidebarFor('lastchanges')
      }
    }
  }, [_vm._v("Letzte Änderungen")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12 publish-date",
    attrs: {
      "label": "Veröffentlichung planen",
      "text": _vm.formatTimestamp(_vm.publishDateTime),
      "placeholder": "Nicht geplant",
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "tooltip": _vm.infoTextFor('setup.publishdatetime'),
      "resetable": _vm.isValidPublishDateTime
    },
    on: {
      "reset": _vm.handlePublishDateTimeReset,
      "click": function($event) {
        _vm.openSidebarFor('publishdatetime')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12 go-offline-date",
    attrs: {
      "label": "Offlinesetzen planen",
      "text": _vm.formatTimestamp(_vm.goOfflineDateTime),
      "placeholder": "Nicht geplant",
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "tooltip": _vm.infoTextFor('setup.gooffdatetime'),
      "resetable": _vm.isValidGoOfflineDateTime
    },
    on: {
      "reset": _vm.handleGoOfflineDateTimeReset,
      "click": function($event) {
        _vm.openSidebarFor('gooffdatetime')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('label', [_vm._v("Prozess")]), _vm._v(" "), (_vm.processTooltip && _vm.processTooltip.text) ? _c('erco-tooltip', {
    attrs: {
      "variant": _vm.processTooltip.variant,
      "title": _vm.processTooltip.title,
      "text": _vm.processTooltip.text
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "process-block"
  }, [_c('div', {
    staticClass: "row padding-bottom"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "approval-indicator",
    class: {
      '-error': !_vm.mandatoryFieldsStatus,
      '-completed': _vm.mandatoryFieldsStatus
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "helptext fullwidth"
  }, [_vm._v(_vm._s(_vm.mandatoryFieldsText))])])]), _vm._v(" "), _vm._l((_vm.pkStatus), function(item) {
    return _c('div', {
      key: item[0],
      staticClass: "row padding-bottom"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('div', {
      staticClass: "approval-indicator",
      class: {
        '-progress': [1, 3, 4, 6, 8, 9, 10, 13, 14].indexOf(parseInt(_vm.getPkStatus(item[0]), 10)) !== -1,
          '-completed': [2, 5, 7, 11, 15, 16].indexOf(parseInt(_vm.getPkStatus(item[0]), 10)) !== -1
      }
    }), _vm._v(" "), _c('b-dropdown', {
      staticClass: "fullwidth",
      attrs: {
        "text": _vm.getPkLabel(_vm.getPkStatus(item[0])) ? _vm.getPkLabel(_vm.getPkStatus(item[0])) : _vm.approval[item[0]],
        "size": "md"
      }
    }, _vm._l((item[1]), function(value, index) {
      return _c('div', {
        key: index
      }, [_c('b-dropdown-item', {
        on: {
          "click": function($event) {
            _vm.handlePkStatusClick(value)
          }
        }
      }, [_vm._v(_vm._s(value.S_Status_Aktion))])], 1)
    }))], 1)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "export-block"
  }, [_c('a', {
    staticClass: "id-text-rtf-export",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.triggerIDTextRTFExport
    }
  }, [_vm._v("\n\t\t\t\t\tID-Text für Übersetzung herunterladen\n\t\t\t\t")])]), _vm._v(" "), (_vm.change) ? _c('div', {
    staticClass: "row bottombar"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [(_vm.change.info) ? _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_c('b-alert', {
    staticClass: "info_",
    attrs: {
      "variant": _vm.change.info.variant,
      "show": ""
    }
  }, [(_vm.change.info.title) ? _c('span', {
    staticClass: "_title"
  }, [_vm._v(_vm._s(_vm.change.info.title) + ":")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "_text"
  }, [_vm._v(_vm._s(_vm.change.info.text))])])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row controls"
  }, [_c('div', {
    staticClass: "col col-auto"
  }, [_c('b-button', {
    staticClass: "apply",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleAsideChangeWithPreCheck
    }
  }, [_vm._v("Bestätigen")]), _vm._v(" "), _c('b-button', {
    staticClass: "cancel",
    on: {
      "click": _vm.handleAsideCancel
    }
  }, [_vm._v("Abbrechen")])], 1)])])]) : _vm._e()])]), _vm._v(" "), _c('b-modal', {
    ref: "actionConfirmation",
    staticClass: "action-confirmation-modal",
    attrs: {
      "id": "action-confirmation",
      "title": _vm.actionConfirmationModalState.title,
      "closeTitle": "Abbrechen"
    },
    on: {
      "ok": _vm.handleAsideChange
    }
  }, [_c('p', {
    staticClass: "_infotext"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.actionConfirmationModalState.text)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "selected-obj-list-container"
  }, [_c('b-list-group', {
    staticClass: "selected-obj-list"
  }, [_c('b-list-group-item', {
    staticClass: "_entry_"
  }, [_c('span', {
    staticClass: "_title font-weight-bold"
  }, [_vm._v(_vm._s(_vm.objectname))]), _vm._v(" "), _c('span', {
    staticClass: "_id float-left text-muted"
  }, [_vm._v(_vm._s(_vm.objectid))]), _vm._v(" "), _c('span', {
    staticClass: "_badge"
  }, [_c('erco-status-badge', {
    attrs: {
      "status": _vm.objectstatus
    }
  })], 1)])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--mikepad",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_c('div', {
    staticClass: "binding"
  }), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pad"
  }, [_c('div', {
    staticClass: "line line1"
  }), _vm._v(" "), _c('div', {
    staticClass: "line line2"
  }), _vm._v(" "), _c('div', {
    staticClass: "line line3"
  })])
}]}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "erco-text-input"
  }, [_c('label', {
    staticClass: "label_",
    attrs: {
      "droppable": ("" + _vm.droppable)
    },
    on: {
      "!click": function($event) {
        _vm.handleLabelClick($event)
      }
    }
  }, [_c('span', {
    staticClass: "_text text-muted"
  }, [_vm._v(_vm._s(_vm.label || ' ') + " "), (_vm.showMandatory) ? _c('sup', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.tooltip && _vm.tooltip.text) ? _c('erco-tooltip', {
    attrs: {
      "variant": _vm.tooltip.variant,
      "title": _vm.tooltip.title,
      "text": _vm.tooltip.text
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "_input-col col-12"
  }, [_c('b-input-group', [_c('b-form-input', {
    ref: "input",
    class: ['_input', {
      '_focus-outline': _vm.forceFocusOutline,
      '_error': _vm.error
    }],
    style: (_vm.inputStyle),
    attrs: {
      "textarea": _vm.isLongOrComplexText,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    on: {
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "change": _vm.handleChange,
      "input": _vm.handleInput
    },
    model: {
      value: (_vm.textvalue),
      callback: function($$v) {
        _vm.textvalue = $$v
      },
      expression: "textvalue"
    }
  }), _vm._v(" "), (this.isResetable) ? _c('b-input-group-button', [_c('b-button', {
    staticClass: "_reset",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        _vm.handleReset($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t×\n\t\t\t\t\t\t")])], 1) : _vm._e()], 1)], 1)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "erco-tooltip",
    on: {
      "mouseenter": function($event) {
        _vm.handleMouseHover(true)
      },
      "mouseleave": function($event) {
        _vm.handleMouseHover(false)
      }
    }
  }, [_c('div', {
    staticClass: "pictogram_"
  }, [(_vm.invertIcon) ? _c('img', {
    staticClass: "_picto_image",
    attrs: {
      "src": __webpack_require__(497),
      "alt": "i"
    }
  }) : _c('img', {
    staticClass: "_picto_image",
    attrs: {
      "src": __webpack_require__(498),
      "alt": "i"
    }
  })]), _vm._v(" "), _c('div', {
    ref: "tooltipBox",
    staticClass: "tooltip-box",
    class: {
      visible: _vm.tooltipVisible
    },
    style: (_vm.tooltipBoxStyle)
  }, [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": _vm.variant
    }
  }, [(_vm.title) ? _c('span', {
    staticClass: "_title"
  }, [_vm._v(_vm._s(_vm.title) + ":")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "_text"
  }, [_vm._v(_vm._s(_vm.text))])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--texture",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-image-editor"
  }, [_c('div', {
    staticClass: "padding-bottom"
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor(_vm.data)
      }
    }
  }, [_vm._v("\n\t\t\tBild aus MAM laden\n\t\t")]), _vm._v(" "), (_vm.imageData.value) ? _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.prepareImageDeletion
    }
  }, [_vm._v("\n\t\t\tBild löschen\n\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('erco-image-editor', {
    ref: "image-editor",
    attrs: {
      "data": _vm.imageData
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--google",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "sidebarDropdown",
    staticClass: "sidebar-dropdown"
  }, _vm._l((_vm.data), function(entry, index) {
    return _c('div', {
      key: entry.key,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('erco-dropdown', {
      staticClass: "_input",
      attrs: {
        "items": _vm.mapItems(entry.enum),
        "currentItemIndex": _vm.getCurrentItemIndexFor(entry)
      },
      on: {
        "change": function($event) {
          _vm.handleSelect(index, $event)
        }
      }
    })], 1)])
  }))
},staticRenderFns: []}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--square-grid",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "sk-cube sk-cube1",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube2",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube3",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube4",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube5",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube6",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube7",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube8",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube9",
    style: (_vm.cubeStyles)
  })])
},staticRenderFns: []}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    staticClass: "object-card",
    attrs: {
      "header-tag": "header",
      "footer-tag": "footer"
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('a', {
    attrs: {
      "href": _vm.objectviewUrl
    }
  }, [_c('div', {
    staticClass: "image",
    style: (("background-image: url(" + _vm.imagePath + ");"))
  })]), _vm._v(" "), (!_vm.markedForDeletion) ? _c('div', {
    staticClass: "checkbox_"
  }, [_c('b-form-checkbox', {
    staticClass: "_input",
    attrs: {
      "plain": "",
      "checked": _vm.isChecked
    },
    on: {
      "change": function($event) {
        _vm.handleCheckClick(_vm.objectId, $event)
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [(_vm.isVisitable) ? _c('erco-dropdown', {
    attrs: {
      "size": "sm",
      "items": _vm.actionSelectionItems,
      "label": "Ansehen",
      "useLabelInline": true
    },
    on: {
      "change": _vm.handleActionSelectionChange
    }
  }) : _vm._e(), _vm._v(" "), _c('erco-status-badge', {
    staticClass: "badge float-right",
    attrs: {
      "status": _vm.computedStatus
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('h4', {
    staticClass: "card-title font-weight-bold"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.type))]), _vm._v(" "), _c('div', {
    staticClass: "cms-structure-info"
  }, [_c('div', {
    staticClass: "_item"
  }, [_vm._v(_vm._s(_vm.category))]), _vm._v(" "), _c('div', {
    staticClass: "_item"
  }, [_vm._v(_vm._s(_vm.specification))]), _vm._v(" "), _c('div', {
    staticClass: "_item"
  }, [_vm._v(_vm._s(_vm.genus))])]), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_c('div', {
    staticClass: "time-wrapper"
  }, [_c('span', {
    staticClass: "time -online"
  }, [_c('span', {
    staticClass: "pictogram"
  }), _vm._v(" "), (_vm.clearPublishDateTime) ? _c('time', {
    staticClass: "text-muted",
    attrs: {
      "datetime": _vm.publishDateTime
    }
  }, [_vm._v(_vm._s(_vm.clearPublishDateTime))]) : _c('span', {
    staticClass: "text-muted"
  })]), _vm._v(" "), _c('span', {
    staticClass: "time -offline"
  }, [_c('span', {
    staticClass: "pictogram"
  }), _vm._v(" "), (_vm.clearOfflineDateTime) ? _c('time', {
    staticClass: "text-muted",
    attrs: {
      "datetime": _vm.offlineDateTime
    }
  }, [_vm._v(_vm._s(_vm.clearOfflineDateTime))]) : _c('span', {
    staticClass: "text-muted"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "objectid text-muted"
  }, [_vm._v(_vm._s(_vm.objectId))])])])])
},staticRenderFns: []}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown-label-box d-inline-block"
  }, [(_vm.label && !_vm.useLabelInline) ? _c('span', {
    staticClass: "label text-muted"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('b-dropdown', {
    ref: "dropdown",
    staticClass: "dropdown",
    attrs: {
      "text": _vm.selectedItemText,
      "size": _vm.size,
      "right": _vm.right
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: item.text,
      on: {
        "contextmenu": function($event) {
          _vm.handleClick($event, index, true)
        }
      }
    }, [_c('b-dropdown-item', {
      attrs: {
        "active": _vm.selectedCurrentItemIndex === index
      },
      on: {
        "click": function($event) {
          _vm.handleClick($event, index, false)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(item.text) + "\n\t\t\t")])], 1)
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--cube-shadow",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--rotate-square",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "spinner spinner--rotate-diamond",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "diamond",
    style: (_vm.diamondStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "diamond",
    style: (_vm.diamondStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "diamond",
    style: (_vm.diamondStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-last-changes"
  }, [_c('b-table', {
    attrs: {
      "hover": "",
      "items": _vm.items,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "type",
      fn: function(cell) {
        return [(cell.value === 'creation') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(197),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'creation_template_set') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(480),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'status_change') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(489),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'image_delete') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(483),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'image_upload') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(484),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'image_change') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(482),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'text_change') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(492),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'site_delete') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(487),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'site_add') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(486),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'site_sort') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(488),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'label_add') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(485),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'assign_to_person') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(475),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'translation_request') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(494),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'translation_finished') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(493),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'assignment_request') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(478),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'assignment_feedback') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(476),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'assignment_finished') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(477),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'synchronization_request') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(491),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'synchronization') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(490),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'empty_copy') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(197),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'basedata_change') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(479),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'unknown') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": __webpack_require__(481),
            "alt": cell.value
          }
        }) : _vm._e()]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--gauge",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  })])
},staticRenderFns: []}

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "erco-group-options"
  }, [(_vm.label) ? _c('label', {
    staticClass: "label text-muted"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.label) + "\n\t")]) : _vm._e(), _vm._v(" "), _c('b-button-group', {
    staticClass: "option-group"
  }, _vm._l((_vm.options), function(option, index) {
    return _c('b-button', {
      key: index,
      staticClass: "option",
      attrs: {
        "size": _vm.size,
        "variant": option.active ? 'primary' : ''
      },
      on: {
        "click": function($event) {
          _vm.handleOptionClick(option)
        }
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(option.text) + "\n\t\t")])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "spinner spinner--circle",
    style: (_vm.styles),
    attrs: {
      "viewBox": "0 0 66 66",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "fill": "none",
      "stroke-width": "6",
      "stroke-linecap": "round",
      "cx": "33",
      "cy": "33",
      "r": "30"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "erco-back-to-top-button-fade"
    }
  }, [(_vm.buttonIsVisible) ? _c('div', {
    staticClass: "erco-back-to-top-button"
  }, [_c('b-button', {
    staticClass: "btn",
    attrs: {
      "size": "sm",
      "title": "Nach oben"
    },
    on: {
      "click": _vm.handleBackToTopClick
    }
  }, [_c('span', {
    staticClass: "chevron"
  })])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "sidebarTextInput",
    staticClass: "sidebar-text-input"
  }, _vm._l((_vm.data), function(input, index) {
    return _c('div', {
      key: input.key,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('erco-text-input', {
      staticClass: "_input",
      attrs: {
        "label": input.label,
        "text": input.text,
        "inputType": "auto",
        "resetable": true,
        "charlength": input.charlength
      },
      on: {
        "input": function($event) {
          _vm.handleInput(index, $event)
        },
        "reset": function($event) {
          _vm.handleReset(index)
        }
      }
    })], 1)])
  }))
},staticRenderFns: []}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('circle-spinner', {
    class: ['erco-spinner', {
      '-fixed-color': _vm.isFixedColor
    }],
    attrs: {
      "size": this.size
    }
  })
},staticRenderFns: []}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "number-stepper"
  }, [_c('b-input-group', {
    staticClass: "stepper-input"
  }, [_c('b-button', {
    staticClass: "-prev",
    on: {
      "click": _vm.innerStepDown
    }
  }, [_vm._v("◀")]), _vm._v(" "), _c('b-form-input', {
    staticClass: "-value",
    class: _vm.inputClasses,
    attrs: {
      "value": _vm.leftPaddedValue
    },
    on: {
      "input": _vm.handleInputValue
    }
  }), _vm._v(" "), _c('b-button', {
    staticClass: "-next",
    on: {
      "click": _vm.innerStepUp
    }
  }, [_vm._v("▶")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "layout-preview-block",
    staticClass: "layout-preview-block"
  }, [_c('div', {
    staticClass: "data-wrapper",
    attrs: {
      "data-specification": _vm.specification,
      "data-category": _vm.category,
      "data-id-area": _vm.idArea,
      "data-id-objekt": _vm.idObject,
      "data-bool-gattungsobjekt": _vm.isGenus
    }
  }, [_c('erco-layout-divider-action-bar', {
    attrs: {
      "prevSiteDataset": false,
      "nextSiteDataset": _vm.datasets[0]
    }
  }), _vm._v(" "), _vm._l((_vm.datasets), function(dataset) {
    return _c('div', {
      key: ("{dataset.lang}" + (dataset.id)),
      staticClass: "item-wrapper",
      attrs: {
        "data-dev-info": ("{ type: 'module', id: '" + (dataset.id) + "', sitenumber: " + (dataset.sitenumber) + ", topicId: '" + (dataset.topicId) + "', templateId: '" + (dataset.templateId) + "', templatePath: '" + (dataset.templatePath) + "' }")
      }
    }, [_c('erco-layout-preview-item', {
      attrs: {
        "dataset": dataset,
        "objecttype": _vm.objecttype,
        "objectname": _vm.objectname
      }
    }), _vm._v(" "), _c('erco-layout-divider-action-bar', {
      attrs: {
        "prevSiteDataset": dataset,
        "nextSiteDataset": _vm.getNextSiteDatasetAfter(dataset)
      }
    })], 1)
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-view"
  }, [(_vm.sites.length === 0 && _vm.sitesFinishedLoading) ? _c('erco-layout-template-selection', {
    attrs: {
      "sets": _vm.templateSets
    }
  }) : _vm._e(), _vm._v(" "), (_vm.sites.length > 0) ? _c('erco-layout-preview-block', {
    staticClass: "preview-block",
    attrs: {
      "datasets": _vm.sites
    }
  }) : _vm._e(), _vm._v(" "), _c('erco-back-to-top-button', {
    attrs: {
      "thresholdType": "windowHeight"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--spin-line",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.lineStyles)
  })])
},staticRenderFns: []}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-wrap"
  }, [(_vm.ordered) ? _c('ol', _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      key: index,
      attrs: {
        "draggable": ("" + _vm.draggable)
      },
      on: {
        "dragstart": function($event) {
          _vm.handleDragStart(index, $event)
        }
      }
    }, [_vm._v("\n\t\t    " + _vm._s(item.text) + "\n\t\t")])
  })) : _vm._e(), _vm._v(" "), (!_vm.ordered) ? _c('ul', _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      key: index,
      attrs: {
        "draggable": ("" + _vm.draggable)
      },
      on: {
        "dragstart": function($event) {
          _vm.handleDragStart(index, $event)
        }
      }
    }, [_vm._v("\n\t\t    " + _vm._s(item.text) + "\n\t\t")])
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-badge', {
    staticClass: "erco-status-badge",
    attrs: {
      "variant": _vm.badgeVariant
    }
  }, [_vm._v(_vm._s(_vm.uppercasedStatus))])
},staticRenderFns: []}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "option-group"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.label) + "\n\t")]), _vm._v(" "), (_vm.tooltip && _vm.tooltip.text) ? _c('erco-tooltip', {
    attrs: {
      "variant": _vm.tooltip.variant,
      "title": _vm.tooltip.title,
      "text": _vm.tooltip.text
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chained) ? _c('div', {
    staticClass: "wrap"
  }, [_c('b-form-radio', {
    attrs: {
      "options": _vm.options,
      "stacked": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.valueChained),
      callback: function($$v) {
        _vm.valueChained = $$v
      },
      expression: "valueChained"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.chained) ? _c('div', {
    staticClass: "wrap",
    on: {
      "!click": function($event) {
        _vm.handleWrapClick($event)
      }
    }
  }, _vm._l((_vm.options), function(option, index) {
    return _c('b-form-radio', {
      key: option.value,
      attrs: {
        "options": [option],
        "stacked": ""
      },
      on: {
        "change": _vm.handleChange
      },
      model: {
        value: (_vm.value[index]),
        callback: function($$v) {
          var $$exp = _vm.value,
            $$idx = index;
          if (!Array.isArray($$exp)) {
            _vm.value[index] = $$v
          } else {
            $$exp.splice($$idx, 1, $$v)
          }
        },
        expression: "value[index]"
      }
    })
  })) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid e-menu"
  }, [_c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      class: {
        'item': true, '-active': item.active
      },
      on: {
        "click": function($event) {
          _vm.jumpTo(item.name)
        }
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(item.title) + "\n\t\t")])
  })), _vm._v(" "), (_vm.languageSelectorIsVisible) ? _c('erco-dropdown', {
    staticClass: "lang-selector",
    attrs: {
      "size": "sm",
      "right": true,
      "currentItemIndex": _vm.selectedLangIndex,
      "items": _vm.langs
    },
    on: {
      "change": _vm.handleLanguageChange
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "sidebarBasisgenus",
    staticClass: "sidebar-basisgenus"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "list-col col-6"
  }, [_c('erco-list', {
    staticClass: "list-available-genus",
    attrs: {
      "items": _vm.data.draggable,
      "draggable": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "destinations-col col-6"
  }, _vm._l((_vm.data.destinations), function(destination, index) {
    return _c('div', {
      key: index,
      staticClass: "input-wrapper",
      on: {
        "dragover": function($event) {
          _vm.handleDragOver($event)
        },
        "drop": function($event) {
          _vm.handleDrop(index, $event)
        }
      }
    }, [_c('erco-text-input', {
      attrs: {
        "keepUnfocused": true,
        "label": destination.label,
        "text": destination.text,
        "resetable": true,
        "droppable": true
      },
      on: {
        "reset": function($event) {
          _vm.handleReset(index)
        }
      }
    })], 1)
  }))])])
},staticRenderFns: []}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date-time-picker"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-date"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('erco-number-stepper', {
    staticClass: "year-stepper",
    attrs: {
      "value": _vm.currentVisibleYear,
      "validator": _vm.inputYearValidator
    },
    on: {
      "change": _vm.handleInputYear
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-8"
  }, [_c('erco-dropdown', {
    staticClass: "month-stepper",
    attrs: {
      "label": "",
      "items": _vm.months,
      "currentItemIndex": _vm.currentMonthIndex,
      "styleInfo": {
        width: '9rem',
        textAlign: 'right'
      }
    },
    on: {
      "change": _vm.handleChangeMonth
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-time"
  }, [_c('erco-number-stepper', {
    staticClass: "hour-stepper",
    attrs: {
      "min": 0,
      "max": 23,
      "leftPadLength": 2,
      "value": _vm.hours
    },
    on: {
      "change": _vm.handleChangeHour
    }
  }), _vm._v("\n\t\t\t:\n\t\t\t"), _c('erco-number-stepper', {
    staticClass: "minute-stepper",
    attrs: {
      "min": 0,
      "max": 59,
      "leftPadLength": 2,
      "value": _vm.minutes
    },
    on: {
      "change": _vm.handleChangeMinute
    }
  }), _vm._v("\n\t\t\tUhr\n\t\t")], 1)]), _vm._v(" "), _c('table', {
    staticClass: "table month-layer mt-5"
  }, [_c('thead', _vm._l((_vm.weekdays), function(item) {
    return _c('th', {
      staticClass: "weekday-entry"
    }, [_vm._v(_vm._s(item))])
  })), _vm._v(" "), _c('tbody', _vm._l((_vm.weeks), function(week) {
    return _c('tr', _vm._l((week), function(day) {
      return _c('td', {
        class: {
          'day-entry': true, '-selected': day.isSelected
        },
        on: {
          "click": function($event) {
            _vm.handleClickDay(day.num)
          }
        }
      }, [_vm._v("\n\t\t\t    \t" + _vm._s(day.text) + "\n\t\t\t    ")])
    }))
  }))])])
},staticRenderFns: []}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.visibleItems), function(item, index) {
    return _c('div', {
      staticClass: "col-sm-6 col-lg-4 col-xl-3 card-container"
    }, [_c('erco-object-card', {
      attrs: {
        "title": item.S_de_Objekt,
        "type": item.S_Zusatz,
        "imageSrc": item.S_Stellvertreterbild,
        "date": item.TS_Aenderungsdatum,
        "publishdate": item.TS_online_Liveserver,
        "offlinedate": item.TS_offline_Liveserver,
        "objectId": item.PKM_Objekt,
        "status": item.S_Status,
        "onlineUrl": item.onlineUrl,
        "previewUrl": item.previewUrl,
        "isProductive": item.isProductive,
        "checked": _vm.belongsToSelection(item.PKM_Objekt),
        "category": item.S_Bereich,
        "specification": item.S_Spezifikation,
        "genus": item.S_Gattung
      }
    })], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h2', [_vm._v(_vm._s(_vm.headline))]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, _vm._l((_vm.contents), function(item, index) {
    return _c('li', [_c('a', {
      staticClass: "nav-link",
      class: _vm.getClassObject(index),
      attrs: {
        "data-item-index": index,
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changeContent($event)
        }
      }
    }, [_vm._v(_vm._s(item.language))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.ismultiline) ? _c('erco-text-area', {
    attrs: {
      "text": _vm.contents[_vm.currentContentIndex].text
    }
  }) : _c('erco-text-input', {
    attrs: {
      "text": _vm.contents[_vm.currentContentIndex].text
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--plane",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "plane"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask",
    attrs: {
      "id": "middle"
    }
  }, [_c('div', {
    staticClass: "plane"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask",
    attrs: {
      "id": "bottom"
    }
  }, [_c('div', {
    staticClass: "plane"
  })])
}]}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid p-0 objectview-wrapper"
  }, [_c('div', {
    staticClass: "row no-gutters header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('erco-header', {
    attrs: {
      "name": _vm.objectName,
      "id": _vm.objectId,
      "breadcrumb": _vm.breadcrumb,
      "previewUrl": _vm.objectPreviewUrl,
      "status": _vm.objectStatus,
      "stati": _vm.stati,
      "isProductive": _vm.objectIsProductive
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row no-gutters view-menu"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('erco-menu', {
    attrs: {
      "items": _vm.subviews,
      "jumpTo": _vm.jumpTo,
      "lang": _vm.objectLanguage
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row no-gutters main"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('erco-main', [_c('keep-alive', [(_vm.objectDataset) ? _c(_vm.view, {
    tag: "component",
    attrs: {
      "dataset": _vm.objectDataset
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sidebar"
    }
  }, [(_vm.sidebar.visible) ? _c('erco-sidebar', {
    attrs: {
      "sidebar": _vm.sidebar
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.loading) ? _c('erco-cloak') : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-editor"
  }, [(_vm.imgNode) ? _c('div', [_c('div', {
    staticClass: "img-wrapper"
  }, [_c('div', {
    staticClass: "img-container",
    class: {
      "-enable-hud": !_vm.drag.dragging && !_vm.misc.picking,
        "-picking": _vm.misc.picking,
        "-dragging": _vm.drag.dragging,
    },
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('canvas', {
    directives: [{
      name: "draw",
      rawName: "v-draw",
      value: (_vm.drawObject()),
      expression: "drawObject()"
    }],
    staticClass: "canvas",
    on: {
      "mousedown": _vm.startDrag,
      "touchstart": _vm.startDrag,
      "mousemove": _vm.onDrag,
      "touchmove": function($event) {
        $event.preventDefault();
        _vm.onDrag($event)
      },
      "mouseup": _vm.stopDrag,
      "touchend": _vm.stopDrag,
      "mouseleave": _vm.stopDrag
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "crosshair"
  }), _vm._v(" "), _c('div', {
    staticClass: "hud"
  }, [_c('span', {
    staticClass: "group",
    on: {
      "mousedown": _vm.startSlide,
      "touchstart": _vm.startSlide,
      "mousemove": _vm.onSlide,
      "touchmove": _vm.onSlide,
      "mouseup": _vm.stopSlide,
      "touchend": _vm.stopSlide,
      "mouseleave": _vm.stopSlide
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sliderrotation),
      expression: "sliderrotation"
    }],
    staticClass: "slider center-bottom",
    style: ({
      width: 2 / 3 * 100 + "%"
    }),
    attrs: {
      "type": "range",
      "min": "-18000",
      "max": "18000"
    },
    domProps: {
      "value": (_vm.sliderrotation)
    },
    on: {
      "__r": function($event) {
        _vm.sliderrotation = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sliderScale),
      expression: "sliderScale"
    }],
    staticClass: "slider center-right",
    style: ({
      width: 2 / 3 * 100 * this.ratio + "%"
    }),
    attrs: {
      "type": "range",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.sliderScale)
    },
    on: {
      "__r": function($event) {
        _vm.sliderScale = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "slider-button scale-grow",
    on: {
      "click": function($event) {
        _vm.changeScaleLevel(1)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t       +\n\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "slider-button scale-shrink",
    on: {
      "click": function($event) {
        _vm.changeScaleLevel(-1)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t       -\n\t\t\t\t\t\t")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 group sizes"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Rahmen")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "id": "border-checkbox",
      "value": "j",
      "unchecked-value": "n"
    },
    model: {
      value: (_vm.border),
      callback: function($$v) {
        _vm.border = $$v
      },
      expression: "border"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tRahmen hinzufügen\n\t\t\t\t\t    ")])], 1), _vm._v(" "), (_vm.sizes.length > 1) ? _c('div', {
    staticClass: "col-lg-6 col-md-12 group sizes"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Seitenverhältnis")]), _vm._v(" "), _c('b-button-group', _vm._l((_vm.sizes), function(size) {
    return _c('b-button', {
      key: size.name,
      attrs: {
        "variant": (size.name === _vm.selectedSize) ? 'primary' : '',
        "data-name": size.name
      },
      on: {
        "click": function($event) {
          _vm.handleSizeClick(size.name)
        }
      }
    }, [_c('div', {
      staticClass: "ratio-block",
      style: (_vm.getRatioBlockStyle(size)),
      attrs: {
        "title": size.name
      }
    })])
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.backgrounds.length > 1) ? _c('div', {
    staticClass: "col-lg-6 col-md-12 group backgrounds"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Hintergrundfarbe")]), _vm._v(" "), _c('b-button-group', [_vm._l((_vm.backgrounds), function(background) {
    return (background.value) ? _c('b-button', {
      key: background.name,
      class: {
        '-selected': background.name === _vm.selectedBackground
      },
      style: (("background-color: " + (background.value) + ";")),
      attrs: {
        "title": background.value,
        "data-name": background.name
      },
      on: {
        "click": function($event) {
          _vm.handleBackgroundColorClick(background.name)
        }
      }
    }, [_c('span', [_vm._v(" ")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-secondary entered-color",
    class: {
      '-selected': _vm.enteredBackground.name === _vm.selectedBackground
    },
    style: (("background-color: " + (_vm.enteredBackground.value) + ";")),
    on: {
      "click": function($event) {
        _vm.handleBackgroundColorClick(_vm.enteredBackground.name)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enteredBackground.value),
      expression: "enteredBackground.value"
    }],
    staticClass: "color-code",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.enteredBackground.value)
    },
    on: {
      "change": function($event) {
        _vm.handleBackgroundColorClick(_vm.enteredBackground.name)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.enteredBackground.value = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('b-button', {
    staticClass: "colorpicker",
    on: {
      "click": _vm.colorPicker
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": __webpack_require__(495),
      "alt": "Color"
    }
  })])], 2)], 1) : _vm._e()])])]) : _c('div', [_c('img', {
    staticClass: "placeholder",
    attrs: {
      "src": __webpack_require__(55)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "live-view"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('erco-header', {
    attrs: {
      "name": _vm.objectName,
      "id": _vm.objectId,
      "processstate": _vm.processState
    },
    on: {
      "change": _vm.handleActionChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "frame"
  }, [(_vm.objectIsLoading || _vm.isUpdatingStatus) ? _c('erco-cloak') : _vm._e(), _vm._v(" "), (!_vm.objectIsLoading) ? _c('div', {
    staticClass: "frame-inner"
  }, [(_vm.objectUrl) ? _c('iframe', {
    staticClass: "iframe",
    attrs: {
      "src": _vm.objectUrl
    }
  }) : _c('div', {
    staticClass: "not-found-info"
  }, [_c('b-alert', {
    staticClass: "info-text",
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_vm._v("\n\t\t\t\t\tDas Objekt besitzt noch keine URL\n\t\t\t\t")])], 1)], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "seo-view container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8 main"
  }, _vm._l((_vm.objectdataSeoTextItems), function(item) {
    return _c('div', {
      staticClass: "row"
    }, [_c('erco-text-input', {
      staticClass: "col-12",
      attrs: {
        "data-infotextkey": ("objectdata." + (item.labelKey)),
        "label": item.label,
        "text": _vm.getInputTextFor(item),
        "inputType": "input",
        "keepUnfocused": true,
        "forcePointerCursor": true,
        "forceFocusOutline": _vm.isSidebarFocused(item.labelKey),
        "error": item.mandatory === 'true' && item.value === '',
        "tooltip": _vm.tooltipFor(item),
        "showMandatory": item.mandatory === 'true',
        "charlength": item.charlength
      },
      on: {
        "click": function($event) {
          _vm.openSidebarFor(item)
        }
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "col-4 aside"
  })])])
},staticRenderFns: []}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-datetimepicker"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('erco-date-time-picker', {
    attrs: {
      "datetime": _vm.data.datetime,
      "fallbackDatetime": _vm.now
    },
    on: {
      "change": _vm.handleDateTimePickerChange
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--jumper",
    style: (_vm.styles)
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
},staticRenderFns: []}

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--scale-out",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "sidebarTextInput",
    staticClass: "sidebar-tags"
  }, [_c('div', {
    staticClass: "tags"
  }, _vm._l((_vm.data.tags), function(tag, index) {
    return _c('b-badge', {
      key: tag.text,
      staticClass: "tag mb-2",
      attrs: {
        "variant": "primary"
      }
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(tag.text) + " "), _c('span', {
      staticClass: "tag badge badge-pill badge-info"
    }, [_vm._v(_vm._s(tag.s_attribut))]), _vm._v(" "), _c('span', {
      staticClass: "tag badge badge-pill badge-primary",
      style: ({
        'background-color': tag.color
      })
    }, [_vm._v(_vm._s(tag.s_type))])]), _vm._v(" "), _c('span', {
      staticClass: "remove",
      on: {
        "click": function($event) {
          _vm.handleTagRemove(index)
        }
      }
    }, [_vm._v("×")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('erco-text-input', {
    ref: "inputField",
    staticClass: "tagInput",
    attrs: {
      "text": _vm.tagInputText
    },
    on: {
      "input": _vm.handleChange
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "suggestions"
    }
  }, [_c('div', {
    staticClass: "suggestions-wrapper",
    on: {
      "click": _vm.handleSuggestionClick
    }
  }, [_c('p', {
    staticClass: "suggestions-title"
  }, [_vm._v("Vorschläge")]), _vm._v(" "), _c('div', {
    staticClass: "spinner-container"
  }, [(_vm.loading) ? _c('erco-spinner', {
    attrs: {
      "is-fixed-color": true
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.suggestions) ? _c('b-list-group', {
    staticClass: "suggestions"
  }, _vm._l((_vm.suggestions), function(suggestion, index) {
    return _c('div', [_c('b-list-group-item', {
      key: suggestion,
      attrs: {
        "action": true,
        "data-index": index
      }
    }, [_c('span', {
      staticClass: "mr-2"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(suggestion.S_Value) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
      staticClass: "tag badge badge-pill badge-info"
    }, [_vm._v(_vm._s(suggestion.S_Attribut))]), _vm._v(" "), _c('span', {
      staticClass: "tag badge badge-pill badge-primary",
      style: ({
        'background-color': suggestion.color
      })
    }, [_vm._v(_vm._s(suggestion.S_Type))])])], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.suggestions && _vm.suggestions.length === 1) ? _c('div', {
    staticClass: "info_"
  }, [_c('span', {
    staticClass: "_text"
  }, [_vm._v("Keine Vorschläge gefunden")])]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner-origami",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner loading",
    style: (_vm.innerStyles)
  }, [_c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  })])])
},staticRenderFns: []}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "blob top",
    style: (_vm.blobStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "blob bottom",
    style: (_vm.blobStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "blob left",
    style: (_vm.blobStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "blob move-blob",
    style: (_vm.moveBlobStyles)
  })])
},staticRenderFns: []}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--socker",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel center-gel"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c1 r1"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c2 r1"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c3 r1"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c4 r1"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c5 r1"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c6 r1"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c7 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c8 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c9 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c10 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c11 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c12 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c13 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c14 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c15 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c16 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c17 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c18 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c19 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c20 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c21 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c22 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c23 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c24 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c25 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c26 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c28 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c29 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c30 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c31 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c32 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c33 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c34 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c35 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c36 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c37 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
}]}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--jawn"
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "jawn",
    style: (_vm.innerStyles)
  })])])
},staticRenderFns: []}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-site-editor"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('erco-options-group', {
    attrs: {
      "label": "Sprache",
      "size": "sm",
      "options": _vm.langs
    },
    on: {
      "click": _vm.handleLangClick
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('erco-dropdown', {
    staticClass: "mr-3",
    attrs: {
      "label": "Paginierung",
      "size": "sm",
      "items": _vm.pagination.items,
      "currentItemIndex": _vm.pagination.selectedIndex
    },
    on: {
      "change": _vm.handlePaginationChange
    }
  }), _vm._v(" "), _c('erco-dropdown', {
    staticClass: "mr-3",
    attrs: {
      "label": "Abstand unten",
      "size": "sm",
      "items": _vm.distanceBelow.items,
      "currentItemIndex": _vm.distanceBelow.selectedIndex
    },
    on: {
      "change": _vm.handleDistanceBelowChange
    }
  }), _vm._v(" "), _c('erco-dropdown', {
    staticClass: "mr-3",
    attrs: {
      "label": "Hintergrund",
      "size": "sm",
      "items": _vm.backgroundType.items,
      "currentItemIndex": _vm.backgroundType.selectedIndex
    },
    on: {
      "change": _vm.handleBackgroundTypeChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row row-distance-above"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('erco-text-input', {
    attrs: {
      "label": "Überschrift",
      "text": _vm.title
    },
    on: {
      "change": _vm.handleTitleChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('erco-text-area', {
    staticClass: "image-subtitle",
    attrs: {
      "label": "Bildunterschrift",
      "text": _vm.imageSubtitle
    },
    on: {
      "change": _vm.handleImageSubtitleChange
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "row subtitle-row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('erco-text-input', {
    attrs: {
      "label": "Überschrift",
      "text": _vm.subtitle
    },
    on: {
      "change": _vm.handleSubtitleChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row text-row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('erco-text-area', {
    staticClass: "text-textarea",
    attrs: {
      "label": "Text",
      "text": _vm.text
    },
    on: {
      "change": _vm.handleTextChange
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "multiform-items"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Multiform")]), _vm._v(" "), _vm._l((_vm.multiformItems), function(multiformItem) {
    return _c('div', {
      key: multiformItem.id,
      class: ['multiform-item', multiformItem.type]
    }, [(multiformItem.type === 'text') ? _c('erco-text-input', {
      attrs: {
        "label": multiformItem.label,
        "text": multiformItem.values.value
      },
      on: {
        "change": function($event) {
          _vm.handleMultiformInputChange(_vm.index, $event)
        }
      }
    }) : (multiformItem.type === 'image') ? _c('erco-text-input', {
      attrs: {
        "label": multiformItem.label,
        "text": multiformItem.values.value
      },
      on: {
        "change": function($event) {
          _vm.handleMultiformInputChange(multiformItem, $event)
        }
      }
    }) : _c('div', [_vm._v("\n\t\t    \tUnbekannter Item-Typ: " + _vm._s(multiformItem.type) + "\n\t\t    ")])], 1)
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 img-editor"
  }, [_c('label', [_c('span', {
    staticClass: "label text-muted",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Bild")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%",
      "margin-top": "0.4rem"
    },
    attrs: {
      "src": "http://placehold.it/600x600"
    }
  })])])])
}]}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-triad"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "tab-col col-12"
  }, [_c('b-tabs', {
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, _vm._l((_vm.data.tabs), function(tab, index) {
    return _c('b-tab', {
      key: index,
      attrs: {
        "title": _vm.tabTitle(index)
      }
    }, [_c('div', {
      staticClass: "tab-wrap"
    }, [_c('ul', {
      staticClass: "tab-list"
    }, _vm._l((tab.groups), function(group, g_index) {
      return _c('li', {
        key: g_index,
        staticClass: "group-list"
      }, [_c('span', {
        staticClass: "group-title"
      }, [_vm._v(_vm._s(group.title))]), _vm._v(" "), _c('ul', {
        staticClass: "item-list"
      }, _vm._l((group.items), function(item, i_index) {
        return _c('li', {
          key: i_index,
          staticClass: "item"
        }, [_c('b-form-checkbox', {
          staticClass: "checkbox",
          attrs: {
            "checked": [_vm.itemValues[((tab.key) + "-" + (item.id))]],
            "value": true,
            "unchecked-value": false
          },
          on: {
            "change": function($event) {
              _vm.handleItemChange(tab.key, group.key, item, $event)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.text) + "\n\t\t\t\t\t\t\t\t\t\t")])], 1)
      }))])
    }))])])
  }))], 1)])])
},staticRenderFns: []}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-linked-products"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "tab-col col-12"
  }, [(_vm.firstTab) ? _c('div', {
    staticClass: "tab-wrap"
  }, [_c('ul', {
    staticClass: "tab-list"
  }, _vm._l((_vm.firstTab.groups), function(group, g_index) {
    return _c('li', {
      key: g_index,
      staticClass: "group-list"
    }, [_c('span', {
      staticClass: "group-title"
    }, [_vm._v(_vm._s(group.title))]), _vm._v(" "), _c('ul', {
      staticClass: "item-list"
    }, _vm._l((group.items), function(item, i_index) {
      return _c('li', {
        key: i_index,
        staticClass: "item"
      }, [_c('b-form-checkbox', {
        staticClass: "checkbox",
        attrs: {
          "checked": [_vm.itemValues[((_vm.firstTab.key) + "-" + (item.id))]],
          "value": true,
          "unchecked-value": false
        },
        on: {
          "change": function($event) {
            _vm.handleItemChange(_vm.firstTab.key, group.key, item, $event)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(item.text) + "\n\t\t\t\t\t\t\t\t")])], 1)
    }))])
  }))]) : _c('div', [_vm._v("\n\t\t\t\tKeine Produkte zur Auswahl\n\t\t\t")])])])])
},staticRenderFns: []}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--ping-pong",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "board"
  }, [_c('div', {
    staticClass: "left"
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }), _vm._v(" "), _c('div', {
    staticClass: "ball"
  })])
}]}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-preview-item",
    attrs: {
      "id": _vm.dataset.id
    }
  }, [_c('div', {
    staticClass: "action-bar row"
  }, [_c('div', {
    staticClass: "col-6 template-info"
  }, [_c('span', {
    staticClass: "_part _title"
  }, [_vm._v(_vm._s(_vm.template.title))]), _vm._v(" "), _c('span', {
    staticClass: "_part _id"
  }, [_vm._v(_vm._s(_vm.template.id))]), _vm._v(" "), _c('span', {
    staticClass: "_part _path"
  }, [_vm._v(_vm._s(_vm.template.path))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 button-group"
  }, [_c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.handleMoveClick
    }
  }, [_vm._v("\n\t\t\t\tverschieben\n\t\t\t")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": _vm.handleDeleteClick
    }
  }, [_vm._v("\n\t\t\t\tlöschen\n\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    ref: "preview-item",
    staticClass: "preview-item 96a5e0e1b988103acd3676a3bfca66930fb87db"
  }, [_c('div', {
    staticClass: "spinner-wrap"
  }, [_c('erco-cloak', {
    ref: "preview-item-cloak",
    attrs: {
      "vCenter": false
    }
  })], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "deleteConfirmation",
    staticClass: "delete-confirmation-modal",
    attrs: {
      "id": "delete-confirmation",
      "title": "Seite löschen",
      "closeTitle": "Abbrechen"
    },
    on: {
      "ok": _vm.handleDeleteConfirmationModalClick
    }
  }, [_c('p', {
    staticClass: "_template"
  }, [_c('span', {
    staticClass: "_path"
  }, [_vm._v(_vm._s(this.dataset.templatePath))]), _vm._v(" "), _c('span', {
    staticClass: "_id"
  }, [_vm._v(_vm._s(this.dataset.templateId))])]), _vm._v(" "), _c('p', {
    staticClass: "_infotext"
  }, [(_vm.textFieldCount || _vm.imgFieldCount) ? _c('span', {
    staticClass: "_fields"
  }, [_vm._v("\n\t\t\t   " + _vm._s(("Wollen Sie diese Seite mit " + (_vm.textFieldCount ? (_vm.textFieldCount + " Text" + (_vm.textFieldCount > 1 ? 'en':'')) : '') + " " + ((_vm.textFieldCount && _vm.imgFieldCount) ? 'und': '') + " " + (_vm.imgFieldCount ? (_vm.imgFieldCount + " Bild" + (_vm.imgFieldCount > 1 ? 'ern':'')) : '') + " wirklich löschen?")) + "\n\t\t\t")]) : _c('span', [_vm._v("\n\t\t\t\tWollen Sie diese Seite wirklich löschen?\n\t\t\t")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "assets-view container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 main"
  }, [_c('div', {
    staticClass: "assets-block",
    attrs: {
      "data-dev-info": ("{ type: 'module', id: '" + _vm.siteId + "' }")
    }
  }, _vm._l((_vm.objectdataImageItems), function(item, index) {
    return _c('div', {
      key: item.key,
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.openSidebarFor(item)
        }
      }
    }, [_c('b-card', {
      staticClass: "card_ mb-5",
      class: {
        '_error': item.mandatory === 'true' && item.value === '', '_focus-outline': _vm.isSidebarFocused(item)
      },
      attrs: {
        "data-dev-info": ("{ type: 'item', id: '" + (item.key) + "', position: " + (item.U_Position) + " }"),
        "header-tag": "header"
      }
    }, [_c('div', {
      staticClass: "_image",
      style: (("background-image: url('" + (_vm.getImgSrc(index)) + "')")),
      slot: "header"
    }), _vm._v(" "), _c('span', {
      attrs: {
        "data-infotextkey": _vm.infoTextKeyForItem(item)
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.label) + "\n\t\t\t\t\t\t\t"), (_vm.infoTextForItem(item)) ? _c('erco-tooltip', {
      attrs: {
        "variant": _vm.infoTextForItem(item).variant,
        "title": _vm.infoTextForItem(item).title,
        "text": _vm.infoTextForItem(item).text
      }
    }) : _vm._e()], 1)])], 1)
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-11",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner"
  })])
},staticRenderFns: []}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-10",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_c('div', {
    staticClass: "loader-xbox"
  })])])
},staticRenderFns: []}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-9",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading spin-1"
  }, [_c('div', {
    staticClass: "loading spin-2"
  }, [_c('div', {
    staticClass: "loading spin-3"
  }, [_c('div', {
    staticClass: "loading spin-4"
  }, [_c('div', {
    staticClass: "loading spin-5"
  }, [_c('div', {
    staticClass: "loading spin-6"
  })])])])])])
}]}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-8",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ball-container"
  }, [_c('div', {
    staticClass: "contener_mixte"
  }, [_c('div', {
    staticClass: "ballcolor ball_1"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "contener_mixte"
  }, [_c('div', {
    staticClass: "ballcolor ball_2"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "contener_mixte"
  }, [_c('div', {
    staticClass: "ballcolor ball_3"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "contener_mixte"
  }, [_c('div', {
    staticClass: "ballcolor ball_4"
  }, [_vm._v(" ")])])])
}]}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-7",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner"
  })])
},staticRenderFns: []}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "spinner spinner--circle-6",
    style: (_vm.styles),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 100 100"
    }
  }, [_c('g', {
    staticClass: "anim-0"
  }, [_c('circle', {
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "50",
      "fill": _vm.background
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "anim-1"
  }, [_c('circle', {
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "5",
      "fill": "white"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "anim-2"
  }, [_c('circle', {
    attrs: {
      "cx": "75",
      "cy": "50",
      "r": "5",
      "fill": "white"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "25",
      "y1": "50",
      "x2": "75",
      "y2": "50",
      "stroke": "white",
      "stroke-width": "3"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "anim-3"
  }, [_c('circle', {
    attrs: {
      "cx": "50",
      "cy": "25",
      "r": "5",
      "fill": "white"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "50",
      "y1": "25",
      "x2": "25",
      "y2": "75",
      "stroke": "white",
      "stroke-width": "3"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "50",
      "y1": "25",
      "x2": "75",
      "y2": "75",
      "stroke": "white",
      "stroke-width": "3"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "anim-4"
  }, [_c('circle', {
    attrs: {
      "cx": "75",
      "cy": "25",
      "r": "5",
      "fill": "white"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "75",
      "y1": "25",
      "x2": "25",
      "y2": "25",
      "stroke": "white",
      "stroke-width": "3"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-5",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-4",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-3",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-2",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--socker",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cube panelLoad"
  }, [_c('div', {
    staticClass: "cube-face cube-face-front"
  }, [_vm._v("L")]), _vm._v(" "), _c('div', {
    staticClass: "cube-face cube-face-back"
  }, [_vm._v("O")]), _vm._v(" "), _c('div', {
    staticClass: "cube-face cube-face-left"
  }, [_vm._v("A")]), _vm._v(" "), _c('div', {
    staticClass: "cube-face cube-face-right"
  }, [_vm._v("D")]), _vm._v(" "), _c('div', {
    staticClass: "cube-face cube-face-bottom"
  }, [_vm._v("I")]), _vm._v(" "), _c('div', {
    staticClass: "cube-face cube-face-top"
  }, [_vm._v("N'")])])
}]}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "spinner spinner--pencil",
    style: (_vm.styles),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 677.34762 182.15429"
    }
  }, [_c('g', [_c('path', {
    staticClass: "body-pencil",
    attrs: {
      "d": "M128.273 0l-3.9 2.77L0 91.078l128.273 91.076 549.075-.006V.008L128.273 0zm20.852 30l498.223.006V152.15l-498.223.007V30zm-25 9.74v102.678l-49.033-34.813-.578-32.64 49.61-35.225z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "line",
    attrs: {
      "d": "M134.482 157.147v25l518.57.008.002-25-518.572-.008z"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "form-group col-sm-10 col-md-6"
  }, [_vm._m(0), _vm._v(" "), (_vm.error) ? _c('b-alert', {
    staticClass: "error-alert",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "form-label-group username-group"
  }, [_c('label', {
    ref: "username",
    staticClass: "label"
  }, [_c('span', {
    staticClass: "-text"
  }, [_vm._v("Benutzer")]), _vm._v(" "), _c('b-form-input', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit()
      }
    },
    model: {
      value: (_vm.credentials.username),
      callback: function($$v) {
        _vm.credentials.username = $$v
      },
      expression: "credentials.username"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-label-group password-group"
  }, [_c('label', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "-text"
  }, [_vm._v("Passwort")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "password"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit()
      }
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.credentials.password = $$v
      },
      expression: "credentials.password"
    }
  })], 1)]), _vm._v(" "), _c('b-button', {
    class: ['login-btn', {
      loading: _vm.loggingIn
    }],
    attrs: {
      "type": "submit",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_c('span', [_vm._v("Login")]), _vm._v(" "), (_vm.loggingIn) ? _c('stretch', {
    staticClass: "loader",
    attrs: {
      "size": "25px",
      "background": "#fff"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _vm._m(1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('h2', {
    staticClass: "headline"
  }, [_vm._v("Login")]), _vm._v(" "), _c('p', {
    staticClass: "subline"
  }, [_vm._v("Light Scout Publisher")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "info text-muted"
  }, [_vm._v("\n\t\t\tDas Passwort vergessen / oder Login-Daten anfordern: "), _c('a', {
    attrs: {
      "href": "mailto:team@klickmeister.de"
    }
  }, [_vm._v("E-Mail an Klickmeister")])])
}]}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-navbar', {
    staticClass: "erco-dashboard-headbar p-0",
    attrs: {
      "toggleable": ""
    }
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "nav-collapse"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "navbar-brand"
  }, [_c('p', {
    staticClass: "navbar-brand mb-0 pb-0 pt-0"
  }, [_vm._v("ERCO "), _c('span', {
    staticClass: "text-warning"
  }, [_vm._v("LSP")])])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav-collapse"
    }
  }, [_c('b-nav', {
    staticClass: "ml-auto",
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    staticClass: "help-dropdown mr-sm-4",
    attrs: {
      "text": "Hilfe"
    }
  }, [_c('b-dropdown-item', [_c('a', {
    attrs: {
      "href": "https://ercowiki.klickmeister.org/mediawiki/index.php/ERCO:LSP4"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("Dokumentation")]), _vm._v(" Zugangsdaten: erco:dvdda\n\t\t\t\t")]), _vm._v(" "), _c('b-dropdown-item', [_vm._v("\n\t\t\t\t\tweitere Fragen und Ideen bitte an "), _c('a', {
    attrs: {
      "href": "mailto:lsp@klickmeister.de"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("lsp@klickmeister.de")])])], 1), _vm._v(" "), _c('b-nav-item-dropdown', {
    staticClass: "mr-sm-4",
    attrs: {
      "text": _vm.username,
      "right-alignment": ""
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": _vm.handleSignoutClick
    }
  }, [_vm._v("Signout")])], 1)], 1), _vm._v(" "), _c('b-form-input', {
    staticClass: "search-input",
    attrs: {
      "type": "text",
      "placeholder": "Suchbegriff"
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid e-main"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--double-bounce",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "double-bounce1",
    style: (_vm.bounceStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "double-bounce2",
    style: (_vm.bounceStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--rotate-square-5",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_c('span', {
    staticClass: "load3 one"
  }), _vm._v(" "), _c('span', {
    staticClass: "load3 two"
  }), _vm._v(" "), _c('span', {
    staticClass: "load3-center"
  })])])
},staticRenderFns: []}

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "spinner spinner--rotate-square4",
    style: (_vm.styles)
  }, [_c('span', {
    staticClass: "loader-inner"
  })])
},staticRenderFns: []}

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "spinner spinner--cube",
    style: (_vm.styles),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 500.00001 500.00001"
    }
  }, [_c('g', {
    attrs: {
      "fill": _vm.color
    }
  }, [_c('path', {
    staticClass: "b0",
    attrs: {
      "d": "M66.734 66.734v366.533h366.532V66.734H66.734zm15 15h336.532v336.533H81.734V81.734z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "b2",
    attrs: {
      "d": "M354.16 2.5v143.34H497.5V2.5H354.16zm10 10H487.5v123.34H364.16V12.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "b1",
    attrs: {
      "d": "M0 2.5v143.34h143.34V2.5H0zm10 10h123.34v123.34H10V12.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "b3",
    attrs: {
      "d": "M354.16 356.66V500H497.5V356.66H354.16zm10 10H487.5V490H364.16V366.66z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "b4",
    attrs: {
      "d": "M0 356.66V500h143.34V356.66H0zm10 10h123.34V490H10V366.66z"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--rotate-square-2",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.insertNewActionActive || _vm.pasteActionActive) ? _c('div', {
    staticClass: "layout-divider-controls"
  }, [(_vm.insertNewActionActive) ? _c('b-button', {
    staticClass: "control create-button",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.handleCreateClick
    }
  }, [_vm._v("\n\t    +\n\t")]) : _vm._e(), _vm._v(" "), (_vm.pasteActionActive) ? _c('b-button', {
    staticClass: "control paste-button",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.handlePasteClick
    }
  }, [_vm._v("\n\t\teinfügen\n\t")]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit-bar"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.newobject",
      modifiers: {
        "newobject": true
      }
    }],
    staticClass: "new-btn mr-4",
    attrs: {
      "variant": "warning"
    }
  }, [_vm._v("\n\t\t\tNeu\n\t\t")]), _vm._v(" "), (_vm.activeObjectsSelected) ? _c('erco-dropdown', {
    staticClass: "mr-1",
    attrs: {
      "label": "Aktion",
      "items": _vm.actions,
      "useLabelInline": true
    },
    on: {
      "change": _vm.handleActionClick
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeObjectsSelected) ? _c('erco-dropdown', {
    staticClass: "mr-1",
    attrs: {
      "label": "Status ändern",
      "items": _vm.statiList,
      "useLabelInline": true
    },
    on: {
      "change": _vm.handleStatiClick
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeObjectsSelected) ? _c('b-btn', {
    staticClass: "selection-reset ml-4",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleObjectSelectionReset
    }
  }, [_vm._v("\n\t\t\tAuswahl aufheben\n\t\t")]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    staticClass: "new-object-modal",
    attrs: {
      "id": "newobject",
      "title": "Neues Objekt anlegen",
      "closeTitle": "Schließen"
    },
    on: {
      "ok": _vm.handleNewClick,
      "shown": _vm.clearNewObjectDataset
    }
  }, [_c('b-alert', {
    staticClass: "alert-list",
    attrs: {
      "variant": "warning",
      "show": _vm.alertTextList.length > 0
    }
  }, _vm._l((_vm.alertTextList), function(alertText, index) {
    return _c('p', {
      key: index,
      staticClass: "_item"
    }, [_vm._v("\n\t\t\t\t\t• " + _vm._s(alertText) + "\n\t\t\t\t")])
  })), _vm._v(" "), _c('erco-text-input', {
    ref: "modalObjectnameInput",
    attrs: {
      "label": "Objektname"
    },
    on: {
      "change": _vm.handleObjectnameChange
    }
  }), _vm._v(" "), _c('erco-dropdown', {
    ref: "modalObjectSpecificationDropdown",
    staticClass: "mr-1 d-block specification-dropdown",
    attrs: {
      "label": "Spezifikation",
      "items": _vm.userSpecificationsDropdown
    },
    on: {
      "change": _vm.handleSpecificationClick
    }
  }), _vm._v(" "), _c('erco-dropdown', {
    ref: "modalObjectGenusDropdown",
    staticClass: "mr-1 d-block genus-dropdown",
    attrs: {
      "label": "Gattung",
      "items": _vm.selectedUserSpecificationGenusDropdown
    },
    on: {
      "change": _vm.handleGenusClick
    }
  })], 1), _vm._v(" "), _c('b-modal', {
    ref: "actionConfirmation",
    staticClass: "action-confirmation-modal",
    attrs: {
      "id": "action-confirmation",
      "title": "Statusänderung",
      "closeTitle": "Abbrechen"
    },
    on: {
      "ok": _vm.handleStatiModalClick,
      "shown": _vm.resetSelectedActionStatus
    }
  }, [_c('p', {
    staticClass: "_infotext"
  }, [(_vm.activeObjectSelection.length === 1) ? _c('span', [_vm._v("Den Status des folgenden Objekts")]) : _c('span', [_vm._v("Den Status der folgenden Objekte")]), _vm._v("\n\t\t\t\twirklich auf "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.selectedActionStatus.currentText))]), _vm._v(" setzen?\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "selected-obj-list-container"
  }, [(_vm.activeObjectSelection.length > 0) ? _c('b-list-group', {
    staticClass: "selected-obj-list"
  }, _vm._l((_vm.activeObjectSelection), function(selectedObj) {
    return _c('b-list-group-item', {
      key: selectedObj.PKM_Objekt,
      staticClass: "_entry_"
    }, [_c('span', {
      staticClass: "_image",
      style: (("background-image: url(" + (_vm.getImageSrcForObject(selectedObj)) + ");"))
    }), _vm._v(" "), _c('span', {
      staticClass: "_title font-weight-bold"
    }, [_vm._v(_vm._s(selectedObj.S_de_Objekt))]), _vm._v(" "), _c('span', {
      staticClass: "_id float-left text-muted"
    }, [_vm._v(_vm._s(selectedObj.PKM_Objekt))]), _vm._v(" "), _c('span', {
      staticClass: "_badge"
    }, [_c('erco-status-badge', {
      attrs: {
        "status": selectedObj.S_Status
      }
    })], 1)])
  })) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--hour-glass",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_c('svg', {
    staticClass: "hourglass",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 120 206",
      "preserveAspectRatio": "none"
    }
  }, [_c('path', {
    staticClass: "middle",
    attrs: {
      "d": "M120 0H0v206h120V0zM77.1 133.2C87.5 140.9 92 145 92 152.6V178H28v-25.4c0-7.6 4.5-11.7 14.9-19.4 6-4.5 13-9.6 17.1-17 4.1 7.4 11.1 12.6 17.1 17zM60 89.7c-4.1-7.3-11.1-12.5-17.1-17C32.5 65.1 28 61 28 53.4V28h64v25.4c0 7.6-4.5 11.7-14.9 19.4-6 4.4-13 9.6-17.1 16.9z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "outer",
    attrs: {
      "d": "M93.7 95.3c10.5-7.7 26.3-19.4 26.3-41.9V0H0v53.4c0 22.5 15.8 34.2 26.3 41.9 3 2.2 7.9 5.8 9 7.7-1.1 1.9-6 5.5-9 7.7C15.8 118.4 0 130.1 0 152.6V206h120v-53.4c0-22.5-15.8-34.2-26.3-41.9-3-2.2-7.9-5.8-9-7.7 1.1-2 6-5.5 9-7.7zM70.6 103c0 18 35.4 21.8 35.4 49.6V192H14v-39.4c0-27.9 35.4-31.6 35.4-49.6S14 81.2 14 53.4V14h92v39.4C106 81.2 70.6 85 70.6 103z"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-cloak",
    style: (_vm.computedStyle)
  }, [_c('erco-spinner', {
    class: ['spinner', {
      '-vcenter': _vm.vCenter
    }],
    attrs: {
      "size": "60px"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status-bar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-11 mt-1"
  }, [_c('erco-dropdown', {
    staticClass: "mr-sm-5 my-2 my-lg-0",
    attrs: {
      "label": "Status",
      "items": _vm.stati,
      "currentItemIndex": _vm.getIndexOf(_vm.currentStatus, _vm.stati)
    },
    on: {
      "change": _vm.handleStatiFilterChange
    }
  }), _vm._v(" "), _c('erco-dropdown', {
    staticClass: "mr-sm-5 my-2 my-lg-0",
    attrs: {
      "label": "letzte Änderung",
      "items": _vm.editors,
      "currentItemIndex": _vm.getIndexOf(_vm.currentEditor, _vm.editors)
    },
    on: {
      "change": _vm.handleLastEditFilterChange
    }
  }), _vm._v(" "), _c('erco-dropdown', {
    staticClass: "my-2 my-lg-0",
    attrs: {
      "label": "Rubrik",
      "items": _vm.categories,
      "currentItemIndex": _vm.getIndexOf(_vm.currentCategory, _vm.categories)
    },
    on: {
      "change": _vm.handleCategoryFilterChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('erco-cms-structure-dropdown', {
    staticClass: "cms-structure-dropdown float-right",
    attrs: {
      "dataset": _vm.cmsStructure
    },
    on: {
      "click": _vm.handleCmsStructureClick
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox-group"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.label) + "\n\t")]), _vm._v(" "), (_vm.tooltip && _vm.tooltip.text) ? _c('erco-tooltip', {
    attrs: {
      "variant": _vm.tooltip.variant,
      "title": _vm.tooltip.title,
      "text": _vm.tooltip.text
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkbox-container",
    class: _vm.containerClasses
  }, _vm._l((_vm.options), function(option, index) {
    return _c('b-form-checkbox', {
      key: index,
      staticClass: "checkbox",
      attrs: {
        "value": option.value,
        "unchecked-value": "",
        "disabled": option.disabled
      },
      on: {
        "change": function($event) {
          _vm.handleChange(index, option.value, $event)
        }
      },
      model: {
        value: (_vm.prepValue[index]),
        callback: function($$v) {
          var $$exp = _vm.prepValue,
            $$idx = index;
          if (!Array.isArray($$exp)) {
            _vm.prepValue[index] = $$v
          } else {
            $$exp.splice($$idx, 1, $$v)
          }
        },
        expression: "prepValue[index]"
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(option.text) + "\n\t\t")])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 676 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "dashboard"
  }, [_c('div', {
    staticClass: "section-dashboard-headbar"
  }, [_c('div', {
    staticClass: "container mt-3 mb-3"
  }, [_c('erco-dashboard-headbar')], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 mt-3 mb-3"
  }, [_c('erco-statusbar')], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "bg-faded"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row pt-3 mb-3"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('erco-editbar')], 1)]), _vm._v(" "), (_vm.freshlyCopiedItems.length > 0) ? _c('div', {
    staticClass: "freshly-copied-items-container"
  }, [_c('b', {
    staticClass: "d-block mt-4 mb-4"
  }, [_vm._v("Geklonte / leer kopierte Objekte")]), _vm._v(" "), _c('erco-object-card-overview', {
    attrs: {
      "items": _vm.freshlyCopiedItems,
      "disabledItemRestriction": true
    }
  }), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), _c('erco-object-card-overview', {
    attrs: {
      "items": _vm.notFreshlyCopiedItems,
      "visibleItemsNum": _vm.visibleItemsNum,
      "disabledItemRestriction": _vm.disabledItemRestriction
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('b-alert', {
    staticClass: "info",
    attrs: {
      "show": _vm.filteredItems.length === 0
    }
  }, [(!_vm.itemFiltersActive) ? _c('span', [_vm._v("Keine Objekte gefunden!")]) : _vm._e(), _vm._v(" "), (_vm.itemFiltersActive) ? _c('span', [_vm._v("Keine Objekte unter Berücksichtigung der aktiven Filter gefunden!")]) : _vm._e(), _vm._v(" "), (_vm.searchString.length > 0) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('strong', [_vm._v("Hinweis:")]), _vm._v(" Die Suche ist aktiv")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-fetcher_"
  }, [(!_vm.disabledItemRestriction && _vm.moreItemsAvailable) ? _c('b-button', {
    staticClass: "_button",
    on: {
      "click": _vm.handleItemFetch
    }
  }, [_vm._v("\n\t\t\t\t\tMehr Einträge anzeigen\n\t\t\t\t")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.inProcess) ? _c('erco-cloak', {
    staticClass: "cloak"
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 677 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.sidebarClasses,
    style: (_vm.sidebarStyle)
  }, [_c('div', {
    staticClass: "row titlebar"
  }, [_c('div', {
    staticClass: "col col-auto"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.sidebar.title))]), _vm._v(" "), (_vm.sidebar.titleAdditional) ? _c('span', {
    staticClass: "title-info"
  }, [_vm._v(_vm._s(_vm.sidebar.titleAdditional))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col text-right"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeSidebar
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "row content"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_c(_vm.sidebar.view, {
    ref: "component",
    tag: "component",
    attrs: {
      "data": _vm.sidebar.outputData
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row bottombar"
  }, [_c('div', {
    staticClass: "col"
  }, [(_vm.sidebar.info) ? _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "col col-auto"
  }, [_c('b-alert', {
    staticClass: "info_",
    attrs: {
      "variant": _vm.sidebar.info.variant,
      "show": ""
    }
  }, [(_vm.sidebar.info.title) ? _c('span', {
    staticClass: "_title"
  }, [_vm._v(_vm._s(_vm.sidebar.info.title) + ":")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "_text"
  }, [_vm._v(_vm._s(_vm.sidebar.info.text))])])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row controls"
  }, [_c('div', {
    staticClass: "col col-auto"
  }, [_c('b-button', {
    class: ['apply-btn', {
      applying: _vm.applying
    }],
    attrs: {
      "variant": _vm.applyButton.variant
    },
    on: {
      "click": _vm.applyChanges
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.applyButton.text))]), _vm._v(" "), (_vm.applying) ? _c('stretch', {
    staticClass: "loader",
    attrs: {
      "background": "#fff",
      "size": "25px"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.resetButton.visible && _vm.applyButton.applied) ? _c('b-button', {
    staticClass: "reset",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.triggerReset
    }
  }, [_c('span', [_vm._v("Zurücksetzen")])]) : _vm._e(), _vm._v(" "), (!_vm.applyButton.applied) ? _c('b-button', {
    staticClass: "cancel",
    on: {
      "click": _vm.closeSidebar
    }
  }, [_vm._v("\n\t\t\t\t\t\tAbbrechen\n\t\t\t\t\t")]) : _vm._e()], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-image-editor"
  }, [_c('iframe', {
    ref: "search",
    staticClass: "-iframe",
    attrs: {
      "src": _vm.src,
      "id": "iframe-mam-search"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--hexagon",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "hexagon-container"
  }, [_c('li', {
    staticClass: "hexagon hex_1"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_2"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_3"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_4"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_5"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_6"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_7"
  })])
}]}

/***/ }),
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */
/***/ (function(module, exports) {

module.exports = {
	"status": {
		"unknown": null,
		"entwurf": null,
		"online": {
			"variant": "warning",
			"title": "Hinweis",
			"text": "Bei Klick auf „Bestätigen“ wird die Seite auf www.erco.com veröffentlicht. Dieser Vorgang kann bis zu 10 Minuten dauern."
		},
		"kopiert": null,
		"löschmarkiert": null,
		"archiv": {
			"variant": "warning",
			"title": "Hinweis",
			"text": "Bei Klick auf „Bestätigen“ wird die Seite archiviert."
		},
		"synchronize": null
	},
	"header": {
		"renewOnlineButton": {
			"variant": "warning",
			"title": "Hinweis",
			"text": "Über den Online-Erneuern Button können Inhalte vom Stagingserver auf www.erco.com übertragen werden. Änderungen, die an Objekten mit Status 'Online' vorgenommen werden, können so auf www.erco.com online gestellt werden."
		},
		"renewPreviewButton": {
			"variant": "warning",
			"title": "Hinweis",
			"text": "Über den Preview-Erneuern Button werden im CMS veränderte Inhalte eines Objekts auf dem Stagingserver zur Preview ausgespielt."
		},
		"createPreviewButton": {
			"variant": "warning",
			"title": "Hinweis",
			"text": "Über den Preview-Erneuern Button werden im CMS veränderte Inhalte eines Objekts auf dem Stagingserver zur Preview ausgespielt."
		},
		"clearCacheButton": {
			"variant": "warning",
			"title": "Hinweis",
			"text": "Über den Cache-Leeren Button wird der zwischengespeicherte (gecachte) Inhalt dieses Objekts auf dem Stagingserver gelöscht. Beim nächsten Aufruf der Seite wird der Inhalt neu erzeugt. Nützlich, wenn auf der Preview noch veraltete oder fehlerhafte Inhalte angezeigt werden."
		}
	},
	"setup": {
		"lastchanges": null,
		"objectname": {
			"variant": "info",
			"title": "Info",
			"text": "Der Objektname dient der Auffindbarkeit im CMS und wird für die Bildung der URL benutzt. Er sollte nicht mehr als {{maxChars}} Zeichen umfassen. Im Light Scout wird bei Ansichten mit wenig Platz (z.B. Slideshow/Raster/Mobil) der Objektname statt der Headline genutzt."
		},
		"pdbKey": null,
		"objectadditional": {
			"variant": "info",
			"title": "Info",
			"text": "Der Objektzusatz dient nur als Infofeld im Backend."
		},
		"objecteditor": {
			"variant": "info",
			"title": "Info",
			"text": "Hier muss der zuständige Redakteur (Gruppe Content) angegeben werden"
		},
		"objectdesigner": {
			"variant": "info",
			"title": "Info",
			"text": "Hier muss der zuständige Designer (Gruppe Media) angegeben werden"
		},
		"specification": {
			"variant": "info",
			"title": "Info",
			"text": "Die Spezifikation gibt den Hauptbereich auf der Website an wie Produkte-Innenraum, Projekte oder Anwendungen planen."
		},
		"basisgenus": {
			"variant": "info",
			"title": "Info",
			"text": "Die Stammgattung legt die Grundzuordnung eines Objekts zu einem Bereich wie Leuchtengattung, Projekt-Cluster oder Storieskategorie fest."
		},
		"categories": {
			"variant": "info",
			"title": "Info",
			"text": "Tags können auf Objekte gelegt werden, u.a. um eine Zuordnung zu Themengebieten oder Filterauswahlen zu ermöglichen. Tags werden auch für die Marketing-Automation genutzt. CMS-Objekte können darüber zu den Kriterien Cluster, Marktsegemente, Interessen und Funneltiefef für die Emarsys-Anbindung zugeordnet werden. Die Tags werden beim Generieren als JS-Variable im Seitencode hinterlegt."
		},
		"mediaformats": {
			"variant": "info",
			"title": "Info",
			"text": "Medienformate klassifizieren Inhalte der Stories-Seite."
		},
		"triad": {
			"variant": "info",
			"title": "Info",
			"text": "Über den Dreiklang können Verknüpfungen von Projekten und Produkten gepflegt werden."
		},
		"linkedProducts": {
			"variant": "info",
			"title": "Info",
			"text": "Über Verwendete Produkte können Verknüpfungen von Produkten gepflegt werden."
		},
		"startpage": {
			"variant": "info",
			"title": "Info",
			"text": "Über diese Radioboxen kann festgelegt werden, wo das Objekt in den Slider-Elementen auf der Startseite angezeigt werden soll."
		},
		"lightscoutClassification": {
			"variant": "info",
			"title": "Info",
			"text": "Über diese Checkboxen kann festgelegt werden, in welchen Sprachen das Objekt im Light Scout verfügbar sein soll."
		},
		"status": {
			"variant": "info",
			"title": "Info",
			"text": "Über den Status wird gesteuert, ob ein Objekt online geht.\nEntwurf= Initales Anlegen, Erstellen und Einpflegen\nOnline= Sofern der Veröffentlichungszeitraum erreicht ist, erscheint das Objekt auf www.erco.com)"
		},
		"publishdatetime": {
			"variant": "info",
			"title": "Info",
			"text": "Wenn ein Veröffentlichungsdatum gesetzt wird, geht das CMS-Objekt automatisch zu dem Zeitpunkt online."
		},
		"gooffdatetime": {
			"variant": "info",
			"title": "Info",
			"text": "Wenn ein Datum für das Offlinesetzen gesetzt wird, geht das CMS-Objekt automatisch zu dem Zeitpunkt offline."
		},
		"process": {
			"variant": "info",
			"title": "Info",
			"text": "Über die Prozess-Dropdowns können Stati zur Qualitätsprüfung gesetzt werden, sowie Benachrichtigungsmails an Prozessbeteiligte ausgelöst werden."
		},
		"visibility": {
			"variant": "info",
			"title": "Info",
			"text": "Ist diese Checkbox gesetzt, wird das Objekt in der Light Scout Suche angezeigt."
		},
		"synchblock": {
			"variant": "info",
			"title": "Info",
			"text": "Ist diese Checkbox gesetzt, wird eine Synchsperre für dieses Objekt gesetzt. Es wird dann nicht auf die prod-Umgbung gesynched."
		}
	},
	"objectdata": {
		"headline": {
			"variant": "info",
			"title": "Info",
			"text": "Die Headline enthält die Haupüberschrift des Objekts, umfasst maximal {{maxChars}} Zeichen und wird in der Regel in der Headerbar auf der Website angezeigt."
		},
		"subheadline": {
			"variant": "info",
			"title": "Info",
			"text": "Die Subheadline enthält den Untertitel des Objekts, umfasst maximal {{maxChars}} Zeichen und wird in der Regel in der Headerbar auf der Website angezeigt."
		},
		"teasertext": {
			"variant": "info",
			"title": "Info",
			"text": "Der Teasertext umfasst maximal {{maxChars}} und wird an unterschiedlichen Stellen genutzt u.a. in der Suche oder auf der Storiesseite in den Objektboxen. Er wird i.d.R. auch als Meta-Description-Text genutzt."
		},
		"projekteVeröffentlichungsdatumTtmmyyyyBzwSprachabhängig": {
			"variant": "info",
			"title": "Info",
			"text": "Das hier angegebene Veröffentlichungsdatum dient lediglich zur Anzeige auf der Website."
		},
		"event": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe unter Event wird in den Credits auf der Website angezeigt und kann für Ausstellungen, Messen usw. genutzt werden."
		},
		"bauherr": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird in den Credits auf der Website angezeigt."
		},
		"architektur": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird in den Credits auf der Website angezeigt."
		},
		"innenarchitektur": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird in den Credits auf der Website angezeigt."
		},
		"lichtplanung": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird in den Credits auf der Website angezeigt."
		},
		"elektroplanung": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird in den Credits auf der Website angezeigt."
		},
		"fotografie": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird in den Credits auf der Website angezeigt."
		},
		"ort": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird in den Credits auf der Website angezeigt."
		},
		"website": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird in den Credits auf der Website angezeigt."
		},
		"linksYoutubeEtcVimeoId": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird genutzt um Filmreferenzen zu vorzuhalten, die in spezifischen Templates genutzt werden. Für Youtube bitte nur die Video-ID eingeben aus der EmbedURL https://youtu.be/sClIaF1HyR4 (ID=sClIaF1HyR4)"
		},
		"veröffentlichungsdatumTtmmyyyyBzwSprachabhängig": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird in den Credits auf der Website angezeigt."
		},
		"latitudeNurZahlBsp52500833": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird u.a. genutzt, um in Kartendarstellungen Marker zu positionieren."
		},
		"longitudeNurZahlBsp52500833": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird u.a. genutzt, um in Kartendarstellungen Marker zu positionieren."
		},
		"googleMapsKurzlinkBspHttpgooglmapsoj0e": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird in den Credits auf der Website angezeigt."
		},
		"metaTitle": {
			"variant": "info",
			"title": "Info",
			"text": "Der Meta-Title sollte maximal {{maxChars}} Zeichen umfassen, seitenspezifisch und einzigartig sein und wichtige Content-Keywords beinhalten."
		},
		"metaDescription": {
			"variant": "info",
			"title": "Info",
			"text": "Die Meta-Description sollte {{maxChars}} Zeichen umfassen und Content-Keywords beinhalten. Sie wird in der SERP angezeigt und sollte den Nutzer auffordern, die Seite anzuklicken."
		},
		"seoNoindex": {
			"variant": "info",
			"title": "Info",
			"text": "Wenn diese Seite nicht von Suchmaschinen indiziert werden soll, bitte die Einstellung 'ja' wählen."
		},
		"shorturl": {
			"variant": "info",
			"title": "Info",
			"text": "Short-URLs ohne Sprachkürzel führen immer zu EN oder zu der einen Sprache, der sie einzeln zugeordnet sind. Mehrere Short-URLs können getrennt durch Pipes \"|\" angegeben werden."
		},
		"rewriteId": {
			"variant": "info",
			"title": "Info",
			"text": "In dieses Feld kann eine CMS-Id eingetragen werden zu der die Urls dieses Objekt umgeleitet werden können. Das kann für offline gestellte Objekte genutzt werden."
		},
		"canonicalId": {
			"variant": "info",
			"title": "Info",
			"text": "In dieses Feld kann eine CMS-Id eingetragen werden über die eine Canonicalurl für dieses Objekts erzeugt wird, sofern dieses Objekt auf 'noindex' gesetzt ist (siehe oben)."
		}
	},
	"assets": {
		"editAsset": null,
		"teaserbild": {
			"variant": "info",
			"title": "Info",
			"text": "Das Teaserbild wird i.d.R. im Seitenkopf bei Reportagenlayouts etc. angezeigt."
		},
		"heroslider": {
			"variant": "info",
			"title": "Info",
			"text": "Das Heroslider-Bild ist ein querformatiges screenfüllendes Format."
		},
		"stellvertreterbild": {
			"variant": "info",
			"title": "Info",
			"text": "Das Stellvertreterbild wird in der Trefferliste der Light Scout-Suche und auf den diversen Übersichtsseiten (u.a. Clusterseiten) angezeigt."
		},
		"multiformat": {
			"variant": "info",
			"title": "Info",
			"text": "Das Multiformat-Bild bietet eine Beschnittauswahl in unterschiedliche Quer- oder Hochformate an."
		},
		"slideshowbild_2": null,
		"slideshowbild_3": null,
		"slideshowbild_4": null,
		"slideshowbild_5": null,
		"slideshowbild_6": null,
		"slideshowbild_7": null,
		"slideshowbild_8": null,
		"slideshowbild_9": null,
		"querformat_1920px816pxvideostill": {
			"variant": "info",
			"title": "Info",
			"text": "Diese Bild wird als Video Still verwendet."
		},
		"querformat_1920px1080pxvideostill": {
			"variant": "info",
			"title": "Info",
			"text": "Diese Bild wird als Video Still verwendet."
		},
		"querformat_830px415px": {
			"variant": "info",
			"title": "Info",
			"text": "Diese Bild wird als Video Still verwendet."
		}
	},
	"layout": {
		"createNewSite": null,
		"itemEdit": null,
		"presets": {
			"reportagen-template": {
				"variant": "info",
				"title": "Info",
				"text": "Template für Reportagen"
			},
			"kurzgeschichten-template": {
				"variant": "info",
				"title": "Info",
				"text": "Template für Kurzgeschichten"
			},
			"highlight-template": {
				"variant": "info",
				"title": "Info",
				"text": "Template für Highlights"
			},
			"fachartikel-template": {
				"variant": "info",
				"title": "Info",
				"text": "Template für Fachartikel"
			},
			"default-template": {
				"variant": "info",
				"title": "Info",
				"text": "Template mit Footer und Header"
			}
		}
	},
	"misc": {
		"imageEditor": null
	}
};

/***/ }),
/* 684 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[212]);


// WEBPACK FOOTER //
// static/js/app.feda648a54c64bb3e165.js